import { adminFaz8Tr } from './admin.faz8.tr';
/** Yönetim paneli arayüz metinleri (Türkçe). */
export const adminTr = {
  ...adminFaz8Tr,
  nav: {
    overview: 'Genel',
    business: 'İşletme',
    team: 'Ekip',
    connections: 'Bağlantılar',
    records: 'Kayıtlar',
    dashboard: 'Ana Panel',
    setup: 'Kurulum Sihirbazı',
    organization: 'İşletme Bilgileri',
    brands: 'Markalar',
    stores: 'Mağazalar',
    users: 'Kullanıcılar',
    roles: 'Roller',
    apiKeys: 'API Anahtarları',
    webhooks: 'Webhook',
    integrations: 'Entegrasyonlar',
    audit: 'Denetim Kayıtları',
    system: 'Sistem Durumu',
    migration: 'Taşıma paketi',
    privacy: 'KVKK başvuruları',
    retention: 'Saklama ve imha',
    ledger: 'Cari hesaplar',
    quotes: 'Teklifler',
    salesRegions: 'Satış bölgeleri',
    commissions: 'Temsilci komisyonları',
    dealerReports: 'Bayi raporları',
    internationalReport: 'Ülke ve ihracat raporu',
    subscriptions: 'Düzenli siparişler',
    bizimhesap: 'BizimHesap',
    exports: 'Dışa aktarma',
    seo: 'SEO merkezi',
    attribution: 'Kampanyalar ve kaynaklar',
    tracking: 'Ölçümleme',
    google: 'Google bağlantıları',
    webVitals: 'Sayfa hızı',
    keywords: 'Anahtar kelimeler',
    siteSearch: 'Site içi arama',
    attributes: 'Ürün özellikleri',
    collections: 'Koleksiyonlar',
    searchConsole: 'Arama performansı',
    merchant: 'Google alışveriş',
    helpEditor: 'Yardım Metinleri',
    uiTranslations: 'Çeviriler',
    account: 'Hesabım',
    menu: 'Menü',
    skipToContent: 'İçeriğe geç',
    stagingBanner: 'Staging (deneme) sunucusu: e-postalar yalnızca izin listesindeki adreslere gider.',
    stagingBannerLink: 'İzin listesi',
    organizationSwitch: 'İşletme',
    sales: 'Satış',
    catalog: 'Katalog',
    orders: 'Siparişler',
    customers: 'Müşteriler',
    dealers: 'Bayiler',
    applications: 'Bayilik Başvuruları',
    products: 'Ürünler',
    categories: 'Kategoriler',
    stock: 'Stok',
    pricing: 'Fiyatlar',
    fx: 'Döviz kurları',
    discounts: 'Kuponlar',
    promotions: 'Otomatik indirimler',
    giftCards: 'Hediye kartları',
    loyalty: 'Sadakat programı',
    referrals: 'Tavsiye programı',
    affiliates: 'İş ortakları',
    imports: 'İçe / Dışa Aktarma',
    payments: 'Ödemeler',
    invoices: 'Faturalar',
    paymentSettings: 'Ödeme ayarları',
    shipping: 'Kargo',
    legal: 'Yasal metinler',
    redirects: 'Yönlendirmeler',
    brokenLinks: 'Kırık linkler',
    storefrontGroup: 'Vitrin',
    marketing: 'Pazarlama',
    marketingAudience: 'Aboneler ve izinler',
    segments: 'Segmentler',
    emailTemplates: 'E-posta şablonları',
    campaigns: 'E-posta kampanyaları',
    automations: 'Otomasyonlar',
    productAlerts: 'Stok ve fiyat bildirimleri',
    smsWhatsapp: 'SMS ve WhatsApp',
    smsTemplates: 'SMS şablonları',
    push: 'Anlık bildirimler',
    design: 'Tasarım',
    menus: 'Menüler',
    pageDesigns: 'Sayfa tasarımları',
    salesPoints: 'Satış noktaları',
    googleAdsCampaigns: 'Google Ads kampanyaları',
    needsFinder: 'İhtiyaç bulucu',
    pages: 'Sayfalar',
    banners: 'Bannerlar',
    blog: 'Blog',
    contentCalendar: 'İçerik takvimi',
    contentReport: 'İçerik raporu',
    forms: 'Formlar',
    contactMessages: 'İletişim mesajları',
    supportTickets: 'Destek talepleri',
    ads: 'Reklam merkezi',
    googleReports: 'Google raporları',
    liveChat: 'Canlı sohbet',
    questions: 'Ürün soruları',
    reviews: 'Ürün değerlendirmeleri',
  },
  help: {
    whatItDoes: 'Ne işe yarar?',
    whenToUse: 'Ne zaman kullanılır?',
    dataChanged: 'Neyi değiştirir?',
    requiredPermission: 'Gerekli yetki',
    reversible: 'Geri alınabilir mi?',
    commonErrors: 'Olası sorunlar ve çözümleri',
    guide: 'Ayrıntılı rehber',
    open: 'Açıklama: {{title}}',
  },
  auth: {
    brand: 'Zootopia Panel',
    tagline: 'Mağazanızı, ekibinizi ve bağlantılarınızı tek yerden yönetin.',
    signInTitle: 'Panele giriş',
    signIn: 'Giriş yap',
    forgot: 'Şifremi unuttum',
    mfaTitle: 'Doğrulama kodu',
    mfaLead: 'Telefonunuzdaki doğrulama uygulamasında görünen 6 haneli kodu girin.',
    code: '6 haneli kod',
    verify: 'Doğrula',
    useBackup: 'Yedek kod kullan',
    backupCode: 'Yedek kod',
    useCode: 'Uygulama koduyla doğrula',
    enrollTitle: 'İki adımlı doğrulamayı kurun',
    enrollLead:
      'Panel güvenliği için her kullanıcı bir doğrulama uygulaması (Google Authenticator, Microsoft Authenticator vb.) kullanır. Uygulamada "hesap ekle"ye dokunup bu karekodu okutun.',
    manualKey: 'Karekodu okutamıyorsanız bu anahtarı uygulamaya elle girin:',
    confirmEnroll: 'Kurulumu tamamla',
    backupTitle: 'Yedek kodlarınızı saklayın',
    backupLead:
      'Telefonunuza erişemediğinizde bu kodlardan biriyle giriş yapabilirsiniz. Her kod bir kez çalışır ve bu kodlar bir daha gösterilmez.',
    backupDone: 'Kodları kaydettim, devam et',
    copyCodes: 'Kodları kopyala',
    printCodes: 'Yazdır',
    forgotTitle: 'Şifre sıfırlama',
    forgotLead: 'Hesabınızın e-posta adresini girin. Kayıtlıysa 1 saat geçerli bir bağlantı göndereceğiz.',
    sendLink: 'Bağlantı gönder',
    forgotSent: 'Adres kayıtlıysa e-posta gönderildi. Gelen kutunuzu ve gereksiz klasörünü kontrol edin.',
    forgotUnavailable:
      'E-posta servisi henüz kurulmadığı için şifre sıfırlama e-postası gönderilemiyor. İşletme yöneticinizden yardım isteyin; sunucu yöneticisi size bir sıfırlama bağlantısı üretebilir.',
    backToSignIn: 'Girişe dön',
    resetTitle: 'Yeni şifre belirleyin',
    newPassword: 'Yeni şifre',
    setPassword: 'Şifreyi kaydet',
    resetDone: 'Şifreniz değiştirildi. Yeni şifrenizle giriş yapabilirsiniz.',
    passwordHint: 'En az 12 karakter. Kolay hatırlanan uzun bir cümle iyi bir seçimdir.',
    inviteTitle: '{{organization}} sizi davet etti',
    inviteLead:
      '{{email}} adresi için davet. Adınızı ve şifrenizi belirleyin; ardından iki adımlı doğrulamayı kuracaksınız.',
    inviteExistingLead: '{{email}} hesabınız zaten var. Daveti kabul etmek için mevcut şifrenizi girin.',
    yourName: 'Adınız soyadınız',
    acceptInvite: 'Daveti kabul et',
    stepUpTitle: 'Kimliğinizi doğrulayın',
    stepUpLead: 'Bu işlem hassas olduğu için doğrulama uygulamanızdaki kodu tekrar girin.',
    stepUpSubmit: 'Doğrula ve devam et',
  },
  dashboard: {
    greeting: 'Merhaba {{name}}',
    setupHeading: 'Kurulum',
    setupProgress: 'Bu fazda açık olan {{total}} adımdan {{done}} tanesi tamamlandı.',
    continueSetup: 'Kuruluma devam et',
    healthHeading: 'Sistem',
    attentionHeading: 'Dikkat gerektirenler',
    salesHeading: 'Satış ve siparişler',
    nothingToDo: 'Şu an dikkat gerektiren bir şey yok.',
    salesPending:
      'Satış ve sipariş grafikleri raporlar modülüyle (Faz 8) gelecek. Şimdilik Siparişler, Ödemeler ve Stok ekranlarını kullanın; gerçek veri olmadan tahmini rakam gösterilmez.',
    alertReturns: '{{count}} iade/cayma talebi yanıt bekliyor.',
    alertPrivacy: '{{count}} KVKK başvurusu yanıt bekliyor (yasal süre 30 gün).',
    alertPrivacyOverdue: '{{count}} KVKK başvurusunun 30 günlük yanıt süresi geçti.',
    alertLowStock: 'Kritik stokta {{count}} ürün var (Stok → Kritik stok).',
    alertPaymentReview: '{{count}} ödeme inceleme bekliyor (sipariş ödenmiş sayılmadı).',
    alertBalanceReview:
      '{{count}} bayi kart ödemesi inceleme bekliyor (cari hesaba işlenmedi; Cari hesaplar → bayi → Kartla bakiye ödemeleri).',
    alertIntegration: '{{name}} bağlantısı hata veriyor.',
    alertTls: '{{host}} SSL sertifikasının bitmesine {{days}} gün kaldı.',
    alertTlsError: '{{host}} için SSL sertifikası okunamadı.',
    alertMail: 'E-posta servisi kurulmamış: davet ve şifre sıfırlama e-postaları gönderilemez.',
    alertBackup: 'Henüz yedek kaydı yok. Sunucu kurulumundan sonra gecelik yedek otomatik başlar.',
    alertBackupFailed: 'Son yedekleme başarısız oldu. Ayrıntı: Sistem Durumu.',
    alertBackupStale: 'Son başarılı yedek 26 saatten eski. Yedekleme servisi çalışmıyor olabilir.',
    alertRestoreFailed:
      'Son geri yükleme testi başarısız oldu: yedekler geri açılamayabilir. Ayrıntı: Sistem Durumu.',
    alertRedis: 'Kuyruk sunucusuna ulaşılamıyor; e-postalar gönderilemez.',
  },
  setup: {
    go: 'Aç',
    skip: 'Atla',
    unskip: 'Geri al',
  },
  organization: {
    systemName: 'Panel adı (sistem adı)',
    systemNameHint:
      'Yönetim panelinin üstünde ve tarayıcı sekmesinde görünen ad. Boş bırakılırsa "Zootopia Panel".',
    legalSection: 'Yasal bilgiler',
    legalLead: 'Sitedeki satıcı bilgileri, faturalar ve POS başvurusu bu bilgileri kullanır.',
    contactSection: 'İletişim',
    defaultsSection: 'Varsayılanlar',
    name: 'Görünen ad',
    legalName: 'Ticari unvan',
    taxOffice: 'Vergi dairesi',
    taxNumber: 'Vergi no / TCKN',
    mersis: 'MERSİS no',
    kep: 'KEP adresi',
    etbis: 'ETBİS doğrulama bağlantısı',
    etbisHint:
      'ETBİS kaydından sonra verilen karekodun açtığı adres. Doluysa vitrin alt bilgisinde "ETBİS\'e kayıtlıdır" bağlantısı ve karekod görünür.',
    phone: 'Telefon',
    email: 'E-posta',
    address: 'Adres',
    defaultLocale: 'Varsayılan dil',
    defaultCurrency: 'Varsayılan para birimi',
  },
  brands: {
    add: 'Marka ekle',
    createTitle: 'Yeni marka',
    editTitle: 'Markayı düzenle',
    name: 'Marka adı',
    slug: 'Kısa ad',
    description: 'Açıklama',
    color: 'Ana renk',
    logo: 'Logo',
    uploadLogo: 'Logo yükle',
    replaceLogo: 'Logoyu değiştir',
    noLogo: 'Logo yok',
    archive: 'Arşivle',
    activate: 'Aktif yap',
    active: 'Aktif',
    archived: 'Arşivde',
    emptyTitle: 'Henüz marka yok',
    emptyLead: 'Zootopia Global ve VITATOPIA gibi sattığınız markaları ekleyin.',
    logoUploaded: 'Logo yüklendi',
  },
  stores: {
    customerAuth: {
      title: 'Müşteri girişi',
      lead: 'Vitrinde giriş, kayıt ve ödeme adımında "Google ile devam et". Varsayılan kapalı; aydınlatma metni ve yurt dışı aktarım envanteri avukat onayıyla güncellenmeden açılmamalıdır.',
      clientReady: 'Google ile giriş istemcisi kurulu',
      clientMissing: 'Kurulum Gerekli: Google ile giriş istemcisi yok',
      configure: 'Entegrasyonlarda kur',
      google: 'Google ile giriş',
      on: 'Açık',
      off: 'Kapalı',
      enable: 'Google ile girişi aç',
      disable: 'Google ile girişi kapat',
      enableConfirm:
        'Müşteriler bu mağazada Google hesabıyla girip üye olabilecek. Aydınlatma metni ve yurt dışı aktarım envanteri avukat onayıyla güncellendiyse devam edin.',
      disableConfirm:
        'Google ile giriş kapatılacak. Google ile açılmış hesaplar e-posta ve şifreyle (şifre yoksa "Şifremi unuttum" ile) girmeye devam edebilir.',
      ownerOnly: 'Açmak yalnızca işletme sahibinin yetkisindedir.',
      redirects: "Google Cloud'daki OAuth istemcisine girilecek yönlendirme adresleri",
      noDomains: 'Mağazanın vitrin alan adı yok.',
    },
    add: 'Mağaza ekle',
    createTitle: 'Yeni mağaza',
    name: 'Mağaza adı',
    code: 'Kod',
    channel: 'Kanal türü',
    channelB2C: 'B2C — son tüketici',
    channelB2B: 'B2B — bayiler',
    channelHYBRID: 'Karma — tüketici ve bayi',
    status_draft: 'Önizleme',
    status_live: 'Yayında',
    status_maintenance: 'Bakımda',
    status_archived: 'Arşivde',
    deleteTitle: 'Mağazayı sil',
    deleteLead:
      'Yanlışlıkla açılmış veya kullanılmayan mağaza içindir. Yalnızca önizlemedeki ya da arşivdeki ve hiç siparişi olmayan mağaza silinebilir; siparişi olan mağazayı arşivleyin.',
    delete: 'Mağazayı sil',
    deleted: 'Mağaza silindi',
    deleteBlocked_store_not_draft:
      'Yayındaki veya bakımdaki mağaza silinemez; önce önizlemeye döndürün ya da arşivleyin.',
    deleteBlocked_store_has_orders: 'Bu mağazanın siparişleri var; silinemez. Kullanmayacaksanız arşivleyin.',
    deleteDialogTitle: '"{{name}}" silinsin mi?',
    deleteDialogLead: 'Bu işlem geri alınamaz. Mağazayla birlikte şunlar da silinir:',
    deleteCodeLabel: 'Onaylamak için mağaza kodunu yazın: {{code}}',
    deleteCount_domains: '{{count}} alan adı',
    deleteCount_markets: '{{count}} pazar',
    deleteCount_priceLists: '{{count}} fiyat listesi (fiyatlarıyla)',
    deleteCount_listings: '{{count}} ürün yayını (ürünler silinmez)',
    deleteCount_pages: '{{count}} sayfa',
    deleteCount_banners: '{{count}} banner',
    deleteCount_menus: '{{count}} menü',
    deleteCount_redirects: '{{count}} yönlendirme',
    deleteCount_shippingMethods: '{{count}} kargo yöntemi',
    brands: 'Satılan markalar',
    domains: 'Alan adları',
    addDomain: 'Alan adı ekle',
    hostname: 'Alan adı',
    purpose: 'Kullanım',
    purpose_storefront: 'Vitrin',
    purpose_admin: 'Panel',
    purpose_api: 'API',
    primary: 'Birincil',
    markets: 'Pazarlar',
    addMarket: 'Pazar ekle',
    makeDefault: 'Varsayılan yap',
    makeDefaultConfirm:
      '"{{name}}" varsayılan pazar olsun mu? Vitrin bu pazarın dili ve para birimiyle ({{currency}}) açılır; bu para biriminde fiyatı olmayan ürün satılamaz.',
    defaultMarketSaved: 'Varsayılan pazar değişti.',
    taxMode: 'Vergi kipi',
    taxModeOf: '{{name}} vergi kipi',
    taxModeSaved: 'Vergi kipi kaydedildi.',
    taxModes: {
      domestic: 'Yurt içi KDV',
      export_exempt: 'İhracat (KDV istisnası)',
      destination: 'Varış ülkesi KDV',
    },
    returnPolicy: {
      title: 'İade politikası (arama motorları için)',
      lead: 'Google ürün sonuçlarında gösterilen iade bilgisi. Yasal metinlerinizdeki cayma ve iade koşullarıyla aynı olmalıdır.',
      enabled: 'Arama motorlarına bildir',
      days: 'İade süresi (gün)',
      method: 'İade yöntemi',
      methods: { by_mail: 'Kargoyla', in_store: 'Mağazada', by_mail_or_in_store: 'Kargoyla veya mağazada' },
      fees: 'İade kargo ücreti',
      feeOptions: { customer_pays: 'Müşteri öder', free: 'Ücretsiz (biz karşılarız)' },
      save: 'İade politikasını kaydet',
      saved: 'İade politikası kaydedildi.',
    },
    marketName: 'Pazar adı',
    country: 'Ülke',
    language: 'Dil',
    currency: 'Para birimi',
    default: 'Varsayılan',
    emptyTitle: 'Henüz mağaza yok',
    emptyLead: 'zootopia.com.tr için bir mağaza oluşturarak başlayın.',
    dnsNote:
      'Alan adını ekledikten sonra, alan adını aldığınız firmanın panelinde A kaydının sunucunuzun IP adresini göstermesi gerekir.',
    noDomains: 'Henüz alan adı yok.',
    noMarkets: 'Henüz pazar yok. Fiyat ve vergiler pazara göre çalışacağı için en az bir pazar ekleyin.',
    tls: 'SSL',
    remove: 'Kaldır',
    open: 'Ayrıntılar',
    back: 'Mağazalara dön',
  },
  users: {
    invite: 'Kullanıcı davet et',
    inviteTitle: 'Kullanıcı davet et',
    inviteSent: 'Davet e-postası gönderildi',
    manualTitle: 'Davet bağlantısını iletin',
    manualLead:
      'E-posta servisi kurulu olmadığı için {{email}} adresine e-posta gönderilmedi. Bu bağlantıyı kişiye güvenli bir yoldan iletin; 7 gün geçerli ve tek kullanımlıktır.',
    copyLink: 'Bağlantıyı kopyala',
    role: 'Rol',
    storeScope: 'Mağaza kısıtı',
    dealerScope: 'Bayi kapsamı',
    dealerScopeOf: '{{name}} — bayi kapsamı',
    dealerScopes: { all: 'Tüm bayiler', assigned: 'Yalnızca atanan bayiler' },
    allStores: 'Tüm mağazalar',
    active: 'Aktif',
    suspended: 'Askıda',
    lastLogin: 'Son giriş',
    members: 'Üyeler',
    pending: 'Bekleyen davetler',
    expires: 'Geçerlilik',
    revoke: 'Daveti iptal et',
    suspend: 'Askıya al',
    activate: 'Aktif yap',
    remove: 'Üyelikten çıkar',
    changeRole: 'Rolü değiştir',
    you: 'siz',
    confirmRemove: '{{name}} üyelikten çıkarılsın mı? Geçmiş işlemleri denetim kayıtlarında kalır.',
    noPending: 'Bekleyen davet yok.',
  },
  roles: {
    system: 'Hazır roller',
    custom: 'Özel roller',
    createCustom: 'Özel rol oluştur',
    createTitle: 'Özel rol',
    basedOn: 'Başlangıç rolü',
    basedOnNone: 'Boş başla',
    permissions: 'Yetkiler',
    permissionCount: '{{count}} yetki',
    sensitive: 'Hassas',
    phaseNote: 'Faz {{phase}}',
    emptyCustom: 'Henüz özel rol yok. Hazır rollerden hiçbiri ihtiyacınıza uymuyorsa oluşturun.',
    name: 'Rol adı',
    description: 'Açıklama',
    delete: 'Rolü sil',
    showPermissions: 'Yetkileri göster',
  },
  apiKeys: {
    create: 'API anahtarı oluştur',
    name: 'Anahtar adı',
    namePlaceholder: 'ör. Muhasebe programı',
    scopes: 'Kapsam',
    prefix: 'Ön ek',
    expiresAt: 'Bitiş tarihi',
    noExpiry: 'Süresiz',
    revoked: 'İptal edildi',
    expired: 'Süresi doldu',
    revoke: 'İptal et',
    secretTitle: 'Anahtarınız hazır',
    secretLead: 'Bu anahtarı şimdi kopyalayıp dış programa girin. Güvenlik gereği bir daha gösterilmeyecek.',
    usage: 'Kullanım örneği',
    emptyTitle: 'Henüz API anahtarı yok',
    emptyLead: 'Muhasebe, ERP veya n8n gibi bir programı bağlamak için anahtar oluşturun.',
    confirmRevoke: 'Bu anahtarı kullanan programlar hemen erişimini kaybedecek. İptal edilsin mi?',
    docs: 'API dokümantasyonu',
  },
  webhooks: {
    add: 'Webhook ekle',
    url: 'Adres (URL)',
    description: 'Açıklama',
    events: 'Olaylar',
    allEvents: 'Tüm olaylar',
    active: 'Aktif',
    disabled: 'Kapalı',
    test: 'Test olayı gönder',
    testSent: 'Test olayı gönderim sırasına alındı. Sonucu teslimat geçmişinde görebilirsiniz.',
    deliveries: 'Teslimat geçmişi',
    rotate: 'Sırrı yenile',
    secretTitle: 'İmza sırrı',
    secretLead:
      'Karşı programın gelen isteklerin bizden geldiğini doğrulaması için bu sırrı kaydedin. Bir daha gösterilmeyecek.',
    signatureHelp:
      'Her istekte X-Zootopia-Signature başlığı bulunur: t=<zaman>,v1=<HMAC-SHA256(sır, zaman + "." + gövde)>.',
    redeliver: 'Yeniden gönder',
    attempt: 'Deneme',
    response: 'Yanıt',
    delivery_pending: 'Bekliyor',
    delivery_succeeded: 'Başarılı',
    delivery_failed: 'Başarısız',
    delivery_dead: 'Vazgeçildi',
    emptyTitle: 'Henüz webhook yok',
    emptyLead: 'Bir program mağazadaki olaylardan anında haberdar olsun istiyorsanız adresini ekleyin.',
    emptyDeliveries: 'Henüz teslimat yok.',
    delete: 'Sil',
    confirmDelete: 'Bu adrese bildirim gönderimi durdurulsun ve kayıt silinsin mi?',
    confirmRotate:
      'Yeni bir imza sırrı üretilecek ve eskisi hemen geçersiz olacak. Karşı programdaki sırrı da güncellemeniz gerekir. Devam edilsin mi?',
    disable: 'Kapat',
    enable: 'Aç',
  },
  integrations: {
    pendingMerged: 'Kartla ödeme için iyzico bağlantısını kullanın',
    pendingDecision: 'Kurulum Gerekli: kullanma kararı ve hesap sahipte',
    log_health_check: 'Bağlantı denetimi',
    health: {
      title: 'Bağlantı denetimi',
      lead: 'Kayıtlı bağlantılar 6 saatte bir kendiliğinden denenir; yalnızca ileti göndermeyen ve ücret doğurmayan testler çalışır. Art arda iki hata Sistem Durumu’nda uyarı olur ve uyarı alıcılarına e-posta gider. Denetim bağlantının durumunu değiştirmez.',
      verify: 'Tüm bağlantıları doğrula',
      summary: '{{time}}: {{ok}} çalışıyor, {{failed}} çalışmıyor, {{skipped}} tek tek denenmeli.',
      tableCaption: 'Bağlantı denetimi sonuçları',
      colService: 'Hizmet',
      colResult: 'Sonuç',
      colDetail: 'Açıklama',
      outcome_ok: 'Çalışıyor',
      outcome_failed: 'Çalışmıyor',
      outcome_skipped: 'Tek tek deneyin',
      lastOk: 'Son denetim {{time}}: çalışıyor',
      lastFailed: 'Son denetim {{time}}: çalışmıyor — "Bağlantıyı test et" ile deneyin',
    },
    carrierViaGeliver:
      'Doğrudan bağlantı kargo firmasıyla kurumsal entegrasyon sözleşmesi ve IP izni gerektirir; bu firmayla şimdilik Geliver üzerinden gönderebilirsiniz.',
    bizimhesapSettings: 'Cari ve kasa ayarları',
    adapterPending: 'Bağlantı henüz yok (Kurulum Gerekli): firma entegrasyon bilgileri bekleniyor',
    configure: 'Yapılandır',
    manageOnGoogle: 'Google bağlantıları ekranından',
    manageOnTracking: 'Ölçümleme ekranından',
    test: 'Bağlantıyı test et',
    testOk: 'Bağlantı başarılı',
    testFail: 'Bağlantı başarısız',
    disconnect: 'Bağlantıyı kaldır',
    save: 'Bilgileri kaydet',
    saved: 'Bilgiler şifrelenerek kaydedildi. Şimdi bağlantıyı test edin.',
    environment: 'Ortam',
    env_sandbox: 'Sandbox (test)',
    env_live: 'Canlı',
    lastTested: 'Son test',
    notAvailable: 'Bu entegrasyon {{phase}}. fazda eklenecek. Şimdilik bilgi girilemez.',
    docs: 'Resmî doküman',
    logs: 'Bağlantı günlüğü',
    emptyLogs: 'Henüz kayıt yok.',
    log_test_connection: 'Bağlantı testi',
    log_mail_send: 'E-posta',
    log_mail_feedback: 'Geri dönen / şikâyet bildirimi',
    logOutcome_success: 'Başarılı',
    logOutcome_failure: 'Başarısız',
    logOutcome_blocked: "Staging'de engellendi",
    reenterSecrets:
      'Güvenlik gereği kayıtlı şifreler gösterilmez. Değiştirmek için tüm alanları yeniden girin.',
    confirmDisconnect: 'Kayıtlı bilgiler silinecek ve bu hizmet kullanılamayacak. Devam edilsin mi?',
    paymentNote:
      'Buradaki "Test" / "Canlı" yalnızca anahtarların bağlantı testinin sonucudur; vitrinde kartla ödemenin kapalı, test ya da canlı olduğu Ödeme ayarlarında görünür:',
  },
  audit: {
    when: 'Zaman',
    actor: 'Yapan',
    action: 'İşlem',
    entity: 'Kayıt',
    filterEntity: 'Kayıt türü',
    allEntities: 'Tümü',
    apply: 'Filtrele',
    clear: 'Temizle',
    loadMore: 'Daha fazla göster',
    before: 'Önce',
    after: 'Sonra',
    actor_system: 'Sistem',
    actor_customer: 'Müşteri',
    actor_api_key: 'API anahtarı',
    actor_user: 'Kullanıcı',
    empty: 'Bu filtreye uyan kayıt yok.',
    details: 'Ayrıntı',
    code: 'İşlem kodu',
    recordId: 'Kayıt kimliği',
  },
  system: {
    refresh: 'Yenile',
    checkedAt: 'Ölçüm zamanı: {{time}}',
    database: 'Veritabanı',
    services: 'Servisler',
    runStatus: { running: 'sürüyor', succeeded: 'başarılı', failed: 'başarısız' },
    redis: 'Kuyruk sunucusu',
    queues: 'Kuyruklar',
    queueName_mail: 'E-posta',
    waiting: 'Bekleyen',
    activeJobs: 'Çalışan',
    failed: 'Başarısız',
    delayed: 'Ertelenen',
    mail: 'E-posta gönderimi',
    mail_organization_smtp: 'İşletme SMTP bağlantısı',
    mail_platform_smtp: 'Platform SMTP',
    mail_not_configured: 'Kurulmamış',
    backup: 'Son yedek',
    restoreTest: 'Son geri yükleme testi',
    offsite: 'Yedeklerin uzak kopyası',
    offsiteSetup: 'Kurulum gerekli',
    offsitePending: 'Bağlı; ilk yükleme bir sonraki gece yedeğinden sonra',
    offsiteKeep: 'Depoda {{days}} gün saklanır',
    none: 'Henüz yok',
    domains: 'Alan adları ve SSL',
    ok: 'Çalışıyor',
    error: 'Hata',
    daysLeft: '{{days}} gün kaldı',
    noQueues: 'Kuyruk bilgisi alınamadı.',
    media: 'Dosya deposu (görsel ve belgeler)',
    media_ok: 'Yazılabilir',
    media_storage_permission_denied: 'Yazma izni yok',
    media_storage_disk_full: 'Disk dolu',
    media_storage_read_only: 'Salt okunur',
    media_storage_write_failed: 'Yazılamıyor',
    failedJobs: 'Başarısız arka plan işleri',
    environment: 'Ortam',
    env_staging: 'Staging (deneme sunucusu)',
    env_production: 'Canlı',
    env_development: 'Geliştirme',
    mailGuardTitle: 'Staging e-posta koruması',
    mailGuardLead:
      'Gerçek müşteri ve bayilere deneme sunucusundan e-posta gitmemesi için yalnızca izin listesindeki adreslere gönderilir. Diğer e-postalar gönderilmez; Entegrasyonlar → SMTP e-posta → Bağlantı günlüğünde "Staging\'de engellendi" olarak görünür. Canlı sunucuda bu kısıtlama yoktur.',
    mailGuardServer: 'Sunucuda tanımlı (MAIL_ALLOWLIST): {{count}} giriş',
    mailGuardList: 'Panelden izin verilen adresler',
    mailGuardListHint: 'Her satıra bir adres (ad@ornek.com) veya alan adı (@ornek.com); en çok 20.',
    mailGuardEmpty: 'İzin listesi boş: staging sunucusundan hiçbir e-posta gönderilmez.',
    mailGuardPlaceholder: 'ad@ornek.com\n@ornek.com',
    mailGuardSave: 'İzin listesini kaydet',
    mailGuardSaved: 'İzin listesi kaydedildi.',
    alertsTitle: 'Kritik durum uyarıları',
    alertsLead:
      'Yedek, geri yükleme testi, disk, iş kuyrukları, SSL sertifikaları, ödeme bildirimleri ve vitrin/panel erişimi 5 dakikada bir denetlenir. Sorun başladığında, sürerse 24 saatte bir ve düzelince e-posta gider (saatte en fazla 10).',
    alertsNone: 'Şu an süren bir sorun yok.',
    alertsResolved: 'Son 7 günde düzelen {{count}} uyarı',
    alertSince: 'başladı: {{time}}',
    alertLastMail: 'son e-posta: {{time}}',
    alertNotMailed: 'e-posta gönderilemedi (saatlik sınır veya alıcı yok)',
    alertResolvedAt: 'düzeldi: {{time}}',
    severity_critical: 'Acil',
    severity_warning: 'Uyarı',
    cspTitle: 'Vitrin içerik güvenliği ihlalleri',
    cspLead:
      'Vitrinin içerik güvenlik politikası (CSP) izin verilmeyen bir betiği, görseli, çerçeveyi veya bağlantıyı engellediğinde ziyaretçinin tarayıcısı bunu bildirir. Yeni eklenen bir etiket, video veya ödeme çerçevesi engelleniyorsa ya da sayfaya dışarıdan kod eklenmeye çalışılıyorsa burada görünür. Kişisel veri ve tarayıcı eklentilerinin bildirimleri alınmaz; {{days}} gün görülmeyen kayıt silinir.',
    cspNone: 'Son {{days}} günde bildirilen ihlal yok.',
    cspSummary: '{{rows}} farklı ihlal, toplam {{hits}} bildirim · son 24 saatte görülen: {{lastDay}}',
    cspDirective: 'Kural',
    cspBlocked: 'Engellenen kaynak',
    cspPage: 'Sayfa',
    cspHits: 'Sayı',
    cspLastSeen: 'Son görülme',
    cspReportOnly: 'yalnızca bildirim',
    cspSource: 'Kaynak: {{file}} (satır {{line}})',
    cspKeyword_inline: 'Satır içi kod (sayfaya gömülü betik veya olay işleyicisi)',
    cspKeyword_eval: 'Dinamik kod (eval)',
    'cspKeyword_wasm-eval': 'WebAssembly derlemesi',
    cspKeyword_data: 'data: adresi',
    cspKeyword_blob: 'blob: adresi',
    cspKeyword_self: 'Vitrinin kendi adresi',
    alertKinds: {
      login_failures:
        'Olağandışı başarısız giriş ({{surface}}): son {{minutes}} dakikada {{count}} deneme, {{locked}} kilitlenen hesap',
      integration: 'Bağlantı denetimi art arda başarısız: {{provider}} ({{result}})',
      backup_missing: 'Veritabanı yedeği 26 saattir alınamıyor',
      backup_failed: 'Son veritabanı yedeği başarısız',
      restore_failed: 'Yedekten geri yükleme testi başarısız',
      queue_backlog: 'İş kuyruğu birikti ({{queue}}: {{waiting}} bekliyor)',
      queue_failed: 'Başarısız işler ({{queue}}: {{failed}})',
      disk_space: 'Disk %{{usedPct}} dolu ({{freeGb}} GB boş)',
      tls: 'SSL sertifikası: {{host}} ({{days}} gün)',
      payment_hooks: 'Ödeme bildirimleri reddediliyor (son 1 saatte {{failures}})',
      uptime: '{{name}} erişilemiyor ({{result}})',
      preauth_expiring: '{{count}} siparişin ön provizyonu 20 günü geçti (en eskisi {{oldest}})',
    },
    errorTracking: 'Dış hata takibi',
    errorTrackingLive: 'Bağlı',
    errorTrackingSetup: 'Kurulum Gerekli',
    observability: 'Gözlemlenebilirlik (OpenTelemetry)',
    recipients: 'Uyarı alıcıları',
    recipientsHint:
      'Her satıra bir e-posta (en fazla 10). Boşsa işletme sahiplerine gider. Sunucuda ALERT_EMAILS tanımlıysa platform uyarıları oraya gider.',
    recipientsSave: 'Alıcıları kaydet',
    recipientsSaved: 'Uyarı alıcıları kaydedildi.',
    mailDnsTitle: 'E-posta alan adı (SPF, DKIM, DMARC)',
    mailDnsLead:
      'Bu kayıtlar alan adınızın DNS ayarlarındadır. Eksikse sipariş ve şifre e-postaları spam klasörüne düşebilir veya reddedilebilir.',
    mailDnsNone: 'Denetlenecek alan adı yok: SMTP bağlantısı veya vitrin alan adı tanımlandığında görünür.',
    mailDnsDomain: '{{domain}} ({{source}}) · denetlendi: {{time}}',
    mailDnsSource_smtp: 'SMTP gönderen adresi',
    mailDnsSource_provider: 'e-posta sağlayıcısındaki gönderen adresi',
    mailDnsSource_storefront: 'vitrin alan adı',
    mailDnsSource_query: 'elle girilen',
    dns: {
      spf: 'SPF',
      dkim: 'DKIM',
      dmarc: 'DMARC',
      spf_ok: 'Var',
      spf_missing: 'Yok — e-posta sağlayıcınızın verdiği SPF kaydını ekleyin',
      spf_multiple: 'Birden çok SPF kaydı var — tek kayıtta birleştirin (aksi hâlde geçersiz)',
      spf_unknown: 'DNS okunamadı; sonra tekrar deneyin',
      dkim_ok: 'Var',
      dkim_not_found: 'Bulunamadı — seçici biliniyorsa aşağıya yazın',
      dkim_unknown: 'DNS okunamadı; sonra tekrar deneyin',
      dmarc_ok: 'Var (koruma açık)',
      dmarc_monitoring: 'Var, yalnızca izleme (p=none)',
      dmarc_missing: 'Yok — en azından "v=DMARC1; p=none" kaydı ekleyin',
      dmarc_unknown: 'DNS okunamadı; sonra tekrar deneyin',
    },
    dkimSelector: 'DKIM seçicisi',
    dkimSelectorHint: 'E-posta sağlayıcınızın DKIM kaydındaki ad (ör. "default"); bilinmiyorsa boş bırakın.',
    dkimSelectorSave: 'Seçiciyi kaydet ve denetle',
    mailGuardTooMany: 'En çok 20 giriş yazılabilir.',
  },
  account: {
    profile: 'Profil',
    phone: 'Telefon',
    language: 'Panel dili',
    uiMode: 'Kullanım modu',
    beginner: 'Başlangıç — açıklamalar açık gelir',
    advanced: 'Gelişmiş — sade ekran',
    password: 'Şifre',
    currentPassword: 'Mevcut şifre',
    newPassword: 'Yeni şifre',
    changePassword: 'Şifreyi değiştir',
    passwordChanged: 'Şifre değiştirildi; diğer cihazlardaki oturumlar kapatıldı.',
    sessions: 'Açık oturumlar',
    thisDevice: 'Bu cihaz',
    revoke: 'Oturumu kapat',
    organizations: 'İşletmelerim',
    switchTo: 'Bu işletmeye geç',
    current: 'Şu anki',
    mobile: 'Mobil uygulama',
    browser: 'Tarayıcı',
  },
  privacy: {
    create: 'Başvuru kaydet',
    createLead:
      'E-posta, KEP, posta veya elden gelen başvuruyu kaydedin. Yanıt süresi başvurunun işletmeye ulaştığı tarihten itibaren 30 gündür.',
    created: 'Başvuru kaydedildi',
    save: 'Kaydet',
    state: 'Göster',
    states: { open: 'Açık başvurular', closed: 'Sonuçlananlar' },
    emptyOpen: 'Açık başvuru yok',
    emptyClosed: 'Sonuçlanmış başvuru yok',
    emptyLead:
      'Müşteriler vitrinde Hesabım → Kişisel verilerim bölümünden başvurabilir; e-postayla gelenleri "Başvuru kaydet" ile ekleyin.',
    overdue: 'Süresi geçti',
    daysLeft: '{{count}} gün kaldı',
    requesterName: 'Başvuran adı soyadı',
    requesterEmail: 'Başvuranın e-postası',
    kind: 'Başvuru türü',
    channel: 'Geldiği yol',
    receivedAt: 'Başvuru tarihi',
    dueAt: 'Son yanıt tarihi',
    store: 'Mağaza (e-postalarda görünen ad)',
    details: 'Başvuru metni / özeti',
    statusLabel: 'Durum',
    customer: 'Müşteri hesabı',
    noCustomer: 'Bu e-postayla hesap yok (misafir siparişleri e-postayla eşleşir)',
    resolution: 'Sonuç',
    exportedAt: 'Veriler en son indirildi',
    recordsTitle: 'Sistemdeki kayıtlar',
    records:
      '{{orders}} sipariş, {{addresses}} adres, {{favorites}} favori, {{questions}} ürün sorusu, {{companies}} bayi firması üyeliği, {{invoices}} fatura, {{acceptances}} sözleşme/aydınlatma onayı, {{messages}} iletişim mesajı, {{tickets}} destek talebi, {{chats}} canlı sohbet, {{newsletter}} bülten aboneliği, {{campaigns}} kampanya e-postası, {{automations}} otomasyon e-postası, {{stockAlerts}} stok bildirimi talebi, {{smsMessages}} SMS/WhatsApp kampanya iletisi; {{loyaltyPoints}} sadakat puanı (silmede düşer).',
    export: 'Verilerin kopyasını indir',
    exported: 'Veriler indirildi',
    erasureTitle: 'Anonimleştirme önizlemesi',
    erasureDeletes:
      'Silinir / anonimleşir: hesap (ad, e-posta, telefon, şifre; giriş kapanır), adres defteri, oturumlar, sepetler, favoriler, bayi firması üyeliği; siparişlerde e-posta, telefon, teslimat adresi (il/ilçe kalır) ve müşteri notu; ürün sorularında yazar adı. Verilmiş ileti izinleri geri alınmış olarak kaydedilir.',
    erasureKeeps:
      'Saklanır (yasal yükümlülük): sipariş tutarları ve kalemleri, fatura adresi ve faturalar, ödeme kayıtları, sözleşme ve ön bilgilendirme onay kayıtları, izin geçmişi, denetim kaydı ve bu başvurunun kaydı.',
    note: 'Başvurana yanıt',
    noteErasure: 'Başvurana yanıt (isteğe bağlı; anonimleştirmede varsayılan metin gider)',
    noteHint:
      'Sonuçlandırma ve retle başvurana e-postayla gider (e-posta kuruluysa). Retle gerekçe zorunludur.',
    startReview: 'İncelemeye al',
    complete: 'Sonuçlandır',
    reject: 'Reddet',
    anonymize: 'Anonimleştir',
    confirmEmail: 'Onaylamak için başvuranın e-postasını yazın: {{email}}',
    anonymizeConfirm: 'Kalıcı olarak anonimleştir',
    anonymized: 'Kişisel veriler anonimleştirildi',
    kinds: {
      export: 'Verilerin kopyası',
      erasure: 'Silme (anonimleştirme)',
      info: 'Bilgi talebi',
      rectification: 'Düzeltme',
      objection: 'İtiraz',
      other: 'Diğer',
    },
    channels: {
      storefront: 'Vitrin (Hesabım)',
      email: 'E-posta',
      kep: 'KEP',
      post: 'Posta',
      in_person: 'Elden',
      other: 'Diğer',
    },
    statuses: {
      received: 'Alındı',
      in_progress: 'İnceleniyor',
      completed: 'Sonuçlandı',
      rejected: 'Reddedildi',
    },
  },
  exports: {
    settingsTitle: 'Dönem ve dosya',
    settingsLead: 'Seçimler aşağıdaki tüm listeler için geçerlidir.',
    period: 'Dönem',
    periods: {
      this_month: 'Bu ay',
      last_month: 'Geçen ay',
      last_30: 'Son 30 gün',
      this_year: 'Bu yıl',
      last_year: 'Geçen yıl',
      custom: 'Tarih aralığı seç',
      all: 'Tüm zamanlar',
    },
    from: 'Başlangıç',
    to: 'Bitiş',
    range: '{{from}} – {{to}} (Türkiye saati, bitiş günü dahil)',
    rangeAll: 'Tüm kayıtlar',
    store: 'Mağaza',
    allStores: 'Tüm mağazalar',
    format: 'Dosya biçimi',
    formats: { xlsx: 'Excel (XLSX)', csv: 'CSV (noktalı virgülle)' },
    personalData: 'Kişisel veriler',
    personalDataHint: 'Açık seçilirse iki adımlı doğrulama istenir ve indirme denetim kaydında işaretlenir.',
    personalDataModes: { masked: 'Maskeli (önerilen)', full: 'Açık (tam bilgi)' },
    listsTitle: 'Listeler',
    listsLead: 'Her indirme denetim kaydına yazılır. Bir dosyada en fazla 50.000 satır olur.',
    noAccess: 'Dışa aktarabileceğiniz bir liste yok. Yöneticinizden ilgili görüntüleme yetkisini isteyin.',
    downloaded: '{{name}} indirildi.',
    stockNote: 'Bugünkü durum; dönemden bağımsız.',
    customersNote: 'Dönem kayıt tarihine uygulanır.',
    kinds: {
      orders: {
        title: 'Siparişler',
        lead: 'Her sipariş bir satır; tutarlar, KDV ve fatura bilgileriyle.',
        action: 'Siparişleri indir',
      },
      order_lines: {
        title: 'Sipariş satırları',
        lead: 'Her ürün bir satır; KDV oranı ve lot bilgisiyle.',
        action: 'Sipariş satırlarını indir',
      },
      customers: {
        title: 'Müşteriler',
        lead: 'Tür, izinler ve sipariş sayısıyla.',
        action: 'Müşterileri indir',
      },
      stock: { title: 'Stok', lead: 'Depo ve lot bazında, son kullanma tarihiyle.', action: 'Stoğu indir' },
      invoices: {
        title: 'Faturalar',
        lead: 'Fatura no, tür, KDV hariç tutar, KDV ve toplam.',
        action: 'Faturaları indir',
      },
      payments: {
        title: 'Ödemeler ve iadeler',
        lead: 'Tahsilat ve iade hareketleri; iadeler eksi tutarla.',
        action: 'Ödemeleri indir',
      },
    },
  },
  seo: {
    indexingTitle: 'Dizine açıklık',
    indexingLead: 'Arama motorlarının mağazayı görüp göremeyeceği.',
    indexOpen: 'Arama motorlarına açık',
    indexClosed: 'Arama motorlarına kapalı',
    closedStore: 'Mağaza yayında değil (önizleme). Yayına alınınca açılır.',
    closedServer: 'Mağaza yayında ama sunucuda dizine açma (SITE_INDEXING) kapalı.',
    checked: 'Denetlenen: {{products}} ürün, {{categories}} kategori, {{pages}} sayfa, {{posts}} yazı.',
    issuesTitle: 'SEO sorunları',
    issuesLead: 'Vitrinde yayında olan içerikteki eksikler. Düzelt bağlantısı ilgili ekranı açar.',
    filter: 'Sorun türü',
    filterAll: 'Tümü ({{count}} öğe)',
    noIssues: 'Bu süzgeçte sorun yok',
    noIssuesLead: 'Yayındaki içerikte bu türden eksik bulunmadı.',
    colKind: 'Tür',
    colTitle: 'Başlık',
    colIssues: 'Sorunlar',
    editItem: '{{title}} düzenle',
    more: 'İlk {{shown}} öğe gösteriliyor (toplam {{total}}).',
    kinds: { product: 'Ürün', category: 'Kategori', page: 'Sayfa', post: 'Blog yazısı' },
    issueNames: {
      title_long: 'Başlık uzun',
      title_duplicate: 'Başlık yineleniyor',
      description_missing: 'Açıklama yok',
      description_long: 'Açıklama uzun',
      description_short: 'Açıklama kısa',
      image_missing: 'Görsel yok',
      image_alt_missing: 'Alternatif metin yok',
      image_too_small: 'Ana görsel küçük',
      image_low_resolution: 'Ana görsel çözünürlüğü düşük',
      gtin_invalid: 'Barkod (GTIN) geçersiz',
      content_thin: 'İçerik zayıf',
    },
    crawl: {
      title: 'Site tarayıcısı',
      lead: 'Vitrini bir ziyaretçi gibi gezer ve teknik sorunları bulur (yalnızca kendi alan adınız).',
      start: 'Taramayı başlat',
      started: 'Tarama sıraya alındı.',
      none: 'Henüz tarama yapılmadı.',
      clean: 'Son taramada sorun bulunmadı.',
      result: '{{pages}} sayfa, {{issues}} sorun',
      truncated: 'Sayfa sınırına ulaşıldı',
      failed: 'Başarısız: {{reason}}',
      failReasons: {
        no_domain: 'Mağazanın vitrin alan adı yok',
        site_protected: 'Vitrin şifreyle korunuyor (staging); tarayıcı sayfaları okuyamaz',
        home_unreachable: 'Ana sayfaya ulaşılamadı',
        https_required: 'Vitrin adresi https değil',
        private_address: 'Alan adı iç ağ adresine çıkıyor',
        unknown: 'Beklenmeyen hata',
      },
      showingPrevious: 'Aşağıdaki sonuçlar {{time}} tarihli son tamamlanan taramadan.',
      filter: 'Sorun türü',
      filterAll: 'Tümü ({{count}})',
      tableLabel: 'Tarama sorunları',
      colSeverity: 'Önem',
      colType: 'Sorun',
      colPath: 'Adres',
      colDetail: 'Ayrıntı',
      status: { queued: 'Sırada', running: 'Taranıyor', completed: 'Tamamlandı', failed: 'Başarısız' },
      trigger: { manual: 'elle', scheduled: 'haftalık' },
      severity: { error: 'Hata', warning: 'Uyarı', info: 'Bilgi' },
      detailStatus: 'durum {{status}}',
      detailFrom: 'bağlantı veren: {{list}}',
      detailCanonical: 'canonical: {{url}}',
      detailCount: '{{count}} adet',
      detailAlso: 'aynısı: {{list}}',
      types: {
        fetch_failed: 'Sayfaya ulaşılamadı',
        server_error: 'Sunucu hatası',
        broken_link: 'Kırık bağlantı',
        sitemap_url_not_ok: 'Site haritasındaki adres açılmıyor',
        redirect_chain: 'Yönlendirme zinciri',
        redirected_link: 'Yönlendirilen bağlantı',
        title_missing: 'Başlık yok',
        title_duplicate: 'Başlık yineleniyor',
        description_missing: 'Açıklama yok',
        description_duplicate: 'Açıklama yineleniyor',
        h1_missing: 'H1 yok',
        h1_multiple: 'Birden çok H1',
        img_alt_missing: 'Alternatif metni olmayan görsel',
        canonical_mismatch: 'Canonical uyuşmuyor',
        noindex_in_sitemap: 'Site haritasında noindex sayfa',
        orphan_page: 'Yetim sayfa (bağlantı yok)',
      },
    },
    historyTitle: 'SEO değişiklik geçmişi',
    historyLead: 'SEO başlığı, açıklaması ve kısa ad değişiklikleri (son 50).',
    historyEmpty: 'Henüz SEO alanı değişikliği yok.',
    fields: { seoTitle: 'SEO başlığı', seoDescription: 'SEO açıklaması', slug: 'Kısa ad (adres)' },
  },
  merchant: {
    previewTitle: 'Feed öncesi denetim',
    previewLead:
      'Mağazada yayında ve perakende müşteriye açık ürünler denetlenir; sorunlu ürün Google’a hiç gönderilmez.',
    counts: { items: 'Gönderilecek teklif', inStock: 'Stokta', excluded: 'Gönderilmeyen ürün' },
    excludedTitle: 'Gönderilmeyen ürünler',
    warningsTitle: 'Uyarılar (gönderilir)',
    colProduct: 'Ürün',
    colReason: 'Neden',
    reasons: {
      excluded_by_user: 'Ürün ekranında kapatıldı',
      health_not_approved: 'Veteriner onayı yok veya içerik değişti',
      health_claim: 'Metinde hastalık/tedavi iddiası',
      image_missing: 'Görsel yok',
      image_too_small: 'Görseller Google için küçük (en az {{min}}×{{min}} px gerekir)',
      image_too_large: 'Görseller 64 megapikselden büyük',
      price_missing: 'Fiyat yok',
      price_not_tax_inclusive: 'Fiyat KDV hariç',
      translation_missing: 'Pazarın dilinde çeviri yok',
      tax_rate_missing: 'Pazarın ülkesi için KDV oranı yok',
      no_variants: 'Etkin varyant yok',
      country_blocked: 'Ürün bu pazarın ülkesinde satışa kapalı',
    },
    warnings: {
      gtin_missing: 'Barkod (GTIN) yok',
      description_missing: 'Açıklama yok',
      google_category_missing: 'Google ürün kategorisi yok',
      title_truncated: 'Başlık 150 karakterde kesildi',
      image_main_replaced: 'İlk görsel Google için küçük; sıradaki görsel ana görsel olarak gönderildi',
      image_below_upcoming_minimum: '31 Ocak 2027’den sonra gönderilmez: Google en az 500×500 px istiyor',
      image_below_recommended: 'Ana görsel önerilen 1500×1500 px altında',
      image_size_unknown: 'Ana görselin boyutu bilinmiyor',
    },
    imageSize: 'ilk görsel {{size}} px',
    feedTitle: 'Feed dosyası',
    feedLead:
      'Merchant Center’da "Ürünler → Veri kaynakları → Dosya → Zamanlanmış getirme" ile bu adresi girin; Google dosyayı her gün alır. Google bağlantısı gerekmez.',
    feedEnabled: 'Feed dosyası açık',
    feedSaved: 'Kaydedildi.',
    previewMarket: 'Pazar',
    marketsTitle: 'Pazarlar (ülke ve dil)',
    marketsLead:
      'Google’a gönderilen her pazarın ayrı feed’i ve Merchant API veri kaynağı olur: fiyat o pazarın para birimi ve listesinden, ad ve açıklama pazarın dilinde, kargo o ülkenin yöntemleri.',
    marketsSaved: 'Pazarlar kaydedildi.',
    defaultMarket: 'Varsayılan',
    marketFeedUrl: '{{market}} feed adresi',
    marketsNote:
      'Her pazarı Merchant Center’da ayrı veri kaynağı olarak (ülke ve dil seçerek) ekleyin; Merchant API senkronunda kaynaklar kendiliğinden açılır. En az bir pazar seçili kalır.',
    feedUrl: 'Feed adresi',
    lastFetch: 'Son getirme: {{time}} ({{count}} teklif)',
    neverFetched: 'Henüz getirilmedi.',
    rotate: 'Adresi yenile',
    rotateConfirm:
      'Eski adres hemen geçersiz olur; Merchant Center’daki adresi yenisiyle değiştirmeniz gerekir.',
    apiTitle: 'Merchant API',
    apiLead:
      'Google bağlantısıyla ürünler doğrudan gönderilir; Google’daki onay durumu ve ret nedenleri buraya gelir.',
    notLinked: 'Merchant Center hesabı seçilmedi',
    notLinkedLead:
      'Google bağlantıları ekranında Merchant Center izniyle bağlanıp bu mağaza için hesabı seçin.',
    lastSync: 'Son senkron: {{time}}',
    neverSynced: 'Henüz senkron yapılmadı',
    status: { approved: 'Onaylı', pending: 'İnceleniyor', disapproved: 'Reddedildi' },
    syncNow: 'Şimdi gönder',
    synced: '{{inserted}} gönderildi, {{deleted}} silindi, {{unchanged}} değişmedi.',
    issuesTitle: 'Google’daki sorunlar',
    issuesLead: 'Reddedilen veya uyarı alan teklifler; Google’ın açıklaması ve belge bağlantısıyla.',
    perfTitle: 'Ürün performansı',
    perfLead:
      'Ürünlerinizin Google’daki ücretsiz listeleme ve alışveriş reklamı gösterim ve tıklamaları. Merchant Center’dan istek anında okunur.',
    perfPeriod: 'Dönem',
    perfLastDays: 'Son {{n}} gün',
    perfTotals: 'Dönem toplamları',
    perfProduct: 'Ürün',
    perfOrganicClicks: 'Ücretsiz tıklama',
    perfOrganicImpressions: 'Ücretsiz gösterim',
    perfAdsClicks: 'Reklam tıklaması',
    perfAdsImpressions: 'Reklam gösterimi',
    perfConversions: 'Dönüşüm (ücretsiz)',
    perfEmpty: 'Bu dönemde Google’da gösterim yok.',
    perfNote:
      'Dün dahil. Google dönüşümü yalnızca ücretsiz listelemede bildirir; reklam harcaması ve gerçek sipariş geliri Reklam merkezinde.',
    colOffer: 'Teklif (stok kodu)',
    colStatus: 'Durum',
    colIssue: 'Sorun',
    docs: 'Google belgesi',
  },
  attribution: {
    builderTitle: 'Kampanya bağlantısı oluştur',
    builderLead:
      'Reklam, e-posta, sosyal medya ve QR kodlarında kullanacağınız bağlantıya kaynak bilgisi (UTM) ekler. Siparişler aşağıdaki raporda bu bilgilerle gruplanır.',
    url: 'Sayfa adresi',
    fields: {
      source: 'Kaynak (utm_source)',
      medium: 'Ortam (utm_medium)',
      campaign: 'Kampanya (utm_campaign)',
      term: 'Anahtar kelime (utm_term)',
      content: 'İçerik (utm_content)',
    },
    result: 'Kampanya bağlantısı',
    resultEmpty: 'Adres, kaynak, ortam ve kampanyayı girin',
    copy: 'Kopyala',
    copied: 'Bağlantı kopyalandı.',
    builderNote:
      'Değerler küçük harfe ve Türkçe karakterler Latin harflerine çevrilir (ör. "Ekim Bülteni" → ekim-bulteni): aynı kampanya raporda tek satırda toplanır.',
    reportTitle: 'Kaynağa göre siparişler',
    reportLead:
      'Gerçek siparişler (taslak ve iptal hariç), siparişin geldiği kaynağa göre. Ciro yalnızca ödemesi alınan siparişlerden; iade ayrı gösterilir.',
    period: 'Dönem',
    lastDays: 'Son {{n}} gün',
    model: 'Temas',
    models: { last: 'Son temas', first: 'İlk temas' },
    dimension: 'Kırılım',
    dimensions: { source_medium: 'Kaynak / ortam', campaign: 'Kampanya' },
    colSource: 'Kaynak',
    colMedium: 'Ortam',
    colCampaign: 'Kampanya',
    colOrders: 'Sipariş',
    colPaid: 'Ödenen',
    colRevenue: 'Ciro (ödenen)',
    colRefunded: 'İade',
    colNet: 'Net',
    noConsent: 'Bilinmiyor (çerez izni yok)',
    direct: 'Doğrudan / bilinmiyor',
    noCampaign: 'Kampanyasız',
    empty: 'Bu dönemde sipariş yok.',
    reportNote:
      'Kaynak bilgisi yalnızca ziyaretçi analitik veya pazarlama çerezlerine izin verdiyse kaydedilir; izin vermeyenlerin siparişleri "Bilinmiyor" satırında sayılır.',
  },
  webVitals: {
    statusTitle: 'Ölçüm',
    statusLead:
      'Ana sayfa, bir kategori, bir ürün ve bir blog yazısı mobil ve masaüstünde Google PageSpeed Insights ile ölçülür. Yayındaki mağazalar her pazartesi kendiliğinden ölçülür.',
    notConfigured: 'PageSpeed Insights anahtarı yok',
    notConfiguredLead:
      'Google Cloud’da ücretsiz bir API anahtarı oluşturup Entegrasyonlar → PageSpeed Insights’a girin ve bağlantıyı test edin.',
    start: 'Şimdi ölç',
    running: 'Ölçülüyor…',
    started: 'Ölçüm başladı; birkaç dakika sürebilir.',
    lastRun: 'Son ölçüm: {{time}}',
    neverRun: 'Henüz ölçülmedi.',
    resultsTitle: 'Son ölçüm sonuçları',
    resultsLead:
      'Puan: Lighthouse laboratuvar ölçümü (0–100). LCP, INP ve CLS: gerçek ziyaretçilerin son 28 günlük deneyimi (Chrome kullanıcı raporu); Google sıralamada bunu kullanır.',
    colPage: 'Sayfa',
    colDevice: 'Cihaz',
    colScore: 'Puan',
    colLcp: 'LCP',
    colInp: 'INP',
    colCls: 'CLS',
    thresholds:
      'İyi: LCP ≤ 2,5 sn, INP ≤ 200 ms, CLS ≤ 0,1. Kötü: LCP > 4 sn, INP > 500 ms, CLS > 0,25. Puan: 90+ iyi, 50–89 geliştirilmeli.',
    templates: { home: 'Ana sayfa', category: 'Kategori', product: 'Ürün', post: 'Blog yazısı' },
    strategies: { mobile: 'Mobil', desktop: 'Masaüstü' },
    ratings: { good: 'İyi', needs_improvement: 'Geliştirilmeli', poor: 'Kötü' },
    change: 'Öncekine göre {{n}}',
    scopes: {
      url: 'Bu sayfanın verisi',
      origin: 'Sitenin geneli (sayfa için yeterli veri yok)',
      none: 'Yeterli ziyaretçi verisi yok',
    },
    fieldLine: 'Saha verisi: {{scope}}',
    labLine: 'Laboratuvar: LCP {{lcp}} sn, TBT {{tbt}} ms, CLS {{cls}}',
    units: { s: '{{n}} sn', ms: '{{n}} ms' },
    runsTitle: 'Son ölçümler',
    runStatus: { queued: 'Sırada', running: 'Ölçülüyor', completed: 'Tamamlandı', failed: 'Başarısız' },
    triggers: { manual: 'Elle', scheduled: 'Haftalık' },
    errors: {
      psi_page_failed: 'Sayfa açılamadı (vitrin parolalı veya erişilemiyor olabilir)',
      psi_key_invalid: 'API anahtarı kabul edilmedi',
      psi_quota: 'Günlük kota doldu',
      psi_timeout: 'Ölçüm zaman aşımına uğradı',
      psi_unreachable: 'PageSpeed Insights’a ulaşılamadı',
      pagespeed_not_configured: 'Anahtar girilmemiş',
      store_has_no_domain: 'Mağazanın alan adı yok',
      unknown: 'Ölçüm başarısız',
    },
  },
  attributes: {
    title: 'Ürün özellikleri',
    lead: 'Ürünlerin teknik özellikleri (ör. net ağırlık, yaş grubu, aroma). Değerler ürün ekranında girilir; görünenler ürün sayfasındaki "Teknik özellikler" tablosunda çıkar.',
    add: 'Özellik ekle',
    edit: 'Özelliği düzenle',
    editItem: '{{name}} özelliğini düzenle',
    saved: 'Özellik kaydedildi',
    deleted: 'Özellik silindi',
    deleteConfirm: '"{{name}}" silinsin mi? {{count}} üründeki değeri de silinir.',
    emptyTitle: 'Henüz özellik yok',
    emptyLead: 'Ör. "Net ağırlık" (sayı, kg) veya "Yaş grubu" (seçenek: yavru, yetişkin, yaşlı) ekleyin.',
    name: 'Ad',
    code: 'Kısa kod',
    type: 'Tür',
    types: {
      text: 'Metin',
      number: 'Sayı',
      select: 'Seçenek (tek)',
      multiselect: 'Seçenek (birden çok)',
      boolean: 'Evet / hayır',
    },
    unit: 'Birim',
    options: 'Seçenekler',
    optionsPlaceholder: 'Her satıra bir seçenek',
    where: 'Nerede görünür',
    onProductPage: 'Ürün sayfası',
    inFilters: 'Süzgeç',
    internal: 'Yalnızca panel',
    productCount: 'Ürün',
    visible: 'Ürün sayfasında göster',
    filterable: 'Vitrin süzgeçlerinde göster',
    position: 'Sıra',
    tagsTitle: 'Kullanılan etiketler',
    tagsLead:
      'Ürünlere verilmiş etiketler ve ürün sayısı. Etiketler ürün ekranında girilir; vitrinde görünmez.',
    noTags: 'Henüz etiket yok.',
  },
  collections: {
    title: 'Koleksiyonlar',
    lead: 'Elle seçtiğiniz veya kurala uyan ürün grupları (ör. "Yavru kedi ürünleri"). Kurallı koleksiyon, ürünler değiştikçe kendiliğinden güncellenir.',
    add: 'Yeni koleksiyon',
    emptyTitle: 'Henüz koleksiyon yok',
    emptyLead:
      'Elle ürün seçerek veya kategori, marka, etiket, tür ve özelliklere göre kural yazarak oluşturun.',
    name: 'Ad',
    kind: 'Tür',
    kinds: { manual: 'Elle seçim', rule: 'Kurallı' },
    kindChoice: { manual: 'Ürünleri elle seçeceğim', rule: 'Kurala uyan ürünler' },
    status: 'Durum',
    statuses: { active: 'Etkin', hidden: 'Gizli' },
    productCount: 'Ürün',
    saved: 'Koleksiyon kaydedildi',
    deleted: 'Koleksiyon silindi',
    deleteConfirm: '"{{title}}" koleksiyonu silinsin mi? Ürünler silinmez.',
    backToList: 'Koleksiyonlara dön',
    basics: 'Temel bilgiler',
    slug: 'Kısa ad (adres)',
    description: 'Açıklama',
    seoTitle: 'SEO başlığı',
    seoDescription: 'SEO açıklaması',
    productsTitle: 'Ürünler',
    pickProducts: 'Ürün ekle',
    matchesTitle: 'Eşleşen ürünler: {{count}}',
    matchesLead: 'Kayıtlı koleksiyondaki ürünler (her durumdaki; vitrinde yalnızca yayındakiler görünür).',
    previewLead: 'Önizleme: kural henüz kaydedilmedi.',
    noMatches: 'Eşleşen ürün yok.',
    match: 'Koşullar',
    matchAll: 'Tüm koşullar sağlansın',
    matchAny: 'Koşullardan biri yeterli',
    conditions: 'Koşul listesi',
    field: 'Alan',
    fields: {
      category: 'Kategori',
      brand: 'Marka',
      tag: 'Etiket',
      species: 'Tür (hayvan)',
      attribute: 'Özellik',
    },
    attribute: 'Özellik',
    op: 'Karşılaştırma',
    ops: { is: 'eşittir', is_not: 'eşit değildir', gte: 'en az', lte: 'en çok' },
    value: 'Değer',
    choose: 'Seçin',
    addCondition: 'Koşul ekle',
    removeCondition: 'Koşulu kaldır',
    preview: 'Eşleşenleri göster',
  },
  siteSearch: {
    reportTitle: 'Arama raporu',
    reportLead:
      'Vitrinde yapılan aramalar (her arama sayfasının ilk görüntülenmesi bir arama sayılır). Kişi bilgisi tutulmaz.',
    period: 'Dönem',
    lastDays: 'Son {{days}} gün',
    emptyTitle: 'Bu dönemde arama yok',
    emptyLead: 'Ziyaretçiler vitrinde arama yaptıkça burada görünür.',
    totalSearches: 'Toplam arama',
    distinctQueries: 'Farklı arama',
    zeroResultSearches: 'Sonuçsuz arama',
    topTitle: 'En çok arananlar',
    zeroTitle: 'Sonuçsuz kalan aramalar',
    noZero: 'Sonuçsuz kalan arama yok.',
    noResults: 'Sonuç yok',
    colQuery: 'Arama',
    colSearches: 'Sayı',
    colResults: 'Son sonuç',
    synonymsTitle: 'Eş anlamlılar',
    synonymsLead:
      'Gruptaki kelimeler birbirinin yerine aranır (ör. mama, yem). Sonuçsuz aramalar için kullanışlıdır.',
    addSynonym: 'Eş anlamlı ekle',
    editSynonym: 'Eş anlamlıları düzenle',
    editSynonymItem: '{{terms}} grubunu düzenle',
    deleteSynonymConfirm: '{{terms}} grubu silinsin mi?',
    synonymSaved: 'Eş anlamlılar kaydedildi',
    synonymDeleted: 'Eş anlamlı grubu silindi',
    noSynonyms: 'Henüz eş anlamlı grubu yok.',
    terms: 'Kelimeler',
    termsPlaceholder: 'Virgülle ayırın: mama, yem, besin',
  },
  keywords: {
    alertsTitle: 'Uyarılar',
    alertsLead:
      'Son 28 günün Search Console verisinden: aynı aramada birbiriyle yarışan sayfalar ve hedef sayfası olmayan kelimeler.',
    noAlerts: 'Uyarı yok.',
    none: 'Yok.',
    cannibalTitle: 'Kanibalizasyon',
    gapTitle: 'İçerik boşluğu',
    gapReasons: { no_target: 'Hedef sayfa yok', target_not_found: 'Hedef sayfa yayında değil' },
    inPool: 'Havuzda',
    target: 'Hedef',
    pageStats: '{{impressions}} gösterim, {{clicks}} tıklama, konum {{position}}',
    poolTitle: 'Anahtar kelime havuzu',
    poolLead: 'Mağazanın hedeflediği aramalar ve son 28 günün Search Console değerleri.',
    add: 'Kelime ekle',
    edit: 'Kelimeyi düzenle',
    editItem: '{{keyword}} kelimesini düzenle',
    saved: 'Kaydedildi.',
    deleted: 'Silindi.',
    deleteConfirm: '"{{keyword}}" havuzdan silinsin mi?',
    cluster: 'Küme',
    allClusters: 'Tüm kümeler',
    language: 'Dil',
    allLanguages: 'Tüm diller',
    search: 'Ara',
    emptyTitle: 'Havuzda kelime yok',
    emptyLead: '"Kelime ekle" ile ekleyin veya aşağıdaki Search Console önerilerinden seçin.',
    colKeyword: 'Kelime',
    colTarget: 'Hedef sayfa',
    colClicks: 'Tıklama',
    colImpressions: 'Gösterim',
    colPosition: 'Ort. konum',
    colTopPage: 'En çok gösterim alan sayfa',
    cannibalized: 'Kanibalizasyon',
    targetStatus: {
      ok: 'Yayında',
      missing: 'Hedef yok',
      not_found: 'Yayında değil',
      unverified: 'Denetlenemedi',
    },
    intents: {
      informational: 'Bilgi',
      commercial: 'Araştırma',
      transactional: 'Satın alma',
      navigational: 'Marka / yön bulma',
    },
    metricsNote:
      'Tıklama, gösterim ve konum son 28 günün Search Console verisidir (Google verisi yaklaşık 2 gün gecikmeli).',
    keyword: 'Kelime',
    intent: 'Arama niyeti',
    intentNone: 'Belirtilmedi',
    targetPath: 'Hedef sayfa',
    notes: 'Not',
    candidatesTitle: 'Search Console önerileri',
    candidatesLead:
      'Havuzda olmayan, son 28 günde en çok gösterim alan aramalar. Seçip havuza ekleyin; hedef sayfa en çok gösterim alan sayfadan önerilir.',
    notSynced: 'Search Console verisi henüz yok. Arama performansı ekranından mülk seçip senkronize edin:',
    noCandidates: 'Yeni öneri yok; tüm aramalar havuzda.',
    candidateStats: '{{impressions}} gösterim, {{clicks}} tıklama, konum {{position}}',
    importCluster: 'Küme',
    importSelected: 'Seçilenleri ekle ({{n}})',
    imported: '{{created}} kelime eklendi, {{skipped}} zaten vardı.',
    rankTitle: 'Sıralama takibi',
    rankLead:
      'Kelimelerin Google sıralamasını günlük izlemek lisanslı (ücretli) bir veri sağlayıcı gerektirir; sağlayıcı seçilip anahtar girilene kadar "Kurulum Gerekli". Şimdilik konum, Search Console ortalamasıdır.',
  },
  scSetup: {
    title: "Google'a bağlan ve kur",
    lead: "Tek düğme: sistem vitrin alan adının ve eski alan adlarının Search Console mülklerini kendisi doğrular ve ekler, site haritasını gönderir, eski sitenin Google'da görünen sayfalarını yeni adreslere eşler. Her sabah ürün sayfalarının ve örnek eski adreslerin Google'daki durumunu denetler.",
    connectedAs: 'Bağlı Google hesabı: {{email}}',
    notConnected: 'Google hesabı bağlı değil.',
    missingScope: 'Site doğrulama izni yok: "Google\'a bağlan" ile izni verin.',
    connect: "Google'a bağlan",
    run: 'Kurulumu çalıştır',
    rerun: 'Kurulumu yeniden çalıştır',
    done: 'Search Console kurulumu tamamlandı',
    siteOk: "Doğrulandı ve Search Console'a eklendi",
    siteVerifiedOnly: "Doğrulandı; Search Console'a eklenemedi",
    siteFailed: '{{step}} adımında durdu: {{reason}}',
    enableApi:
      'Google Cloud projesinde "{{api}}" etkinleştirilmeli (ücretsiz); sonra Kurulumu yeniden çalıştır.',
    enableApiLink: 'Etkinleştirme sayfasını aç',
    sitePending: 'Henüz kurulmadı',
    lastRun: 'Son kurulum: {{date}}',
    sitemapOk: 'Site haritası gönderildi: {{url}}',
    sitemapFailed: 'Site haritası gönderilemedi: {{reason}}',
    sitemapSkipped: 'Site haritası gönderilmedi (vitrin mülkü eklenemedi).',
    legacyPages:
      "Eski mülklerde Google'da görünen {{found}} sayfa: {{matched}} yeni eşleşme, {{table}} zaten yönlendiriliyor, {{fallback}} karşılıksız (Kırık linkler).",
    publishNote:
      'Bağlantının kalıcı olması için Google Cloud\'daki OAuth uygulaması "Üretimde" (In production) olmalı; "Test" durumundaki uygulamanın izni 7 günde düşer.',
    inspectionsTitle: 'Google dizin durumu (günlük URL denetimi)',
    inspectionsEmpty: 'Henüz denetim yok. Kurulumdan sonraki sabah ilk sonuçlar burada görünür.',
    colUrl: 'Adres',
    colKind: 'Tür',
    colState: "Google'daki durum",
    colCrawl: 'Son tarama',
    checkedAt: 'denetlendi: {{date}}',
    roles: {
      store: 'Vitrin',
      legacy: 'Eski alan adı',
    },
    kinds: {
      product: 'Ürün sayfası',
      legacy: 'Eski adres',
    },
    steps: {
      token: 'Doğrulama dosyası',
      verify: 'Doğrulama',
      add: "Search Console'a ekleme",
      link: 'Bağlama',
      sitemap: 'Site haritası',
      pages: 'Eski sayfalar',
    },
  },
  indexNow: {
    title: 'IndexNow (Bing, Yandex)',
    lead: "Değişen ürün, kategori, sayfa ve makale adresleri Bing ve Yandex'e on dakikada bir kendiliğinden bildirilir; ilk çalışmada tüm adresler bir kez gönderilir.",
    notLive: 'Mağaza yayında değil: bildirim gönderilmez.',
    indexingOff: 'Sunucuda arama motorlarına açma kapalı: bildirim gönderilmez.',
    key: 'Anahtar: {{key}} (dosyası sitede yayında)',
    noKey: 'Anahtar ilk bildirimde oluşturulur.',
    last: 'Son bildirim: {{date}} · {{count}} adres',
    never: 'Henüz bildirim yapılmadı.',
    failed: 'Bildirim başarısız: {{reason}}',
    sent: "{{count}} adres IndexNow'a gönderildi",
    submit: 'Tüm adresleri şimdi gönder',
    skipped: {
      not_live: 'Mağaza yayında değil.',
      indexing_off: 'Arama motorlarına açma kapalı.',
      no_domain: 'Mağazanın alan adı yok.',
      nothing_changed: 'Gönderilecek adres yok.',
    },
  },
  sc: {
    notLinked: 'Search Console mülkü seçilmedi',
    notLinkedLead:
      'Google hesabınızı bağlayıp bu mağaza için Search Console mülkünü seçin; veriler ertesi sabah (veya "Şimdi senkronize et" ile) gelir.',
    statusTitle: 'Bağlı mülk',
    lastSync: 'Son senkron: {{time}}',
    neverSynced: 'Henüz senkron yapılmadı',
    dataRange: 'Veri: {{from}} – {{to}}',
    syncNow: 'Şimdi senkronize et',
    synced: 'Senkron tamamlandı ({{rows}} satır).',
    noData:
      'Henüz veri yok. "Şimdi senkronize et" ile çekin; yeni mülklerde Google verisi birkaç gün sonra oluşur.',
    summaryTitle: 'Özet',
    period: 'Dönem',
    lastDays: 'Son {{count}} gün',
    metrics: { clicks: 'Tıklama', impressions: 'Gösterim', ctr: 'Tıklama oranı', position: 'Ortalama konum' },
    vsPrevious: 'Önceki döneme göre {{change}}',
    chartLabel: 'Günlük tıklama grafiği',
    chartCaption: 'Günlük tıklama (Google verisi yaklaşık 2 gün gecikmeli).',
    tableTitle: 'Ayrıntı',
    dimension: 'Göster',
    dims: { query: 'Sorgular', page: 'Sayfalar', country: 'Ülkeler', device: 'Cihazlar' },
    devices: { mobile: 'Mobil', desktop: 'Masaüstü', tablet: 'Tablet' },
    filter: 'Ara',
    noRows: 'Bu dönemde kayıt yok.',
    moversTitle: 'Yükselen ve düşen sayfalar',
    moversLead: 'Son dönemin tıklamaları önceki eşit döneme göre.',
    rising: 'Yükselen',
    falling: 'Düşen',
    noMovers: 'Kayda değer değişiklik yok.',
    notComparable:
      'Karşılaştırma için önceki dönemin verisi henüz yok (Search Console verisi her gün birikir).',
    sitemapsTitle: 'Site haritaları',
    sitemapsLead: 'Search Console’a gönderilmiş site haritaları ve durumları.',
    sitemapsError: 'Site haritaları okunamadı; Google bağlantısını test edin.',
    noSitemaps: 'Henüz site haritası gönderilmedi.',
    colSitemap: 'Site haritası',
    colSubmitted: 'Gönderim',
    colStatus: 'Durum',
    colUrls: 'Adres',
    sitemapPending: 'İşleniyor',
    sitemapOk: 'İşlendi',
    sitemapErrors: '{{count}} hata',
    ownSitemap: 'Mağazanın site haritası:',
    notInProperty: 'Mülkün kapsamında değil',
    submitSitemap: 'Site haritasını gönder',
    sitemapSubmitted: 'Site haritası Search Console’a gönderildi.',
    inspectTitle: 'URL denetimi',
    inspectLead: 'Bir sayfanın Google dizinindeki durumu (Search Console URL denetimi).',
    inspectUrl: 'Sayfa adresi',
    inspect: 'Denetle',
    quota: 'Bugün {{used}} / {{limit}} denetim kullanıldı.',
    verdicts: {
      PASS: 'Dizinde',
      PARTIAL: 'Kısmen (uyarılarla)',
      FAIL: 'Dizinde değil (hata)',
      NEUTRAL: 'Dizinde değil',
      VERDICT_UNSPECIFIED: 'Bilinmiyor',
    },
    inspectFields: {
      verdict: 'Sonuç',
      coverageState: 'Kapsam',
      indexingState: 'Dizine eklenme izni',
      robotsTxtState: 'robots.txt',
      pageFetchState: 'Sayfa alma',
      lastCrawlTime: 'Son tarama',
      googleCanonical: 'Google’ın seçtiği canonical',
    },
    digestTitle: 'Haftalık e-posta özeti',
    digestLead:
      'Her pazartesi 09:00’da uyarı alıcılarına son 7 günün arama özeti, en çok tıklanan sorgular, yükselen/düşen sayfalar ve son site taraması.',
    digestToggle: 'Haftalık e-posta özeti',
    digestSaved: 'Kaydedildi.',
  },
  google: {
    connected: 'Google hesabı bağlandı.',
    clientTitle: 'OAuth istemcisi',
    clientLead:
      'Google Cloud Console’da açtığınız OAuth istemcisi. Kimlik ve gizli anahtar Entegrasyonlar ekranında şifreli saklanır.',
    clientOk: 'Doğrulandı',
    clientMissing:
      'Önce Entegrasyonlar → Google hesabı (OAuth istemcisi) bölümüne istemci kimliği ve gizli anahtarı girip test edin.',
    toIntegrations: 'Entegrasyonlara git',
    redirectUri: 'Yetkili yönlendirme adresi',
    copy: 'Kopyala',
    copied: 'Adres kopyalandı.',
    accountTitle: 'Google hesabı',
    accountLead: 'Seçtiğiniz hizmetler için Google’ın izin ekranında onay verirsiniz; parolanız bize gelmez.',
    account: 'Bağlı hesap',
    connectedAt: 'Bağlandığı zaman',
    lastChecked: 'Son kontrol',
    notConnected: 'Henüz Google hesabı bağlanmadı.',
    chooseServices: 'Bağlanacak hizmetler',
    permissionsTitle: 'Verilen izinler',
    granted: 'İzin verildi',
    notGranted: 'İzin yok',
    connect: 'Google ile bağlan',
    reconnect: 'Yeniden bağlan',
    test: 'Bağlantıyı test et',
    testOk: 'Bağlantı çalışıyor.',
    testFailed: 'Bağlantıda sorun var; ayrıntı günlükte.',
    disconnect: 'Bağlantıyı kaldır',
    disconnectConfirm:
      'Google erişimi iptal edilecek ve mağazalara seçilen mülk/hesaplar silinecek. Yeniden bağlanıp seçmeniz gerekir.',
    disconnected: 'Bağlantı kaldırıldı ve Google’da erişim iptal edildi.',
    disconnectedLocal:
      'Bağlantı kaldırıldı; Google’a ulaşılamadığı için erişimi Google hesabınızdan (Güvenlik → Üçüncü taraf erişimi) ayrıca kaldırın.',
    status: { active: 'Etkin', error: 'Hata' },
    errors: {
      token_revoked: 'Erişim Google tarafında kaldırılmış; yeniden bağlanın.',
      userinfo_failed: 'Hesap bilgisi okunamadı.',
      resource_not_accessible: 'Bu kaynağa artık erişilemiyor.',
      insufficient_scope: 'İzin verilmemiş.',
      permission_denied: 'Bu kaynağa erişim yok.',
      api_not_enabled: 'Cloud projesinde API etkin değil.',
      unauthorized: 'Yetki reddedildi.',
      quota_exceeded: 'Google kotası doldu; sonra tekrar denenecek.',
      http_error: 'Google isteği reddetti.',
      network: 'Google’a ulaşılamadı.',
      timeout: 'Google zamanında yanıt vermedi.',
    },
    services: {
      search_console: 'Search Console',
      analytics: 'Google Analytics 4',
      merchant_center: 'Merchant Center',
      google_ads: 'Google Ads',
      business_profile: 'Google Business Profile',
    },
    serviceLeads: {
      search_console: 'Arama sorguları, sayfa performansı, site haritası gönderimi.',
      analytics: 'Mülk listesi ve raporlar (salt okuma).',
      merchant_center: 'Ürün verisi gönderimi ve ürün durumları.',
      google_ads:
        'Reklam harcaması (reklam merkezine) ve isteğe bağlı dönüşüm yükleme. Geliştirici jetonu gerekmez; gerçek hesap için Cloud projesinde Explorer erişimi gerekir.',
      business_profile: 'İşletme konumu bilgileri ve Google yorumları (yalnızca okuma).',
    },
    resourcesTitle: 'Mağaza kaynakları',
    resourcesLead:
      'Her mağaza için hangi Search Console mülkü, GA4 mülkü, Merchant Center hesabı, Google Ads müşteri hesabı ve Business Profile konumunun kullanılacağı.',
    notLinked: 'Seçilmedi.',
    serviceNotGranted: 'Bu hizmet için izin verilmedi; hizmeti seçip yeniden bağlanın.',
    choose: 'Seç',
    change: 'Değiştir',
    unlink: 'Kaldır',
    linked: 'Kaynak kaydedildi.',
    unlinked: 'Kaynak bağlantısı kaldırıldı.',
    resourceLabel: '{{service}} kaynağı',
    pick: 'Seçin',
    noResources:
      'Bu Google hesabının erişebildiği kaynak yok. Google tarafında hesaba yetki verin ve listeyi yenileyin.',
    lastSync: 'Son senkron: {{time}}',
    noSyncYet: 'Henüz senkron yapılmadı',
    logsTitle: 'Günlük',
    logsLead: 'Son 50 işlem. Jeton ve kişisel veri yazılmaz.',
    noLogs: 'Henüz kayıt yok.',
    colTime: 'Zaman',
    colOperation: 'İşlem',
    colOutcome: 'Sonuç',
    colDetail: 'Ayrıntı',
    logError: 'Hata: {{code}}',
    operations: {
      oauth_start: 'Bağlantı başlatıldı',
      oauth_callback: 'Google dönüşü',
      token_refresh: 'Jeton yenileme',
      list_resources: 'Kaynak listesi',
      verify_resource: 'Hesap erişim denetimi',
      test: 'Bağlantı testi',
      revoke: 'Erişim iptali',
    },
    outcomes: { success: 'Başarılı', failure: 'Başarısız', blocked: 'Engellendi' },
  },
  tracking: {
    crossDomain: {
      title: 'Alanlar arası izleme',
      lead: 'Mağazanın birden çok vitrin alan adı varsa ziyaretçi bunlar arasında geçerken aynı ziyaretçi ve aynı kaynak (kampanya) olarak ölçülür.',
      active: 'Etkin',
      inactive: 'Gerekmiyor',
      activeLead: '{{count}} alan adı arasında GA4 bağlayıcısı ve kaynak bilgisi taşınıyor.',
      reasons: {
        single_domain: 'Mağazanın tek vitrin alan adı var; ikinci alan adı eklenince kendiliğinden açılır.',
        no_google_tag: 'GA4 ölçüm kimliği veya GTM konteyneri girilmemiş.',
      },
      toDomains: 'Alan adlarına git',
      domains: 'Alanlar arası izlemedeki alan adları',
      stepsTitle: 'Yapılacaklar',
      stepAuto:
        'Vitrin bu alan adları arasındaki bağlantılara GA4 bağlayıcı parametresini ve kaynak bilgisini kendiliğinden ekler; bu alan adlarından gelmek yönlendiren site sayılmaz.',
      stepGa4:
        "Google Analytics'te Yönetici → Veri akışları → web akışı → Etiket ayarlarını yapılandırın → Alan adlarınızı yapılandırın (Admin → Data streams → Configure tag settings → Configure your domains) bölümüne bu alan adlarını ekleyin. GTM kullanıyorsanız bu adım gereklidir.",
      stepReferrals:
        'Geçişlerin raporda yönlendirme olarak görünmemesi için gerekirse aynı yerdeki "İstenmeyen yönlendirmeleri listeleyin" (List unwanted referrals) bölümüne de ekleyin.',
      stepConsent:
        'Çerez onayı alan adı başınadır: ziyaretçi diğer alan adında yeniden sorulur; kaynak bilgisi orada yalnızca izin verilirse yazılır.',
    },
    server: {
      title: 'Sunucu taraflı olaylar',
      lead: 'Gerçekleşen satış ve iadeler tarayıcıdan bağımsız olarak sunucudan da gönderilir: havale ve kapıda ödeme siparişleri ile reklam engelleyicisi olan ziyaretçilerin satışları da ölçülür. Ziyaretçinin sipariş anındaki çerez onayına uyulur.',
      providers: {
        ga4: 'Google Analytics 4 (Measurement Protocol)',
        meta: 'Meta (Conversions API)',
        tiktok: 'TikTok (Events API)',
      },
      short: { ga4: 'GA4', meta: 'Meta', tiktok: 'TikTok' },
      status: {
        live: 'Açık',
        off: 'Kapalı',
        needs_secret: 'Kurulum Gerekli',
        needs_id: 'Kimlik yok',
      },
      needsId: {
        ga4: 'Önce yukarıdaki Vitrin etiketleri bölümüne GA4 ölçüm kimliğini girin.',
        meta: 'Önce yukarıdaki Vitrin etiketleri bölümüne Meta piksel kimliğini girin.',
        tiktok: 'Önce yukarıdaki Vitrin etiketleri bölümüne TikTok piksel kimliğini girin.',
      },
      secret: {
        ga4: 'API gizli anahtarı (Measurement Protocol)',
        meta: 'Erişim jetonu (Conversions API)',
        tiktok: 'Erişim jetonu (Events API)',
      },
      secretSaved: 'Kayıtlı — değiştirmek için yenisini girin',
      testCode: 'Test olayı kodu',
      enabled: 'Sunucu olaylarını gönder',
      save: 'Kaydet',
      saved: 'Kaydedildi.',
      test: 'Test olayı gönder',
      testOk: 'Test olayı sağlayıcıya ulaştı.',
      testFailed: 'Test başarısız: {{reason}}',
      remove: 'Anahtarı kaldır',
      removeConfirm: 'Anahtar silinir ve bu sağlayıcıya sunucu olayı gönderimi durur.',
      last24h:
        'Son 24 saat: {{sent}} gönderildi, {{failed}} başarısız, {{pending}} bekliyor, {{skipped}} gönderilmedi.',
      userData: 'Kişisel veri eşleştirme (e-posta ve telefon özeti)',
      userDataLead:
        'Açıkken müşterinin e-posta ve telefonu SHA-256 özetiyle Meta ve TikTok’a gönderilir (eşleşme oranı artar). Bu kişisel veri aktarımıdır: açmadan önce aydınlatma metni ve çerez politikası avukatla güncellenmelidir. Varsayılan kapalı.',
      logTitle: 'Sunucu olayı günlüğü',
      logLead:
        'Son 100 olay: gönderilen veri, deneme sayısı ve sağlayıcının hata mesajı. Kayıtlar 90 gün tutulur.',
      logEmpty:
        'Henüz sunucu olayı yok. Onay veren ziyaretçinin siparişinin ödemesi alındığında burada görünür.',
      filter: 'Durum',
      all: 'Tümü',
      eventStatus: {
        pending: 'Bekliyor',
        sent: 'Gönderildi',
        failed: 'Başarısız',
        skipped: 'Gönderilmedi',
      },
      events: { purchase: 'Satın alma', refund: 'İade' },
      colTime: 'Zaman',
      colProvider: 'Sağlayıcı',
      colEvent: 'Olay',
      colOrder: 'Sipariş',
      colStatus: 'Durum',
      colDetail: 'Ayrıntı',
      attempts: '{{n}} deneme',
      payload: 'Gönderilen veri',
      retry: 'Yeniden dene',
      retried: 'Yeniden kuyruğa alındı.',
      errors: {
        no_client_id: 'GA çerezi yok (ziyaretçi GA yüklenmeden sipariş verdi)',
        no_match_keys: 'Eşleştirme kimliği yok (piksel çerezi yok)',
        disabled: 'Gönderim kapatıldığı için gönderilmedi',
        timeout: 'Sağlayıcı zamanında yanıt vermedi',
        network: 'Sağlayıcıya ulaşılamadı',
        redirect: 'Sağlayıcı isteği başka adrese yönlendirdi (servis adresi değişmiş olabilir)',
      },
    },
    statusTitle: 'Vitrinde durum',
    statusLead: 'Etiketler vitrinde yalnızca çerez politikası yayımdayken ve ziyaretçinin izniyle yüklenir.',
    active: 'Etkin',
    inactive: 'Etkin değil',
    activeLead: 'Ziyaretçi izin verirse yüklenecek etiketler: {{list}}.',
    reasons: {
      no_tags: 'Henüz etiket eklenmedi. Vitrinde çerez bandı çıkmaz; yalnızca zorunlu çerezler kullanılır.',
      cookie_policy_missing:
        'Çerez politikası yayımlanmadığı için etiketler vitrine eklenmiyor. Önce Yasal metinler ekranında çerez politikasını yayımlayın.',
    },
    toLegal: 'Yasal metinlere git',
    tagsTitle: 'Etiketler',
    tagsLead: 'Kimlikleri ilgili hesaplardan kopyalayın. Boş bırakılan alan o etiketin olmaması demektir.',
    fields: {
      gtmContainerId: 'Google Tag Manager kimliği',
      ga4MeasurementId: 'GA4 ölçüm kimliği',
      googleAdsId: 'Google Ads kimliği',
      googleAdsPurchaseLabel: 'Satın alma dönüşüm etiketi',
      metaPixelId: 'Meta piksel kimliği',
      tiktokPixelId: 'TikTok piksel kimliği',
    },
    consentNote:
      'GA4 yalnızca analitik izniyle; Google Ads, Meta ve TikTok yalnızca pazarlama izniyle; GTM ikisinden biriyle yüklenir. İzin vermeyen ziyaretçide hiçbir etiket çalışmaz.',
    save: 'Etiketleri kaydet',
    saved: 'Etiketler kaydedildi. Vitrinde birkaç dakika içinde geçerli olur.',
    providers: {
      site: 'Vitrin (onay seçimi)',
      gtm: 'Google Tag Manager',
      ga4: 'Google Analytics 4',
      googleAds: 'Google Ads',
      meta: 'Meta pikseli',
      tiktok: 'TikTok pikseli',
    },
    legal: {
      title: 'Yasal metin etkisi',
      lead: 'Eklenen etiketlerin çerezleri ve verinin aktarıldığı kuruluşlar; yayımdaki metinlerde geçip geçmediği.',
      policyVersion: 'Yayımdaki çerez politikası: sürüm {{version}}.',
      policyMissing: 'Çerez politikası yayımlanmamış.',
      actionNeeded:
        'Bazı çerezler veya aktarımlar metinlerde geçmiyor: metinleri avukatınıza güncelletip yeni sürüm yayımlayın.',
      cookiesTitle: 'Çerezler',
      transfersTitle: 'Veri aktarımı (yurt dışı)',
      colCookie: 'Çerez',
      colService: 'Hizmet',
      colDuration: 'Süre',
      colRecipient: 'Veriyi alan',
      colCountries: 'Ülkeler',
      colInPolicy: 'Çerez politikasında',
      colInNotice: 'Aydınlatma metninde',
      found: 'Geçiyor',
      missing: 'Geçmiyor',
      days: '{{count}} gün',
      note: 'Sistem yasal metin yazmaz; yalnızca çerez ve sağlayıcı adının metinde geçip geçmediğine bakar. Çerez adları ve süreler sağlayıcıların belgelerine göredir ve değişebilir. Çerez politikasının yeni sürümü yayımlanınca ziyaretçilere onay yeniden sorulur.',
    },
    stats: {
      title: 'Çerez onayı istatistikleri',
      lead: 'Son 30 gün; aynı tarayıcının son seçimi sayılır.',
      none: 'Son 30 günde seçim yapılmadı.',
      visitors: 'Seçim yapan tarayıcı',
      acceptAll: 'Tümünü kabul etti',
      rejectAll: 'Reddetti',
      custom: 'Tercihlerden seçti',
      analytics: 'Analitiğe izin',
      marketing: 'Pazarlamaya izin',
    },
  },
  migration: {
    exportTitle: 'Dışa aktar (staging)',
    exportLead:
      'Seçilen mağazanın yapılandırma ve içeriğini tek bir ZIP dosyası olarak indirir. Canlı panelde "İçe aktar" ile yüklenir.',
    sourceStore: 'Mağaza',
    export: 'Taşıma paketini indir',
    exported: 'Taşıma paketi indirildi',
    included:
      'Pakette: ürünler, kategoriler, fiyat listeleri ve fiyatlar, stok bakiyeleri (lot/SKT ile), yasal metinler, sayfalar, blog, menüler, bannerlar, tema, kargo yöntemleri, banka hesapları, mağaza ve künye bilgileri, yönlendirmeler ve görseller.',
    excluded:
      'Pakette yok: müşteriler, bayiler, siparişler, ödemeler, denetim kaydı, kullanıcılar, alan adları, işletme vergi numarası ve tüm anahtarlar/şifreler (SMTP, iyzico, PayTR, API).',
    importTitle: 'İçe aktar (canlı)',
    importLead:
      'Önce önizlenir: hiçbir şey yazılmaz. Eşleşme kısa ad, SKU, kod ve IBAN ile yapılır; aynı paketi tekrar yüklemek kopya oluşturmaz.',
    targetStore: 'Hedef mağaza',
    targetFromPackage: 'Paketteki mağaza (koduyla eşleşir; yoksa oluşturulur)',
    includeStock: 'Stok bakiyelerini açılış stoku olarak taşı',
    overwrite: 'Var olan ama farklı kayıtların üzerine yaz (kapalıyken yalnızca eksikler eklenir)',
    legalReviewed:
      'Yasal metinlerin avukat tarafından incelendiğini onaylıyorum ("incelendi" işaretiyle yayımlansın)',
    carryApprovals: "Staging'de verilmiş veteriner (uzman) onaylarını kendi adıma taşıyorum",
    chooseFile: 'Paket dosyası seç ve önizle',
    previewOf: '{{org}} işletmesinin "{{store}}" mağazasından ({{env}}) {{date}} tarihinde alınmış paket.',
    storeWillCreate:
      '"{{store}}" mağazası bu işletmede yok; önizleme durumunda oluşturulacak (alan adı sonra eklenir).',
    sectionsCaption: 'Bölüm bazında yapılacak işlemler',
    section: 'Bölüm',
    create: 'Eklenecek',
    update: 'Güncellenecek',
    unchanged: 'Değişmeyen',
    skipped: 'Atlanan',
    stockTitle: 'Açılış stoku (ürün ürün)',
    stockSkipped: 'Stok taşınmayacak (seçenek kapalı)',
    product: 'Ürün',
    stockStatus: 'Durum',
    stockStatus_new: 'Yazılacak',
    stockStatus_already: 'Daha önce yazılmış',
    stockStatus_exists: 'Depoda zaten stok kaydı var; yazılmaz',
    stockStatus_missing: 'Ürün veya depo yok',
    approvalsPending:
      '{{products}} ürün ve {{content}} içerik veteriner onayı bekleyecek (onaylar taşınmıyor); onaylanana kadar vitrinde görünmez.',
    legalWithReview: 'Yasal metinler "avukat inceledi" işaretiyle yayımlanacak: {{list}}',
    legalWithoutReview:
      'Yasal metinler yayımlanacak ama "avukat inceledi" işareti verilmeyecek (canlıya alma şartı): {{list}}',
    warnings: {
      migration_no_secrets:
        'Anahtarlar ve şifreler pakette yok: SMTP, ödeme ve kargo bilgilerini canlı panelde yeniden girin.',
      migration_card_off:
        'Kartla ödeme kapalı gelir; anahtarlar girilip test edildikten sonra Ödeme ayarlarından açılır.',
      migration_domains_manual: 'Alan adları taşınmaz; canlı alan adını Mağazalar ekranından ekleyin.',
    },
    refresh: 'Önizlemeyi yenile',
    stale: 'Seçenekler değişti; önizlemeyi yenileyin',
    apply: 'İçe aktar',
    applyConfirm:
      'Paket bu işletmeye uygulanacak (tek işlemde). Var olan kayıtlar yalnızca "üzerine yaz" seçiliyse değişir. Devam edilsin mi?',
    applied: 'Taşıma paketi uygulandı',
    resultTitle: '"{{store}}" mağazasına uygulandı. Sonuç:',
    sections: {
      store: 'Mağaza',
      organization: 'İşletme künyesi',
      files: 'Görseller',
      brands: 'Markalar',
      taxClasses: 'KDV sınıfları',
      categories: 'Kategoriler',
      customerGroups: 'Müşteri grupları',
      warehouses: 'Depolar',
      products: 'Ürünler',
      productOptions: 'Ürün seçenekleri',
      productVariants: 'Varyantlar (SKU)',
      productCategories: 'Ürün–kategori bağları',
      productMedia: 'Ürün görselleri',
      markets: 'Pazarlar',
      storeBrands: 'Mağaza markaları',
      priceLists: 'Fiyat listeleri',
      prices: 'Fiyatlar',
      productStoreListings: 'Ürün yayınları',
      shippingMethods: 'Kargo yöntemleri',
      paymentSettings: 'Ödeme ayarları (kart kapalı)',
      bankAccounts: 'Banka hesapları',
      legalDocuments: 'Yasal metinler',
      legalDocumentVersions: 'Yasal metin sürümleri',
      postCategories: 'Blog kategorileri',
      posts: 'Blog yazıları',
      postVersions: 'Yazı sürümleri',
      pages: 'Sayfalar',
      pageVersions: 'Sayfa sürümleri',
      banners: 'Bannerlar',
      menus: 'Menüler',
      themes: 'Tema',
      themeVersions: 'Tema sürümleri',
      redirects: 'Yönlendirmeler',
    },
  },
  uiTranslations: {
    coverageTitle: 'Dil başına çeviri durumu',
    coverageLead:
      'Arayüz (panel, vitrin, mobil) ve yardım metinlerinin her dildeki kapsamı. Kaynak dil Türkçe; eksik metin İngilizceye, o da yoksa Türkçeye düşer.',
    language: 'Dil',
    ui: 'Arayüz metinleri',
    help: 'Yardım metinleri',
    direction: 'Yazı yönü',
    ltr: 'Soldan sağa',
    rtl: 'Sağdan sola',
    complete: 'Tam ({{total}})',
    missing: '{{count}} eksik / {{total}}',
    missingKeys: '{{language}}: eksik anahtarlar ({{count}})',
    helpNote:
      'Yardımın ayrıntı alanları Türkçe dışındaki dillerde Türkçe kayıttan gelir; dil bazında düzenlemek için:',
  },
  helpEditor: {
    search: 'Anahtar veya başlık ara',
    edit: 'Düzenle',
    customized: 'Düzenlendi',
    saved: 'Açıklama kaydedildi',
    title: 'Başlık',
    short: 'Kısa açıklama',
    history: 'Önceki sürümler',
    noHistory: 'Önceki sürüm yok.',
    locale: 'Dil',
  },
  confirm: {
    title: 'Emin misiniz?',
    yes: 'Evet, devam et',
  },
  products: {
    customs: {
      title: 'Gümrük ve ihracat',
      lead: 'Yurt dışı gönderide proforma faturada ve gümrük beyanında kullanılır.',
      hsCode: 'GTİP / HS kodu',
      hsCodeHint: '6–12 hane; nokta ve boşluk yazabilirsiniz (ör. 2309.10.13.00.00).',
      originCountry: 'Menşe ülke',
      description: 'Gümrük tanımı',
      descriptionHint: 'Beyanda geçecek kısa mal tanımı (ör. kuru kedi maması).',
    },
    extrasTitle: 'Video, belge ve tamamlayıcı ürünler',
    extrasLead:
      'Ürün sayfasında "Videolar" ve "Belgeler" sekmeleri ile "Birlikte iyi gider" bölümü. Değişiklikler Kaydet ile kaydedilir.',
    videos: 'Videolar',
    videoUrl: '{{n}}. video adresi',
    videoTitle: '{{n}}. video başlığı',
    addVideo: 'Video ekle',
    removeVideo: '{{n}}. videoyu kaldır',
    documents: 'Belgeler',
    noDocuments: 'Belge yok.',
    documentTitle: '{{n}}. belge başlığı',
    documentKind: '{{n}}. belge türü',
    documentFile: 'Dosya: {{name}} ({{size}} KB)',
    documentKinds: {
      analysis_certificate: 'Analiz sertifikası',
      leaflet: 'Kullanma kılavuzu',
      safety_data_sheet: 'Güvenlik bilgi formu',
      registration: 'Kayıt / onay belgesi',
      other: 'Diğer belge',
    },
    addDocument: 'PDF belge yükle',
    openDocument: 'Aç',
    removeDocument: '{{n}}. belgeyi kaldır',
    documentUploaded: 'Belge yüklendi. Ürünü kaydedince vitrinde görünür.',
    complementary: 'Tamamlayıcı ürünler (Birlikte iyi gider)',
    create: 'Yeni ürün',
    createTitle: 'Yeni ürün',
    search: 'Ara',
    searchPlaceholder: 'Ürün adı, SKU veya barkod',
    status: 'Durum',
    statuses: {
      draft: 'Taslak',
      active: 'Etkin',
      archived: 'Arşiv',
    },
    vetReview: 'Veteriner onayı',
    vetStatuses: {
      pending: 'Onay bekliyor',
      approved: 'Onaylı',
      rejected: 'Reddedildi',
      not_required: 'Gerekmiyor',
    },
    brand: 'Marka',
    empty: 'Henüz ürün yok',
    emptyLead:
      '"Yeni ürün" ile tek tek ekleyin veya İçe / Dışa Aktarma sayfasından Excel/Shopify dosyası yükleyin.',
    product: 'Ürün',
    sku: 'SKU',
    stock: 'Stok',
    variantCount: '{{count}} varyant',
    backToList: 'Ürün listesi',
    basics: 'Temel bilgiler',
    title: 'Ürün adı',
    slug: 'Kısa ad (adres)',
    species: 'Tür',
    speciesNames: {
      cat: 'Kedi',
      dog: 'Köpek',
      bird: 'Kuş',
      rodent: 'Kemirgen (hamster, kobay vb.)',
      rabbit: 'Tavşan',
      reptile: 'Sürüngen ve kaplumbağa',
      exotic: 'Diğer egzotik',
    },
    taxClass: 'KDV sınıfı',
    defaultTax: 'Varsayılan KDV sınıfı',
    b2cVisible: 'Perakende müşterilere görünür',
    b2bVisible: 'Bayilere görünür',
    dealerMinQuantity: 'Bayi için en az adet',
    dealerPackSize: 'Bayi koli adedi (adet bunun katı olur)',
    healthContent: 'Sağlık içeriği var (veteriner onayı gerekir)',
    subscribable: 'Düzenli gönderime uygun (müşteri "her N haftada bir" sipariş verebilir)',
    content: 'İçerik',
    contentLead:
      'Hastalığı önleme veya tedavi etme iddiası kullanmayın. Bu alanlar değişirse veteriner onayı yenilenir.',
    shortDescription: 'Kısa açıklama',
    description: 'Açıklama',
    composition: 'İçerik (bileşim)',
    usage: 'Kullanım',
    warnings: 'Uyarılar',
    feedRegistrationNo: 'Yem kayıt no',
    categories: 'Kategoriler',
    noCategories: 'Henüz kategori yok; Kategoriler sayfasından ekleyin.',
    tagsAttributes: 'Etiketler ve özellikler',
    tagsAttributesLead:
      'Etiketler koleksiyon kuralları ve panel süzgeçleri içindir; özellikler ürün sayfasındaki "Teknik özellikler" tablosunda görünür.',
    tags: 'Etiketler',
    tagsPlaceholder: 'Virgülle ayırın: yavru kedi, tahılsız',
    tagSuggestions: 'Sık kullanılan:',
    tag: 'Etiket',
    noAttributes: 'Henüz ürün özelliği tanımlanmamış.',
    attributeEmpty: 'Boş',
    variants: 'Seçenekler ve varyantlar',
    variantsLead: 'Seçenek değerlerini virgülle yazın (ör. 60 tablet, 120 tablet). Her satır bir varyanttır.',
    optionName: 'Seçenek adı',
    optionNamePlaceholder: 'ör. Boyut',
    optionValues: 'Seçenek değerleri',
    optionValuesPlaceholder: 'ör. 60 tablet, 120 tablet',
    removeOption: 'Seçeneği kaldır',
    addOption: 'Seçenek ekle',
    barcode: 'Barkod',
    weight: 'Ağırlık (g)',
    cost: 'Maliyet',
    reservedShort: '{{n}} ayrılmış',
    archiveVariant: 'Arşivle',
    restoreVariant: 'Geri al',
    addVariant: 'Varyant ekle',
    seo: 'Arama motoru (SEO)',
    seoTitle: 'SEO başlığı',
    seoTitleHint: 'En fazla 70 karakter. Boşsa ürün adı kullanılır.',
    seoDescription: 'SEO açıklaması',
    seoDescriptionHint: 'En fazla 170 karakter.',
    merchant: {
      title: 'Google alışveriş',
      lead: 'Merchant Center’a gönderilen ürün bilgileri. Fiyat, stok, görsel ve barkod ürünün kendisinden alınır.',
      include: 'Google alışverişe gönder',
      googleCategory: 'Google ürün kategorisi',
      condition: 'Ürünün durumu',
      conditions: { new: 'Yeni', refurbished: 'Yenilenmiş', used: 'İkinci el' },
      identifierExists: 'Üretici barkodu',
      identifiers: { auto: 'Barkod (GTIN) varsa var', no: 'Bu ürünün barkodu yok' },
      skuIsMpn: 'Stok kodu üretici parça numarasıdır (MPN)',
      customLabels: 'Özel etiketler (kampanya gruplama)',
      customLabel: 'Etiket {{n}}',
    },
    vetReviewTitle: 'Veteriner incelemesi',
    vetReviewLead: 'Sağlık içerikli ürün, Veteriner Uzman İnceleyici onaylamadan yayınlanamaz.',
    claimsFound: 'Kontrol edilmesi gereken ifadeler bulundu:',
    noClaims: 'Otomatik denetim riskli ifade bulmadı (karar inceleyicinindir).',
    reviewNote: 'İnceleme notu',
    reviewNoteHint: 'reddederken zorunlu',
    approveContent: 'İçeriği onayla',
    rejectContent: 'Reddet',
    reviewSaved: 'İnceleme kaydedildi',
    fields: {
      title: 'Ürün adı',
      shortDescription: 'Kısa açıklama',
      description: 'Açıklama',
      composition: 'İçerik',
      usage: 'Kullanım',
      warnings: 'Uyarılar',
    },
    media: 'Görseller',
    mediaLead: 'İlk görsel listede ve vitrinde kapak olarak kullanılır.',
    mediaAlt: '{{n}}. görselin alternatif metni',
    mediaMoveLeft: '{{n}}. görseli öne al',
    mediaMoveRight: '{{n}}. görseli arkaya al',
    mediaReordered: 'Görsel sırası kaydedildi',
    mediaOrderLead: 'Vitrindeki galeri bu sırayla gösterilir.',
    mediaStatus: {
      ready: 'Hazır',
      pending_download: 'İndirme bekliyor',
      failed: 'İndirilemedi',
    },
    mediaFailure: {
      invalid_url: 'Adres geçersiz',
      blocked_address: 'İç ağ adresine izin verilmez',
      dns_failed: 'Alan adı bulunamadı',
      connect_failed: 'Sunucuya bağlanılamadı',
      tls_failed: 'Güvenli bağlantı kurulamadı',
      timeout: 'Zaman aşımı (30 sn)',
      not_found: 'Görsel kaynakta yok',
      forbidden: 'Kaynak erişimi reddetti',
      http_error: 'Kaynak sunucu hatası',
      too_many_redirects: 'Çok fazla yönlendirme',
      too_large: "20 MB'tan büyük",
      not_image: 'Dosya görsel değil veya bozuk',
      storage_failed: 'Sunucuya kaydedilemedi',
      unknown: 'Bilinmeyen hata',
    },
    mediaRetry: 'Yeniden dene',
    mediaSize: '{{width}}×{{height}} px',
    mediaSmall: 'Google alışveriş için küçük: en az 500×500 px önerilir (31 Ocak 2027’den sonra zorunlu)',
    mediaRetryQueued: 'Görsel yeniden indirilecek (yaklaşık 30 sn içinde).',
    confirmRemoveMedia: 'Görsel üründen kaldırılsın mı?',
    imageAdded: 'Görsel eklendi',
    addImage: 'Görsel ekle',
    prices: 'Fiyatlar',
    pricesLead: 'Fiyatı yazıp kutudan çıkınca kaydedilir. Boş bırakmak fiyatı kaldırır.',
    noPriceLists: 'Önce Fiyatlar sayfasından bir fiyat listesi oluşturun.',
    noBaseList_none:
      '"{{store}}" mağazası için temel (perakende) fiyat listesi yok: ürün bu mağazada fiyatsız kalır ve vitrinde listelenmez. Fiyatlar sayfasında mağaza seçili, grup boş bir liste oluşturun.',
    noBaseList_inactive:
      '"{{store}}" mağazasının temel fiyat listesi etkin değil: ürün vitrinde fiyatsız kalır. Fiyatlar sayfasında listeyi etkinleştirin.',
    noBaseList_currency:
      '"{{store}}" mağazasının pazarı {{currency}} kullanıyor ama temel fiyat listesi başka para biriminde. {{currency}} para birimli bir liste oluşturun.',
    noBaseList_dates:
      '"{{store}}" mağazasının temel fiyat listesi bugün geçerli değil (başlangıç/bitiş tarihi). Fiyatlar sayfasında tarihleri kontrol edin.',
    goPriceLists: 'Fiyatlar sayfasına git',
    listInactive: 'etkin değil',
    listings: 'Mağazalarda yayın',
    listingsLead: 'Yayın şartları: ürün etkin, sağlık içeriği onaylı, temel listede fiyatı var.',
    published: 'Yayında',
    notPublished: 'Yayında değil',
    publish: 'Yayınla',
    unpublish: 'Yayından kaldır',
  },
  categories: {
    name: 'Kategori adı',
    parent: 'Üst kategori',
    slug: 'Kısa ad (adres)',
    slugLead: 'Adres: {{path}}. Değişirse eski adres yeni adrese kalıcı olarak yönlendirilir.',
    description: 'Açıklama',
    seoTitle: 'Arama sonuçlarında başlık',
    seoDescription: 'Arama sonuçlarında açıklama',
    editTitle: 'Kategoriyi düzenle',
    editHint:
      'Kategorinin adını, adresini, açıklamasını ve arama sonuçlarındaki görünümünü "Düzenle" ile değiştirebilirsiniz.',
    topLevel: 'Ana kategori',
    add: 'Kategori ekle',
    productCount: '{{count}} ürün',
    statuses: {
      active: 'Görünür',
      hidden: 'Gizli',
    },
    hide: 'Gizle',
    show: 'Göster',
    confirmDelete: '"{{name}}" silinsin mi? Ürünler silinmez, yalnızca bu kategoriden çıkar.',
    empty: 'Henüz kategori yok',
    emptyLead: 'Örneğin "Kedi Takviyeleri", "Köpek Takviyeleri" gibi ana kategorilerle başlayın.',
  },
  pricing: {
    referencePriceNote:
      'Vitrindeki "önceki fiyat", son 30 günde gerçekten uygulanmış en düşük fiyattır; elle üstü çizili fiyat girilemez.',
    groups: 'Müşteri grupları',
    groupsLead: 'Bayi seviyeleri (ör. Bayi, Bayi – Altın). Onaylı bayi firması bir gruba bağlanır.',
    addGroup: 'Grup ekle',
    noGroups: 'Henüz müşteri grubu yok',
    noGroupsLead: 'Bayi fiyatı için en az bir "Bayi" türünde grup oluşturun.',
    minOrderShort: 'Minimum sipariş: {{amount}}',
    noMinOrder: 'Minimum sipariş yok',
    editMinOrder: 'Minimum sipariş',
    minOrderTitle: '{{name}} — minimum sipariş tutarı',
    minOrderLead:
      'Bu gruptaki bayiler sepet tutarı (ürünler, indirimler ve KDV dahil; kargo hariç) bu tutarın altındayken sipariş veremez. Firmaya özel tutar bayi kartından girilir.',
    minOrder: 'Minimum sipariş tutarı ({{currency}})',
    minOrderHint: 'Boş: yok',
    groupName: 'Grup adı',
    groupCode: 'Kod',
    groupCodeHint: 'Küçük harf, rakam, - ve _ (içe aktarmada bu kod kullanılabilir).',
    groupKind: 'Tür',
    kinds: {
      dealer: 'Bayi',
      retail: 'Perakende',
    },
    lists: 'Fiyat listeleri',
    listsLead: 'Grup seçilmeyen liste temel (perakende) listedir; herkes görür.',
    addList: 'Fiyat listesi ekle',
    noLists: 'Henüz fiyat listesi yok',
    noListsLead: 'Önce temel (perakende) listeyi, sonra bayi listesini oluşturun.',
    taxIncl: 'KDV dahil',
    taxExcl: 'KDV hariç',
    forGroup: 'Grup: {{group}}',
    baseList: 'Temel liste',
    priceCount: '{{count}} fiyat',
    listStatus: {
      active: 'Etkin',
      inactive: 'Pasif',
    },
    activate: 'Etkinleştir',
    deactivate: 'Pasifleştir',
    listName: 'Liste adı',
    store: 'Mağaza',
    listGroup: 'Müşteri grubu',
    baseListOption: 'Yok — temel (perakende) liste',
    market: 'Pazar',
    allMarkets: 'Tüm pazarlar (bu para birimindeki)',
    forMarket: 'Pazar: {{market}}',
    currency: 'Para birimi',
    taxInclusive: 'Fiyatlar KDV dahil',
    priority: 'Öncelik',
    taxes: 'KDV sınıfları',
    taxesLead: 'Ürünlere atanan KDV oranları.',
    defaultTax: 'Varsayılan',
    noTaxes: 'Henüz KDV sınıfı yok',
    taxName: 'Ad',
    taxNamePlaceholder: 'ör. KDV %20',
    taxRate: 'Oran',
    addTax: 'KDV sınıfı ekle',
    countryRates: 'Ülke KDV oranları',
    countryRatesLead:
      'Vergi kipi "Varış ülkesi KDV" olan pazarlarda ürünün KDV sınıfının o ülkedeki oranı uygulanır. Oranı tanımlı olmayan ürün o pazarda satılamaz.',
    noCountryRates: 'Henüz ülke oranı yok',
    countryRateClass: 'KDV sınıfı',
    countryRateCountry: 'Ülke',
    addCountryRate: 'Ülke oranı ekle',
    countryRateDelete:
      '{{country}} için "{{name}}" oranı silinsin mi? Bu ülkenin "Varış ülkesi KDV" pazarında bu sınıftaki ürünler satılamaz olur.',
    bulk: 'Toplu fiyat değişikliği',
    bulkLead: 'Önce önizleyin; uygulanan değişiklik geri alınabilir.',
    targetList: 'Değişecek liste',
    operation: 'İşlem',
    ops: {
      percent: 'Yüzde artır/azalt',
      fixed: 'Tutar ekle/çıkar',
      from_list: 'Başka listeden türet',
      from_cost: 'Maliyetten (kâr oranı)',
      target_margin: 'Hedef brüt marj',
      fx: 'Başka para biriminden (kur)',
    },
    markup: 'Kâr oranı (%)',
    markupHint: 'KDV hariç fiyat = maliyet × (1 + oran). KDV dahil listede ürünün KDV oranı eklenir.',
    targetMargin: 'Brüt marj (%)',
    targetMarginHint: 'KDV hariç fiyat = maliyet ÷ (1 − marj). Ör. %40 marj, 100 ₺ maliyet → 166,67 ₺.',
    fxRate: 'Kur',
    fxRateHint: 'Kaynak para biriminin 1 biriminin bu listedeki karşılığı (ör. 1 TRY = 0,0291 EUR → 0,0291).',
    fxAdjust: 'Ek oran (%)',
    minMargin: 'En düşük marj (%)',
    minMarginHint:
      'Boş bırakılırsa denetlenmez. Marj KDV hariç fiyat ve maliyetle hesaplanır; maliyeti olmayan ürün denetlenmez.',
    minMarginMode: 'Altında kalırsa',
    minMarginModes: { warn: 'Uyar (yine uygulanır)', block: 'Uygulama' },
    margin: 'Marj',
    lowMargin: 'Düşük marj',
    noCost: 'Maliyeti girilmemiş (veya başka para biriminde) {{count}} varyant atlandı.',
    blocked: '{{count}} varyant en düşük marjın altında kaldığı için uygulanmayacak.',
    lowMarginCount: '{{count}} varyantın marjı en düşük marjın altında.',
    campaign: 'Kampanya',
    campaignStates: { upcoming: 'Başlamadı', live: 'Geçerli', ended: 'Sona erdi' },
    validity: '{{from}} – {{to}}',
    startsAt: 'Geçerlilik başlangıcı',
    endsAt: 'Geçerlilik bitişi',
    datesHint:
      'Boş bırakılırsa liste her zaman geçerlidir. Kampanya listesi için tarih verin ve önceliği temel listeden yüksek yapın.',
    editDates: 'Tarihleri düzenle',
    noLimit: 'sınırsız',
    amount: 'Tutar',
    percent: 'Yüzde',
    valueHint: 'Azaltmak için başına eksi yazın (ör. -10).',
    sourceList: 'Kaynak liste',
    filterBrand: 'Marka',
    filterCategory: 'Kategori',
    ending: 'Fiyat sonu',
    endings: {
      none: 'Değiştirme',
      whole: 'Tam lira',
      end_90: ',90',
      end_99: ',99',
    },
    previewBulk: 'Önizle',
    previewSummary: '{{affected}} fiyat değişecek, {{skipped}} atlandı (fiyatı yok veya değişmiyor).',
    before: 'Önce',
    after: 'Sonra',
    confirmApply: '{{count}} fiyat değiştirilecek. Devam edilsin mi?',
    applyBulk: 'Uygula',
    bulkApplied: 'Toplu fiyat uygulandı',
    bulkReverted: 'Toplu fiyat geri alındı',
    history: 'Geçmiş',
    affectedCount: '{{count}} fiyat',
    bulkStatus: {
      preview: 'Önizleme',
      applied: 'Uygulandı',
      reverted: 'Geri alındı',
      expired: 'Süresi doldu',
    },
    confirmRevert: 'Bu toplu değişiklik geri alınsın mı? Sonradan elle değişen fiyatlar korunur.',
    revert: 'Geri al',
  },
  discounts: {
    create: 'Kupon oluştur',
    empty: 'Henüz kupon yok',
    emptyLead: 'Kampanya için yüzde veya tutar indirimli kupon oluşturun.',
    min: 'en az {{amount}}',
    used: '{{used}}/{{limit}} kullanıldı',
    until: '{{date}} tarihine kadar',
    name: 'Kupon adı (iç kullanım)',
    code: 'Kod',
    type: 'Tür',
    types: {
      percentage: 'Yüzde',
      fixed_amount: 'Sabit tutar',
    },
    minSubtotal: 'En az sepet tutarı',
    usageLimit: 'Kullanım sınırı',
    endsAt: 'Bitiş tarihi',
    groups: 'Geçerli müşteri grupları',
    groupsHint: 'Hiçbiri seçilmezse herkes kullanabilir.',
  },
  stock: {
    ledgerNote: 'Stok hareketleri silinmez; hatalı girişi ters yönlü düzeltmeyle dengeleyin.',
    warehouses: 'Depolar',
    warehousesLead: 'İlk depo varsayılan olur; siparişler önce varsayılan depodan ayrılır.',
    default: 'Varsayılan',
    noWarehouses: 'Henüz depo yok',
    warehouseName: 'Depo adı',
    warehouseCode: 'Kod',
    addWarehouse: 'Depo ekle',
    variantStock: 'Ürün stoğu',
    variantStockLead: 'Ürünü bulun, varyantı seçin; depo/lot bakiyeleri ve son hareketler görünür.',
    findProduct: 'Ürün bul',
    newMovement: 'Stok hareketi',
    transfer: 'Transfer',
    warehouse: 'Depo',
    lot: 'Lot',
    expiry: 'SKT',
    onHand: 'Eldeki',
    reserved: 'Ayrılmış',
    movements: 'Son hareketler',
    types: {
      receipt: 'Mal kabul',
      sale: 'Satış',
      return: 'İade',
      adjustment: 'Düzeltme',
      transfer_in: 'Transfer giriş',
      transfer_out: 'Transfer çıkış',
      damage: 'Hasar / fire',
      count: 'Sayım',
      import: 'İçe aktarma',
      opening: 'Açılış stoku',
    },
    noResults: 'Sonuç yok',
    movementType: 'Hareket türü',
    lotPick: 'Lot',
    chooseLot: 'Lot seçin',
    lotless: 'Lotsuz stok',
    lotOption: '{{lot}} · SKT {{expiry}} · {{onHand}} adet',
    countedQuantity: 'Sayılan adet (yeni toplam)',
    quantity: 'Adet',
    lotNo: 'Lot no',
    reason: 'Açıklama',
    fromWarehouseId: 'Çıkış deposu',
    toWarehouseId: 'Giriş deposu',
    noLot: 'Lotsuz',
    expiryLabel: 'SKT {{date}}',
    availableCount: '{{count}} kullanılabilir',
    transferNoStock:
      'Bu üründe taşınabilir stok yok. Transfer, bir depodaki mevcut stoğu başka depoya taşır; ilk stok girişi "Mal kabul" ile yapılır.',
    goReceipt: 'Mal kabul gir',
    transferNeedsTwo: 'Transfer için başka bir etkin depo gerekir (Depolar bölümünden ekleyin).',
    transferMax: 'En fazla {{count}} adet taşınabilir.',
    transferTooMany: 'Bu kaynakta en fazla {{count}} adet var.',
    noStockYet:
      'Bu ürün için henüz stok yok. İlk girişi "Stok hareketi" → "Mal kabul" ile yapın (lot ve son kullanma tarihiyle).',
    expiring: 'SKT yaklaşanlar',
    expiringLead: 'Son kullanma tarihi yaklaşan ve stoğu olan lotlar.',
    withinDays: 'Süre',
    days: '{{n}} gün',
    lotLabel: 'Lot {{lot}}',
    noExpiring: "Bu süre içinde SKT'si dolacak lot yok.",
    critical: {
      title: 'Kritik stok',
      lead: 'Satılabilir adedi eşiğe eşit veya altında olan ürünler. Eşiğin en çok altında olan en üstte.',
      none: 'Kritik stokta ürün yok.',
      product: 'Ürün',
      available: 'Satılabilir',
      threshold: 'Eşik',
      rule: 'Kural',
      allWarehouses: 'Tüm depolar',
      sources: { warehouse: 'Depo eşiği', variant: 'Ürün eşiği', default: 'Varsayılan eşik' },
      more: 'İlk {{shown}} satır gösteriliyor (toplam {{total}}).',
      defaultThreshold: 'Varsayılan eşik',
      defaultThresholdHint: 'Kendi eşiği olmayan ürünler için; boş bırakılırsa uygulanmaz.',
      saveDefault: 'Varsayılan eşiği kaydet',
      defaultSaved: 'Varsayılan eşik kaydedildi.',
      dailyDigest: 'Günlük e-posta özeti',
      digestOn: 'Günlük e-posta özeti açık (her sabah 08:00).',
      digestOff: 'Günlük e-posta özeti kapalı.',
      thresholds: 'Kritik stok eşikleri',
      thresholdsLead: 'Satılabilir adet bu sayıya eşit veya altına düşünce ürün kritik stok listesine girer.',
      saveThresholds: 'Eşikleri kaydet',
      thresholdsSaved: 'Eşikler kaydedildi.',
    },
  },
  customers: {
    create: 'Müşteri ekle',
    search: 'Ara',
    searchMaskedHint: 'Kişisel veri yetkiniz olmadığı için yalnızca ada göre aranır.',
    kind: 'Tür',
    kinds: {
      dealer: 'Bayi',
      retail: 'Bireysel',
    },
    maskedNote: 'Kişisel veriler maskeli gösteriliyor.',
    empty: 'Henüz müşteri yok',
    emptyLead: 'Müşteriler vitrinden üye olunca veya bayi listesi yüklenince burada görünür.',
    notActivated: 'Etkinleştirilmedi',
    disabled: 'Devre dışı',
    createdAndEmailed: 'Kaydedildi; giriş bağlantısı e-postayla gönderildi.',
    name: 'Ad soyad',
    email: 'E-posta',
    phone: 'Telefon',
    sendAccessLink: 'Şifre belirleme bağlantısı gönder',
    manualLinkTitle: 'Bağlantıyı elle iletin',
    manualLinkLead:
      'E-posta altyapısı kurulu olmadığı için bağlantı gönderilmedi. Aşağıdaki bağlantıyı müşteriye güvenli bir kanaldan iletin.',
    linkEmailed: 'Bağlantı e-postayla gönderildi.',
    backToList: 'Müşteri listesi',
    profile: 'Profil',
    activated: 'Hesap etkin (şifre belirlendi)',
    emailVerified: 'E-posta doğrulandı',
    created: 'Kayıt tarihi',
    companies: 'Bayi firmaları',
    sendReset: 'Şifre sıfırlama bağlantısı',
    sendActivation: 'Etkinleştirme bağlantısı',
    unlock: 'Kilidi aç',
    confirmDisable: 'Müşteri hesabı devre dışı bırakılsın mı? Açık oturumları kapanır.',
    confirmEnable: 'Müşteri hesabı yeniden etkinleştirilsin mi?',
    disable: 'Devre dışı bırak',
    enable: 'Etkinleştir',
    consents: 'İleti izinleri',
    channels: {
      email: 'E-posta',
      sms: 'SMS',
      call: 'Arama',
      whatsapp: 'WhatsApp',
    },
    consentStatus: {
      granted: 'İzin var',
      revoked: 'İzin yok (geri alındı)',
      none: 'Kayıt yok',
    },
    consentSource: {
      register: 'Üyelikte',
      account: 'Hesabım sayfası',
      checkout: 'Siparişte',
      import: 'İçe aktarma',
      admin: 'Panelden',
      unsubscribe: 'Çıkma bağlantısı',
    },
    confirmRevoke: 'İzin geri alınsın mı? Kayıt geçmişte saklanır.',
    revoke: 'İzni geri al',
    addresses: 'Adresler',
    masked: 'maskeli',
    noAddresses: 'Kayıtlı adres yok.',
    orders: 'Son siparişler',
    noOrders: 'Henüz sipariş yok.',
    tags: 'Etiketler',
    tagsLead:
      'Vitrinde görünmez; müşteri listesinde süzgeç ve segment kuralı olarak kullanılır. KVKK veri kopyasında müşteriye verilir.',
    tagsLabel: 'Etiketler (virgülle ayırın)',
    tagsPlaceholder: 'ör. vip, fuar 2026, kedi sahibi',
    tagSuggestions: 'Sık kullanılanlar:',
    saveTags: 'Etiketleri kaydet',
    tagsSaved: 'Etiketler kaydedildi.',
    noTags: 'Etiket yok.',
    tagFilter: 'Etiket',
    metricsTitle: 'Sipariş özeti ve RFM',
    metricsLead: 'Geçerli siparişlerden (iptal, taslak ve tamamı iade edilenler hariç) her gece hesaplanır.',
    noMetrics: 'Geçerli siparişi yok veya RFM henüz hesaplanmadı.',
    orderCount: 'Sipariş sayısı',
    totalSpent: 'Net harcama',
    avgOrder: 'Ortalama sipariş',
    firstOrder: 'İlk sipariş',
    lastOrder: 'Son sipariş',
    rfmGroup: 'RFM grubu',
    rfmScores: 'R{{r}} · F{{f}} · M{{m}}',
    otherCurrency: '{{count}} sipariş başka para biriminde (harcamaya dahil değil)',
    metricsComputed: 'Hesaplama: {{date}}',
    summaryTitle: 'Müşteri özeti',
    summaryLead:
      'Siparişlerden anlık hesaplanır (iptal, taslak, ödeme bekleyen ve tamamı iade edilen siparişler hariç); RFM grubu her gece güncellenir.',
    lifetimeSpent: 'Bugüne kadar net harcama',
    last12Months: 'Son 12 ayda',
    daysAgo: '{{count}} gün önce',
    cycle: 'Sipariş aralığı',
    cycleValue: 'Ortalama {{days}} günde bir',
    cycleNone: 'En az iki sipariş gerekir',
    nextExpected: 'Beklenen sonraki sipariş: {{date}} (geçmiş siparişlere göre tahmin)',
    returnsCount: 'İade talepleri',
    newsletter: 'Bülten',
    acquisition: 'Edinme kaynağı',
    acquisitionNoAd: 'Reklam hesabıyla eşleşmedi',
    cacValue: 'Edinme maliyeti {{amount}} ({{month}}, {{count}} yeni müşteri)',
    newsletterNone: 'Abone değil',
    rfmNotYet: 'Henüz hesaplanmadı',
    notes: 'İç notlar',
    notesLead: 'Yalnızca panel kullanıcıları görür; KVKK veri kopyasında müşteriye verilir.',
    notesLabel: 'Not',
    saveNotes: 'Notu kaydet',
    notesSaved: 'Not kaydedildi.',
    noNotes: 'Not yok.',
    timelineTitle: 'Etkinlik geçmişi',
    timelineLead: 'Son 40 etkinlik, yeniden eskiye; görme yetkiniz olan bölümler listelenir.',
    timeline: {
      account: 'Üye oldu',
      order: 'Sipariş {{number}} · {{status}} · {{total}}',
      return: 'İade talebi (sipariş {{order}}) · {{resolution}} · {{status}}',
      review: '{{product}} için {{rating}}/5 değerlendirme · {{status}}',
      question: '{{product}} hakkında soru · {{status}}',
      consent: '{{channel}} izni: {{status}} · {{source}}',
      contact: 'İletişim formundan mesaj · {{status}}',
      ticket: 'Destek talebi #{{number}}: {{subject}} · {{status}}',
      privacy: 'KVKK başvurusu: {{kind}} · {{status}}',
      newsletter: 'Bülten: {{status}}',
      campaign: 'Kampanya e-postası: {{name}}',
      campaignClicked: 'bağlantıya tıkladı',
      campaignUnsubscribed: 'çıktı',
      automation: 'Otomasyon e-postası: {{name}}',
      message: '{{channel}} kampanyası: {{name}} ({{status}})',
    },
  },
  dealers: {
    ledgerTitle: 'Cari hesap',
    ledgerOpen: 'Cari hesabı aç',
    ledgerSummary: 'Bakiye {{balance}} · vadesi geçen {{overdue}}',
    paymentTerm: 'Vade (gün)',
    paymentTermInvalid: '0 ile 365 arasında tam sayı girin.',
    paymentTermValue: 'Vade: siparişten sonra {{days}} gün.',
    importList: 'Bayi listesi yükle',
    create: 'Bayi ekle',
    search: 'Ara',
    searchHint: 'Unvan, bayi kodu, şehir veya tam vergi numarası.',
    status: 'Durum',
    statuses: {
      applied: 'Başvuru',
      approved: 'Onaylı',
      suspended: 'Askıda',
      rejected: 'Reddedildi',
    },
    empty: 'Henüz bayi yok',
    emptyLead: 'Bayi listenizi Excel/CSV ile yükleyin veya tek tek ekleyin.',
    memberCount: '{{count}} kullanıcı',
    legalName: 'Firma unvanı',
    tradeName: 'Ticari ad',
    taxOffice: 'Vergi dairesi',
    taxNumber: 'Vergi no / TCKN',
    externalCode: 'Bayi kodu',
    city: 'İl',
    district: 'İlçe',
    email: 'Firma e-postası',
    phone: 'Telefon',
    group: 'Bayi grubu',
    createApproved: 'Onaylı olarak oluştur (bayi fiyatları hemen açılır)',
    backToList: 'Bayi listesi',
    info: 'Firma bilgileri',
    address: 'Adres',
    source: 'Kaynak',
    sources: {
      application: 'Vitrin başvurusu',
      import: 'İçe aktarma',
      manual: 'Panelden',
    },
    approvedAt: 'Onay tarihi',
    statusActions: 'Durum işlemleri',
    note: 'Açıklama',
    noteHint: 'reddederken zorunlu',
    actions: {
      approved: 'Onayla',
      rejected: 'Reddet',
      suspended: 'Askıya al',
    },
    confirm: {
      approved: 'Bayi onaylansın mı? Kullanıcıları bayi fiyatlarını görmeye başlar.',
      rejected: 'Bayi reddedilsin mi?',
      suspended: 'Bayi askıya alınsın mı? Kullanıcıları perakende fiyat görür.',
    },
    members: 'Kullanıcılar',
    membersLead: 'Firma adına vitrine giriş yapan kişiler.',
    roles: {
      owner: 'Yetkili',
      buyer: 'Satın alma',
      viewer: 'Yalnızca görüntüleme',
    },
    rolesLead: 'Rol, kullanıcının vitrinde firma adına neler yapabileceğini belirler.',
    roleHelp: {
      owner:
        'Sipariş verir; firma siparişlerini, cari hesabı ve firma kullanıcılarını görür; firma lokasyonlarını yönetir. Sipariş eşiği uygulanmaz.',
      buyer:
        'Sipariş verir ve yalnızca kendi siparişlerini görür. Sipariş eşiği girilirse bu tutarı aşan sipariş Yetkili onayı ister.',
      viewer:
        'Bayi fiyatlarını, firma siparişlerini ve cari hesabı görür; sipariş veremez (ör. muhasebe çalışanı).',
    },
    editMember: 'Rol ve eşik',
    orderRules: 'Sipariş koşulları',
    orderRulesLead:
      'Bu bayiye özel minimum sipariş tutarı (boşsa bayi grubunun tutarı) ve vitrin siparişinde satın alma emri (PO) zorunluluğu.',
    minOrder: 'Minimum sipariş tutarı ({{currency}})',
    minOrderHint: 'Boş: bayi grubunun tutarı',
    poRequirement: 'Satın alma emri (PO)',
    poRequirements: {
      none: 'İsteğe bağlı',
      number: 'PO numarası zorunlu',
      number_and_document: 'PO numarası ve belgesi zorunlu',
    },
    editMemberTitle: '{{name}} — rol ve sipariş eşiği',
    orderLimit: 'Sipariş eşiği ({{currency}})',
    orderLimitHint: 'Boş: eşik yok',
    orderLimitShort: 'Eşik: {{amount}}',
    confirmRemoveMember: '{{name}} firmadan çıkarılsın mı? Hesabı silinmez.',
    noMembers: 'Henüz kullanıcı yok.',
    role: 'Rol',
    addMember: 'Kullanıcı ekle',
    applications: 'Başvurular',
  },
  applications: {
    status: 'Durum',
    statuses: {
      pending: 'Bekliyor',
      approved: 'Onaylandı',
      rejected: 'Reddedildi',
    },
    empty: 'Başvuru yok',
    emptyLead: 'Vitrindeki bayilik başvuru formundan gelen başvurular burada listelenir.',
    documentCount: '{{count}} belge',
    businessType: 'İşletme türü',
    applicant: 'Başvuran',
    note: 'Başvuru notu',
    documents: 'Belgeler',
    noDocuments: 'Belge yüklenmemiş.',
    decisionNote: 'Açıklama',
    decisionNoteHint: 'Reddederken zorunludur ve başvurana e-postayla iletilir.',
    approve: 'Onayla',
    reject: 'Reddet',
  },
  imports: {
    products: 'Ürünler',
    productsLead:
      "Kendi şablonumuz (Excel/CSV), Shopify ürün CSV'si veya ürün JSON/XML belgesi. Ürünler taslak olarak eklenir; 50'den fazla ürün arka planda uygulanır.",
    columnMapping: 'Sütun eşleştirme',
    columnMappingLead:
      'Dosyadaki her sütunun hangi alana aktarılacağı. Tanınmayan sütunu bir alana bağlayın veya yok sayın, sonra yeniden önizleyin. Uygulayınca eşleştirme kaydedilir; aynı başlıklı sonraki dosyalarda kendiliğinden kullanılır.',
    unmatchedCount: '{{count}} sütun tanınmadı',
    fileColumn: 'Dosyadaki sütun',
    targetField: 'Aktarılacağı alan',
    columnSource: 'Nasıl eşleşti',
    noField: '— aktarılmaz —',
    ignoreColumn: 'Yok say',
    attributeColumn: 'Özellik sütunu',
    columnSources: {
      auto: 'Otomatik',
      saved: 'Kayıtlı eşleştirme',
      manual: 'Elle seçildi',
      attribute: 'Özellik',
      ignored: 'Yok sayılıyor',
      unmatched: 'Tanınmadı',
    },
    remap: 'Eşleştirmeyle yeniden önizle',
    fields: {
      handle: 'Ürün kodu (kısa ad)',
      title: 'Ürün adı',
      brand: 'Marka',
      categories: 'Kategori',
      species: 'Tür',
      shortDescription: 'Kısa açıklama',
      description: 'Açıklama',
      composition: 'İçerik (bileşim)',
      usage: 'Kullanım',
      warnings: 'Uyarılar',
      feedRegistrationNo: 'Yem kayıt no',
      tax: 'KDV',
      visibility: 'Görünürlük',
      option1Name: 'Seçenek 1 adı',
      option1Value: 'Seçenek 1 değeri',
      option2Name: 'Seçenek 2 adı',
      option2Value: 'Seçenek 2 değeri',
      option3Name: 'Seçenek 3 adı',
      option3Value: 'Seçenek 3 değeri',
      sku: 'SKU',
      barcode: 'Barkod',
      weight: 'Ağırlık (g)',
      cost: 'Maliyet',
      price: 'Fiyat',
      stock: 'Stok',
      images: 'Görsel adresleri',
      imageAlt: 'Görsel açıklaması',
      seoTitle: 'SEO başlığı',
      seoDescription: 'SEO açıklaması',
      tags: 'Etiketler',
    },
    importQueued: 'Arka planda uygulanıyor: {{processed}} / {{total}} ürün',
    importQueuedLead: 'Bu sayfadan ayrılabilirsiniz; içe aktarma sürer. Sonuç burada görünür.',
    importProgress: 'İçe aktarma ilerlemesi',
    retryFailed: 'Hatalıları yeniden dene',
    exportJson: 'JSON indir',
    exportXml: 'XML indir',
    template: 'Şablonu indir',
    exportProducts: 'Ürünleri indir',
    priceList: 'Fiyat listesi',
    skipPrices: 'Fiyatları alma',
    warehouse: 'Depo',
    skipStock: 'Stokları alma',
    defaultBrand: 'Varsayılan marka',
    healthContent: 'Ürünler sağlık içeriği taşır (veteriner onayı gerekir)',
    chooseFile: 'Dosya seç ve önizle',
    formats: {
      zootopia: 'Zootopia şablonu',
      shopify: 'Shopify CSV',
    },
    toCreate: '{{count}} yeni',
    toUpdate: '{{count}} güncelleme',
    skipped: '{{count}} atlanacak',
    variants: '{{count}} varyant',
    images: '{{count}} görsel',
    unknownHeaders: 'Tanınmayan sütunlar (yok sayılacak): {{list}}',
    issues: '{{count}} sorun bulundu; hatalı satırların ürünü/bayisi uygulanmaz.',
    row: 'Satır {{row}}',
    downloadIssues: 'Hata listesini indir',
    issueRow: 'Satır',
    issueField: 'Alan',
    issueProblem: 'Sorun',
    issueValue: 'Dosyadaki değer',
    productsDraftNote: 'Ürünler yayına alınmaz; kontrol edip veteriner onayından sonra yayınlayın.',
    apply: 'Uygula',
    applied: 'İçe aktarma uygulandı',
    stockSkippedLot:
      '{{count}} varyantın stoku lot/SKT ile takip edildiği için dosyadan yazılmadı; Stok ekranından lot seçerek girin.',
    productResult: '{{created}} ürün eklendi, {{updated}} güncellendi, {{failed}} başarısız.',
    categories: 'Kategoriler',
    categoriesLead:
      'Kategori ağacını dosyayla toplu ekleyin veya güncelleyin. Kategorileri ürünlerden önce yükleyin; aynı dosyayı tekrar yüklemek kopya oluşturmaz.',
    exportCategories: 'Kategorileri indir',
    categoriesPreview: 'Kategori önizlemesi',
    categoryResult: '{{created}} kategori eklendi, {{updated}} güncellendi.',
    createMissingCategories: 'Eksik kategorileri oluştur',
    categoryMode: 'Var olan ürünlerin kategorileri',
    categoryModes: {
      merge: 'Dosyadakileri ekle (mevcutlar kalır)',
      replace: 'Dosyadakilerle değiştir',
    },
    categoriesToCreate: '{{count}} kategori oluşturulacak',
    skuMissing:
      "{{count}} varyantın SKU'su boş; bu satırların ürünleri atlanacak. Önerilen SKU'lar hata listesinde parantez içinde (barkod varsa barkod, yoksa ürün kodu + seçenek).",
    skuGenerate: "Önerilen SKU'larla yeniden önizle",
    skuGenerated:
      "{{count}} varyanta SKU önerildi (aşağıda ürün bazında). Uygularsanız bu SKU'lar kaydedilir; aynı dosya tekrar yüklenince aynı SKU'lar üretilir, kopya oluşmaz.",
    mediaStatusTitle: 'İçe aktarılan görseller',
    mediaPending: '{{count}} görsel indirme bekliyor (arka planda, 30 sn aralıklarla).',
    mediaFailed: '{{count}} görsel indirilemedi.',
    mediaReasons: 'Nedenler: {{list}}',
    mediaRetryAll: 'İndirilemeyenleri yeniden dene',
    mediaRetryQueued: '{{count}} görsel yeniden indirilecek.',
    dealers: 'Bayi listesi',
    dealersLead:
      'Zorunlu: Firma Unvanı ve Bayi Kodu veya Vergi No. Aynı dosyayı tekrar yüklemek kopya oluşturmaz.',
    exportDealers: 'Bayileri indir',
    noDealerGroups: 'Önce Fiyatlar sayfasında "Bayi" türünde bir müşteri grubu oluşturun.',
    defaultGroup: 'Varsayılan bayi grubu',
    defaultStatus: 'Varsayılan durum',
    useCompanyEmail: 'Yetkili e-postası yoksa firma e-postasını giriş e-postası yap',
    sendLinks: 'Kullanıcılara şifre belirleme e-postası gönder',
    unchanged: '{{count}} değişmeyen',
    errorRows: '{{count}} hatalı satır',
    members: '{{count}} kullanıcı',
    action: 'İşlem',
    actions: {
      create: 'Yeni',
      update: 'Güncelleme',
      unchanged: 'Değişmiyor',
      error: 'Hatalı',
    },
    dealerResult: '{{created}} bayi eklendi, {{updated}} güncellendi, {{members}} kullanıcı bağlandı.',
    linksEmailed: '{{count}} kullanıcıya şifre belirleme e-postası gönderildi.',
    needActivation:
      '{{count}} kullanıcıya bağlantı gönderilmedi (e-posta kurulu değil veya seçilmedi). Bağlantıyı bayi sayfasından üretebilir ya da e-posta kurulunca bayiler "Şifremi unuttum" ile hesaplarını açabilir.',
  },
  orders: {
    geliver: {
      ship: 'Geliver ile kargola',
      lead: 'Koli ölçülerini ve ağırlığı girin, kargo firmalarının tekliflerini alın, birini seçip etiketi satın alın.',
      testBadge: 'Test ortamı',
      weight: 'Ağırlık (g)',
      weightMissing:
        '{{count}} ürünün ağırlığı girilmemiş; varsayılan ağırlık eklendi. Paketi tartıp düzeltin.',
      getOffers: 'Teklifleri getir',
      offersPending: 'Teklifler geliyor (%{{percent}})',
      refresh: 'Yenile',
      noOffers: 'Teklif gelmedi. Ölçüleri ve adresi kontrol edip yeniden deneyin.',
      offers: 'Kargo teklifleri',
      cheapest: 'En ucuz',
      fastest: 'En hızlı',
      buy: 'Etiketi satın al ({{amount}})',
      confirm:
        'Etiket ücreti {{amount}} Geliver bakiyenizden düşülecek; gönderi kaydedilir ve paketteki ürünler stoktan düşer.',
      confirmTest:
        'Test gönderisi için etiket alınacak; gönderi kaydedilir ve paketteki ürünler stoktan düşer.',
      confirmYes: 'Onayla ve satın al',
      back: 'Geri',
      bought: 'Etiket alındı; gönderi kaydedildi.',
      codNote: 'Kapıda ödemeli siparişler şimdilik Geliver ile gönderilmez.',
      notReady: 'Geliver ile göndermek için Kargo sayfasında gönderici adresi seçin.',
      badge: 'Geliver',
      label: 'Etiketi aç',
      sync: 'Durumu yenile',
      synced: 'Durum güncellendi',
      cancel: "Geliver'de iptal et",
      cancelConfirm:
        "Gönderi Geliver'de iptal edilecek; paketteki ürünler stoğa döner ve sipariş yeniden gönderilebilir. Etiket ücretinin iadesi Geliver'in kurallarına göre yapılır.",
      cancelled: 'Gönderi iptal edildi',
      price: 'Etiket {{amount}}',
      awaitingTracking: 'Takip numarası kargo firması paketi alınca gelir; müşteriye e-posta o zaman gider.',
    },
    createManual: 'Sipariş oluştur',
    paymentNote:
      'Kartla ödenen siparişler sağlayıcının doğrulamasıyla kendiliğinden "Ödendi" olur. Havale/EFT siparişlerinde para geçince sipariş ayrıntısında "Ödeme alındı"yı kullanın; kapıda ödeme ve bayi açık hesabı siparişleri doğrudan "Hazırlanıyor" gelir.',
    search: 'Ara (sipariş no, müşteri, firma, PO no)',
    po: {
      title: 'Satın alma emri ve firma onayı',
      lead: 'Bayinin satın alma emri (PO) numarası ve belgesi; Satın alma kullanıcısının eşiği aşan siparişinde firma Yetkilisinin onayı.',
      number: 'PO numarası',
      save: 'PO numarasını kaydet',
      document: 'PO belgesi:',
      download: '{{name}} ({{kb}} KB) indir',
      noDocument: 'eklenmedi',
      attach: 'Belge ekle',
      replace: 'Belgeyi değiştir',
      attached: 'PO belgesi eklendi.',
      approval: 'Firma içi onay',
      requestedBy: 'İsteyen',
      approvedBy: 'Onaylayan (firma Yetkilisi)',
      approvedAmount: 'Onaylanan ürün toplamı',
      approvalNote: 'Onay notu',
      listLabel: 'PO: {{number}}',
    },
    status: 'Durum',
    statuses: {
      draft: 'Taslak',
      awaiting_payment: 'Ödeme bekliyor',
      paid: 'Ödendi',
      processing: 'Hazırlanıyor',
      shipped: 'Kargoda',
      delivered: 'Teslim edildi',
      completed: 'Tamamlandı',
      cancelled: 'İptal',
    },
    empty: 'Henüz sipariş yok',
    emptyLead: 'Vitrin siparişleri, bayi siparişleri ve panelden girilen siparişler burada listelenir.',
    number: 'Sipariş no',
    customer: 'Müşteri',
    channel: 'Kanal',
    channels: {
      web: 'Vitrin',
      b2b: 'Bayi',
      manual: 'Panel',
      api: 'API',
    },
    total: 'Toplam',
    detailTitle: 'Sipariş {{number}}',
    backToList: 'Sipariş listesi',
    payment: {
      unpaid: 'Ödenmedi',
      pending: 'Ödeme bekleniyor',
      paid: 'Ödendi',
      authorized: 'Provizyon alındı',
      partially_refunded: 'Kısmi iade',
      refunded: 'İade edildi',
    },
    lines: 'Ürünler',
    qty: 'Adet',
    unitPrice: 'Birim fiyat',
    lineTotal: 'Tutar',
    lotAllocated: "Lot / SKT'ye göre ayrıldı",
    subtotal: 'Ara toplam',
    discount: 'İndirim {{code}}',
    promotion: 'Kampanya: {{label}}',
    loyaltyTier: 'Seviye indirimi: {{tier}} ({{percent}})',
    loyaltyPoints: '{{points}} puan',
    shippingPromotion: 'Ücretsiz ({{label}})',
    tax: 'KDV',
    shipping: 'Kargo',
    customerInfo: 'Müşteri ve adres',
    shippingAddress: 'Teslimat adresi',
    billingAddress: 'Fatura adresi',
    customerNote: 'Sipariş notu',
    changeStatus: 'Durum işlemleri',
    actions: {
      awaiting_payment: 'Siparişi kesinleştir (stok ayır)',
      processing: 'Hazırlanıyor',
      shipped: 'Kargoya verildi',
      delivered: 'Teslim edildi',
      completed: 'Tamamla',
      cancelled: 'İptal et',
    },
    actionHints: {
      awaiting_payment: 'Taslak sipariş kesinleşir; stok ayrılır ve kupon hakkı sayılır.',
      processing: 'Sipariş hazırlanmaya başlar. Hazır olunca "Kargoya ver" ile takip numarasını girin.',
      shipped: 'Ayrılan stok defterden "satış" olarak düşülür. Bu adımdan sonra iptal yapılamaz.',
      delivered: 'Sipariş müşteriye teslim edildi olarak işaretlenir.',
      completed: 'Sipariş kapatılır.',
      cancelled: 'Ayrılan stok ve kupon hakkı geri verilir.',
    },
    statusNote: 'Açıklama',
    timeline: 'Zaman çizelgesi',
    noteEvent: 'İç not',
    internalNote: 'İç not ekle',
    addNote: 'Not ekle',
    manualLead: 'Fiyatlar müşterinin grubuna göre (bayiyse bayi fiyatı) hesaplanır.',
    createButton: 'Siparişi oluştur',
    created: 'Sipariş oluşturuldu',
    changeCustomer: 'Değiştir',
    customerHint: 'Ad ile arayın (kişisel veri yetkiniz varsa e-postayla da).',
    addProduct: 'Ürün ekle',
    manualPrice: 'Elle birim fiyat',
    manualPricePlaceholder: 'Liste fiyatı',
    fullName: 'Alıcı adı',
    addressLine: 'Adres',
    discountCode: 'Kupon kodu',
    initialStatus: 'Başlangıç durumu',
    codFee: 'Kapıda ödeme bedeli',
    paymentMethod: 'Ödeme yöntemi',
    paymentMethods: {
      card: 'Kredi/banka kartı',
      paypal: 'PayPal',
      bank_transfer: 'Havale/EFT',
      cash_on_delivery: 'Kapıda ödeme',
      open_account: 'Açık hesap (cari)',
      manual: 'Elle (havale/nakit vb.)',
      gift_card: 'Hediye kartı',
      store_credit: 'Mağaza kredisi',
      loyalty_points: 'Sadakat puanı',
    },
    shippingMethod: 'Kargo yöntemi',
    initialStatuses: {
      confirmed: 'Kesinleştir (stok ayır)',
      draft: 'Taslak (stok ayırma)',
    },
    paymentsTitle: 'Ödeme',
    capture: 'Ödeme alındı',
    refund: 'İade et',
    noPayments: 'Ödeme kaydı yok.',
    installments: '{{count}} taksit',
    refundedAmount: 'İade: {{amount}}',
    refunds: 'İadeler',
    refundReasons: {
      customer_request: 'Müşteri talebi',
      withdrawal: 'Cayma hakkı',
      damaged: 'Hasarlı/kusurlu ürün',
      out_of_stock: 'Stok yok',
      duplicate: 'Mükerrer ödeme',
      other: 'Diğer',
    },
    restocked: 'stoğa geri alındı',
    testPaymentWarning:
      'Bu siparişin ödemesi test ortamında alındı; gerçek para çekilmedi. Kargoya vermeyin; deneme bittiyse siparişi iptal edin.',
    resolveRefund: 'Sonucu belirle',
    resolveRefundTitle: 'İade sonucunu belirle',
    resolveRefundLead:
      'Bu iade işlemi yarıda kaldı ve sonucu bilinmiyor. Ödeme sağlayıcısının panelinde iadenin yapılıp yapılmadığını kontrol edin ve sonucu seçin. Sağlayıcıya yeni iade isteği gönderilmez.',
    resolveRefundOutcome: 'Sağlayıcı panelinde bu iade',
    resolveRefundSucceeded: 'Yapılmış (tutar iade edildi)',
    resolveRefundFailed: 'Yapılmamış',
    resolveRefundNote: 'Açıklama',
    resolveRefundSave: 'Sonucu kaydet',
    resolveRefundDone: 'İade sonucu kaydedildi',
    eventTypes: {
      preauth_captured: 'Provizyon tahsil edildi',
      preauth_released: 'Provizyon bırakıldı; sipariş iptal edildi',
      preauth_capture_failed: 'Provizyon tahsil edilemedi',
      edited: 'Sipariş düzenlendi',
      return_requested: 'İade/cayma talebi açıldı',
      return_approved: 'İade talebi onaylandı',
      return_rejected: 'İade talebi reddedildi',
      return_completed: 'İade talebi tamamlandı',
      return_cancelled: 'İade talebi iptal edildi',
      created: 'Sipariş oluşturuldu',
      status_changed: 'Durum değişti',
      payment_failed: 'Ödeme başarısız',
      payment_review: 'Ödeme incelemeye düştü',
      payment_after_cancel: 'İptal edilen siparişe ödeme geldi (iade gerekli)',
      payment_captured: 'Ödeme alındı',
      payment_amount_mismatch: 'Ödeme tutarı uyuşmadı',
      refund: 'İade yapıldı',
      refund_failed: 'İade başarısız',
      partially_shipped: 'Paket kargoya verildi (kısmi gönderi)',
      exchange_shipped: 'Değişim ürünü kargoya verildi',
      items_cancelled: 'Ürünler iptal edildi (kısmi iptal)',
      shipment_cancelled: 'Gönderi iptal edildi; ürünler stoğa geri alındı',
    },
    eventMessages: {
      draft_updated: 'Taslak güncellendi (ürünler, müşteri, kargo veya indirim).',
      lines_changed: 'Ürünler/adetler değişti; tutarlar ve stok ayırma yeniden hesaplandı.',
      address_changed: 'Teslimat adresi değişti.',
      billing_changed: 'Fatura adresi değişti.',
      note_changed: 'Sipariş notu değişti.',
      po_number_changed: 'Satın alma emri (PO) numarası değişti.',
      po_document_attached: 'Satın alma emri (PO) belgesi eklendi.',
      payment_timeout: 'Ödeme süresi doldu; sipariş kendiliğinden iptal edildi.',
      bank_transfer_timeout: 'Havale/EFT ödemesi süresinde gelmedi; sipariş kendiliğinden iptal edildi.',
    },
    refundStatuses: {
      pending: 'Sürüyor',
      succeeded: 'Başarılı',
      failed: 'Başarısız',
    },
    captured: 'Ödeme kaydedildi',
    captureTitle: 'Ödeme alındı · {{amount}}',
    captureLead:
      'Paranın hesabınıza geçtiğini kontrol ettikten sonra kaydedin. Müşteriye "ödemeniz alındı" e-postası gider.',
    captureNote: 'Ödeme açıklaması',
    refundDone: 'İade yapıldı',
    refundFailed: 'İade başarısız; ayrıntı ödeme bölümünde',
    refundTitle: 'Para iadesi',
    refundCardLead:
      'İade, ödemenin alındığı sağlayıcı (iyzico, PayTR, Sipay, Stripe veya PayPal) üzerinden yapılır; tutarın karta veya PayPal hesabına yansıması birkaç iş günü sürebilir.',
    refundManualLead: 'Havale/kapıda ödeme iadesini bankanızdan siz yaparsınız; burada kaydını tutarsınız.',
    refundConfirm: 'İadeyi yap',
    refundable: 'İade edilebilir: {{amount}}',
    refundAmount: 'İade tutarı (₺)',
    refundReason: 'Neden',
    refundNote: 'Açıklama',
    refundNoteHint: 'Ör. iade edilen IBAN ve tarih.',
    refundPayment: 'İade edilecek ödeme',
    refundPaymentOption: '{{provider}} · iade edilebilir {{amount}}',
    refundAsCredit: 'Para yerine mağaza kredisi olarak iade et',
    refundCreditConsent: 'Müşteri, iadenin mağaza kredisi olarak verilmesini açıkça kabul etti',
    refundCreditLead:
      'Tutar müşterinin mağaza kredisine yazılır; karta veya banka hesabına iade yapılmaz. Yalnızca müşterinin açık onayıyla ve cayma dışındaki iadelerde kullanılır.',
    refundTenderLead: 'Tutar hediye kartına veya mağaza kredisine geri yüklenir; sağlayıcıya iade yapılmaz.',
    refundToStoreCredit: 'Mağaza kredisi olarak',
    restock: 'İade gelen ürünleri stoğa geri al',
    restockQty: '{{title}} geri alınan adet',
    shipmentsTitle: 'Kargo',
    ship: 'Kargoya ver',
    shipAfterPayment: 'Ödeme alınmadan kargoya verilemez.',
    noShipments: 'Henüz gönderi yok.',
    trackingLink: 'Takip',
    shipmentStatuses: {
      created: 'Oluşturuldu',
      in_transit: 'Yolda',
      out_for_delivery: 'Dağıtımda',
      delivered: 'Teslim edildi',
      returned: 'İade',
      exception: 'Sorun var',
      cancelled: 'İptal',
    },
    updateShipment: 'Durumu güncelle',
    shipped: 'Sipariş kargoya verildi',
    shipTitle: 'Kargoya ver',
    shipLead:
      'Pakete giren ürünleri ve adetleri seçin. Paketteki adetler stoktan düşer ve müşteriye takip numarasıyla e-posta gider. Kalan ürün yoksa sipariş "Kargoda" olur; bir bölümü gönderilirse sipariş hazırlanıyor kalır.',
    shipItems: 'Paketteki ürünler',
    shipQty: '{{title}} gönderilecek adet',
    shipProgress: '{{shipped}}/{{ordered}} gönderildi',
    shipCodNote: 'Kapıda ödemeli sipariş bölünemez; kalan ürünlerin hepsi bu pakette gönderilir.',
    shipPartialNote: 'Bu paket siparişin bir bölümü; kalan ürünler sonraki gönderiyle yollanır.',
    shipNothing: 'Pakete en az bir ürün ekleyin.',
    shippedPartial: 'Paket kargoya verildi; kalan ürünler gönderilmeyi bekliyor',
    partiallyShipped: 'Kısmen gönderildi',
    ledgerSettled: 'Cari ile kapandı',
    exportExempt: 'İhracat — KDV istisnası',
    waitingToShip: 'Gönderilmeyi bekleyen: {{items}}',
    shipmentItem: '{{quantity}} × {{title}}',
    chooseProvince: 'İl seçin',
    chooseDistrict: 'İlçe seçin',
    chooseProvinceFirst: 'Önce il seçin',
    legacyPlace: '{{value}} (listede yok)',
    cancelledQty: '{{count}} iptal',
    cancelledItems: 'İptal edilen ürünler',
    refundDue:
      'Gönderilemeyip iptal edilen ürünlerin {{amount}} tutarı henüz iade edilmedi. "İade et" ile iade edin (tutar önerilir).',
    cancelItems: 'Kalan ürünleri iptal et',
    cancelItemsLead:
      'Gönderilemeyecek ürünler siparişten iptal edilir: ayrılan stok serbest kalır, müşteriye e-posta gider. Sipariş tutarı değişmez; ödemesi alınmışsa iptal edilen ürünlerin tutarını "İade et" ile iade edin. Kalan ürün kalmazsa sipariş "Kargoda" olur.',
    cancelQty: '{{title}} iptal edilecek adet',
    cancelItemsNote: 'Müşteriye açıklama',
    cancelItemsNoteHint: 'E-postada müşteriye gösterilir (ör. "Ürün tedarikçide kalmadı").',
    itemsCancelled: 'Ürünler iptal edildi; iptal tutarı {{amount}}',
    trackingNumber: 'Takip numarası',
    trackingUrl: 'Takip adresi',
    trackingUrlHint: 'Boş bırakırsanız firmanın takip sayfası kullanılır (biçimi doğrulanmamıştır).',
    packageCount: 'Koli sayısı',
    updateShipmentLead:
      '"Teslim edildi" seçilirse ve siparişin tüm paketleri teslim edildiyse sipariş de teslim edildi olur.',
    shipmentCancelNote:
      'İptal edilen paketteki ürünler stoğa geri alınır ve siparişe yeniden ayrılır; sipariş "Hazırlanıyor"a döner ve ürünler yeniden gönderilebilir. Yalnızca paket kargoya hiç verilmediyse iptal edin.',
    shipmentStatus: 'Durum',
    shipmentNote: 'Açıklama',
    invoicesTitle: 'Fatura',
    createInvoice: 'Fatura oluştur',
    noInvoices: 'Fatura yok.',
    contractsTitle: 'Onaylanan metinler',
    contractsLead: 'Müşterinin sipariş sırasında gördüğü ve onayladığı metinler, sürümü ve zamanıyla.',
    contractHash: 'Metin özeti: {{hash}}…',
  },
  orderTools: {
    manualPriceHint:
      'Elle birim fiyat ({{currency}}, KDV durumu fiyat listesindeki gibi); boş bırakılırsa müşterinin liste fiyatı kullanılır.',
    editDraftTitle: 'Taslak sipariş {{number}}',
    saveDraft: 'Taslağı kaydet',
    customerKind: 'Müşteri türü',
    customerKinds: { customer: 'Kayıtlı müşteri', guest: 'Misafir' },
    guestEmail: 'E-posta',
    guestEmailHint: 'Sipariş ve ödeme bilgileri bu adrese gider.',
    maskedKeep: 'Kayıtlı değer gizli; değiştirmek istemiyorsanız boş bırakın.',
    guestPhone: 'Müşteri telefonu',
    noShippingMethod: 'Kargo yöntemi yok (ücretsiz veya sonra belirlenecek)',
    audience: { retail: 'yalnızca perakende', dealers: 'yalnızca bayi' },
    shippingFee: 'Kargo ücreti ({{currency}}, KDV dahil)',
    shippingFeeHint:
      'Boş bırakılırsa ücret seçilen yöntemden hesaplanır (ağırlık kademesi, ücretsiz kargo sınırı).',
    discountKind: 'İndirim',
    discountKinds: { none: 'İndirim yok', code: 'Kupon kodu', manual: 'Elle tutar' },
    manualDiscount: 'İndirim tutarı ({{currency}}, KDV dahil)',
    manualDiscountHint: 'Ürünlere tutarlarıyla orantılı dağıtılır; ara toplamı geçemez.',
    addressMasked:
      'Adres gizli (kişisel verileri görme yetkiniz yok). Değiştirmek için adresi baştan girin; boş bırakırsanız kayıtlı adres korunur.',
    editLinesTitle: 'Ürünleri düzenle',
    editLinesLead:
      'Siparişteki ürünlerin birim fiyatı korunur; yeni eklenen ürün güncel fiyatla eklenir. Kargo ücreti değişmez, stok yeniden ayrılır.',
    editAddressTitle: 'Adres ve notu düzenle',
    editAddressLead:
      'Gönderi oluşturulana kadar teslimat adresi ve sipariş notu değiştirilebilir. Fatura kesildiyse fatura adresi değişmez.',
    editDraft: 'Taslağı düzenle',
    editLines: 'Ürünleri düzenle',
    editAddress: 'Adres ve notu düzenle',
    bulkRegion: 'Seçili siparişler',
    selected: '{{count}} sipariş seçildi',
    printOrders: 'Sipariş özeti yazdır',
    printPacking: 'Sevk listesi yazdır',
    exportSelected: 'Excel olarak indir',
    bulkStatus: 'Durumu değiştir',
    bulkDone: '{{count}} siparişin durumu değişti.',
    bulkStatusTitle: '{{count}} siparişin durumunu değiştir',
    bulkStatusLead:
      'Her sipariş kendi kurallarıyla değişir (stok, kupon, müşteri bildirimi); uygun olmayanlar nedeniyle listelenir.',
    bulkApply: 'Uygula',
    bulkSummary: '{{ok}} sipariş değişti, {{failed}} değişmedi.',
    bulkTarget: 'Yeni durum',
    bulkCancelWarning:
      'İptal edilen siparişlerin müşterilerine iptal e-postası gider; ayrılan stok ve kupon hakkı geri verilir. Ödenmiş sipariş iade yapılmadan iptal edilmez.',
    selectAllPage: 'Bu sayfadaki siparişlerin tümünü seç',
    selectRow: '{{number}} siparişini seç',
  },
  preauth: {
    held: 'Kartta {{amount}} provizyon (bloke) var; henüz çekilmedi.',
    deadline: 'Son tahsil tarihi: {{date}} ({{days}} gün kaldı).',
    expiringSoon: 'Süre dolmak üzere: kargoya verin veya şimdi tahsil edin.',
    partial:
      'Sipariş toplamı {{amount}}: tahsilatta bu tutar çekilir, kalan {{rest}} bloke bankaca kaldırılır.',
    capture: 'Tahsil et',
    captureTitle: 'Provizyonu tahsil et',
    captureLead:
      'Karttaki {{held}} provizyondan {{amount}} çekilecek. Kargoya verirken bu işlem kendiliğinden de yapılır.',
    captured: 'Tutar tahsil edildi',
    release: 'Provizyonu bırak',
    releaseTitle: 'Provizyonu bırak',
    releaseLead:
      'Karttaki bloke kaldırılır ve sipariş iptal edilir; stok ve kupon hakkı geri verilir, müşteriye iptal e-postası gider. Bu işlem geri alınamaz.',
    releaseNote: 'Açıklama',
    released: 'Provizyon bırakıldı; sipariş iptal edildi',
  },
  paymentLinks: {
    title: 'Ödeme linki',
    create: 'Ödeme linki oluştur',
    renew: 'Yeni bağlantı oluştur',
    empty: 'Bu sipariş için ödeme linki yok.',
    createdAt: 'Oluşturuldu: {{date}}',
    expiresAt: 'Son geçerlilik: {{date}}',
    paidAt: 'Ödendi: {{date}}',
    openedAt: 'Müşteri açtı: {{date}}',
    notOpened: 'Henüz açılmadı',
    states: {
      active: 'Geçerli',
      paid: 'Ödendi',
      expired: 'Süresi doldu',
      cancelled: 'İptal edildi',
      closed: 'Kapandı',
      amount_changed: 'Tutar değişti',
    },
    cancel: 'İptal et',
    cancelConfirm: 'Bağlantı iptal edilsin mi? Müşteri bu bağlantıyla ödeme yapamaz.',
    cancelledToast: 'Bağlantı iptal edildi',
    createTitle: 'Ödeme linki oluştur',
    createLead:
      'Müşteri bağlantıda siparişi ve sözleşme metinlerini görür, onaylar ve {{amount}} tutarı kartla öder.',
    draftNote:
      'Sipariş taslak: bağlantı oluşturulunca sipariş kesinleşir, stok ayrılır ve kupon hakkı sayılır.',
    renewNote: 'Geçerli bağlantı iptal edilir; müşteriye yeni bağlantıyı gönderin.',
    hours: 'Geçerlilik süresi',
    hourOptions: { h24: '24 saat', h72: '3 gün', h168: '7 gün', h720: '30 gün' },
    sendEmail: 'Bağlantıyı müşterinin e-posta adresine gönder ({{email}})',
    noEmail: 'Siparişte e-posta adresi yok; bağlantıyı kopyalayıp müşteriye kendiniz iletin.',
    createButton: 'Oluştur',
    createdTitle: 'Ödeme linki hazır',
    createdLead:
      'Bağlantı yalnızca şimdi gösterilir; kopyalayıp müşteriye iletin (WhatsApp, SMS, e-posta). Kaybolursa yeni bağlantı oluşturun.',
    url: 'Bağlantı',
    copy: 'Kopyala',
    copied: 'Bağlantı kopyalandı',
    copyFailed: 'Kopyalanamadı; bağlantıyı seçip elle kopyalayın.',
    emailed: 'Bağlantı müşterinin e-posta adresine gönderildi.',
    notEmailed: 'E-posta gönderilmedi.',
  },
  proforma: {
    title: 'Proforma fatura',
    open: 'Proforma fatura',
    back: 'Siparişe dön',
    documentLabel: 'Proforma fatura {{number}}',
    notInvoice: 'Bu belge proforma faturadır; ticari fatura (e-Fatura / e-Arşiv) yerine geçmez.',
    currency: 'Para birimi: {{currency}}',
    sellerTax: 'Vergi dairesi / no: {{office}} / {{number}}',
    mersis: 'MERSİS: {{no}}',
    buyer: 'Alıcı',
    consignee: 'Teslim alan',
    totalWeight: 'Toplam ürün ağırlığı',
    kg: '{{value}} kg',
    description: 'Mal tanımı',
    hsCode: 'GTİP',
    origin: 'Menşe',
    weight: 'Ağırlık',
    discount: 'İndirim',
    exportExemption: 'İhracat teslimi: KDV hesaplanmamıştır (3065 sayılı KDV Kanunu 11/1-a).',
    exemptionVerify: 'İstisna gerekçesi ve belgedeki ifade mali müşavirinizce teyit edilmelidir.',
    fxLine: 'Kur: {{pair}} (TCMB döviz alış, {{date}})',
    pricesInclusive: 'Fiyatlara KDV dahildir.',
    pricesExclusive: 'Fiyatlara KDV dahil değildir.',
    missingCustoms:
      'GTİP veya menşe ülkesi eksik ürünler: {{skus}}. Ürün düzenleme sayfasındaki "Gümrük ve ihracat" bölümünden tamamlayın.',
  },
  catalogTranslations: {
    title: 'Çeviriler',
    productLead:
      'Ürünün ana dili {{base}}. Diğer dillerde ad, açıklama ve SEO alanları; çevirisi olan dil vitrinde dil önekli adreste (ör. /en/…) arama motorlarına açılır.',
    missing: 'Çeviri yok',
    findings: '{{count}} olası sağlık iddiası; onaylamadan önce inceleyin',
    vet: { approved: 'Onaylandı', pending: 'Veteriner onayı bekliyor' },
    approve: 'Onayla',
    approveConfirm: '{{language}} çevirisi onaylansın mı? Onaylanan metin vitrinde yayınlanır.',
    approved: 'Çeviri onaylandı.',
    add: 'Çeviri ekle',
    deleteConfirm: '{{language}} çevirisi silinsin mi?',
    dialogTitle: '{{language}} çevirisi',
    dialogLead:
      'Boş bırakılan açıklama alanları vitrinde gösterilmez. Bileşim, kullanım ve uyarılar ana dilde kalır.',
    productTitle: 'Ürün adı',
    shortDescription: 'Kısa açıklama',
    description: 'Açıklama',
    seoTitle: 'SEO başlığı',
    seoDescription: 'SEO açıklaması',
    categoryTitle: '{{name}} — çeviriler',
    categoryLead:
      'Kategori adı, açıklaması ve SEO alanları; çevirisi olan kategori o dilde arama motorlarına açılır.',
    noLanguages: 'Mağazalarınızda ana dil dışında dil yok. Başka dilde pazar ekleyince çeviri yapılabilir.',
    language: 'Dil',
    done: 'çevrildi',
    categoryName: 'Kategori adı',
    saveLanguage: '{{language}} kaydet',
  },
  orderPrint: {
    orderTitle: 'Sipariş özeti',
    packingTitle: 'Sevk listesi',
    print: 'Yazdır / PDF kaydet',
    nothing: 'Yazdırılacak sipariş bulunamadı.',
    lead: '{{count}} sipariş. Her sipariş ayrı sayfaya basılır; PDF için yazdırma penceresinde "PDF olarak kaydet"i seçin.',
    maskedNote: 'Kişisel verileri görme yetkiniz olmadığı için adresler ve iletişim bilgileri gizli.',
    documentLabel: '{{title}} {{number}}',
    packingNote: 'Depo içi toplama ve sevk listesi; e-İrsaliye yerine geçmez.',
    lots: 'Lot / SKT',
    check: 'Kontrol',
    lotLine: '{{lot}} (SKT {{expiry}}) × {{qty}}',
    preparedBy: 'Hazırlayan',
    checkedBy: 'Kontrol eden',
  },
  payments: {
    store: 'Mağaza',
    noStore: 'Önce bir mağaza oluşturun',
    noStoreLead: 'Ödeme ve kargo ayarları mağaza bazındadır. Mağazalar ekranından mağaza ekleyin.',
    cardTitle: 'Kartla ödeme (sanal POS)',
    cardLead:
      'iyzico veya PayTR. Kart bilgisi mağazaya gelmez; ödeme sağlayıcının güvenli sayfasında alınır.',
    envSandbox: 'Test',
    envLive: 'Canlı',
    keysHint: 'Anahtarlar Entegrasyonlar ekranında şifreli saklanır; bağlantı testi de orada yapılır:',
    cardProvider: 'Kartla ödeme sağlayıcısı',
    cardOff: 'Kapalı',
    cardStatus: 'Vitrinde kartla ödeme:',
    cardState_off: 'Kapalı',
    cardState_test: 'Test (gerçek para çekilmez)',
    cardState_live: 'Canlı',
    cardNext_off_none:
      "Sonraki adım: Entegrasyonlar'da iyzico veya PayTR test (sandbox) anahtarlarını girip bağlantıyı test edin; sonra aşağıda sağlayıcıyı seçip kaydedin.",
    cardNext_off_live_only:
      'Canlı anahtarlar bağlı ama kart ödemesi kapalı. İşletme sahibi: sağlayıcıyı seçin veya "Canlıya geç"e basın; test ödemesi yoksa uyarıyı onaylayıp iki adımlı doğrulamayla doğrudan canlıya geçebilirsiniz, sonra ilk canlı siparişi küçük tutarla verip iade edin. Diğer roller için önce test ortamında başarılı bir ödeme gerekir.',
    cardNext_off_ready:
      'Sonraki adım: aşağıda sağlayıcıyı seçip kaydedin; kart ödemesi test ortamında açılır.',
    cardNext_test:
      'Müşteriler test kartıyla ödeyebilir, gerçek para çekilmez. Bir test siparişiyle ödeme yapıp sonucu Ödemeler\'de görün; başarılıysa "Canlıya geç" ile gerçek ödemeye geçin (yayın günü).',
    cardNext_live: 'Gerçek kart ödemeleri alınıyor.',
    environment: 'Ortam',
    goLive: 'Canlıya geç',
    backToSandbox: 'Teste dön',
    backToSandboxConfirm: 'Kartla ödeme kapatılır ve test ortamına dönülür. Devam edilsin mi?',
    sandboxNote: 'Test ortamında gerçek para çekilmez; sağlayıcının test kartlarıyla deneme siparişi verin.',
    maxInstallments: 'Taksit',
    singlePayment: 'Tek çekim',
    upTo: '{{count}} taksite kadar',
    cardTimeout: 'Kart ödemesi süresi (dakika)',
    cardCapture: 'Tahsilat zamanı',
    cardCaptures: {
      immediate: 'Ödeme anında çek',
      preauth: 'Önce provizyon, kargoya verirken çek',
    },
    cardCapturePreauthHint:
      'Tutar ödeme sırasında kartta bloke edilir; sipariş kargoya verilirken (veya sipariş ayrıntısında "Tahsil et" ile) çekilir. 25 gün içinde tahsil edilmeyen bloke banka tarafından kaldırılır. Tek çekim; banka kartlarıyla (debit) provizyon yapılamaz.',
    preauthPaytr:
      "PayTR'de ön provizyon seçeneği yok: PayTR'nin ön provizyon teknik belgesi herkese açık değil; PayTR'den belge alınınca eklenebilir.",
    preauthSipay: "Sipay'de ön provizyon kullanılmaz: tahsilat ödeme anında yapılır.",
    cardCurrencies: 'Kartla döviz tahsilatı',
    cardCurrenciesHint: {
      iyzico:
        'TL dışı para birimindeki mağazada kart yalnızca burada işaretli para biriminde sunulur. iyzico ile döviz tahsilatı anlaşması yaptıysanız işaretleyin.',
      paytr:
        "TL dışı para birimindeki mağazada kart yalnızca burada işaretli para biriminde sunulur. PayTR'de EUR/USD/GBP için PayTR kurumsal ekibiyle anlaşma gerekir.",
      sipay:
        'TL dışı para birimindeki mağazada kart yalnızca burada işaretli para biriminde sunulur. Sipay EUR ve USD kabul eder; döviz tahsilatı için Sipay ile anlaşma gerekir.',
      stripe:
        'Döviz kart ödemesi Stripe ile: burada işaretli para birimindeki pazarlarda kart Stripe’ın ödeme sayfasıyla alınır.',
    },
    cardCurrencyLabel: '{{currency}} ile kart ödemesi',
    notifyUrls: 'Bildirim adresleri',
    iyzicoNotify: 'iyzico bildirim (webhook) adresi',
    paytrNotify: 'PayTR Bildirim URL',
    sipayNotify: 'Sipay bildirim (webhook) adresi',
    intlTitle: 'Yurt dışı ödemeler (Stripe, PayPal)',
    intlLead:
      'Döviz pazarlarında kartı Stripe’ın, PayPal ödemesini PayPal’ın güvenli sayfasında alın. TL ödemeleri yukarıdaki kart sağlayıcısıyla alınmaya devam eder.',
    intlEntityTitle: 'Yurt dışında kurulu şirket gerekir',
    intlEntityLead:
      'Stripe ve PayPal, Türkiye’de kurulu işletmelere hesap açmıyor. Hesap, desteklenen bir ülkedeki şirketiniz adına açılır ve tahsilat o şirkete geçer. Faturalama ve muhasebeyi mali müşavirinizle netleştirmeden canlıya geçmeyin.',
    intlCardProvider: 'Döviz kart ödemesi',
    intlCardHint: 'Stripe seçiliyse TL dışı kart ödemeleri Stripe ile alınır; taksit ve ön provizyon yoktur.',
    intlCardOff: 'Yurt içi kart sağlayıcısıyla (döviz anlaşması varsa)',
    intlCardEnvironment: 'Döviz kartı ortamı',
    paypal: 'PayPal ile ödeme',
    paypalHint:
      'Ödeme adımında PayPal seçeneği; yalnızca EUR, USD ve GBP pazarlarında görünür. Önce Entegrasyonlar → PayPal bağlantısını kurun.',
    paypalEnvironment: 'PayPal ortamı',
    stripeNotify: 'Stripe bildirim (webhook) adresi',
    paypalNotify: 'PayPal bildirim (webhook) adresi',
    otherTitle: 'Diğer ödeme yöntemleri',
    otherLead:
      'Kart dışındaki yöntemlerde ödeme alındığında sipariş ekranından "Ödeme alındı" ile işaretlenir.',
    bankTransfer: 'Havale/EFT',
    bankTransferHold: 'Havale ödeme süresi (saat)',
    bankTransferHint:
      'Müşteri siparişten sonra banka bilgilerini görür; ödeme gelince siz işaretlersiniz. Süresinde ödenmeyen sipariş kendiliğinden iptal edilir.',
    cod: 'Kapıda ödeme',
    codHint: 'Yalnızca kapıda ödeme destekleyen kargo yöntemlerinde sunulur.',
    codFee: 'Kapıda ödeme bedeli (₺)',
    codMax: 'Kapıda ödeme üst sınırı (₺)',
    dealerOpenAccount: 'Bayi açık hesabı',
    dealerOpenAccountHint: 'Onaylı bayiler ödeme yapmadan sipariş verir; tutar cari hesaba işlenir.',
    guestCheckout: 'Üye olmadan sipariş',
    guestCheckoutHint: 'Kapalıysa müşteri sipariş için üye olmak zorundadır.',
    summaryTitle: 'Vitrinde sunulan yöntemler',
    summaryCard: 'Kart: {{provider}} ({{env}})',
    summaryNoCard: 'Kartla ödeme kapalı',
    summaryIntl: 'Döviz kartı: {{provider}} ({{env}})',
    summaryPaypal: 'PayPal ({{env}})',
    goLiveTitle: '{{provider}} ile canlı ödemeye geç',
    goLiveLead:
      'Bundan sonra müşterilerin kartlarından gerçek para çekilir. Geçişten önce aşağıdakilerin tamamlanmış olması gerekir.',
    goLiveConfirm: 'Canlıya geç',
    checkLiveConnection: 'Canlı anahtarlarla bağlantı testi başarılı',
    checkSandboxPayment: 'Test ortamında en az bir başarılı ödeme alındı',
    noSandboxTitle: 'Test ödemesi yapılmadı',
    noSandboxLead:
      'Test ortamında başarılı bir ödeme yok. Canlıya geçerseniz ilk canlı siparişi küçük tutarla kendi kartınızla verip iade edin; ödeme ve iadenin sorunsuz çalıştığını böyle doğrularsınız.',
    noSandboxAck:
      'Test ödemesi yapılmadan canlıya geçiyorum; ilk canlı siparişi küçük tutarla kendim verip iade edeceğim (işletme sahibi onayı).',
    noSandboxOwnerOnly: 'Test ödemesi olmadan canlıya geçişi yalnızca işletme sahibi onaylayabilir.',
    firstLiveOrderTitle: 'İlk canlı siparişi kendiniz verin ve iade edin',
    firstLiveOrderLead:
      'Test ödemesi yapılmadan canlıya geçildi. Vitrinden kendi kartınızla küçük tutarlı bir sipariş verin, siparişin "Ödendi" olduğunu görün ve sipariş ayrıntısından iade edin. İade tamamlanınca bu uyarı kalkar.',
    goLiveAck: 'Gerçek kartlardan para çekileceğini ve ödeme kuruluşu sözleşmesinin onaylandığını biliyorum.',
    bankAccounts: 'Banka hesapları',
    bankAccountsLead: 'Havale/EFT seçen müşteriye gösterilir.',
    addBankAccount: 'Banka hesabı ekle',
    editBankAccount: 'Banka hesabını düzenle',
    noBankAccounts: 'Banka hesabı yok',
    noBankAccountsLead: 'Havale/EFT açıksa en az bir hesap ekleyin; yoksa vitrinde bu yöntem gösterilmez.',
    accountStatus: {
      active: 'Aktif',
      inactive: 'Pasif',
    },
    deleteBankAccountConfirm: 'Banka hesabı silinsin mi? Geçmiş siparişler etkilenmez.',
    bankAccountDialogLead:
      'IBAN kontrol hanesiyle doğrulanır. Değişiklik iki adımlı doğrulama ister ve denetim kaydına yazılır.',
    bankName: 'Banka',
    accountHolder: 'Hesap sahibi (unvan)',
    iban: 'IBAN',
    accountStatusLabel: 'Durum',
    accountCurrency: 'Para birimi',
    status: 'Durum',
    provider: 'Yöntem',
    statuses: {
      pending: 'Bekliyor',
      requires_action: 'İnceleme gerekiyor',
      authorized: 'Provizyon (bloke)',
      captured: 'Alındı',
      failed: 'Başarısız',
      cancelled: 'İptal',
      expired: 'Süresi doldu',
    },
    providers: {
      iyzico: 'iyzico',
      paytr: 'PayTR',
      stripe: 'Stripe',
      paypal: 'PayPal',
      sipay: 'Sipay',
      bank_transfer: 'Havale/EFT',
      cash_on_delivery: 'Kapıda ödeme',
      open_account: 'Açık hesap',
      manual: 'Elle',
      gift_card: 'Hediye kartı',
      store_credit: 'Mağaza kredisi',
      loyalty_points: 'Sadakat puanı',
    },
    empty: 'Henüz ödeme yok',
    emptyLead: 'Vitrinden veya panelden alınan ödemeler burada görünür.',
    amount: 'Tutar',
    refunded: 'İade',
    events: 'Bildirimler',
    eventsTitle: 'Ödeme kayıtları · {{number}}',
    eventsLead: 'Sağlayıcıdan gelen bildirimler ve yapılan sorgular. İmzası geçersiz bildirimler işlenmez.',
    noEvents: 'Kayıt yok.',
    eventKinds: {
      webhook: 'Bildirim',
      callback: 'Bildirim (PayTR)',
      return: 'Tarayıcı dönüşü',
      status_query: 'Durum sorgusu',
      reconcile: 'Mutabakat',
      manual: 'Elle',
    },
    outcomes: {
      applied: 'İşlendi',
      duplicate: 'Tekrar (yok sayıldı)',
      ignored: 'Yok sayıldı',
      rejected: 'Reddedildi',
      error: 'Hata',
    },
    signatureOk: 'İmza geçerli',
    signatureBad: 'İmza geçersiz',
  },
  returns: {
    title: 'İade / cayma talepleri',
    customerNote: 'Müşterinin açıklaması',
    decisionNote: 'Mağazanın notu',
    kinds: {
      withdrawal: 'Cayma hakkı',
      defective: 'Hasarlı / kusurlu ürün',
      wrong_item: 'Yanlış ürün',
      other: 'Diğer',
    },
    statuses: {
      requested: 'Yanıt bekliyor',
      approved: 'Onaylandı',
      rejected: 'Reddedildi',
      completed: 'Tamamlandı',
      cancelled: 'İptal',
    },
    actions: {
      approved: 'Onayla',
      rejected: 'Reddet',
      completed: 'Tamamlandı',
      cancelled: 'İptal et',
    },
    leads: {
      approved:
        'Müşteriye onay e-postası gider. Ürünü nasıl göndereceğini (kargo firması, anlaşmalı kod, adres) not olarak yazın. Para iadesi ürün gelince ödeme bölümünden yapılır.',
      rejected: 'Müşteriye gerekçeyle birlikte e-posta gider. Gerekçe zorunludur.',
      completed:
        'Ürün geldi ve para iadesi ödeme bölümünden yapıldıysa talebi kapatın. Bu işlem para iadesi YAPMAZ.',
      cancelled: 'Müşteri talebinden vazgeçtiyse kapatın. Açıklama zorunludur.',
    },
    noteLabels: {
      approved: 'Gönderim talimatı',
      rejected: 'Gerekçe',
      completed: 'Not',
      cancelled: 'Açıklama',
    },
    done: {
      approved: 'Talep onaylandı',
      rejected: 'Talep reddedildi',
      completed: 'Talep tamamlandı',
      cancelled: 'Talep iptal edildi',
    },
    resolutions: {
      refund: 'Para iadesi',
      exchange: 'Değişim',
    },
    exchangeTo: 'Yerine gönderilecek: {{items}}',
    exchangeShipped: 'Değişim ürünü kargoda: {{carrier}} · {{tracking}}',
    restockedYes: 'İade gelen ürün stoğa alındı.',
    restockedNo: 'İade gelen ürün stoğa alınmadı.',
    shipExchange: 'Değişimi kargoya ver',
    shipExchangeLead:
      'İade edilen ürün geldiyse yeni ürünü kargoya verin. Ayrılan ürün stoktan düşer, talep tamamlanır ve müşteriye takip numarasıyla e-posta gider. Para hareketi olmaz.',
    restock: 'İade gelen ürünü satılabilir stoğa geri al',
    restockHint: 'Kusurlu veya ambalajı açılmış ürünü stoğa almayın.',
    exchangeShippedDone: 'Değişim ürünü kargoya verildi',
    exchangeLeads: {
      approved:
        'Onaylayınca istenen ürün stokta müşteriye ayrılır ve müşteriye onay e-postası gider. Ürünü nasıl göndereceğini not olarak yazın. İade edilen ürün gelince "Değişimi kargoya ver" ile yeni ürünü gönderin.',
      rejected: 'Müşteriye gerekçeyle birlikte e-posta gider. Gerekçe zorunludur.',
      cancelled: 'Müşteri vazgeçtiyse kapatın; ayrılan ürün yeniden satışa açılır. Açıklama zorunludur.',
    },
  },
  launch: {
    title: 'Yayın durumu',
    lead_draft:
      'Mağaza önizlemede: vitrin açık ama "önizleme" uyarılı ve arama motorlarına kapalı. Aşağıdaki şart maddeler tamamlanınca yayına alınabilir.',
    lead_live: 'Mağaza yayında: vitrin gerçek müşterilere açık.',
    lead_maintenance: 'Mağaza bakımda: ziyaretçiler bakım sayfası görür. Panel ve sipariş işlemleri çalışır.',
    lead_archived:
      'Mağaza arşivde: vitrin kapalı (alan adı "mağaza yok" der), panelde listenin sonunda. Arşivden çıkarınca önizlemeye döner.',
    toArchive: 'Arşivle',
    unarchive: 'Arşivden çıkar',
    dialogTitle_archived: 'Mağazayı arşivle',
    dialogLead_archived:
      'Vitrin kapanır; siparişler, ürünler ve ayarlar silinmez. İstediğiniz zaman arşivden çıkarabilirsiniz.',
    confirm_archived: 'Arşivle',
    done_archived: 'Mağaza arşivlendi',
    goLive: 'Mağazayı yayına al',
    toMaintenance: 'Bakıma al',
    toDraft: 'Önizlemeye döndür',
    blocked: 'Yayına almak için {{count}} şart madde eksik.',
    noPermission: 'Yayın durumunu yalnızca işletme sahibi ve yöneticisi değiştirebilir.',
    dialogTitle_live: 'Mağazayı yayına al',
    dialogLead_live: 'Bu işlem iki adımlı doğrulama ister ve denetim kaydına yazılır.',
    dialogTitle_maintenance: 'Mağazayı bakıma al',
    dialogLead_maintenance:
      'Ziyaretçiler bakım sayfası görür (en geç bir dakikada). Arama motorlarına geçici kapalı yanıtı verilir.',
    dialogTitle_draft: 'Önizlemeye döndür',
    dialogLead_draft:
      'Mağaza yayından kalkar: vitrin "önizleme" uyarısıyla açılır ve arama motorlarına kapanır.',
    liveEffect1: 'Vitrindeki "önizleme" uyarısı kalkar; verilen siparişler gerçek siparişlerdir.',
    liveEffect2: 'Test ortamındaki kart ödemesi müşteriye sunulmaz; kartla ödeme için canlı ortam gerekir.',
    liveEffect3:
      'Arama motorlarına açılma ayrıca sunucu ayarıyla (SITE_INDEXING=on) yapılır; geçiş rehberine bakın.',
    confirmText:
      'Fiyatları, ödeme yöntemlerini ve yasal metinleri kontrol ettim; mağaza gerçek müşterilere açılacak.',
    note: 'Not',
    confirm_live: 'Yayına al',
    confirm_maintenance: 'Bakıma al',
    confirm_draft: 'Önizlemeye döndür',
    done_live: 'Mağaza yayında',
    done_maintenance: 'Mağaza bakımda',
    done_draft: 'Mağaza önizlemeye döndü',
  },
  readiness: {
    title: 'Canlıya hazırlık',
    lead: 'Mağazanın satışa açılması için gerekenler. Her madde gerçek verilerden kontrol edilir.',
    progress: '{{total}} maddeden {{done}} tamam',
    ok: 'Tamam',
    missing: 'Eksik',
    fix: 'Düzelt',
    goLiveLocked:
      'Şart maddeler tamamlanınca mağaza, Mağazalar → mağaza → Yayın durumu bölümünden açık onay ve iki adımlı doğrulamayla yayına alınır.',
    items: {
      seller_info: 'Satıcı bilgileri (unvan, adres, telefon, e-posta)',
      domain: 'Mağaza alan adı',
      products: 'Vitrinde yayında en az bir ürün',
      shipping: 'En az bir kargo yöntemi',
      payment_methods: 'En az bir ödeme yöntemi',
      card_live: 'Kartla ödeme canlı ortamda',
      etbis: 'ETBİS kaydı (önerilir)',
      legal_published: 'Zorunlu yasal metinler yayımlandı',
      legal_reviewed: 'Yasal metinler hukuken incelendi',
      legal_languages: 'Pazar dillerinde yasal metinler',
    },
    hints: {
      seller_info:
        'İşletme Bilgileri ekranında eksik alanları doldurun; vitrinin alt bilgisinde ve sözleşmelerde kullanılır.',
      domain: 'Mağazalar ekranından vitrin alan adı ekleyin.',
      products: 'Ürünler ekranında en az bir ürünü yayına alın.',
      shipping: 'Kargo ekranından bir kargo yöntemi ekleyin.',
      payment_methods: 'Kartla ödeme, havale/EFT veya kapıda ödemeden en az birini açın.',
      card_live: 'Test ödemesi başarılı olduktan sonra "Canlıya geç" ile açılır.',
      etbis:
        "Ticaret Bakanlığı ETBİS kaydını yapın; verilen doğrulama bağlantısını İşletme Bilgileri'ne girin. Kayıt yasal yükümlülüktür; sitede gösterim zorunluluğu doğrulanıyor.",
      legal_published: 'Yasal Metinler ekranında eksik metinleri yayımlayın.',
      legal_reviewed: 'Metinleri avukatınıza inceletip "hukuken incelendi" işaretiyle yeniden yayımlayın.',
      legal_languages:
        'Açık pazarların dilinde yayımlanmamış metinler var; o dildeki ziyaretçi Türkçe metni görür. Yasal Metinler ekranında dil sekmesinden ekleyin (şart değil).',
    },
    sellerFields: {
      legalName: 'ticari unvan',
      address: 'adres',
      phone: 'telefon',
      email: 'e-posta',
    },
  },
  reconcile: {
    title: 'Mutabakat',
    lead: 'Sağlayıcının işlem dökümü ile sizdeki ödemeler karşılaştırılır. Canlı bağlantıda önceki gün her gün kendiliğinden kontrol edilir.',
    done: 'Mutabakat tamamlandı',
    date: 'Gün',
    run: 'Karşılaştır',
    empty: 'Henüz mutabakat yapılmadı.',
    issues: '{{count}} fark',
    statuses: {
      running: 'Çalışıyor',
      ok: 'Fark yok',
      mismatch: 'Fark var',
      error: 'Hata',
    },
    view: 'Ayrıntı',
    detailTitle: 'Mutabakat ayrıntısı',
    summary: 'Sizde {{local}} ödeme, sağlayıcıda {{remote}} işlem; {{issues}} fark.',
    kinds: {
      missing_local: 'Sağlayıcıda var, sizde yok',
      missing_provider: 'Sizde var, sağlayıcıda yok',
      amount_mismatch: 'Tutar farkı',
      status_mismatch: 'Durum farkı',
    },
    amounts: 'Sizde: {{ours}} · Sağlayıcıda: {{theirs}}',
    resolvedNote: 'Kapatıldı',
    resolveNote: 'Açıklama',
    resolve: 'Farkı kapat',
  },
  shipping: {
    currency: 'Ücret para birimi',
    currencyMismatch:
      'Mağazanın para birimi {{currency}}; yöntem yalnızca bu para birimindeki siparişlerde sunulur, aksi hâlde görünmez.',
    otherCurrency: '{{currency}} (mağazada görünmez)',
    countries: 'Gönderilen ülkeler',
    countriesHint:
      'Hiçbiri seçilmezse yöntem tüm pazarlarda sunulur; seçilirse yalnızca bu ülkelerin pazarlarında görünür.',
    countriesShort: 'Ülkeler: {{list}}',
    add: 'Kargo yöntemi ekle',
    edit: 'Kargo yöntemini düzenle',
    empty: 'Kargo yöntemi yok',
    emptyLead: 'Ödeme adımında müşterinin seçeceği en az bir kargo yöntemi ekleyin.',
    carriers: {
      yurtici: 'Yurtiçi Kargo',
      aras: 'Aras Kargo',
      mng: 'MNG Kargo (DHL eCommerce)',
      ptt: 'PTT Kargo',
      surat: 'Sürat Kargo',
      hepsijet: 'HepsiJET',
      kolaygelsin: 'Kolay Gelsin',
      ups: 'UPS',
      other: 'Diğer',
    },
    freeAlways: 'Ücretsiz',
    byWeight: 'Ağırlığa göre ({{count}} kademe)',
    freeOverShort: '{{amount}} üzeri ücretsiz',
    codShort: 'Kapıda ödeme var',
    audiences: {
      all: 'Herkes',
      retail: 'Perakende müşteriler',
      dealers: 'Bayiler',
    },
    daysShort: '{{days}} iş günü',
    statuses: {
      active: 'Aktif',
      inactive: 'Pasif',
    },
    deleteConfirm: 'Kargo yöntemi silinsin mi? Verilmiş siparişler etkilenmez.',
    trackingTitle: 'Kargo takibi',
    trackingLead:
      'Siparişi kargoya verirken takip numarasını girersiniz; müşteri takip numarasını e-postada ve sipariş sayfasında görür.',
    carrierApiNote:
      'Geliver bağlıysa sipariş sayfasındaki "Geliver ile kargola" ile teklif alınır, etiket satın alınır ve takip numarası kendiliğinden gelir. Yurtiçi, Aras ve MNG\'nin doğrudan bağlantısı firmaların kurumsal entegrasyon bilgileri ve IP izniyle kurulur (Kurulum Gerekli); o zamana kadar bu firmalarla Geliver üzerinden veya takip numarasını elle girerek gönderilir.',
    geliver: {
      title: 'Geliver ile kargo',
      lead: "Geliver hesabınızla siparişten gönderi açılır, kargo firmalarının fiyatları karşılaştırılır ve etiket panelden alınır; durum ve takip numarası Geliver'den kendiliğinden gelir.",
      notConnected: 'Geliver bağlı değil (Kurulum Gerekli).',
      connect: 'Entegrasyonlarda bağla',
      test: 'Test ortamı',
      live: 'Canlı',
      testNote: "Test ortamında gönderiler Geliver'e test gönderisi olarak açılır.",
      liveNote: 'Canlı ortamda etiket ücreti Geliver bakiyenizden düşer.',
      sender: 'Gönderici adresi',
      senderHint: "Geliver'de tanımlı adreslerden seçin.",
      senderNone: 'Seçilmedi',
      sendersEmpty:
        'Geliver hesabında gönderici adresi yok. Geliver panelinde adres ekleyip sayfayı yenileyin.',
      senderDefault: '{{name}} (Geliver varsayılanı)',
      length: 'Uzunluk (cm)',
      width: 'Genişlik (cm)',
      height: 'Yükseklik (cm)',
      parcel: 'Varsayılan koli ölçüleri',
      defaultWeight: 'Varsayılan ağırlık (g)',
      defaultWeightHint: 'Ürün ağırlığı girilmemiş satırlar için kullanılır.',
    },
    name: 'Ad',
    nameHint: 'Müşterinin gördüğü ad (ör. Standart kargo).',
    carrier: 'Kargo firması',
    audience: 'Kimlere gösterilir',
    rateType: 'Ücret türü',
    rateTypes: {
      flat: 'Sabit ücret',
      weight: 'Ağırlığa göre',
    },
    price: 'Ücret (₺, KDV dahil)',
    priceHint: '0 girerseniz kargo ücretsizdir.',
    tiers: 'Ağırlık kademeleri',
    tiersHint: 'Her satır: o ağırlığa (gram) kadar olan sepetler için ücret. Küçükten büyüğe sıralayın.',
    upToGrams: 'En fazla (gram)',
    addTier: 'Kademe ekle',
    freeOver: 'Ücretsiz kargo sınırı (₺)',
    estimatedDays: 'Tahmini teslim (iş günü)',
    estimatedDaysHint: 'Ör. 1-3',
    handlingDays: 'Hazırlık süresi (iş günü)',
    transitDays: 'Kargoda geçen süre (iş günü)',
    daysMin: 'En az',
    daysMax: 'En çok',
    status: 'Durum',
    codAvailable: 'Kapıda ödeme yapılabilir',
    codAvailableHint: 'Bu yöntemde kapıda ödeme sunulur (Ödeme ayarlarında kapıda ödeme açıksa).',
  },
  brokenLinks: {
    collect: 'Arşivden eski adresleri topla',
    collected:
      'Arşivde {{found}} adres bulundu: {{matched}} yeni eşleşme, {{table}} zaten listede, {{fallback}} karşılıksız (güvenli sayfaya gidiyor).',
    collectFailed: 'Arşive ulaşılamadı: {{hosts}}. Biraz sonra yeniden deneyin.',
    storeHost: 'Vitrin alan adı',
    foundVia: 'Nereden',
    emptyLead: 'Vitrinde 404 veren veya karşılığı bulunamayan eski adres olduğunda burada görünür.',
    fallback: 'Karşılık bulunamadı; ziyaretçi 301 ile şuraya gönderiliyor: {{to}}',
    shown404: 'Vitrinde "sayfa bulunamadı" (404) gösteriliyor',
    notVisited: 'Henüz ziyaret yok · eklendi: {{date}}',
    via: {
      request: 'Ziyaret',
      archive: 'Arşivden',
      search_console: 'Search Console',
    },
    kinds: {
      product: 'Ürün',
      category: 'Kategori',
      shop: 'Mağaza',
      blog: 'Makaleler',
      post: 'Makale',
      page: 'Sayfa',
      asset: 'Dosya',
      home: 'Ana sayfa',
    },
  },
  redirects: {
    goneTarget: 'Kalıcı olarak kaldırıldı (yönlendirme yok)',
    gone: 'Kalıcı olarak kaldırıldı (410)',
    goneLead:
      'Bu adres için yönlendirme yapılmaz; ziyaretçiye "sayfa kaldırıldı" sayfası, arama motoruna 410 kodu döner ve adres dizinden çıkarılır. Benzer bir sayfa varsa 301 tercih edin.',
    goneSaved: 'Adres kalıcı olarak kaldırıldı olarak işaretlendi',
    goneConfirm:
      '"{{path}}" için 410 (kalıcı olarak kaldırıldı) verilsin mi? Arama motorları bu adresi dizinden çıkarır.',
    notFoundTitle: 'Bulunamayan adresler',
    notFoundLead:
      'Vitrinde 404 veren adresler ve karşılığı bulunamadığı için güvenli sayfaya gönderilen eski adresler, en çok görülen önce. Doğru karşılığı yönlendirme olarak ekleyin, 410 verin ya da yok sayın. Yalnızca alan adı ve adres yolu saklanır (IP ve sorgu dizesi yok).',
    notFoundFilter: 'Göster',
    notFoundOpen: 'Bekleyenler',
    notFoundIgnored: 'Yok sayılanlar',
    notFoundEmpty: 'Bulunamayan adres yok.',
    notFoundIgnoredEmpty: 'Yok sayılan adres yok.',
    notFoundHits: '{{count}} kez görüldü · son: {{date}}',
    notFoundRedirect: 'Yönlendir',
    notFoundGone: '410 ver',
    notFoundIgnore: 'Yok say',
    notFoundReopen: 'Listeye geri al',
    notFoundMore: 'En çok görülen {{shown}} adres gösteriliyor (toplam {{total}}).',
    add: 'Yönlendirme ekle',
    edit: 'Yönlendirmeyi düzenle',
    import: 'Dosyadan içe aktar',
    search: 'Adreslerde ara',
    empty: 'Henüz yönlendirme yok',
    emptyLead:
      'Eski sitenin adreslerini yeni adreslere bağlayın; böylece Google sıralaması ve kayıtlı bağlantılar kaybolmaz. Ürün veya kategori adresi değişince yönlendirme kendiliğinden eklenir.',
    noMatch: 'Aramaya uyan yönlendirme yok',
    from: 'Eski adres',
    to: 'Yeni adres',
    code: 'Yönlendirme türü',
    permanent: '301 — kalıcı (önerilen)',
    temporary: '302 — geçici',
    note: 'Not',
    saved: 'Yönlendirme kaydedildi',
    dialogLead:
      'Eski adres "/" ile başlayan yol olmalı (tam adres yazarsanız yolu alınır). Yeni adres bu sitede bir yol veya https:// ile başlayan tam adres olabilir.',
    deleteConfirm: '{{path}} yönlendirmesi silinsin mi? Bu adrese gelen ziyaretçi sayfa bulunamadı görür.',
    hits: '{{count}} kez kullanıldı · son {{date}}',
    noHits: 'Henüz kullanılmadı',
    range: '{{from}}–{{to}} / {{total}}',
    sources: {
      manual: 'Elle',
      import: 'İçe aktarım',
      auto: 'Kendiliğinden',
      match: 'Eşleştirme',
    },
    importTitle: 'Yönlendirme listesini içe aktar',
    importLead:
      'CSV veya Excel dosyası: eski adres, yeni adres, isteğe bağlı kod (301/302) ve not sütunları. Önce önizlenir; hatalı satır varsa hiçbiri kaydedilmez. Aynı eski adres varsa güncellenir. İsteğe bağlı "alan adı" sütunu kuralı tek bir eski alan adına özel yapar.',
    chooseFile: 'Dosya seç ve önizle',
    apply: 'İçe aktar',
    previewSummary:
      '{{total}} satır: {{create}} yeni, {{update}} güncellenecek, {{unchanged}} değişmeyecek, {{errors}} hatalı.',
    errorLine: 'Satır {{line}}',
    imported: '{{created}} yönlendirme eklendi, {{updated}} güncellendi',
    howTitle: 'Nasıl çalışır',
    howLead: 'Vitrin her sayfa isteğinde bu listeye bakar (liste en geç bir dakikada güncellenir).',
    how1: 'Eşleşme büyük/küçük harf ve sondaki "/" farkı gözetmeden yapılır; "/uyeol/" ile "/uyeol" aynıdır. Sorgu (?...) dikkate alınmaz.',
    how2: "Zincirler tek adıma indirilir (A→B ve B→C ise A doğrudan C'ye gider); döngü oluşturan kayıt uygulanmaz.",
    how3: 'Kullanım sayısı, eski adresin hâlâ trafik alıp almadığını gösterir; aylarca kullanılmayan kayıt silinebilir.',
    allHosts: 'Tüm alan adları',
    host: 'Kaynak alan adı',
    filterSource: 'Kaynak',
    filterHost: 'Alan adı',
    anySource: 'Tümü',
    anyHost: 'Tümü',
    matchScore: 'benzerlik %{{score}}',
    shadowTitle: 'Mağazanın kendi sayfalarını gölgeleyen {{count}} kural',
    shadowLead:
      'Bu adresler vitrinde gerçek bir sayfa (ör. Satış Noktaları, Makaleler, İhtiyaç Bulucu, yayındaki ürün veya kategori). Kural yönlendirme yaptığı için ziyaretçi sayfayı göremiyor. Sayfanın açılması için kuralı silin.',
    shadowDelete: 'Kuralı sil',
    how4: "Eski alan adına (ör. zootopiaglobal.com) gelen her istek — http veya https, www'lu veya www'suz — bu listeye göre tek adımda 301 ile son adrese gider.",
    how5: 'Listede olmayan eski adresin karşılığını sistem bulur: emin olduğu karşılığı "Eşleştirme" olarak ekler, emin değilse ziyaretçiyi türün kategorisine, tüm ürünlere veya ana sayfaya gönderir ve adresi şuraya yazar:',
    matchKinds: {
      product: 'ürün',
      category: 'kategori',
      category_species: 'türün kategorisi',
      shop: 'tüm ürünler',
      blog: 'makaleler',
      post: 'makale',
      page: 'sayfa',
    },
  },
  legal: {
    lawyerNote:
      'Buradaki metinler sizin yazacağınız veya avukatınızın hazırlayacağı metinlerdir; sistem hukuki içerik üretmez. Yayımlamadan önce avukatınıza inceletin.',
    kinds: {
      kvkk_notice: 'KVKK Aydınlatma Metni',
      membership_terms: 'Üyelik Sözleşmesi',
      pre_information: 'Ön Bilgilendirme Formu',
      distance_sales: 'Mesafeli Satış Sözleşmesi',
      return_policy: 'İade ve Cayma Koşulları',
      privacy_policy: 'Gizlilik Politikası',
      cookie_policy: 'Çerez Politikası',
    },
    required: '(canlı için zorunlu)',
    publishedVersion: 'Sürüm {{version}} · {{date}} yayımlandı',
    notPublished: 'Yayımlanmadı',
    templated: 'Siparişte doldurulur',
    reviewed: 'Hukuken incelendi',
    notReviewed: 'İnceleme beyan edilmedi',
    hasDraft: 'Taslak var',
    write: 'Yaz',
    draftSaved: 'Taslak kaydedildi',
    published: 'Yeni sürüm yayımlandı',
    templatedLead:
      'Bu metin siparişte satıcı, alıcı, ürün ve tutar bilgileriyle doldurulup müşteriye onaylatılır. Zorunlu değişkenler: satıcı unvanı, alıcı adı, ürünler, toplam.',
    plainLead: 'Bu metin vitrinde kendi sayfasında yayımlanır; satıcı değişkenleri doldurulur.',
    discardConfirm: 'Taslak silinsin mi? Yayımlanmış sürüm etkilenmez.',
    discard: 'Taslağı sil',
    saveDraft: 'Taslağı kaydet',
    publish: 'Yayımla',
    title: 'Başlık',
    variables: 'Değişkenler',
    insertVariable: 'İmlecin olduğu yere ekle',
    body: 'Metin',
    bodyHint: 'Düz metin; paragraflar boş satırla ayrılır.',
    reviewedAck: 'Bu metin avukatım/hukuk danışmanım tarafından incelendi.',
    saveBeforePublish: 'Yayımlamadan önce taslağı kaydedin.',
    history: 'Sürüm geçmişi',
    versionLabel: 'Sürüm {{version}}',
    statuses: {
      published: 'Yayında',
      retired: 'Arşiv',
      draft: 'Taslak',
    },
    view: 'Görüntüle',
    languages: 'Dil sürümleri',
    languageGaps:
      'Açık pazarlarınızın dilinde yayımlanmamış zorunlu metinler var (o dildeki ziyaretçi Türkçe metni görür; canlıya almayı engellemez):',
    langPublished: 'yayında, sürüm {{version}}',
    language: 'Dil',
    primaryLanguage: 'esas',
    marketLanguage: 'pazar dili',
    copyTurkish: 'Türkçe metinden başla',
    translationNote:
      '{{language}} sürümü Türkçe metnin çevirisidir. Çeviriyi de avukatınıza inceletin; hukuki inceleme beyanı bu dil için ayrıca verilir. Bu dilde yayımlanmış sürüm olmadıkça ziyaretçi Türkçe metni görür.',
    switchLanguageConfirm: 'Kaydedilmemiş değişiklikler kaybolacak. Başka dile geçilsin mi?',
  },
  invoices: {
    providerCancelStates: {
      required: 'BizimHesap’ta iptal edilmeli',
      failed: 'BizimHesap iptali başarısız',
      uncertain: 'BizimHesap iptali belirsiz',
      return_required: 'e-belge kesilmiş: iade faturası gerekli',
      done: 'BizimHesap’ta iptal edildi',
    },
    providerCancelResult: {
      done: 'Fatura BizimHesap’ta iptal edildi.',
      failed: 'BizimHesap iptali reddetti; hata faturada.',
      uncertain:
        'BizimHesap yanıt vermedi: iptal oluşmuş olabilir. BizimHesap panelinde kontrol edip işaretleyin.',
    },
    cancelAtProvider: 'BizimHesap’ta iptal et',
    resolveProviderCancel: 'İptali işaretle',
    returnDone: 'İade faturası kesildi',
    returnLead:
      'Fatura resmî e-belge numarası almış: BizimHesap’ta iptal edilmez, iade faturası düzenlenir (mali müşavir teyidi bekleniyor). İade faturasını kestikten sonra buradan işaretleyin.',
    providerResolveLead: 'BizimHesap panelinde faturanın iptal edilip edilmediğini kontrol edin.',
    providerOutcomes: { done: 'İptal edilmiş', not_done: 'İptal edilmemiş (yeniden denenebilir)' },
    sendResult: {
      sent: "Fatura BizimHesap'a gönderildi",
      failed: 'Fatura gönderilemedi',
      uncertain: 'Bağlantı kesildi: fatura belirsiz',
      draft: 'Kaydedildi',
      sending: 'Gönderiliyor',
      cancelled: 'İptal',
    },
    bhTarget: 'BizimHesap cari kodu {{code}} · kasa {{cash}}',
    bhNoCash: 'yok (cari borç)',
    resend: 'Yeniden gönder',
    send: 'Gönder',
    resolve: 'Kontrol ettim',
    markCancelled: 'İptal edildi olarak işaretle',
    resolveTitle: 'Belirsiz faturayı işaretle',
    cancelTitle: 'Faturayı iptal edildi olarak işaretle',
    resolveLead: 'BizimHesap panelinde bu siparişin faturasının oluşup oluşmadığını kontrol edin.',
    cancelLead:
      "Bu işlem yalnızca buradaki kaydı iptal eder. BizimHesap'taki fatura/e-Arşiv iptali BizimHesap panelinden yapılır.",
    outcome: 'Sonuç',
    outcomes: {
      sent: 'Fatura oluşmuş',
      not_sent: 'Fatura oluşmamış',
    },
    number: 'Fatura numarası',
    note: 'Açıklama',
    status: 'Durum',
    statuses: {
      draft: 'Taslak',
      sending: 'Gönderiliyor',
      sent: 'Gönderildi',
      failed: 'Başarısız',
      uncertain: 'Belirsiz',
      cancelled: 'İptal',
    },
    empty: 'Henüz fatura yok',
    emptyLead: 'Faturalar sipariş ayrıntısından oluşturulur.',
    providers: {
      bizimhesap: 'BizimHesap',
      manual: 'Elle (başka yerde kesildi)',
    },
    kinds: {
      e_arsiv: 'e-Arşiv',
      e_fatura: 'e-Fatura',
      unknown: 'Belirtilmedi',
    },
    open: 'Faturayı aç',
    bizimhesapNote:
      "BizimHesap API'si faturayı kayıt olarak oluşturur; e-Arşiv/e-Fatura'ya dönüştürme BizimHesap panelinden yapılır.",
    bizimhesapLead:
      'Kalemler ve toplamlar siparişle birebir oluşturulur; gönderim ayrı adımdır. BizimHesap bağlantısı Entegrasyonlar ekranında kurulur.',
    manualLead: 'Faturayı başka bir programda kestiyseniz numarasını kaydedin.',
    provider: 'Nereden',
    kind: 'Tür',
  },
  pageDesigns: {
    published: '{{experience}}: {{variant}} tasarımı yayında.',
    option: '{{letter}} — {{name}}',
    live: 'Yayında',
    preview: 'Önizle',
    previewOf: '{{name}} tasarımını önizle',
    publish: 'Yayına al',
    publishOf: '{{name}} tasarımını yayına al',
    shotDesktop: '{{name}}: masaüstü görünümü',
    shotMobile: '{{name}}: mobil görünümü',
    history: 'Geçiş geçmişi',
    historyLead: 'Kim, ne zaman, hangi seçenekten hangisine geçti (denetim kaydından).',
    noHistory: 'Henüz değişiklik yok; tüm deneyimler A seçeneğinde.',
    colWhen: 'Tarih',
    colWho: 'Kişi',
    colWhat: 'Deneyim',
    colChange: 'Değişiklik',
    change: '{{from}} → {{to}}',
    experiences: {
      header: {
        title: 'Üst menü',
        lead: 'Vitrinin her sayfasındaki başlık: logo, menü öğeleri (Menüler), arama, Giriş yap ve Sepet; mobilde çekmece menü.',
      },
      articles: {
        title: 'Makaleler',
        lead: 'Blog listesi, kategori ve arşiv sayfaları: öne çıkan yazı, kategoriler, okuma süresi ve arama. Yazı sayfası her seçenekte aynı.',
      },
      store_locator: {
        title: 'Satış Noktaları',
        lead: 'Onaylı bayilerin vitrinde listelendiği sayfa: il, ilçe ve mahalleye göre süzme, "Konumumu kullan", harita ve il/ilçe sayfaları.',
      },
      needs_finder: {
        title: 'Evcil Dostumun İhtiyacı',
        lead: 'Ziyaretçinin dostu için soru akışı ve önerilen bakım rutini (/ihtiyac-bulucu). Sorular, kurallar ve sonuç üç seçenekte aynı.',
      },
    },
    variants: {
      header: {
        a: {
          name: 'Klasik yatay',
          character:
            'Logo, arama ve sepet üstte, menü öğeleri yatay sırada; alışveriş sitelerinden alışılmış, en hızlı tarama.',
        },
        b: {
          name: 'Ortalanmış logo',
          character: 'Ortada büyük marka adı, menü alt satırda ortalı; butik, sakin bir karşılama.',
        },
        c: {
          name: 'Kompakt ve görselli',
          character:
            'İnce tek satır; Ürünler türe göre çizimli karolarla açılır, ekranda içeriğe daha çok yer kalır.',
        },
      },
      articles: {
        a: {
          name: 'Dergi',
          character: 'Büyük öne çıkan yazı ve kategori şeritleri; içerik vitrin gibi sergilenir.',
        },
        b: {
          name: 'Kart ızgarası',
          character: 'Eşit kartlar ve süzme çipleri; çok yazı arasında hızlı seçim.',
        },
        c: {
          name: 'Okuma listesi',
          character: 'Tipografi öncelikli sade liste, küçük görseller; okumaya odaklı.',
        },
      },
      store_locator: {
        a: {
          name: 'Harita öncelikli',
          character: 'Solda süzgeç ve liste, sağda il haritası; harita ile liste birlikte gezilir.',
        },
        b: {
          name: 'Liste öncelikli',
          character: 'Üstte tek satır süzgeç, altında kart ızgarası; harita isteğe bağlı.',
        },
        c: {
          name: 'Bölge rehberi',
          character:
            'İl ve ilçe dizini, her bölgenin kendi sayfası; arama motorlarından gelen ziyaretçiye uygun.',
        },
      },
      needs_finder: {
        a: {
          name: 'Kartlar',
          character:
            'Her adım tek ekranda büyük kartlarla; üstte ilerleme, altta Geri / Devam. Telefonda en rahat akış.',
        },
        b: {
          name: 'Sohbet',
          character:
            'Sorular konuşma balonlarında sırayla gelir, cevaplar çiple verilir; her cevap değiştirilebilir. Sorular sabittir, yapay zekâ yoktur.',
        },
        c: {
          name: 'Tek sayfa + canlı özet',
          character:
            'Tüm sorular tek sayfada; yanda rutin özeti cevap verdikçe güncellenir. Geniş ekranda karşılaştırma için uygun.',
        },
      },
    },
  },
  needsFinder: {
    editor: 'İhtiyaç bulucu düzenleyicisi',
    startTitle: 'Evcil Dostumun İhtiyacı henüz kurulmadı',
    startLead:
      'Ziyaretçi türünü, temel bilgileri ve destek alanlarını seçer; sabit kurallarla ona uygun ürünlerden bir bakım rutini önerilir. İlk taslağı ürün verinizden oluşturabilir veya boş başlayabilirsiniz. Taslak veteriner uzman onayı olmadan yayına alınamaz.',
    generate: 'Ürün verisinden ilk taslağı oluştur',
    startEmpty: 'Boş taslakla başla',
    generated: 'Taslak ürün verisinden oluşturuldu. Metinleri ve kuralları inceleyin.',
    noDraft: 'Henüz taslak yok. İçerik düzenleme yetkisi olan biri oluşturabilir.',
    save: 'Taslağı kaydet',
    saved: 'Taslak kaydedildi.',
    unsaved: 'Kaydedilmemiş değişiklik var.',
    discard: 'Değişiklikleri geri al',
    saveErrors: 'Taslak kaydedilemedi; şunları düzeltin:',
    saveFirst: 'Önce taslağı kaydedin.',
    statusTitle: 'Durum ve yayın',
    statusLead:
      'Taslak → incelemeye gönder → veteriner uzman onayı → yayına al. Onaydan sonra taslak değişirse onay düşer; vitrin yayındaki onaylı hâli göstermeye devam eder.',
    review: {
      not_submitted: 'İncelemeye gönderilmedi',
      pending: 'Uzman incelemesinde',
      approved: 'Uzman onayladı',
      rejected: 'Uzman reddetti',
    },
    live: 'Vitrinde yayında',
    notLive: 'Vitrinde yayında değil',
    liveDiffers: 'Taslak, yayındaki hâlden farklı',
    publishedAt: 'Son yayın: {{date}}',
    generatedNote:
      'Bu taslak ürün verisinden otomatik üretildi: alanlar kategorilerden, kurallar ürünlerden. Gerekçe metinlerini, acil durum sorusunu ve hariç tutmaları uzmanla birlikte gözden geçirin.',
    reviewNote: 'Uzman notu: {{note}}',
    problemsTitle: 'Kontrol listesi',
    problems: {
      no_areas: 'Destek alanı yok (yayına engel).',
      no_rules: 'Öneri kuralı yok (yayına engel).',
      no_emergency_option: 'Hiçbir soruda acil durum seçeneği yok (yayına engel).',
      area_without_rules: '“{{ref}}” alanında kural yok; bu alanı seçen ziyaretçiye ürün çıkmaz.',
      product_hidden:
        '{{product}} vitrinde görünmüyor (taslak, gizli, mağazada yayında değil veya veteriner onayı yok); önerilmez.',
      product_species_mismatch: '{{product}} kuralın türleriyle uyuşmuyor; hiçbir zaman önerilmez.',
      product_no_species: '{{product}} için hedef tür seçilmemiş; hiçbir zaman önerilmez.',
      bundle_promotion_not_running: 'Bağlı paket kampanyası şu an çalışmıyor; vitrinde gösterilmez.',
    },
    submit: 'İncelemeye gönder',
    submitted: 'Taslak uzman incelemesine gönderildi.',
    publish: 'Yayına al',
    publishedToast: 'Evcil Dostumun İhtiyacı vitrinde yayında.',
    unpublish: 'Yayından kaldır',
    unpublishedToast: 'Vitrinden kaldırıldı.',
    unpublishTitle: 'Yayından kaldırılsın mı?',
    unpublishLead:
      'Vitrindeki sayfa kapanır ve üst menüdeki varsayılan bağlantı kalkar. Taslak ve uzman onayı korunur; yeniden yayına alabilirsiniz.',
    regenerate: 'Taslağı yeniden üret',
    regenerateTitle: 'Taslak yeniden üretilsin mi?',
    regenerateLead:
      'Mevcut taslağın yerine ürün verisinden yeni bir taslak gelir; yaptığınız düzenlemeler ve uzman onayı düşer. Yayındaki hâl değişmez.',
    petProfiles: 'Dostumu kaydet (üye)',
    petProfilesLead:
      'Açıkken üye, dostunun temel bilgilerini açık rızayla hesabına kaydedebilir. Rıza metni hukuk incelemesinden geçmeden açmayın. Sağlık sorularının cevapları kaydedilmez.',
    reviewTitle: 'Veteriner uzman incelemesi',
    reviewLead:
      'Uzman; soruları, gerekçe metinlerini ve önerilebilecek ürünlerin tam listesini inceler. Karar ekrandaki içeriğe verilir.',
    findings: 'Sağlık beyanı denetimi {{count}} ifade buldu',
    productsTitle: 'Önerilebilecek ürünler',
    colProduct: 'Ürün',
    colSpecies: 'Tür',
    colReasons: 'Gerekçe',
    colState: 'Durum',
    visible: 'Vitrinde görünür',
    hidden: 'Vitrinde görünmüyor',
    noUsage: 'Kullanım metni yok',
    reviewNoteLabel: 'Uzman notu',
    approve: 'Onayla',
    reject: 'Reddet',
    decided: 'Karar kaydedildi.',
    waitingExpert: 'Veteriner Uzman İnceleyicinin kararı bekleniyor.',
    otherLanguages: 'Diğer diller',
    lang: {
      en: 'İngilizce',
      de: 'Almanca',
      ar: 'Arapça',
    },
    condition: 'Koşul',
    conditionLead:
      'Seçtiğiniz her bölüm tutmalı; bir bölümde işaretlediklerinizden biri yeterli. Hiçbir şey seçmezseniz her zaman geçerlidir.',
    cond: {
      species: 'Tür',
      ages: 'Yaş',
      weights: 'Kilo',
      neutered: 'Kısırlaştırma',
      any: 'Fark etmez',
      reproductive: 'Gebe / emziren',
      areas: 'Destek alanı',
      answer: 'Bir sorunun cevabı',
      noAnswer: 'Soru cevabına bakılmaz',
      answerOptions: 'Şu cevaplardan biri',
    },
    always: 'Her zaman',
    moveUp: '{{name}}: yukarı taşı',
    moveDown: '{{name}}: aşağı taşı',
    edit: '{{name}}: düzenle',
    delete: '{{name}}: sil',
    deleteTitle: 'Silinsin mi?',
    deleteLead: 'Öğe taslaktan çıkar; taslağı kaydedene kadar geri alabilirsiniz ("Değişiklikleri geri al").',
    apply: 'Uygula',
    tabs: {
      areas: 'Destek alanları',
      questions: 'Sorular',
      rules: 'Öneri kuralları',
      exclusions: 'Hariç tutmalar',
      texts: 'Metinler',
      preview: 'Önizleme',
      report: 'Rapor',
    },
    areasLead:
      'Ziyaretçinin seçtiği konular (ör. eklem, deri ve tüy). Yalnızca işaretli türlerde gösterilir.',
    rulesCount: '{{count}} kural',
    addArea: 'Alan ekle',
    noAreas: 'Henüz destek alanı yok.',
    areaDialog: 'Destek alanı',
    areaLabel: 'Alan adı',
    areaDescription: 'Kısa açıklama',
    areaSpecies: 'Gösterildiği türler',
    areaCategories: 'İlgili kategoriler',
    id: 'Kimlik',
    idLead: 'Kurallarda kullanılan kısa ad (küçük harf, rakam, tire). Kaydettikten sonra değiştirmeyin.',
    questionsLead:
      'Sorular bu sırayla sorulur. Bir alana bağlı soru yalnızca o alan seçilince, koşullu soru koşulu tutunca sorulur (dallanma).',
    general: 'Genel (her ziyaretçiye)',
    optionsCount: '{{count}} seçenek',
    hasEmergency: 'Acil durum seçeneği var',
    askedWhen: 'Soruluş koşulu: {{condition}}',
    defaultYes: 'Evet',
    defaultNo: 'Hayır',
    addQuestion: 'Soru ekle',
    noQuestions: 'Henüz soru yok. En az bir soruda acil durum seçeneği olmalı.',
    questionDialog: 'Soru',
    questionText: 'Soru metni',
    questionHelp: 'Yardım metni',
    questionArea: 'Bağlı olduğu alan',
    questionMultiple: 'Birden çok seçenek seçilebilir',
    askWhen: 'Ne zaman sorulsun? (dallanma)',
    options: 'Seçenekler',
    optionLabel: '{{n}}. seçenek',
    optionEmergency: 'Acil durum (ürün önerme, veterinere yönlendir)',
    optionExclusive: 'Tek başına seçilir ("Hiçbiri")',
    addOption: 'Seçenek ekle',
    rulesLead:
      'Koşul tutarsa ürün, onaylı gerekçesiyle önerilir. Ürün seçilen türe uygun değilse hiçbir zaman önerilmez. Stokta yoksa sıradaki alternatif gelir.',
    unsavedProduct: 'Ürün (kaydedince adı görünür)',
    priorityValue: 'Öncelik {{n}}',
    alternativesCount: '{{count}} alternatif',
    addRule: 'Kural ekle',
    noRules: 'Henüz kural yok.',
    ruleDialog: 'Öneri kuralı',
    ruleProduct: 'Önerilen ürün',
    ruleReason: 'Neden önerildi (vitrinde görünür)',
    rulePriority: 'Öncelik (0–100)',
    rulePriorityLead: 'Yüksek öncelikli öneri listede önce gelir.',
    ruleAlternatives: 'Stokta yoksa alternatifler (sırayla, en çok 5)',
    exclusionsLead:
      'Koşul tutarsa listelenen ürünler hiçbir kuraldan önerilmez (ör. gebelikte uygun olmayanlar). Hariç tutma her zaman önceliklidir.',
    addExclusion: 'Hariç tutma ekle',
    noExclusions: 'Henüz hariç tutma yok.',
    exclusionDialog: 'Hariç tutma',
    exclusionProducts: 'Önerilmeyecek ürünler',
    exclusionNote: 'Not (panelde)',
    textsLead: 'Sayfanın giriş metni, acil durum metni ve isteğe bağlı paket kampanyası.',
    intro: 'Giriş metni',
    emergencyText: 'Acil durum metni',
    bundle: 'İhtiyaç paketi kampanyası',
    bundleLead:
      'İsteğe bağlı; varsayılan kapalı. Bağlı otomatik kampanya çalışıyorsa sonuçta adı ve koşulu gösterilir; indirimi sepet hesaplar.',
    bundleOff: 'Kampanya yok',
    bundleLinked: 'Bir kampanya bağlı',
    previewLead:
      'Vitrindeki kural motoruyla aynı hesap. Bir ziyaretçinin cevaplarını seçin; hangi ürünlerin hangi gerekçeyle geleceğini ve hangilerinin neden çıkarıldığını görün.',
    previewResult: 'Sonuç',
    removedTitle: 'Çıkarılan ürünler',
    removed: {
      excluded: 'hariç tutma kuralı',
      species: 'seçilen türe uygun değil',
      unavailable: 'vitrinde görünmüyor',
    },
    previewNote:
      'Önizleme kaydedilmiş ürün bilgisini kullanır ve stoğu dikkate almaz; yeni eklenen ürünler taslak kaydedilince görünür.',
    emergencyShort: 'acil',
    reportLead:
      'Yalnızca toplam sayılar: kaç ziyaretçi başladı, tamamladı, acil durum seçti, hepsini sepete ekledi. Ziyaretçi kimliği veya cevap saklanmaz.',
    reportDays: 'Dönem',
    lastDays: 'Son {{n}} gün',
    reportEmpty: 'Bu dönemde kayıt yok.',
    metrics: {
      starts: 'Başlayan',
      completes: 'Tamamlayan',
      emergencies: 'Acil durum',
      addAll: 'Hepsini sepete ekledi',
      rate: 'Tamamlama oranı',
    },
    bySpecies: 'Türe göre',
    reportPrivacy:
      'Sayaçlarda kişisel veri yoktur; ölçüm etiketleri (GA4/GTM) yalnızca çerez izniyle olay alır.',
  },
  salesPoints: {
    sectionTitle: 'Satış noktası',
    sectionLead:
      'Vitrindeki Satış Noktaları sayfasında görünen işletme bilgisi. Yetkili adı ve cep telefonu kendiliğinden gösterilmez.',
    add: 'Satış noktası ekle',
    edit: 'Satış noktasını düzenle',
    saved: 'Satış noktası kaydedildi.',
    deleted: 'Satış noktası silindi.',
    confirmDelete: '"{{name}}" satış noktası silinsin mi? Bayi kaydı değişmez.',
    empty: 'Bu bayinin satış noktası yok',
    emptyLead: 'Ekleyince vitrindeki Satış Noktaları sayfasında görünür (bayi onaylıysa).',
    fromLocation: 'Lokasyondan ekle:',
    addFromLocation: '{{label}}',
    personNameNote:
      'Bu bayinin unvanı bir kişinin adı olabilir. Görünen ada tabela veya işletme adını yazın ya da noktayı gizleyin (KVKK).',
    notApprovedNote:
      'Bayi onaylı olmadığı için satış noktaları vitrinde görünmez; onaylanınca kendiliğinden görünür.',
    shown: 'Vitrinde',
    hidden: 'Gizli',
    visible: 'Vitrinde göster',
    name: 'Görünen ad',
    nameLead: 'Tabela veya işletme adı. Bir kişinin adını yazmayın.',
    neighbourhood: 'Mahalle',
    chooseNeighbourhood: 'Mahalle seçin',
    addressLine: 'Cadde, sokak, no',
    pin: 'Konum (harita pini)',
    pinLead:
      "Google Haritalar'da yeri bulun, sağ tıklayıp koordinatı kopyalayın ve buraya yapıştırın (bağlantı da olur). Boş bırakılırsa nokta mesafe sıralamasına girmez.",
    pinRead: 'Okunan konum: {{lat}}, {{lng}}',
    pinInvalid:
      'Konum okunamadı. "41.0082, 28.9784" biçiminde koordinat veya Google Haritalar bağlantısı yapıştırın.',
    findOnMaps: "Google Haritalar'da adresi aç",
    phone: 'Vitrin telefonu',
    phoneLead:
      'Ziyaretçilerin arayacağı işletme numarası. Bayi yetkilisinin cep telefonunu yalnızca yetkili onay verdiyse yazın.',
    hours: 'Çalışma saatleri',
    days: {
      mon: 'Pazartesi',
      tue: 'Salı',
      wed: 'Çarşamba',
      thu: 'Perşembe',
      fri: 'Cuma',
      sat: 'Cumartesi',
      sun: 'Pazar',
    },
    dayMode: '{{day}}: durum',
    dayUnknown: 'Belirtilmedi',
    dayOpen: 'Açık',
    dayClosed: 'Kapalı',
    opens: '{{day}}: açılış',
    closes: '{{day}}: kapanış',
    note: 'Not (vitrinde görünür)',
    warnings: {
      no_pin: 'Pin yok',
      no_phone: 'Telefon yok',
      person_name: 'Kişi adı olabilir',
      company_not_approved: 'Bayi onaylı değil',
      address_missing: 'Adres eksik',
      geocode_not_found: 'Adres haritada bulunamadı',
      geocode_mismatch: 'Adres başka yeri gösteriyor',
      geocode_approximate: 'Yaklaşık konum',
    },
    settings: 'Otomatik ekleme',
    autoAdd: 'Yeni onaylanan bayiler satış noktası olarak eklensin',
    autoAddLead:
      'Bayi onaylanınca lokasyonlarından satış noktası oluşturulur (yetkili adı ve telefonu olmadan). Unvanı kişi adı olabilecek bayi de görünür eklenir ve "Kişi adı olabilir" uyarısı çıkar; görünen adı kontrol edin. Askıya alınan bayinin noktaları vitrinde kendiliğinden gizlenir.',
    autoAddOn: 'Yeni onaylanan bayiler satış noktası olarak eklenecek.',
    autoAddOff: 'Yeni onaylanan bayiler satış noktası olarak eklenmeyecek.',
    geocode: 'Konumu adresten bul (OpenStreetMap)',
    geocodeLead:
      'Elle pin girilmemiş noktaların konumu adresinden bulunur; vitrinde "Konumumu kullan" en yakın noktaları bu konumla sıralar. Adres başka bir yeri gösterirse veya bulunamazsa bayi kartında uyarı çıkar. Dışarı yalnızca işletme adresi gider.',
    geocodeOn: 'Konumlar adresten bulunacak.',
    geocodeOff: 'Konumlar adresten bulunmayacak; yalnızca elle girilen pinler kullanılır.',
    backfill: 'Onaylı bayilerden oluştur',
    backfillDone:
      '{{created}} satış noktası eklendi ({{companies}} bayi). Adresi tanınmayan bayi: {{skipped}}.',
    backfillSkipped: 'Bu bayilerin adresi il/ilçe listesinde bulunamadığı için satış noktası oluşturulamadı:',
    geocodeNow: 'Konumları şimdi bul',
    geocodeNowRunning: 'Adresler aranıyor…',
    geocodeNowDone: '{{checked}} adres arandı: {{found}} konum bulundu, {{problems}} adreste sorun var.',
    geocodeNowNone: 'Konumu bekleyen nokta yok.',
    geocodeOne: 'Adresten konum bul',
    geocodeResult: {
      ok: 'Konum bulundu ve pin yazıldı.',
      approximate: 'Yaklaşık konum bulundu (mahalle düzeyi); pin yazıldı.',
      not_found: 'Adres haritada bulunamadı; adresi kontrol edin veya pini elle girin.',
      mismatch: 'Adres başka bir yeri gösteriyor ({{place}}); pin yazılmadı.',
      error: 'Konum servisine ulaşılamadı; biraz sonra yeniden denenecek.',
    },
    pinSource: {
      manual: 'Konum: elle girildi',
      geocoded: 'Konum: adresten bulundu (OpenStreetMap)',
      none: 'Konum: yok',
    },
    mismatchFound: 'bulunan yer: {{place}}',
    missing: {
      no_address: 'Bu bayinin adresi yok; satış noktası oluşturulamadı. Lokasyon veya firma adresi ekleyin.',
      address_unknown:
        'Bu bayinin adresindeki il/ilçe resmî listede bulunamadı; satış noktası oluşturulamadı. Adresi düzeltin veya noktayı elle ekleyin.',
    },
    listTitle: 'Satış noktaları',
    listLead:
      'Nokta bilgileri bayi kartında düzenlenir. Vitrinde yalnızca "Vitrinde" işaretli ve bayisi onaylı noktalar görünür.',
    allCities: 'Tüm iller',
    visibility: 'Vitrin durumu',
    bulkShow: 'Seçilenleri göster ({{count}})',
    bulkHide: 'Seçilenleri gizle ({{count}})',
    bulkDone: '{{count}} satış noktası güncellendi.',
    selectAll: 'Tümünü seç',
    selectOne: '{{name}} satış noktasını seç',
    none: 'Satış noktası yok',
    noneLead: 'Bayi kartından ekleyin; otomatik ekleme açıksa yeni onaylanan bayiler kendiliğinden eklenir.',
    colName: 'Görünen ad',
    colPlace: 'İlçe/İl',
    colDealer: 'Bayi',
    colStatus: 'Durum',
  },
  design: {
    saved: 'Tema taslağı kaydedildi.',
    published: 'Tema yayımlandı. Vitrinde en geç bir dakika içinde görünür.',
    discarded: 'Yayımlanmamış değişiklikler atıldı.',
    rolledBack: 'Seçilen sürüm yeniden yayımlandı.',
    preview: 'Vitrinde önizle',
    previewBlocked: 'Tarayıcı yeni sekmeyi engelledi. Bağlantıyı kopyalayıp açın:',
    save: 'Taslağı kaydet',
    publish: 'Yayımla',
    unsaved: 'Kaydedilmemiş değişiklikler var.',
    revertLocal: 'Değişikliklerden vazgeç',
    discard: 'Yayındaki temaya döndür',
    discardConfirm:
      'Taslaktaki yayımlanmamış değişiklikler silinir ve taslak yayındaki sürüme ({{version}}) döner. Devam edilsin mi?',
    editor: 'Tema ayarları',
    liveVersion: 'Yayında: sürüm {{version}} · {{date}}',
    noLiveTheme: 'Yayında tema yok (varsayılan görünüm)',
    unpublished: 'Yayımlanmamış değişiklik var',
    issuesCount: '{{count}} okunabilirlik sorunu',
    templates: 'Şablonlar',
    templatesLead:
      'Renk, yazı tipi ve düzeni birlikte değiştirir. Seçtiğiniz şablon kaydedene kadar yalnızca önizlemede görünür.',
    templatePick: 'Şablon seçin',
    templateNames: {
      clinic: 'Klinik',
      natural: 'Doğal',
      modern: 'Modern',
      classic: 'Klasik',
    },
    colors: 'Renkler',
    colorsLead:
      'Hazır bir paletle başlayıp renkleri tek tek değiştirebilirsiniz. Okunmayan renk çiftleri önizlemenin altında listelenir.',
    palettes: 'Hazır paletler',
    paletteNames: {
      pine: 'Çam',
      ocean: 'Okyanus',
      forest: 'Orman',
      amber: 'Kehribar',
      plum: 'Erik',
      ink: 'Mürekkep',
    },
    lightColors: 'Açık görünüm renkleri',
    darkColors: 'Koyu görünüm renkleri',
    darkMode: 'Cihaz koyu moddaysa koyu renkleri kullan',
    colorNames: {
      background: 'Arka plan',
      surface: 'Kart ve alan zemini',
      text: 'Yazı',
      mutedText: 'İkincil yazı',
      border: 'Çizgi ve çerçeve',
      primary: 'Ana renk (bağlantılar)',
      secondary: 'İkincil renk',
      accent: 'Vurgu rengi',
      button: 'Düğme',
      buttonText: 'Düğme yazısı',
      buttonHover: 'Düğme (üzerine gelince)',
    },
    typography: 'Yazı',
    typographyLead: 'Yazı tipleri vitrinle birlikte sunulur; ziyaretçinin cihazında yüklü olması gerekmez.',
    bodyFont: 'Gövde yazı tipi',
    headingFont: 'Başlık yazı tipi',
    fontKinds: {
      sans: 'tırnaksız',
      serif: 'tırnaklı',
    },
    baseSize: 'Gövde yazı boyutu',
    px: '{{value}} px',
    headingScale: 'Başlık boyutları',
    headingScales: {
      compact: 'Küçük',
      normal: 'Orta',
      large: 'Büyük',
    },
    headingWeight: 'Başlık kalınlığı',
    weights: {
      w500: 'Orta',
      w600: 'Yarı kalın',
      w700: 'Kalın',
    },
    shape: 'Şekil',
    shapeLead: 'Köşe yuvarlaklığı ve gölge kartlara, alanlara ve düğmelere uygulanır.',
    radius: 'Köşe yuvarlaklığı',
    buttonShape: 'Düğme biçimi',
    buttonShapes: {
      square: 'Köşeli',
      rounded: 'Yuvarlatılmış',
      pill: 'Hap',
    },
    shadow: 'Gölge',
    shadows: {
      none: 'Yok',
      soft: 'Hafif',
      strong: 'Belirgin',
    },
    layout: 'Düzen',
    layoutLead: 'Ürün kartları, üst ve alt bilgi, ürün sayfası ve form alanları.',
    cardStyle: 'Ürün kartı',
    cardStyles: {
      bordered: 'Çerçeveli',
      flat: 'Düz',
      raised: 'Gölgeli',
    },
    imageRatio: 'Ürün görseli oranı',
    imageRatios: {
      square: 'Kare (1:1)',
      portrait: 'Dikey (4:5)',
      landscape: 'Yatay (4:3)',
    },
    gridDesktop: 'Masaüstünde sütun',
    gridMobile: 'Telefonda sütun',
    columns: '{{count}} sütun',
    headerLayout: 'Logo konumu',
    headerLayoutMoved: 'Üst menünün ve logonun yerleşimi artık Sayfa tasarımlarından seçilir:',
    headerLayouts: {
      start: 'Solda',
      center: 'Ortada',
    },
    headerStyle: 'Üst bilgi zemini',
    headerStyles: {
      surface: 'Açık',
      brand: 'Ana renk',
    },
    headerSticky: 'Üst bilgi sayfa kayarken üstte kalsın',
    footerStyle: 'Alt bilgi zemini',
    footerStyles: {
      surface: 'Açık',
      dark: 'Koyu',
      brand: 'Ana renk',
    },
    gallery: 'Ürün sayfasında görsel',
    galleryPositions: {
      start: 'Solda',
      end: 'Sağda',
    },
    blogLayout: 'Blog sayfası',
    blogLayouts: {
      grid: 'Izgara',
      list: 'Liste',
    },
    inputStyle: 'Form alanları',
    inputStyles: {
      outline: 'Çerçeveli',
      filled: 'Dolgulu',
    },
    livePreview: 'Canlı önizleme',
    device: 'Cihaz',
    devices: {
      phone: 'Telefon',
      tablet: 'Tablet',
      desktop: 'Masaüstü',
    },
    scheme: 'Görünüm',
    schemes: {
      light: 'Açık',
      dark: 'Koyu',
    },
    mock: {
      store: 'Mağaza adı',
      search: 'Ürün ara',
      account: 'Hesabım',
      cart: 'Sepet',
      heading: 'Başlık örneği',
      lead: 'Giriş paragrafı ikincil yazı renginde görünür.',
      body: 'Gövde metni seçilen yazı tipi ve boyutta görünür;',
      link: 'bağlantılar ana renkte.',
      primaryButton: 'Ana düğme',
      secondaryButton: 'İkincil düğme',
      secondaryTag: 'İkincil renk',
      accentTag: 'Vurgu rengi',
      products: 'Ürünler',
      product: 'Ürün adı',
      price: 'Fiyat',
      field: 'Form alanı',
      placeholder: 'Örnek giriş',
      fieldHelp: 'Alan açıklaması ikincil yazı renginde.',
      footer: 'Alt bilgi',
    },
    contrastOk: 'Tüm renk çiftleri okunaklı (WCAG AA).',
    contrastTitle: 'Bu renk çiftleri yeterince okunaklı değil; düzeltilmeden yayımlanamaz:',
    contrastIssue: '{{palette}} görünüm: {{fg}} / {{bg}} — {{ratio}}:1 (en az {{min}}:1)',
    versions: 'Sürüm geçmişi',
    versionsLead:
      'Her yayım değişmez bir sürüm olarak saklanır. Önceki bir sürüme dönmek de yeni sürüm olarak yayımlanır; geçmiş silinmez.',
    noVersions: 'Henüz yayımlanmış sürüm yok.',
    versionNo: 'Sürüm {{version}}',
    restoredFrom: 'Sürüm {{version}} geri alındı',
    current: 'Yayında',
    rollback: 'Bu sürüme dön',
    rollbackConfirm:
      'Sürüm {{version}} yeniden yayımlanacak ve taslak bu sürüme getirilecek. Kaydedilmemiş taslak değişiklikleriniz silinir. Devam edilsin mi?',
    publishTitle: 'Temayı yayımla',
    publishLead:
      'Yeni görünüm vitrinde en geç bir dakika içinde ziyaretçilere görünür. İstediğiniz zaman önceki sürüme dönebilirsiniz.',
    publishConfirm: 'Yayımla',
    publishSavesFirst: 'Kaydedilmemiş değişiklikler önce kaydedilecek.',
    note: 'Sürüm notu',
  },
  menus: {
    save: 'Menüyü kaydet',
    startFrom: 'Başka dildeki menüden başla',
    loadDraft: 'Taslağı yükle',
    draftLoaded: 'Taslak menü yüklendi; etiketleri çevirip kaydedin.',
    draftDropped: 'Bu dilde karşılığı olmayan bağlantılar çıkarıldı: {{labels}}',
    draftEmpty: '{{lang}} menüsü boş; yüklenecek öğe yok.',
    saved: 'Menü kaydedildi. Vitrinde en geç bir dakika içinde görünür.',
    unsaved: 'Kaydedilmemiş değişiklik var',
    location: 'Menü konumu',
    locations: {
      header: 'Üst menü',
      footer: 'Alt bilgi menüsü',
    },
    locationLead: {
      header:
        'Üst menü vitrinin üst bilgisinin altında görünür. Alt öğesi olan öğe tıklanınca mega menü açar: ikinci seviye sütun başlıkları, üçüncü seviye bağlantılardır.',
      footer:
        'Alt bilgi menüsünde birinci seviye sütun başlığıdır, ikinci seviye o sütunun bağlantılarıdır. Alt öğesi olmayan bağlantılar "Bağlantılar" sütununda toplanır.',
    },
    empty: 'Bu menüde henüz öğe yok',
    emptyLead: {
      header:
        'Menü boşken vitrinin üst bilgisinde "Ürünler", "Satış Noktaları" ve "Makaleler" bağlantıları görünür.',
      footer: 'Menü boşken alt bilgide satıcı bilgileri, müşteri hizmetleri ve yasal metinler görünür.',
    },
    add: 'Öğe ekle',
    addChild: 'Alt öğe ekle',
    newItem: 'Yeni öğe',
    label: 'Menüde görünen ad',
    link: 'Bağlantı',
    linkTypes: {
      none: 'Bağlantısız başlık',
      category: 'Kategori',
      product: 'Ürün',
      products: 'Tüm ürünler',
      page: 'Sayfa',
      blog: 'Makaleler (blog)',
      post: 'Blog yazısı',
      url: 'Adres',
    },
    category: 'Kategori',
    chooseCategory: 'Kategori seçin',
    page: 'Sayfa',
    choosePage: 'Sayfa seçin',
    post: 'Yazı',
    choosePost: 'Yazı seçin',
    blogLead: 'Vitrindeki Makaleler sayfasına (/blog) gider.',
    notLivePage: '{{name}} (yayında değil)',
    hiddenCategory: '{{name}} (gizli)',
    product: 'Ürün',
    productSearch: 'Ürün adı, SKU veya barkod',
    productPicked: 'Seçili ürün: {{title}}',
    productNone: 'Henüz ürün seçilmedi.',
    url: 'Adres',
    newTab: 'Yeni sekmede aç',
    noneLead: 'Bağlantısız başlık yalnızca alt öğeleri gruplar.',
    productsLead: 'Tüm ürünler sayfasına gider.',
    unavailable: 'Hedef vitrinde görünmüyor',
    moveUp: '{{label}} yukarı taşı',
    moveDown: '{{label}} aşağı taşı',
  },
  editor: {
    toolbar: 'Metin biçimlendirme',
    paragraph: 'Paragraf',
    heading2: 'Başlık',
    heading3: 'Alt başlık',
    bold: 'Kalın',
    italic: 'İtalik',
    bulletList: 'Madde işaretli liste',
    orderedList: 'Numaralı liste',
    blockquote: 'Alıntı',
    rule: 'Ayırıcı çizgi',
    link: 'Bağlantı ekle',
    unlink: 'Bağlantıyı kaldır',
    image: 'Görsel ekle',
    undo: 'Geri al',
    redo: 'Yinele',
    moveUp: 'Seçili bloğu yukarı taşı',
    moveDown: 'Seçili bloğu aşağı taşı',
    linkTitle: 'Bağlantı',
    linkApply: 'Bağlantıyı uygula',
    linkUrl: 'Adres',
    linkUrlLead:
      'Site içi yol (ör. /urunler), https:// ile başlayan adres, mailto: veya tel: kullanabilirsiniz.',
    linkNewTab: 'Yeni sekmede aç',
    imageTitle: 'Görsel ekle',
    imageInsert: 'Görseli ekle',
    imageAlt: 'Alternatif metin',
    imageAltLead: 'Görselin ne gösterdiğini kısaca yazın; ekran okuyucular bu metni okur.',
    imageCaption: 'Altyazı',
    table: 'Tablo ekle',
    tableToolbar: 'Tablo işlemleri',
    addRow: 'Satır ekle',
    addColumn: 'Sütun ekle',
    deleteRow: 'Satırı sil',
    deleteColumn: 'Sütunu sil',
    deleteTable: 'Tabloyu sil',
    video: 'Video ekle',
    videoTitle: 'Video ekle',
    videoLead:
      'YouTube veya Vimeo adresini yapıştırın. Vitrinde ziyaretçi "oynat" diyene kadar video hizmetine hiçbir istek gitmez.',
    videoUrl: 'Video adresi',
    videoName: 'Video başlığı',
    videoInsert: 'Videoyu ekle',
    import: 'Markdown veya HTML içe al',
    importTitle: 'Markdown veya HTML içe al',
    importLead:
      'Başka bir yerde yazdığınız metni yapıştırın; imlecin olduğu yere eklenir. Başlık, liste, tablo, alıntı, kalın/italik ve bağlantılar korunur; betik, stil ve dış görseller alınmaz.',
    importFormat: 'Biçim',
    importText: 'Metin',
    importRun: 'Dönüştür ve ekle',
    importEmpty: 'Dönüştürülecek içerik bulunamadı.',
    imported: 'İçerik eklendi.',
    importSkippedImages: '{{count}} dış görsel alınmadı (görselleri "Görsel ekle" ile yükleyin).',
    importSkippedScripts: '{{count}} betik/stil bloğu atıldı.',
    importSkippedEmbeds: '{{count}} gömülü öğe atıldı (yalnızca YouTube/Vimeo videoları alınır).',
  },
  pages: {
    create: 'Yeni sayfa',
    createConfirm: 'Oluştur ve düzenle',
    empty: 'Henüz sayfa yok',
    emptyLead:
      'Ana sayfa düzeni yayımlanana kadar vitrin varsayılan ana sayfayı gösterir. "Yeni sayfa" ile ana sayfa düzeni, kurumsal sayfa veya kampanya sayfası oluşturun.',
    updated: 'Son değişiklik {{date}}',
    kind: 'Sayfa türü',
    kinds: { home: 'Ana sayfa düzeni', page: 'Kurumsal sayfa', landing: 'Kampanya sayfası' },
    states: {
      draft: 'Taslak',
      scheduled: 'Zamanlandı',
      live: 'Yayında',
      expired: 'Süresi doldu',
      unpublished: 'Yayından kaldırıldı',
    },
    reviews: {
      not_required: 'Onay gerekmiyor',
      pending: 'Uzman onayı bekliyor',
      approved: 'Uzman onayladı',
      rejected: 'Uzman reddetti',
    },
    title: 'Sayfa başlığı',
    newHeading: 'Yeni başlık',
    back: 'Tüm sayfalar',
    saved: 'Taslak kaydedildi',
    publishedToast: 'Sayfa yayımlandı',
    unpublishedToast: 'Sayfa yayından kaldırıldı',
    reviewedToast: 'İnceleme kararı kaydedildi',
    preview: 'Önizle',
    save: 'Taslağı kaydet',
    publish: 'Yayımla',
    liveVersion: 'Yayındaki sürüm: {{version}}',
    unpublished: 'Yayımlanmamış değişiklik var',
    publishAtInfo: 'Yayın: {{date}}',
    unpublishAtInfo: 'Kaldırma: {{date}}',
    basics: 'Sayfa bilgileri',
    slug: 'Kısa ad',
    slugLead: 'Adres: {{path}}',
    seoTitle: 'SEO başlığı',
    seoDescription: 'SEO açıklaması',
    chars: '{{count}}/{{max}} karakter',
    healthContent: 'Sağlık içeriği (uzman onayı gerekir)',
    sections: 'Bölümler',
    sectionsLead: 'Vitrinde yukarıdan aşağıya bu sırayla görünür. Gizlenen bölüm taslakta kalır.',
    noSections: 'Henüz bölüm yok. Aşağıdan bir bölüm türü seçip ekleyin.',
    sectionType: 'Bölüm türü',
    sectionTypes: {
      hero: 'Büyük başlık',
      richText: 'Metin',
      imageText: 'Görsel ve metin',
      productGrid: 'Ürün ızgarası',
      categoryTiles: 'Kategori kutuları',
      faq: 'Sıkça sorulan sorular',
      banners: 'Bannerlar',
      postList: 'Blog yazıları',
    },
    addSection: 'Bölüm ekle',
    hidden: 'Gizli',
    hide: 'Gizle',
    moveUp: '{{n}}. bölümü yukarı taşı',
    moveDown: '{{n}}. bölümü aşağı taşı',
    sectionUnavailable: 'Bu bölüm türü henüz desteklenmiyor.',
    heading: 'Başlık',
    heroText: 'Kısa metin',
    ctaLabel: 'Düğme metni',
    ctaHref: 'Düğme adresi',
    body: 'Metin',
    imagePosition: 'Görselin yeri',
    gridSource: 'Ürün kaynağı',
    gridSources: {
      newest: 'En yeni ürünler',
      category: 'Bir kategorinin ürünleri',
      products: 'Seçtiğim ürünler',
      bestsellers: 'Çok satanlar (son 30 gün)',
      discounted: 'İndirimli ürünler',
      collection: 'Bir koleksiyonun ürünleri',
      brand: 'Bir markanın ürünleri',
    },
    gridCollection: 'Koleksiyon',
    gridBrand: 'Marka',
    chooseRef: 'Seçin',
    refInactive: '{{name}} (vitrinde görünmez)',
    gridLimit: 'Ürün sayısı',
    products: 'Ürün ekle',
    unknownProduct: 'Ürün bulunamadı (silinmiş olabilir)',
    tileCategories: 'Gösterilecek kategoriler',
    question: '{{n}}. soru',
    answer: '{{n}}. cevap',
    addQuestion: 'Soru ekle',
    removeQuestion: 'Bu soruyu kaldır',
    noImage: 'Görsel yok',
    uploadImage: 'Görsel yükle',
    replaceImage: 'Görseli değiştir',
    imageAlt: 'Alternatif metin',
    review: 'Uzman incelemesi',
    reviewLead:
      'Sağlık içeriği veya sağlık beyanı olan sayfalar Veteriner Uzman İnceleyici onayıyla yayımlanır. İçerik değişirse onay düşer.',
    reviewNote: 'İnceleyici notu: {{note}}',
    reviewNoteLabel: 'İnceleme notu',
    reviewSaveFirst: 'Önce taslağı kaydedin; karar kaydedilen içeriğe verilir.',
    findings: 'Olası sağlık beyanı: {{count}} ifade',
    approve: 'Onayla',
    reject: 'Reddet',
    versions: 'Yayımlanan sürümler',
    versionsLead: 'Her yayın değiştirilemez bir sürüm olarak saklanır.',
    noVersions: 'Bu sayfa henüz yayımlanmadı.',
    unpublish: 'Yayından kaldır',
    unpublishConfirm: 'Sayfa vitrinden hemen kalkar. Taslak ve sürümler saklanır. Devam edilsin mi?',
    deleteConfirm: 'Bu taslak sayfa kalıcı olarak silinecek. Devam edilsin mi?',
    publishTitle: 'Sayfayı yayımla',
    publishLead: 'Taslak yeni bir sürüm olarak vitrine çıkar. Tarih vermezseniz hemen yayına girer.',
    publishConfirm: 'Yayımla',
    publishAt: 'Yayın tarihi',
    bannerPlacement: 'Banner alanı',
    bannersLead: 'Bu bölüm, seçilen alana eklenen etkin bannerları gösterir.',
    manageBanners: 'Bannerları yönet',
    allPostCategories: 'Tüm kategoriler',
    postLimit: 'Yazı sayısı',
    unpublishAt: 'Kaldırma tarihi',
  },
  banners: {
    create: 'Yeni banner',
    createConfirm: 'Taslak olarak kaydet',
    save: 'Kaydet',
    saved: 'Banner kaydedildi',
    activate: 'Etkinleştir',
    activated: 'Banner etkinleştirildi',
    deactivate: 'Durdur',
    deactivated: 'Banner durduruldu',
    reordered: 'Sıra kaydedildi',
    back: 'Tüm bannerlar',
    unsaved: 'Kaydedilmemiş değişiklik var',
    saveBeforeActivate: 'Etkinleştirmeden önce kaydedin.',
    activeLocked: 'Bu banner etkin; değiştirmek için İçerik yayınlama yetkisi gerekir.',
    emptyPlacement: 'Bu alanda banner yok.',
    noText: 'Metin yok',
    startsInfo: 'Başlangıç: {{date}}',
    endsInfo: 'Bitiş: {{date}}',
    updated: 'Son değişiklik {{date}}',
    moveUp: '{{name}} yukarı taşı',
    moveDown: '{{name}} aşağı taşı',
    placements: {
      home_hero: "Ana sayfa slider'ı",
      home_secondary: 'Ana sayfa ikincil alan',
      category_top: 'Kategori üstü',
      announcement: 'Duyuru çubuğu',
      popup: 'Açılır pencere',
    },
    placementLead: {
      home_hero: 'Ana sayfanın üstünde sırayla döner (en fazla 8). Ziyaretçi durdurabilir.',
      home_secondary: 'Ana sayfada kutular hâlinde (en fazla 6).',
      category_top: 'Seçilen kategorilerin sayfasında, ürün listesinin üstünde (ilk sıradaki).',
      announcement: 'Sitenin en üstünde tek satır (ilk sıradaki).',
      popup: 'Sayfa açılınca bir kez çıkar; ödeme ve sepet adımlarında çıkmaz (ilk sıradaki).',
    },
    states: {
      draft: 'Taslak',
      scheduled: 'Zamanlandı',
      live: 'Yayında',
      expired: 'Süresi doldu',
      inactive: 'Durduruldu',
    },
    audiences: { all: 'Herkes', retail: 'Bayi olmayanlar', dealer: 'Yalnızca bayiler' },
    basics: 'Banner bilgileri',
    placement: 'Yerleşim',
    name: 'İç ad',
    nameLead: 'Yalnızca panelde görünür.',
    title: 'Başlık',
    text: 'Metin',
    announcementText: 'Duyuru metni',
    ctaLabel: 'Düğme metni',
    href: 'Bağlantı adresi',
    images: 'Görseller',
    imagesLead: 'Metin görselin üstüne yazılmaz; görsel yalnızca görsel olarak kullanılır.',
    desktopImage: 'Masaüstü görseli',
    uploadDesktop: 'Masaüstü görseli yükle',
    replaceDesktop: 'Masaüstü görselini değiştir',
    mobileImage: 'Mobil görsel',
    uploadMobile: 'Mobil görsel yükle',
    replaceMobile: 'Mobil görseli değiştir',
    targeting: 'Kitle ve zaman',
    targetingLead: 'Kimin göreceği ve ne zaman görüneceği.',
    audience: 'Hedef kitle',
    startsAt: 'Başlangıç',
    endsAt: 'Bitiş',
    dismissDays: 'Kapatınca kaç gün gizlensin',
    categories: 'Kategoriler',
    categoriesLead: 'Hiçbiri seçilmezse tüm kategori sayfalarında görünür.',
    dangerZone: 'Silme',
    deleteConfirm: 'Bu banner kalıcı olarak silinecek. Devam edilsin mi?',
  },
  blog: {
    create: 'Yeni yazı',
    posts: 'Yazılar',
    filter: 'Göster',
    filters: {
      all: 'Tüm yazılar',
      review: 'Uzman onayı bekleyenler',
      live: 'Yayındakiler',
      draft: 'Taslaklar',
    },
    pendingCount: '{{count}} yazı uzman onayı bekliyor',
    empty: 'Yazı yok',
    emptyLead: '"Yeni yazı" ile ilk yazınızı hazırlayın; yayımlayana kadar vitrinde görünmez.',
    publishedInfo: 'Yayın {{date}}',
    states: { draft: 'Taslak', scheduled: 'Zamanlandı', live: 'Yayında', unpublished: 'Yayından kaldırıldı' },
    title: 'Yazı başlığı',
    back: 'Tüm yazılar',
    feature: 'Öne çıkar',
    unfeature: 'Öne çıkarmayı kaldır',
    featuredBadge: 'Öne çıkan',
    featuredToast: 'Yazı Makaleler sayfasında öne çıkarıldı.',
    unfeaturedToast: 'Yazı artık öne çıkan değil.',
    readingTime: '{{n}} dk okuma',
    article: 'Yazı',
    excerpt: 'Özet',
    category: 'Kategori',
    noCategory: 'Kategorisiz',
    tags: 'Etiketler',
    tagsLead: 'Virgülle ayırın.',
    authorName: 'Yazar adı',
    authorTitle: 'Yazar unvanı',
    authorTitlePlaceholder: 'Veteriner Hekim',
    cover: 'Kapak görseli',
    uploadCover: 'Kapak görseli yükle',
    replaceCover: 'Kapak görselini değiştir',
    body: 'Yazının metni',
    references: 'Kaynaklar',
    referencesLead: 'Yazının dayandığı bilimsel kaynaklar ve bağlantılar.',
    referenceTitle: '{{n}}. kaynak',
    referenceUrl: '{{n}}. kaynağın bağlantısı',
    referenceRemove: '{{n}}. kaynağı kaldır',
    referenceAdd: 'Kaynak ekle',
    related: 'İlgili ürünler',
    relatedLead: 'Yazının sonunda gösterilir.',
    relatedSearch: 'Ürün ekle',
    seo: 'Arama motorları',
    noVersions: 'Bu yazı henüz yayımlanmadı.',
    publishedToast: 'Yazı yayımlandı',
    unpublishedToast: 'Yazı yayından kaldırıldı',
    unpublishConfirm: 'Yazı vitrinden hemen kalkar. Taslak ve sürümler saklanır. Devam edilsin mi?',
    deleteConfirm: 'Bu taslak yazı kalıcı olarak silinecek. Devam edilsin mi?',
    publishTitle: 'Yazıyı yayımla',
    publishLead: 'Taslak yeni bir sürüm olarak vitrine çıkar. Tarih vermezseniz hemen yayına girer.',
    categories: 'Blog kategorileri',
    categoriesLead: 'Kategori, içinde yayındaki yazı olunca vitrinde listelenir.',
    categoryName: 'Kategori adı',
    categoryAdd: 'Kategori ekle',
    categoryEdit: 'Kategoriyi düzenle',
    categorySlugLead: 'Değişirse eski adres yeni adrese yönlendirilir.',
    categoryDescription: 'Açıklama',
    categorySaved: 'Kategori kaydedildi',
    categoryDelete: '{{name}} kategorisini sil',
    categoryDeleteConfirm: '"{{name}}" silinecek; yazıları kategorisiz kalır. Devam edilsin mi?',
    postCount: '{{count}} yazı',
  },
  contentPlan: {
    kind: 'Tür',
    allKinds: 'Tüm içerikler',
    kinds: { post: 'Blog yazısı', page: 'Sayfa', banner: 'Banner' },
    monthNav: 'Ay seçimi',
    prevMonth: 'Önceki ay',
    nextMonth: 'Sonraki ay',
    thisMonth: 'Bu ay',
    summary: '{{planned}} planlı, {{done}} gerçekleşen olay',
    agenda: '{{month}} içerik takvimi',
    today: 'Bugün',
    planned: 'Planlı',
    empty: 'Bu ay yayın olayı yok',
    emptyLead:
      'Yazı veya sayfayı ileri bir tarihe zamanlayarak yayımlayınca, banner başlangıç/bitiş tarihi verince burada görünür.',
    truncated: 'Bu ay çok fazla olay var; ilk 1000 olay gösteriliyor.',
    events: {
      publish_planned: 'Yayına girecek',
      publish_done: 'Yayına girdi',
      update: 'Güncellendi (sürüm {{version}})',
      start_planned: 'Gösterilmeye başlayacak',
      start_done: 'Gösterilmeye başladı',
      end_planned: 'Yayından kalkacak',
      end_done: 'Yayından kalktı',
    },
    statesTitle: 'Durum özeti',
    postsTitle: 'Blog yazıları',
    pagesTitle: 'Sayfalar',
    bannersTitle: 'Bannerlar',
    pendingReview: 'Uzman onayı bekliyor',
    categoriesTitle: 'Kategorilere göre yayındaki yazılar',
    categoriesLead: 'Yayımlanan sürümdeki kategoriye göre sayılır.',
    noCategories: 'Henüz blog kategorisi ve yayındaki yazı yok.',
    livePosts: 'Yayındaki yazı',
    monthlyTitle: 'Son 12 ayda yayına giren yazılar',
    monthlyLead:
      'Yazının vitrinde görünen tarihine göre (Türkiye saati); şu an yayında olan yazılar sayılır.',
    month: 'Ay',
    published: 'Yazı',
    bar: 'Görsel karşılaştırma',
    staleTitle: 'Güncellenmeyen yazılar',
    staleLead:
      'Son yayımlanan sürümü {{days}} günden eski olan yayındaki yazılar. Bilgileri gözden geçirip yeniden yayımlayın.',
    staleNone: 'Bir yıldan uzun süredir güncellenmeyen yazı yok.',
    staleMore: 've {{count}} yazı daha',
    lastPublished: 'Son yayın: {{date}}',
    scTitle: 'Search Console: yazıların son 28 günü',
    scUnavailable: 'Search Console verisi bu dil için gösterilemiyor.',
    scOtherLocale:
      'Search Console tıklamaları yalnızca vitrinin dilindeki (varsayılan dil) yazılar için gösterilir.',
    setupRequired: 'Kurulum gerekli',
    scNotLinked: 'Bu mağaza için Search Console mülkü bağlı değil. Google bağlantıları sayfasından bağlayın.',
    scNoData: 'Henüz Search Console verisi yok; ilk senkrondan sonra burada görünür.',
    scRange: 'Veri aralığı: {{from}} – {{to}}',
    scNoClicks: 'Bu dönemde blog yazılarına arama tıklaması veya gösterimi yok.',
    scWithoutClicks: 'Bu dönemde tıklama almayan yayındaki yazı: {{count}}',
    post: 'Yazı',
  },
  forms: {
    form: 'Form',
    kinds: { contact: 'İletişim formu', dealer_application: 'Bayilik başvurusu (ek alanlar)' },
    settingsTitle: 'Yayın ve bildirim',
    noticeMissing: 'KVKK aydınlatma metni yayımda değil',
    noticeMissingLead: 'Formu vitrinde açmak için önce aydınlatma metnini yayımlayın.',
    enabled: 'Formu İletişim sayfasında göster',
    notifyStaff: 'Yeni mesajda e-posta bildirimi',
    newMessages: '{{count}} yeni mesaj',
    dealerLead:
      'Firma unvanı, vergi bilgileri, telefon, adres, il/ilçe, işletme türü, not ve belge alanları sabittir. Buraya eklediğiniz alanlar başvuru formunun sonunda gösterilir ve başvuruyla birlikte saklanır.',
    fieldsTitle: 'Form alanları',
    extraFieldsTitle: 'Ek alanlar',
    fieldsLead: 'Alanlar vitrinde bu sırayla gösterilir. Değişiklik "Formu kaydet" ile hemen yayına girer.',
    noFields: 'Henüz ek alan yok.',
    addField: 'Alan ekle',
    save: 'Formu kaydet',
    saved: 'Form kaydedildi',
    untitled: 'Adsız alan',
    fieldN: '{{n}}. alan: {{name}}',
    requiredBadge: 'Zorunlu',
    label: 'Etiket',
    type: 'Alan türü',
    help: 'Yardım metni',
    options: 'Seçenekler (her satıra bir seçenek)',
    required: 'Zorunlu alan',
    moveUp: '{{name}} alanını yukarı taşı',
    moveDown: '{{name}} alanını aşağı taşı',
    remove: '{{name}} alanını kaldır',
    types: {
      text: 'Kısa metin',
      textarea: 'Uzun metin',
      email: 'E-posta',
      tel: 'Telefon',
      number: 'Sayı',
      select: 'Seçim listesi',
      checkbox: 'Onay kutusu',
      date: 'Tarih',
    },
    presets: { name: 'Ad soyad', email: 'E-posta', phone: 'Telefon', message: 'Mesaj' },
  },
  messages: {
    filter: 'Göster',
    convert: 'Talebe dönüştür',
    filters: { new: 'Yeni mesajlar', handled: 'İşlenenler', all: 'Tüm mesajlar' },
    newCount: '{{count}} yeni mesaj',
    listTitle: 'Mesajlar',
    empty: 'Mesaj yok',
    emptyLead: 'İletişim formu açıkken vitrinden gönderilen mesajlar burada listelenir (Vitrin → Formlar).',
    statuses: { new: 'Yeni', handled: 'İşlendi' },
    reply: 'E-postayla yanıtla',
    markHandled: 'İşlendi olarak işaretle',
    markNew: 'Yeniye geri al',
    deleteConfirm: 'Mesaj kalıcı olarak silinsin mi? Bu işlem geri alınamaz.',
    deleted: 'Mesaj silindi',
    pageOf: 'Sayfa {{page}} / {{pages}}',
  },
  topbar: {
    store: 'Çalışılan mağaza',
    jobsRunning: '{{count}} iş sürüyor',
    jobsDone: 'İşler tamamlandı ({{count}})',
    jobsTitle: 'Arka plan işleri',
    jobsLead: 'Süren işler ve son 10 dakikada bitenler.',
    progress: '{{processed}} / {{total}}',
    statuses: { queued: 'Sırada', running: 'Sürüyor', done: 'Tamamlandı', failed: 'Başarısız' },
    kinds: {
      import: 'İçe aktarma',
      product_bulk: 'Toplu ürün işlemi',
      seo_crawl: 'Site taraması',
      web_vitals: 'Sayfa hızı ölçümü',
    },
    imports: {
      products: 'Ürün içe aktarma',
      shopify_products: 'Shopify ürün içe aktarma',
      categories: 'Kategori içe aktarma',
      dealers: 'Bayi listesi içe aktarma',
      migration: 'Taşıma paketi',
    },
  },
  audience: {
    subscribersTitle: 'Bülten aboneleri',
    subscribersLead:
      'Vitrindeki bülten formundan abone olanlar. Abonelik e-postadaki onay bağlantısıyla başlar (çift onay); üyelerin izinleri müşteri kartında.',
    status: 'Durum',
    statuses: {
      subscribed: 'Abone',
      pending: 'Onay bekliyor',
      unsubscribed: 'Çıktı',
      all: 'Tümü',
    },
    sources: { storefront_form: 'Vitrin formu', admin_import: 'İçe aktarma' },
    search: 'E-postada ara',
    member: 'Üye',
    colEmail: 'E-posta',
    colStatus: 'Durum',
    colConsent: 'İzin tarihi ve metni',
    noSubscribers: 'Bu durumda abone yok',
    noSubscribersLead:
      'Bülten formu, e-posta gönderimi kurulu ve KVKK aydınlatma metni yayımdayken vitrinin alt bilgisinde görünür.',
    unsubscribe: 'Aboneliği sonlandır',
    unsubscribeConfirm:
      'Bu adrese bir daha pazarlama e-postası gönderilmez (engel listesine "çıktı" olarak girer) ve İYS\'ye ret bildirilir. Devam edilsin mi?',
    unsubscribedDone: 'Abonelik sonlandırıldı.',
    deleteConfirm:
      'Abone kaydı silinir (KVKK). Çıkma kaydı ve İYS kayıtları ispat için kalır. Geri alınamaz. Devam edilsin mi?',
    deletedDone: 'Abone silindi.',
    suppressionsTitle: 'Engel listesi',
    suppressionsLead:
      'Bu adreslere izin olsa bile hiçbir pazarlama iletisi gönderilmez: çıkanlar, geri dönen veya şikâyet eden adresler ve elle eklenenler. Sipariş ve kargo bildirimleri etkilenmez.',
    channel: 'Kanal',
    channels: { email: 'E-posta', sms: 'SMS', whatsapp: 'WhatsApp' },
    channelFilter: 'Listeyi kanala göre süz',
    allChannels: 'Tüm kanallar',
    address: 'Adres',
    note: 'Not (isteğe bağlı)',
    suppress: 'Engelle',
    suppressedDone: 'Adres engel listesine eklendi.',
    colReason: 'Neden',
    colDate: 'Tarih',
    reasons: {
      unsubscribe: 'Çıktı',
      bounce: 'Geri döndü',
      complaint: 'Şikâyet',
      manual: 'Elle eklendi',
      iys_ret: "İYS'de ret",
    },
    noSuppressions: 'Engel listesi boş',
    noSuppressionsLead: 'Çıkma bağlantısını kullananlar ve elle engellediğiniz adresler burada listelenir.',
    unsuppress: 'Kaldır',
    unsuppressConfirm:
      'Engel kaldırılır; kişinin izni geri gelmez, tekrar ileti alması için yeniden izin vermesi gerekir. Devam edilsin mi?',
    unsuppressedDone: 'Engel kaldırıldı.',
    iysTitle: 'İYS kayıtları',
    iysLead:
      "İzin ve retler üç iş günü içinde İleti Yönetim Sistemi'ne bildirilmelidir; İYS'ye bildirilmeyen izinle pazarlama iletisi gönderilmez.",
    iysConnected: 'İYS bağlı',
    iysSetup: 'Kurulum gerekli',
    iysSetupLink: 'Entegrasyonlar → İYS',
    iysPending: 'Bekleyen: {{count}}',
    iysOverdue: 'Süresi geçen: {{count}}',
    iysFailed: 'Reddedilen: {{count}}',
    iysFilter: 'Göster',
    iysFilters: {
      open: 'Bildirilecekler',
      sent: "İYS'ye gönderilenler",
      reported: 'Elle bildirilenler',
      failed: 'Reddedilenler',
      all: 'Tümü',
    },
    iysDownload: 'Dosya indir (CSV)',
    iysMark: 'Seçilenleri bildirildi işaretle ({{count}})',
    iysMarked: 'Kayıtlar bildirildi olarak işaretlendi.',
    iysEmpty: 'Bildirilecek kayıt yok',
    iysEmptyLead: 'Yeni izin veya ret geldikçe burada listelenir.',
    select: 'Seç',
    selectRecord: '{{address}} kaydını seç',
    colIys: 'İzin',
    colDue: 'Son bildirim günü',
    colState: 'Durum',
    overdue: 'Süresi geçti',
    recipientTypes: { BIREYSEL: 'Bireysel', TACIR: 'Tacir/esnaf (bayi)' },
    iysTypes: { EPOSTA: 'E-posta', MESAJ: 'Mesaj', ARAMA: 'Arama' },
    iysStatuses: { ONAY: 'Onay', RET: 'Ret' },
    eligibility: {
      invalid_address: 'Adres geçersiz',
      suppressed: 'Engel listesinde',
      no_consent: 'Pazarlama izni yok',
      iys_not_registered: "İzin İYS'ye henüz bildirilmedi",
      iys_refused: "İYS'de ret kaydı var",
    },
    iysStates: {
      pending: 'Bekliyor',
      sent: "İYS'ye gönderildi",
      reported: 'Elle bildirildi',
      failed: 'Reddedildi',
    },
  },
  segments: {
    rfmTitle: 'RFM grupları',
    rfmLead:
      'Müşteriler son alışverişin yakınlığına (R), sipariş sayısına (F) ve net harcamasına (M) göre 1–5 puanlanır ve gruplara ayrılır. Her gece kendiliğinden hesaplanır.',
    computedAt: 'Son hesaplama: {{date}}',
    neverComputed:
      'Henüz hesaplanmadı. "Şimdi yeniden hesapla" ile başlatabilirsiniz; ayrıca her gece hesaplanır.',
    recompute: 'Şimdi yeniden hesapla',
    recomputed: 'RFM grupları ve segment sayıları güncellendi.',
    thresholds:
      'R: son {{r5}} gün içinde alışveriş 5, {{r4}} gün 4, {{r3}} gün 3, {{r2}} gün 2, daha eski 1. F: en az {{f5}} sipariş 5, {{f4}} → 4, {{f3}} → 3, {{f2}} → 2, tek sipariş 1. M: müşteriler arasında beşte bir dilim (en çok harcayan %20 → 5).',
    groupCount: '{{count}} müşteri',
    groupShare: 'müşterilerin %{{pct}}',
    groupSpent: 'Net harcama {{amount}}',
    noOrdersCount: '{{count}} üye',
    saveAsSegment: 'Segment olarak kaydet',
    saveAsSegmentLabel: '{{group}} grubunu segment olarak kaydet',
    savedAsSegment: 'Segment oluşturuldu.',
    groups: {
      champions: 'Şampiyonlar',
      loyal: 'Sadık müşteriler',
      new: 'Yeni müşteriler',
      potential: 'Umut vadedenler',
      need_attention: 'İlgi bekleyenler',
      cant_lose: 'Kaybedilmemesi gerekenler',
      at_risk: 'Risk altındakiler',
      hibernating: 'Uykudakiler',
      lost: 'Kaybedilenler',
      none: 'Sipariş vermemiş üyeler',
    },
    groupHints: {
      champions:
        'Son {{r4}} gün içinde alışveriş yapmış, en az {{f4}} sipariş vermiş ve en çok harcayan %40 içinde.',
      loyal: 'Son {{r3}} gün içinde alışveriş yapmış, en az {{f3}} sipariş vermiş.',
      new: 'Tek siparişini son {{r4}} gün içinde vermiş.',
      potential: 'Son {{r4}} gün içinde ikinci siparişini vermiş.',
      need_attention: 'Son alışverişi {{r4}}–{{r3}} gün önce, en çok iki sipariş.',
      cant_lose: 'En az {{f4}} sipariş vermiş ama {{r3}} günden uzun süredir alışveriş yapmamış.',
      at_risk: '2–3 sipariş vermiş, {{r3}} günden uzun süredir alışveriş yapmamış.',
      hibernating: 'Tek siparişi {{r3}}–{{r2}} gün önce.',
      lost: 'Tek siparişi {{r2}} günden eski.',
      none: 'Üye olmuş ama geçerli siparişi yok.',
    },
    listTitle: 'Segmentler',
    listLead:
      'Kurallarla tanımlanan müşteri grupları; kampanya ve otomasyonlarda kitle olarak kullanılır. Üyeler her kullanımda kurallardan yeniden hesaplanır.',
    add: 'Yeni segment',
    emptyTitle: 'Henüz segment yok',
    emptyLead: 'Yukarıdaki bir RFM grubunu kaydedin veya kendi kurallarınızla segment oluşturun.',
    colName: 'Segment',
    colMembers: 'Müşteri sayısı',
    colCounted: 'Son sayım',
    backToList: 'Tüm segmentler',
    basics: 'Segment bilgileri',
    name: 'Ad',
    description: 'Açıklama',
    rulesTitle: 'Kurallar',
    rulesLead:
      'Kurallara uyan müşteriler segmenttedir. Sipariş koşulları anlık, RFM grubu son hesaplamaya göre değerlendirilir; KVKK ile silinen müşteriler hiçbir segmentte yer almaz.',
    match: 'Eşleşme',
    matchAll: 'Tüm koşullar sağlanmalı',
    matchAny: 'Koşullardan biri yeterli',
    conditions: 'Koşullar',
    field: 'Alan',
    op: 'Karşılaştırma',
    value: 'Değer',
    choose: 'Seçin',
    addCondition: 'Koşul ekle',
    removeCondition: 'Koşulu kaldır',
    fields: {
      order_count: 'Sipariş sayısı',
      total_spent: 'Net harcama',
      last_order_days: 'Son siparişten bu yana geçen gün',
      registered_days: 'Üyelikten bu yana geçen gün',
      species: 'Aldığı ürünün türü',
      tag: 'Etiket',
      city: 'Şehir',
      kind: 'Müşteri tipi',
      consent: 'Pazarlama izni olan kanal',
      consent_source: 'E-posta izninin alındığı yer',
      rfm: 'RFM grubu',
    },
    ops: { is: 'eşittir', is_not: 'eşit değildir', gte: 'en az', lte: 'en çok' },
    kinds: { dealer: 'Bayi (onaylı firma üyesi)', retail: 'Perakende' },
    amountIn: 'Tutar ({{currency}})',
    days: 'Gün',
    preview: 'Önizle',
    previewTitle: 'Eşleşen müşteri: {{count}}',
    previewLead: 'Kaydetmeden önceki önizleme; ilk 10 müşteri gösterilir.',
    noMatches: 'Kurallara uyan müşteri yok.',
    saved: 'Segment kaydedildi.',
    deleted: 'Segment silindi.',
    deleteConfirm: '"{{name}}" segmenti silinir; müşteriler etkilenmez. Devam edilsin mi?',
    membersTitle: 'Segmentteki müşteriler: {{count}}',
    membersEmpty: 'Bu segmentte şu an müşteri yok.',
    colCustomer: 'Müşteri',
    colRfm: 'RFM grubu',
    colOrders: 'Sipariş',
    colSpent: 'Net harcama',
    colLastOrder: 'Son sipariş',
  },
  emailRouting: {
    title: 'E-posta gönderimi',
    lead: 'Sipariş, şifre ve davet e-postaları (işlem) ile bülten ve kampanya e-postaları (pazarlama) ayrı sağlayıcıdan gönderilebilir. Listede yalnızca bağlantı testi başarılı sağlayıcılar çıkar.',
    transactional: 'İşlem e-postaları',
    marketing: 'Pazarlama e-postaları',
    smtpDefault: 'SMTP (işletme veya platform)',
    sameAsTransactional: 'İşlem e-postalarıyla aynı',
    noProviders:
      'Henüz bağlı bir e-posta sağlayıcısı (Amazon SES, SendGrid, Postmark) yok; e-postalar SMTP ile gider.',
    save: 'Gönderim seçimini kaydet',
    saved: 'Gönderim seçimi kaydedildi.',
    webhooksLead:
      'Geri dönen, şikâyet ve çıkma bildirimleri için bu adresleri sağlayıcının paneline girin; bu adreslere gelen bildirimler engel listesine işlenir. Adresler gizli anahtar içerir, paylaşmayın.',
    webhookFor: '{{provider}} bildirim adresi',
    rotate: 'Adresleri yenile',
    rotateConfirm:
      'Yeni gizli anahtar üretilir; eski adresler hemen geçersiz olur. Sağlayıcı panellerindeki adresleri güncellemeniz gerekir. Devam edilsin mi?',
    rotated: 'Bildirim adresleri yenilendi.',
  },

  emailTemplates: {
    create: 'Yeni şablon',
    lead: 'Bülten ve kampanya e-postalarının şablonları. Bloklarla içerik kurarsınız; renkler ve logo mağazanın yayındaki temasından, alt bilgideki yasal bilgiler işletme ayarlarından gelir. Gönderim kampanya ekranından yapılır.',
    emptyTitle: 'Henüz şablon yok',
    emptyLead:
      '"Yeni şablon" ile başlayın: başlık, metin, görsel, düğme ve ürün kartı bloklarını ekleyip sıralayın.',
    listLabel: 'E-posta şablonları',
    colName: 'Şablon',
    colReview: 'Uzman incelemesi',
    colUpdated: 'Son değişiklik',
    noReview: 'Gerekmiyor',
    saved: 'Şablon kaydedildi.',
    deleted: 'Şablon silindi.',
    save: 'Kaydet',
    createConfirm: 'Şablonu oluştur',
    back: 'Tüm şablonlar',
    unsaved: 'Kaydedilmemiş değişiklik',
    completeFirst: 'Kaydetmek için ad, konu ve eksik görünen blokları tamamlayın.',
    editor: 'Şablon düzenleyici',
    basics: 'Şablon bilgileri',
    name: 'Şablon adı',
    nameLead: 'Yalnızca panelde görünür (ör. "Ekim bülteni").',
    subject: 'Konu',
    preheader: 'Ön metin',
    preheaderLead: 'Gelen kutusunda konunun yanında görünen kısa açıklama; e-postanın içinde görünmez.',
    mergeTitle: 'Kişiselleştirme alanları',
    mergeFields: {
      firstName: 'alıcının adı',
      name: 'alıcının adı ve soyadı',
      email: 'alıcının e-posta adresi',
      storeName: 'mağaza adı',
    },
    mergeFallback: 'Değer yoksa yerine yazılacak metni dikey çizgiden sonra yazın:',
    blocks: 'İçerik blokları',
    blocksLead:
      'Bloklar yukarıdan aşağıya bu sırayla görünür. Tutamaktan sürükleyerek veya ok düğmeleriyle sıralayın. Yasal bilgiler ve çıkma bağlantısı her e-postanın altına kendiliğinden eklenir.',
    noBlocks: 'Henüz blok yok. Aşağıdan bir blok ekleyin.',
    moved: 'Blok {{position}}. sıraya taşındı.',
    removed: '{{n}}. blok kaldırıldı.',
    added: '{{type}} bloğu {{n}}. sıraya eklendi.',
    dragHint: 'Sıralamak için sürükleyin',
    blockTitle: '{{n}}. {{type}}',
    blockTypes: {
      heading: 'Başlık',
      text: 'Metin',
      image: 'Görsel',
      button: 'Düğme',
      products: 'Ürün kartları',
      divider: 'Ayırıcı çizgi',
      spacer: 'Boşluk',
      cart: 'Sepet',
      order: 'Sipariş',
      quote: 'Teklif',
    },
    missing: {
      text: 'Metin yazın',
      image: 'Görsel yükleyin',
      label: 'Düğme yazısını girin',
      link: 'Bağlantı adresini girin',
      products: 'En az bir ürün seçin',
      collection: 'Koleksiyon seçin',
      category: 'Kategori seçin',
    },
    moveUp: '{{n}}. bloğu yukarı taşı',
    moveDown: '{{n}}. bloğu aşağı taşı',
    removeBlock: '{{n}}. bloğu kaldır',
    addBlock: 'Blok ekle',
    blockLimit: 'Bir şablonda en çok {{max}} blok olabilir.',
    dangerZone: 'Şablonu sil',
    deleteConfirm: '"{{name}}" şablonu silinir. Başka dillerdeki sürümleri kalır. Devam edilsin mi?',
    updated: 'Son değişiklik: {{date}}',
    align: 'Hizalama',
    aligns: { left: 'Sola', center: 'Ortaya' },
    headingText: 'Başlık',
    level: 'Boyut',
    levels: { '1': 'Büyük başlık', '2': 'Ara başlık' },
    text: 'Metin',
    textLead: 'Boş satır yeni paragraf başlatır. **iki yıldız** arasındaki yazı kalın görünür.',
    replaceImage: 'Görseli değiştir',
    uploadImage: 'Görsel yükle',
    imageAlt: 'Görsel açıklaması',
    imageAltLead: 'Görsel yüklenmezse veya ekran okuyucuda okunan metin. Bağlantılı görselde zorunlu.',
    imageLink: 'Görsel bağlantısı',
    width: 'Genişlik',
    widths: { full: 'Tam genişlik', half: 'Yarım genişlik (ortada)' },
    buttonLabel: 'Düğme yazısı',
    buttonLink: 'Düğme bağlantısı',
    source: 'Ürün kaynağı',
    sources: {
      newest: 'En yeni ürünler',
      collection: 'Koleksiyon',
      category: 'Kategori',
      manual: 'Elle seçilen ürünler',
    },
    columns: 'Sütun',
    columnCount: '{{count}} sütun',
    limit: 'Ürün sayısı',
    collection: 'Koleksiyon',
    category: 'Kategori',
    choose: 'Seçin',
    pickProducts: 'Ürünler',
    showPrice: 'Fiyatı göster',
    productsLead:
      'Yalnızca bu mağazada yayında, etkin ve içeriği onaylı ürünler gösterilir; sağlık beyanı onay bekleyen ürünler e-postaya girmez. Fiyat, varsayılan pazarın vergi dahil en düşük varyant fiyatıdır ve gönderim anında yeniden hesaplanır.',
    spacerSize: 'Boşluk yüksekliği',
    sizes: { sm: 'Küçük', md: 'Orta', lg: 'Büyük' },
    cartLead:
      'Sepet hatırlatma otomasyonunda müşterinin sepetindeki ürünler ve toplam burada listelenir. Kampanya e-postasında yerine açıklama görünür.',
    orderLead:
      'Sipariş sonrası otomasyonlarda siparişin ürünleri ve toplamı burada listelenir. Kampanya e-postasında yerine açıklama görünür.',
    quoteLead:
      'Bayi teklif takibi otomasyonunda teklifin ürünleri, toplamı ve geçerlilik tarihi burada listelenir. Kampanya e-postasında yerine açıklama görünür.',
    dividerLead: 'Bloklar arasında ince bir çizgi.',
    preview: 'Önizleme',
    previewUpdating: 'Güncelleniyor…',
    device: 'Ekran',
    devices: { desktop: 'Masaüstü', phone: 'Telefon' },
    format: 'Biçim',
    formats: { html: 'E-posta', text: 'Düz metin' },
    previewFieldErrors: 'Önizleme oluşturulamadı; işaretli alanları düzeltin.',
    previewWaiting: 'Konu yazınca önizleme burada görünür.',
    previewFrame: 'E-posta önizlemesi',
    findingsTitle:
      'Sağlık beyanı olabilecek {{count}} ifade var. Kaydettikten sonra Veteriner Uzman İnceleyici onayı gerekir; onay olmadan kampanyada kullanılamaz.',
    emptyProducts:
      'Ürün bloğunda gösterilecek ürün yok (blok: {{blocks}}). Kaynakta yayında ve onaylı ürün bulunmuyor; bu blok e-postada görünmez.',
    test: 'Test gönder',
    testLead:
      'Kaydedilmiş hâli, konusu "[Test]" ile başlayarak gönderilir. Yalnızca işletmenizin panel kullanıcılarına gider; müşterilere gitmez.',
    testSend: 'Gönder',
    testQueued: 'Test e-postası gönderim sırasına alındı ({{count}} alıcı).',
    testSaveFirst: 'Kaydedilmemiş değişiklik var. Test, kaydedilmiş hâli gönderir; önce kaydedin.',
    testTo: 'Alıcılar',
    testToLead:
      'Panel kullanıcılarının e-posta adresleri, virgülle ayırarak en çok 5 adres. Boş bırakırsanız yalnızca size gönderilir.',
  },
  campaigns: {
    create: 'Yeni kampanya',
    lead: "Kampanya bir e-posta şablonunu seçilen kitleye gönderir. Her alıcı gönderim anında yeniden denetlenir: engel listesindeki, izni olmayan veya izni İYS'ye bildirilmemiş kişiye gitmez. Gönderim arka planda, dakikadaki hız sınırıyla yapılır.",
    emptyTitle: 'Henüz kampanya yok',
    emptyLead: 'Önce bir e-posta şablonu hazırlayın, sonra "Yeni kampanya" ile kitleyi seçin.',
    listLabel: 'E-posta kampanyaları',
    colName: 'Kampanya',
    colStatus: 'Durum',
    colSent: 'Gönderilen / alıcı',
    colClicked: 'Tıklayan',
    colWhen: 'Tarih',
    statuses: {
      draft: 'Taslak',
      scheduled: 'Zamanlandı',
      sending: 'Gönderiliyor',
      testing: 'A/B testi sürüyor',
      sent: 'Gönderildi',
      paused: 'Duraklatıldı',
      cancelled: 'Durduruldu',
    },
    saved: 'Kampanya kaydedildi.',
    deleted: 'Kampanya silindi.',
    cancelled: 'Gönderim durduruldu.',
    resumed: 'Gönderim sürüyor.',
    save: 'Kaydet',
    createConfirm: 'Taslağı oluştur',
    back: 'Tüm kampanyalar',
    unsaved: 'Kaydedilmemiş değişiklik',
    editor: 'Kampanya ayarları',
    content: 'İçerik',
    name: 'Kampanya adı',
    nameLead: 'Panelde ve raporlarda görünür; bağlantılara eklenen kampanya kodu bundan üretilir.',
    template: 'E-posta şablonu',
    chooseTemplate: 'Şablon seçin',
    openTemplate: 'Şablonu aç',
    noTemplates: 'Bu mağazada henüz e-posta şablonu yok.',
    subject: 'Konu',
    subjectLead:
      'Boşsa şablonun konusu kullanılır: "{{subject}}". Başka dildeki alıcılar o dildeki şablonun konusunu alır.',
    preheader: 'Ön metin',
    preheaderLead: 'Boşsa şablonun ön metni kullanılır.',
    audience: 'Kitle',
    audienceLead:
      'Segmentlerdeki müşteriler ve isterseniz mağazanın bülten aboneleri. Aynı adres bir kez sayılır.',
    segments: 'Segmentler',
    noSegments: 'Kayıtlı segment yok (Pazarlama → Segmentler).',
    segmentCount: '(son sayım {{count}} müşteri)',
    subscribers: 'Mağazanın bülten aboneleri',
    estimate: 'Alıcıları hesapla',
    estimateResult: '{{eligible}} kişiye gönderilebilir ({{total}} kişiden).',
    estimateNote: 'Sayılar şimdiki duruma göredir; gönderim sırasında her alıcı yeniden denetlenir.',
    skipReasons: {
      suppressed: 'Engel listesinde: {{count}}',
      no_consent: 'Pazarlama izni yok: {{count}}',
      iys_not_registered: "İzni İYS'ye bildirilmemiş: {{count}}",
      iys_refused: "İYS'de ret var: {{count}}",
      invalid_address: 'Geçersiz adres: {{count}}',
      staging_allowlist: 'Staging izin listesinde değil (gönderilmedi): {{count}}',
    },
    abTitle: 'A/B testi (konu)',
    abLead:
      'Alıcıların bir bölümüne iki farklı konu gider. Bekleme süresi sonunda bağlantı tıklama oranı yüksek olan konu kalan alıcılara gönderilir.',
    abEnable: 'Konu için A/B testi yap',
    subjectB: 'B konusu',
    abPercent: 'Test grubu',
    percentOption: 'Alıcıların %{{pct}}',
    abWait: 'Kazananı seçmeden önce bekle',
    hoursOption: '{{count}} saat',
    delivery: 'Gönderim hızı',
    deliveryLead:
      'Sağlayıcının sınırına ve alan adınızın itibarına göre ayarlayın. Yeni bir alan adında düşük hızla başlamak önerilir.',
    rate: 'Dakikada en çok e-posta',
    dangerZone: 'Kampanyayı sil',
    deleteConfirm: '"{{name}}" kampanyası silinir. Devam edilsin mi?',
    updated: 'Son değişiklik: {{date}}',
    send: 'Gönder…',
    templateNotApproved: 'Şablon uzman onayı bekliyor; onaylanmadan gönderilemez.',
    sendTitle: 'Kampanyayı gönder',
    sendLead:
      'E-postalar gerçek kişilere gider ve geri alınamaz. Gönderimi başladıktan sonra durdurabilirsiniz; gönderilenler geri alınmaz.',
    scheduleConfirm: 'Zamanla',
    sendConfirm: '{{count}} kişiye gönder',
    when: 'Ne zaman',
    now: 'Hemen',
    later: 'İleri bir tarihte',
    scheduledAt: 'Gönderim zamanı',
    scheduledToast: 'Kampanya zamanlandı.',
    queuedToast: 'Gönderim başlıyor; ilerlemeyi bu ekranda izleyebilirsiniz.',
    statusTitle: 'Gönderim durumu',
    statusLabel: 'Durum',
    startedAt: 'Başladı',
    abDecideAt: 'Kazanan seçilecek',
    winner: 'Kazanan konu',
    variantLabel: '{{v}} konusu',
    finishedAt: 'Bitti',
    progressLabel: 'Gönderim ilerlemesi',
    progress: '{{done}} / {{total}} alıcı işlendi: {{sent}} gönderildi, {{skipped}} atlandı.',
    abSkipped: 'A/B testi yapılmadı: yeterli alıcı yoktu (en az 100). Herkese A konusu gönderildi.',
    pauseReasons: {
      email_not_configured:
        'E-posta gönderimi kurulu değil (Kurulum Gerekli). Bağlantılar ekranından SMTP veya bir sağlayıcı bağlayıp "Sürdür"e basın.',
      provider_auth_failed:
        'E-posta sağlayıcısı anahtarı reddetti. Bağlantıyı düzeltip "Sürdür"e basın; gönderilmemiş alıcılar bekliyor.',
      template_review_required: 'Şablon uzman onayı bekliyor. Onaylandıktan sonra "Sürdür"e basın.',
      campaign_template_invalid:
        'Şablon bulunamadı (silinmiş olabilir). Kampanyayı durdurup yenisini oluşturun.',
    },
    resume: 'Sürdür',
    cancel: 'Gönderimi durdur',
    cancelConfirm:
      'Henüz gönderilmemiş alıcılara gönderilmez; gönderilmiş e-postalar geri alınamaz. Devam edilsin mi?',
    reportTitle: 'Rapor',
    reportLead:
      'Açılma ölçülmez (gizlilik ve güvenilirlik nedeniyle). "Teslim edildi" yalnızca bildirim adresi girilmiş SES, SendGrid veya Postmark ile dolar.',
    purged: 'Alıcı kayıtları saklama süresi (180 gün) dolduğu için silindi; toplamlar korunuyor.',
    stats: {
      recipients: 'Alıcı',
      sent: 'Gönderildi',
      skipped: 'Atlandı',
      delivered: 'Teslim edildi',
      bounced: 'Geri döndü',
      clicked: 'Tıklayan',
      clicks: 'Tıklama',
      unsubscribed: 'Çıkan',
      complained: 'Şikâyet',
      failed: 'Gönderilemedi',
    },
    skippedTitle: 'Atlananlar',
    colVariant: 'Konu',
    winnerBadge: 'Kazanan',
    linksTitle: 'Bağlantı',
    ordersTitle: 'Kampanyadan gelen siparişler',
    noOrders: 'Henüz kampanya bağlantısıyla gelen sipariş yok.',
    ordersLine: '{{orders}} sipariş, {{paid}} ödenmiş · ciro {{revenue}}',
    ordersNote:
      'Sipariş, e-postadaki bağlantıyla gelen ve çerez izni veren ziyaretçinin son temasıysa sayılır (Kampanyalar ve kaynaklar raporuyla aynı kural).',
  },
  automations: {
    lead: 'Otomasyon, bir olay olduğunda (yeni üyelik, terk edilen sepet, teslim edilen sipariş…) kişiye kendiliğinden e-posta gönderen akıştır. Akışlar varsayılan olarak kapalıdır; açıldıkları andan sonraki olaylar akışa girer. Her e-postadan önce engel listesi, pazarlama izni, İYS, sıklık sınırı ve sessiz saat denetlenir.',
    listLabel: 'Pazarlama otomasyonları',
    colFlow: 'Akış',
    colStatus: 'Durum',
    colEnrolled: 'Akışa giren',
    colSent: 'Gönderilen',
    on: 'Açık',
    off: 'Kapalı',
    activeCount: '{{count}} süren',
    last30Note: 'Sayılar son 30 günü gösterir.',
    kinds: {
      welcome: 'Hoş geldin',
      cart_abandon: 'Sepeti terk edenler',
      checkout_abandon: 'Ödemeyi tamamlamayanlar',
      post_purchase: 'Satın alma sonrası',
      repurchase: 'Tekrar satın alma hatırlatması',
      winback: 'Uzun süredir alışveriş yapmayanlar',
      vip: 'VIP müşteriler',
      birthday: 'Doğum günü',
      dealer_welcome: 'Bayi karşılama',
      quote_followup: 'Bayi teklif takibi',
    },
    summaries: {
      welcome: 'Yeni üyeye veya bülten abonesine ilk e-posta.',
      cart_abandon: 'Sepetinde ürün bırakan üyeye hatırlatma, gerekirse ertesi gün ikinci e-posta.',
      checkout_abandon: 'Siparişi oluşturup ödemesini tamamlamayan kişiye hatırlatma.',
      post_purchase: 'Teslimattan sonra değerlendirme daveti.',
      repurchase: 'Son siparişten belirli gün sonra yeniden sipariş hatırlatması.',
      winback: 'Uzun süredir sipariş vermeyen müşteriyi geri kazanma.',
      vip: 'En değerli müşteri grubuna (Şampiyonlar) yılda bir teşekkür.',
      birthday: 'Hesabına doğum gününü yazan müşteriye kutlama.',
      dealer_welcome: 'Bayilik başvurusu onaylanan firmanın kullanıcılarına karşılama.',
      quote_followup: 'Gönderilmiş ama siparişe dönmemiş teklif için bayiye hatırlatma.',
    },
    settingsTitle: 'Gönderim kuralları',
    settingsLead:
      'Tüm akışlar için geçerlidir. Kampanya e-postaları da sıklık sınırında sayılır; kampanya gönderimi bu kurallarla sınırlanmaz.',
    frequencyCap: 'Sıklık sınırı',
    frequencyCapLead:
      'Bu süre içinde kampanya veya başka bir akıştan e-posta almış kişiye otomasyon e-postası gönderilmez (atlanır). Akışın kendi e-postaları arasındaki süreyi bekleme adımı belirler.',
    capNone: 'Sınır yok',
    capHours: '{{count}} saatte en çok bir e-posta',
    quietHours: 'Sessiz saatler',
    quietStart: 'Başlangıç',
    quietEnd: 'Bitiş',
    quietLead:
      'Türkiye saatiyle {{start}}–{{end}} arasında e-posta gönderilmez; bu aralığa düşen e-posta {{end}} saatinde gider.',
    quietOff: 'Sessiz saat yok: e-postalar günün her saatinde gidebilir.',
    saveSettings: 'Kuralları kaydet',
    settingsSaved: 'Gönderim kuralları kaydedildi.',
    unknownTitle: 'Akış bulunamadı',
    unknownLead: 'Adres hatalı olabilir. Otomasyonlar listesinden bir akış seçin.',
    back: 'Tüm otomasyonlar',
    unsaved: 'Kaydedilmemiş değişiklik',
    editor: 'Akış ayarları',
    save: 'Kaydet',
    saveAndEnable: 'Kaydet ve aç',
    enableConfirm:
      'Akış açılınca, bundan sonra koşulları sağlayan kişilere e-postalar kendiliğinden gider (izin, engel listesi ve İYS denetiminden geçenlere). Gönderilen e-posta geri alınamaz. Açılsın mı?',
    saved: 'Akış kaydedildi.',
    enabledToast: 'Akış açıldı; bundan sonraki olaylar akışa girecek.',
    disabledToast: 'Akış kapatıldı; süren kayıtlar akıştan çıkarıldı.',
    statusTitle: 'Durum',
    enabledLabel: 'Akış açık',
    enabledSince: 'Açılış: {{date}}. Bu tarihten sonraki olaylar akışa girer.',
    enableLead:
      'Açmak için her e-posta adımına bir şablon seçin. E-posta altyapısı kurulu olmalı; sağlık beyanı içeren şablon uzman onayı ister.',
    disableWarning: 'Kaydedince akış kapanır ve şu an akışta bekleyen kişiler akıştan çıkar.',
    stepsChangedWarning:
      'Adımları değiştirdiniz: kaydedince şu an akışta bekleyen kişiler akıştan çıkar; yeni olaylar yeni adımlarla işlenir.',
    triggerTitle: 'Tetikleyici',
    triggers: {
      welcome:
        'Mağazada yeni hesap açılınca veya bülten aboneliği onaylanınca. Aynı adres bu akışa bir kez girer.',
      cart_abandon:
        'Üye müşterinin sepetinde son değişiklikten {{hours}} saat sonra. Sepet sonradan değişirse yeni kayıt açılır, eskisi kapanır.',
      checkout_abandon:
        'Sipariş oluşturulduktan {{hours}} saat sonra ödemesi hâlâ bekliyorsa (ör. tamamlanmayan kart ödemesi). Misafir siparişlerinde de çalışır.',
      post_purchase: 'Sipariş teslim edildikten {{days}} gün sonra.',
      repurchase: 'Bu mağazadaki son siparişin üzerinden {{days}} gün geçince (arada yeni sipariş yoksa).',
      winback: 'Bu mağazadaki son siparişin üzerinden {{days}} gün geçince (arada yeni sipariş yoksa).',
      vip: 'Müşteri RFM gruplarında "Şampiyonlar" grubundaysa, her gün bir kez bakılır; her müşteriye yılda en çok bir kez.',
      birthday:
        'Müşterinin hesabında isteğe bağlı yazdığı doğum gününde (gün başında; sessiz saatteyse sabah). 29 Şubat doğanlar artık yıl olmayan yıllarda 28 Şubat günü.',
      dealer_welcome: 'Bayilik başvurusu onaylanan firmanın kullanıcılarına, onaydan hemen sonra.',
      quote_followup:
        'Bayiye gönderilen teklifin (son sürümü) üzerinden {{days}} gün geçince, teklif hâlâ açıksa. Firmanın Yetkililerine ve teklifi isteyen kullanıcıya gider; teklifin yeni sürümü gönderilirse yeniden başlar.',
    },
    afterHours: 'Ne kadar sonra',
    hoursOption: '{{count}} saat',
    daysLabel: {
      post_purchase: 'Teslimattan kaç gün sonra',
      repurchase: 'Son siparişten kaç gün sonra',
      winback: 'Son siparişten kaç gün sonra',
      quote_followup: 'Teklif gönderildikten kaç gün sonra',
    },
    storeScoped: 'Bu akış yalnızca seçili mağazadaki sepet, sipariş ve tekliflerle tetiklenir.',
    stepsTitle: 'Adımlar',
    stepsLead:
      'Adımlar sırayla işlenir. Bekleme sonraki adımı erteler; koşul karşılanmazsa kişi akıştan çıkar; e-posta adımı seçilen şablonu gönderir.',
    stepTitle: '{{n}}. adım: {{type}}',
    stepNumber: '{{n}}. adım',
    stepTypes: { wait: 'Bekle', condition: 'Koşul', email: 'E-posta' },
    waitHours: 'Kaç saat beklensin',
    condition: 'Devam koşulu',
    conditionLead: 'Koşul karşılanmazsa kişi akıştan çıkar ve sonraki adımlar uygulanmaz.',
    conditions: {
      cart_not_converted: 'Sepet hâlâ dolu ve sipariş verilmedi',
      order_not_paid: 'Siparişin ödemesi hâlâ bekliyor',
      not_reviewed: 'Siparişteki ürünler henüz değerlendirilmedi',
      no_order_since_enrollment: 'Akışa girdiğinden beri sipariş vermedi',
      quote_open: 'Teklif hâlâ açık (aynı sürüm, süresi dolmadı, siparişe dönmedi)',
    },
    template: 'E-posta şablonu',
    chooseTemplate: 'Şablon seçin',
    openTemplate: 'Şablonu aç',
    noTemplates: 'Bu mağazada henüz e-posta şablonu yok.',
    templateHints: {
      welcome: 'Kişinin adı için {{firstName}} alanını kullanabilirsiniz.',
      cart_abandon:
        'Şablona "Sepet" bloğu eklerseniz kişinin sepetindeki ürünler ve güncel fiyatları gösterilir.',
      checkout_abandon: 'Şablona "Sipariş" bloğu eklerseniz bekleyen sipariş ve bağlantısı gösterilir.',
      post_purchase: 'Şablona "Sipariş" bloğu eklerseniz teslim edilen sipariş gösterilir.',
      repurchase: 'Şablona "Sipariş" bloğu eklerseniz son sipariş gösterilir.',
      winback: 'Şablona "Sipariş" bloğu eklerseniz son sipariş gösterilir.',
      vip: 'Kişinin adı için {{firstName}} alanını kullanabilirsiniz.',
      birthday: 'Kişinin adı için {{firstName}} alanını kullanabilirsiniz.',
      dealer_welcome:
        'Bayi fiyatları üye girişinden sonra görünür; e-postada giriş bağlantısı vermeniz önerilir.',
      quote_followup:
        'Şablona "Teklif" bloğu eklerseniz teklifin ürünleri, toplamı, geçerlilik tarihi ve teklife giden düğme gösterilir.',
    },
    moveUp: '{{n}}. adımı yukarı taşı',
    moveDown: '{{n}}. adımı aşağı taşı',
    removeStep: '{{n}}. adımı sil',
    moved: 'Adım {{n}}. sıraya taşındı.',
    added: '{{n}}. adım eklendi.',
    removed: '{{n}}. adım silindi.',
    addStep: 'Adım ekle',
    resetDefaults: 'Varsayılan adımlara dön',
    reportTitle: 'Rapor',
    reportLead:
      'Akışa girenler, çıkış nedenleri ve gönderimler. Kayıtlar akış bittikten 180 gün sonra silinir. Açılma ölçülmez.',
    stats: {
      enrolled: 'Akışa giren',
      active: 'Süren',
      completed: 'Tamamlayan',
      exited: 'Çıkan',
      sent: 'Gönderildi',
      skipped: 'Atlandı',
      failed: 'Gönderilemedi',
    },
    exitsTitle: 'Akıştan çıkış nedenleri',
    exitReasons: {
      cart_not_converted: 'Sepet siparişe döndü veya boşaldı: {{count}}',
      order_not_paid: 'Ödeme tamamlandı veya sipariş iptal edildi: {{count}}',
      not_reviewed: 'Değerlendirme yazdı: {{count}}',
      no_order_since_enrollment: 'Sipariş verdi: {{count}}',
      superseded: 'Sepet değişti, yeni kayıt açıldı: {{count}}',
      expired: 'E-posta 72 saat içinde gönderilemedi: {{count}}',
      flow_changed: 'Akışın adımları değişti: {{count}}',
      disabled: 'Akış kapatıldı: {{count}}',
      quote_open:
        'Teklif siparişe döndü, reddedildi, iptal edildi, süresi doldu veya yeni sürümü gönderildi: {{count}}',
    },
    skipsTitle: 'Gönderilmeyen e-postalar',
    skipReasons: {
      suppressed: 'Engel listesinde: {{count}}',
      no_consent: 'Pazarlama izni yok: {{count}}',
      iys_not_registered: "İzni İYS'ye bildirilmemiş: {{count}}",
      iys_refused: "İYS'de ret var: {{count}}",
      invalid_address: 'Geçersiz adres: {{count}}',
      frequency_cap: 'Sıklık sınırı (yakın zamanda başka e-posta aldı): {{count}}',
      template_unavailable: 'Şablon kullanılamıyor (silinmiş veya onay bekliyor): {{count}}',
      staging_allowlist: 'Staging izin listesinde değil: {{count}}',
      rejected: 'Sağlayıcı reddetti: {{count}}',
      error: 'Gönderim hatası: {{count}}',
    },
    skipOther: 'Diğer: {{count}}',
    byStepTitle: 'Adım başına gönderim',
    colStep: 'Adım',
    ordersTitle: 'Akıştan gelen siparişler',
    noOrders: 'Henüz akış e-postasındaki bağlantıyla gelen sipariş yok.',
    ordersNote:
      'E-postadaki mağaza bağlantılarına akışa özel kampanya kodu eklenir; sipariş, bu bağlantıyla gelen ve çerez izni veren ziyaretçinin son temasıysa sayılır.',
    updated: 'Son değişiklik: {{date}}',
  },
  productAlerts: {
    lead: 'Vitrinde stoksuz ürüne "Gelince haber ver" ile e-posta bırakılabilir; stok gelince kişiye bir kez bildirim gider. Favorilerdeki ürünün fiyatı belirli oranda düşünce pazarlama izni olan müşteriye e-posta gönderilebilir. İkisi de varsayılan olarak kapalıdır.',
    settingsTitle: 'Ayarlar',
    settingsLead:
      'Açmak için e-posta altyapısı kurulu olmalı. Vitrindeki form, KVKK aydınlatma metni yayımda değilse görünmez.',
    stockToggle: 'Vitrinde "Gelince haber ver"',
    stockToggleLead:
      'Stoksuz seçenekte e-posta formu görünür. Stok gelince bekleyenler talep sırasıyla bildirilir (bir turda stok adedinin 3 katı, en az 5 kişi; stok sürdükçe 5 dakikada bir devam). Kişinin istediği tek seferlik bildirimdir; pazarlama izni aranmaz.',
    priceDropToggle: 'Favorilerde fiyat düşüşü bildirimi',
    priceDropLead:
      "Her gün 10:05'te bakılır. Ürünün müşteriye görünen fiyatı, favoriye eklendiğinden beri görülen en düşük fiyattan belirtilen oranda düşükse e-posta gider. Pazarlama iletisidir: izin, engel listesi, İYS ve otomasyonların sıklık sınırı uygulanır. E-postada yalnızca güncel fiyat gösterilir.",
    store: 'Mağaza',
    chooseStore: 'Mağaza seçin',
    minPercent: 'En az düşüş',
    percentOption: '%{{pct}}',
    save: 'Kaydet',
    saved: 'Ayarlar kaydedildi.',
    enableConfirm:
      'Açılınca koşulu sağlayan kişilere e-postalar kendiliğinden gider; gönderilen e-posta geri alınamaz. Açılsın mı?',
    requestsTitle: 'Gelince haber ver talepleri',
    requestsLead:
      'Varyant başına bekleyen ve bildirilen talepler. Talepler 6 ay geçerlidir; kapanan kayıtlar 180 gün sonra silinir.',
    emptyTitle: 'Henüz talep yok',
    emptyLead: 'Vitrinde "Gelince haber ver" açıkken stoksuz ürünlere bırakılan e-postalar burada görünür.',
    colProduct: 'Ürün',
    colWaiting: 'Bekleyen',
    colNotified: 'Bildirilen',
    colStock: 'Stok',
    colOldest: 'En eski talep',
    colActions: 'İşlemler',
    inStock: 'Stokta ({{count}})',
    outOfStock: 'Stok yok',
    view: 'Talepler',
    viewFor: '{{product}} talepleri',
    priceDropLast30:
      'Son 30 günde fiyat düşüşü e-postası: {{sent}} gönderildi, {{skipped}} gönderilmedi (izin, sıklık sınırı vb.).',
    statusFilter: 'Durum',
    statuses: { waiting: 'Bekleyen', notified: 'Bildirilen', cancelled: 'Kapanan' },
    noRequests: 'Bu durumda talep yok.',
    member: 'Üye',
    requestedAt: 'Talep: {{date}}',
    notifiedAt: 'Bildirildi: {{date}}',
    reasons: {
      panel: 'Panelden iptal edildi',
      expired: 'Süresi doldu (6 ay)',
      suppressed: 'Adres engel listesinde',
      staging_allowlist: 'Staging izin listesinde değil',
      rejected: 'Sağlayıcı reddetti',
    },
    cancel: 'İptal et',
    cancelConfirm: 'Talep kapanır ve kişiye bildirim gitmez. Devam edilsin mi?',
    cancelled: 'Talep iptal edildi.',
  },
  messaging: {
    create: 'Yeni SMS/WhatsApp kampanyası',
    lead: "Segmentlerdeki müşterilere SMS veya Meta'da onaylı WhatsApp şablonu gönderin. Her alıcı gönderim anında izin, engel listesi ve İYS bakımından yeniden denetlenir; sıklık sınırı ve sessiz saate uyulur. Gönderim gerçek ve ücretlidir: önce kitleyi ve tahmini maliyeti kontrol edin.",
    emptyTitle: 'Bu mağaza için SMS/WhatsApp kampanyası yok',
    emptyLead: 'Önce bir SMS şablonu hazırlayın, sonra "Yeni SMS/WhatsApp kampanyası" ile taslak oluşturun.',
    listLabel: 'SMS ve WhatsApp kampanyaları',
    colName: 'Kampanya',
    colChannel: 'Kanal',
    colStatus: 'Durum',
    colSent: 'Gönderilen',
    colDelivered: 'Teslim',
    colWhen: 'Tarih',
    channels: { sms: 'SMS', whatsapp: 'WhatsApp' },
    statuses: {
      draft: 'Taslak',
      scheduled: 'Zamanlandı',
      sending: 'Gönderiliyor',
      sent: 'Gönderildi',
      paused: 'Duraklatıldı',
      cancelled: 'Durduruldu',
    },
    recipientStatuses: {
      pending: 'sırada',
      sending: 'gönderiliyor',
      sent: 'gönderildi',
      delivered: 'teslim edildi',
      failed: 'gönderilemedi',
      skipped: 'atlandı',
      cancelled: 'iptal',
    },
    setupTitle: 'Kurulum durumu',
    setupLead:
      'Ticari SMS için bağlı bir SMS sağlayıcısı, MERSİS numarası ve ret metni gerekir; WhatsApp için WhatsApp Business bağlantısı. Eksik olan kanal "Kurulum Gerekli" görünür ve gönderilemez.',
    connectedVia: '{{provider}} bağlı',
    connected: 'Bağlı',
    webhookUrl: 'Meta webhook adresi:',
    smsSetupLink: "Entegrasyonlar'da Netgsm, İleti Merkezi veya Verimor'u bağlayın, sonra aşağıda seçin",
    whatsappSetupLink: "Entegrasyonlar'da WhatsApp Business'ı bağlayın",
    mersis: 'MERSİS numarası',
    missing: 'Eksik',
    mersisLink: 'İşletme bilgilerinden girin',
    optOut: 'Ret metni',
    settingsTitle: 'Ayarlar',
    settingsLead:
      'SMS sağlayıcısı, ticari SMS ret metni, tahmini birim maliyetler, sıklık sınırı ve staging test numaraları. Sessiz saat otomasyon ayarlarıyla ortaktır.',
    smsProvider: 'SMS sağlayıcısı',
    smsProviderLead: 'Yalnızca Entegrasyonlar ekranında bağlanmış ve testi geçmiş sağlayıcılar seçilebilir.',
    noProvider: 'Seçilmedi',
    providerNotConnected: '{{provider}} (Kurulum Gerekli)',
    optOutLead:
      "Ticari SMS'in sonuna MERSİS numarasıyla birlikte eklenir (en çok 80 karakter). Örnek: RET yazip 3XXX'e gonderin. Türkçe karakter kullanmamak SMS boyunu kısaltır.",
    smsUnitCost: 'SMS boyu başına maliyet (TL)',
    whatsappUnitCost: 'WhatsApp iletisi başına maliyet (TL)',
    costInvalid: 'Tutar okunamadı; örnek: 0,25',
    frequencyCap: 'Sıklık sınırı',
    frequencyCapLead:
      'Bir telefon numarasına bu süre içinde ikinci SMS/WhatsApp kampanya iletisi gönderilmez.',
    capNone: 'Sınır yok',
    capHours: '{{count}} saatte en çok bir ileti',
    stagingPhones: 'Staging test numaraları',
    stagingPhonesLead:
      'Staging sunucusunda yalnızca bu numaralara gönderilir (her satıra bir numara, en çok 10). Canlıda kullanılmaz.',
    saveSettings: 'Ayarları kaydet',
    settingsSaved: 'Ayarlar kaydedildi.',
    saved: 'Kampanya kaydedildi.',
    deleted: 'Kampanya silindi.',
    cancelled: 'Gönderim durduruldu.',
    resumed: 'Gönderim sürdürülüyor.',
    save: 'Kaydet',
    createConfirm: 'Taslağı oluştur',
    back: 'SMS ve WhatsApp kampanyaları',
    unsaved: 'Kaydedilmemiş değişiklik',
    channelSetup: '{{channel}}: Kurulum Gerekli',
    editor: 'Kampanya düzenleyici',
    content: 'İçerik',
    channel: 'Kanal',
    name: 'Kampanya adı',
    nameLead: 'Yalnızca panelde görünür.',
    smsTemplate: 'SMS şablonu',
    chooseTemplate: 'Şablon seçin',
    openTemplate: 'Şablonu aç',
    noTemplates: 'Henüz SMS şablonu yok.',
    audience: 'Kitle',
    audienceLead:
      'Seçilen segmentlerdeki müşteriler; telefon numarası aynı olanlara bir kez gider. Bireysel alıcıda izin ve İYS onayı, tacirde (bayi firması üyesi) SMS için İYS reddi olmaması aranır. WhatsApp her alıcıdan açık izin ister.',
    estimate: 'Alıcıları ve maliyeti hesapla',
    dangerZone: 'Silme',
    deleteConfirm: '"{{name}}" kampanyası silinsin mi?',
    updated: 'Son değişiklik: {{date}}',
    whatsappNotConnected:
      "WhatsApp Business bağlı değil (Kurulum Gerekli): onaylı şablon listesi alınamıyor. Şablon adını ve dilini Meta'daki gibi yazarak taslak hazırlayabilirsiniz; göndermek için bağlantı gerekir.",
    whatsappTemplate: 'WhatsApp şablonu',
    whatsappOption: '{{name}} ({{language}}) · {{status}}',
    waStatuses: {
      APPROVED: 'onaylı',
      PENDING: 'Meta incelemesinde',
      REJECTED: 'reddedildi',
      PAUSED: 'duraklatıldı',
      DISABLED: 'devre dışı',
      OTHER: 'kullanılamaz',
    },
    whatsappName: 'Şablon adı',
    whatsappNameLead: "Meta'daki şablon adı (ör. kampanya_duyuru).",
    whatsappLanguage: 'Dil kodu',
    whatsappParams: 'Şablon değişkenleri',
    noParams: 'Bu şablonda değişken yok.',
    paramLabel: 'Değişken {{n}}',
    addParam: 'Değişken ekle',
    paramsLead:
      'Sırasıyla şablondaki {{1}}, {{2}}… yerine geçer. Kişiye özel değer için {{firstName}}, {{name}} veya {{storeName}} yazabilirsiniz.',
    estimateResult: '{{total}} kişiden {{eligible}} kişiye gönderilebilir.',
    skipReasons: {
      no_phone: 'Telefon numarası yok: {{count}}',
      not_mobile: 'Türkiye cep telefonu değil: {{count}}',
      suppressed: 'Engel listesinde: {{count}}',
      no_consent: 'Bu kanal için izin yok: {{count}}',
      iys_not_registered: "İzni İYS'ye bildirilmemiş: {{count}}",
      iys_refused: "İYS'de ret var: {{count}}",
      duplicate_phone: 'Aynı numara birden çok müşteride (bir kez gönderilir): {{count}}',
      frequency_cap: 'Sıklık sınırı (yakın zamanda başka ileti aldı): {{count}}',
      staging_allowlist: 'Staging test numarası değil (gönderilmedi): {{count}}',
      invalid_address: 'Geçersiz numara: {{count}}',
    },
    partsPerMessage: 'Kişi başı {{count}} SMS boyu',
    costEstimate: 'Tahmini maliyet: {{cost}}',
    costUnknown: 'Tahmini maliyet için ayarlardan birim maliyeti girin.',
    estimateNote:
      'Tahmindir: gönderim anında izin ve engel listesi yeniden denetlenir; SMS boyu kişinin adına göre değişebilir.',
    send: 'Gönder…',
    templateNotApproved: 'Şablon uzman onayı bekliyor; onaylanmadan gönderilemez.',
    sendTitle: '{{channel}} kampanyasını gönder',
    sendLead:
      'Gerçek kişilere ücretli ileti gider ve geri alınamaz. Alıcı sayısını ve tahmini maliyeti kontrol edin; gönderim iki adımlı doğrulama ister.',
    scheduleConfirm: 'Zamanla',
    sendConfirm: '{{count}} kişiye gönder',
    sendSetupWarning: 'Bu kanalın kurulumu tamamlanmamış (Kurulum Gerekli); gönderim reddedilecek.',
    scheduledToast: 'Kampanya zamanlandı.',
    queuedToast: 'Kampanya gönderim sırasına alındı.',
    statusTitle: 'Gönderim durumu',
    statusLabel: 'Durum',
    progressLabel: 'Gönderim ilerlemesi',
    progress:
      '{{done}} / {{total}} işlendi: {{sent}} gönderildi, {{delivered}} teslim edildi, {{skipped}} atlandı, {{failed}} gönderilemedi.',
    pauseReasons: {
      sms_template_required: 'Duraklatıldı: SMS şablonu silinmiş. Kampanyayı durdurup yenisini hazırlayın.',
      template_review_required: 'Duraklatıldı: şablon değişti ve uzman onayı bekliyor. Onaylanınca sürdürün.',
      sms_footer_missing: 'Duraklatıldı: MERSİS numarası veya ret metni eksik. Tamamlayıp sürdürün.',
      sms_not_configured:
        "Duraklatıldı: SMS sağlayıcısı bağlı değil veya seçilmemiş. Entegrasyonlar'dan bağlayıp sürdürün.",
      whatsapp_not_configured:
        "Duraklatıldı: WhatsApp Business bağlantısı yok. Entegrasyonlar'dan bağlayıp sürdürün.",
      provider_invalid_settings: 'Duraklatıldı: sağlayıcı ayarları eksik veya hatalı.',
      provider_auth_failed:
        "Duraklatıldı: sağlayıcı kullanıcı bilgilerini kabul etmedi. Entegrasyonlar'da yenileyin.",
      provider_sender_invalid: 'Duraklatıldı: SMS başlığı (gönderici adı) sağlayıcıda onaylı değil.',
      provider_iys_not_configured: 'Duraklatıldı: sağlayıcı hesabında İYS marka kodu tanımlı değil.',
      provider_insufficient_balance:
        'Duraklatıldı: sağlayıcı hesabında yeterli bakiye yok. Yükleyip sürdürün.',
      provider_template_invalid:
        "Duraklatıldı: WhatsApp şablonu Meta'da geçersiz veya parametreleri uyuşmuyor.",
    },
    pauseReasonOther: 'Duraklatıldı ({{code}}).',
    resume: 'Sürdür',
    cancelConfirm: 'Gönderim durdurulsun mu? Gönderilmemiş alıcılara ileti gitmez.',
    cancel: 'Durdur',
    reportTitle: 'Rapor',
    reportLead:
      'SMS teslim bilgisi sağlayıcıdan 10 dakikada bir alınır; WhatsApp teslim bilgisi Meta bildirimiyle gelir.',
    purged: 'Alıcı kayıtları saklama süresi (180 gün) dolduğu için silindi; toplamlar korunur.',
    stats: {
      recipients: 'Alıcı',
      sent: 'Gönderilen',
      delivered: 'Teslim',
      failed: 'Gönderilemeyen',
      skipped: 'Atlanan',
      parts: 'SMS boyu',
      cost: 'Tahmini maliyet',
    },
    skippedTitle: 'Atlananlar',
    errorsTitle: 'Gönderilemeyenler',
    sendErrors: {
      whatsapp_opted_out: 'Kişi WhatsApp pazarlama iletilerini kapatmış: {{count}}',
      interrupted: 'Gönderim yarıda kaldı (yeniden gönderilmez): {{count}}',
      undelivered: 'Operatör teslim edemedi: {{count}}',
      whatsapp_failed: 'WhatsApp teslim edemedi: {{count}}',
      error: 'Gönderim hatası: {{count}}',
    },
    providerError: 'Sağlayıcı hata kodu {{code}}: {{count}}',
    reportNote:
      'Maliyet, ayarlardaki birim maliyetten hesaplanan tahmindir; kesin tutar sağlayıcı faturasındadır.',
  },
  smsTemplates: {
    create: 'Yeni SMS şablonu',
    lead: 'Kampanyalarda kullanılan SMS metinleri. Gönderimde metnin sonuna MERSİS numarası ve ret metni eklenir; boy hesabı bunlarla birlikte yapılır. Sağlık beyanı içeren metin Veteriner Uzman İnceleyici onayı olmadan gönderilmez.',
    emptyTitle: 'Henüz SMS şablonu yok',
    emptyLead: 'Kısa ve açık bir metinle başlayın; kişiye özel alanlar eklenebilir.',
    listLabel: 'SMS şablonları',
    colName: 'Şablon',
    colReview: 'Uzman onayı',
    colUpdated: 'Son değişiklik',
    noReview: 'Gerekmiyor',
    saved: 'Şablon kaydedildi.',
    deleted: 'Şablon silindi.',
    save: 'Kaydet',
    createConfirm: 'Şablonu oluştur',
    back: 'SMS şablonları',
    unsaved: 'Kaydedilmemiş değişiklik',
    editor: 'SMS şablonu düzenleyici',
    name: 'Şablon adı',
    nameLead: 'Yalnızca panelde görünür.',
    body: 'Metin',
    bodyLead: 'En çok 900 karakter. MERSİS ve ret metni gönderimde kendiliğinden eklenir; buraya yazmayın.',
    insertField: 'Alan ekle:',
    fields: { firstName: 'Ad', name: 'Ad soyad', storeName: 'Mağaza adı' },
    preview: 'Önizleme',
    previewEmpty: 'Metin yazdıkça burada gönderilecek hâli görünür.',
    encoding: 'Karakter kümesi',
    encodings: {
      gsm7: 'Standart (Türkçe karakter yok)',
      turkish: 'Türkçe karakterli',
      unicode: 'Unicode (emoji veya özel karakter)',
    },
    length: 'Karakter',
    parts: 'Boy',
    multiPart: 'Metin {{count}} SMS boyu tutuyor; her boy ayrı ücretlendirilir.',
    unicodeWarning:
      'Emoji veya özel karakter var: bir SMS boyu 65 karaktere düşer ve maliyet artar. Mümkünse kaldırın.',
    tooLong: 'Metin 7 SMS boyunu aşıyor; sağlayıcılar gönderemez. Kısaltın.',
    footerMissing: 'Ticari SMS alt bilgisi eksik; kampanya gönderilemez:',
    footerParts: {
      mersis: 'MERSİS numarası (İşletme bilgileri)',
      optOut: 'Ret metni (SMS ve WhatsApp ayarları)',
    },
    findingsNote:
      'Metinde {{count}} olası sağlık beyanı var: kaydettikten sonra uzman onayı gerekir. Hastalık önleme veya tedavi iddiası kullanılmaz.',
    previewNote:
      'Örnek kişi: Ayşe Yılmaz. Boy hesabı tahminidir; operatör kodu sağlayıcı tarafından eklenir.',
    dangerZone: 'Silme',
    deleteConfirm: '"{{name}}" şablonu silinsin mi?',
    updated: 'Son değişiklik: {{date}}',
  },
  push: {
    create: 'Yeni bildirim kampanyası',
    lead: 'Vitrinde bildirimlere izin veren ziyaretçilerin tarayıcısına kısa bir bildirim gönderin. Ziyaretçi yalnızca kendisi düğmeye basıp tarayıcı iznini verirse abone olur ve istediği an kapatabilir. Gönderim gerçek kişilere gider; önce kitleyi kontrol edin.',
    emptyTitle: 'Bu mağaza için bildirim kampanyası yok',
    emptyLead: 'Kurulumu tamamlayın, sonra "Yeni bildirim kampanyası" ile taslak oluşturun.',
    listLabel: 'Bildirim kampanyaları',
    colName: 'Kampanya',
    colStatus: 'Durum',
    colSent: 'Gönderilen',
    colWhen: 'Tarih',
    subscriberCount: 'Bu mağazada bildirimleri açık {{count}} tarayıcı var.',
    statuses: {
      draft: 'Taslak',
      scheduled: 'Zamanlandı',
      sending: 'Gönderiliyor',
      sent: 'Gönderildi',
      paused: 'Duraklatıldı',
      cancelled: 'Durduruldu',
    },
    setupTitle: 'Kurulum',
    setupLead:
      'Vitrin düğmesi için anahtar, iletişim adresi ve yayımda KVKK aydınlatma metni gerekir. Android yönetim uygulaması bildirimleri için Firebase bağlantısı gerekir.',
    vapidKey: 'Bildirim anahtarı (VAPID)',
    keyReady: 'Hazır ({{date}})',
    createKey: 'Anahtar oluştur',
    replaceKey: 'Anahtarı yenile',
    replaceConfirm:
      'Anahtar yenilenirse tüm tarayıcı abonelikleri geçersiz olur; ziyaretçilerin bildirimleri yeniden açması gerekir. Devam edilsin mi?',
    keyCreated: 'Anahtar oluşturuldu.',
    privacyNotice: 'KVKK aydınlatma metni',
    published: 'Yayımda',
    missing: 'Eksik',
    privacyLink: 'Yasal metinlerden yayımlayın',
    android: 'Android uygulaması (Firebase)',
    connected: 'Bağlı',
    firebaseLink: "Entegrasyonlar'da Firebase'i bağlayın",
    settingsTitle: 'Vitrin ayarları',
    contact: 'İletişim adresi',
    contactLead:
      'Bildirim hizmetleri (Google, Mozilla, Apple) sorun olursa bu adrese ulaşır. mailto: ile e-posta veya https: ile site adresi yazın.',
    enabled: 'Vitrinde "Bildirimleri aç" düğmesini göster',
    saveSettings: 'Kaydet',
    settingsSaved: 'Ayarlar kaydedildi.',
    saved: 'Kampanya kaydedildi.',
    deleted: 'Kampanya silindi.',
    cancelled: 'Gönderim durduruldu.',
    resumed: 'Gönderim sürdürülüyor.',
    save: 'Kaydet',
    createConfirm: 'Taslağı oluştur',
    back: 'Anlık bildirimler',
    unsaved: 'Kaydedilmemiş değişiklik',
    notReady: 'Kurulum Gerekli: vitrin bildirimleri kapalı veya anahtar yok',
    editor: 'Bildirim düzenleyici',
    name: 'Kampanya adı',
    nameLead: 'Yalnızca panelde görünür.',
    title: 'Başlık',
    body: 'Metin',
    counter: '{{n}} / {{max}} karakter',
    url: 'Açılacak sayfa',
    urlLead:
      'Mağaza içi adres (ör. /kategori/kedi). Bildirime tıklanınca açılır; kaynak raporu için UTM eklenir.',
    audience: 'Kitle',
    audienceLead:
      'Segment seçmezseniz mağazanın tüm abonelerine gider. Segment seçerseniz yalnızca o segmentlerdeki üyelerin (abone olurken giriş yapmış) tarayıcılarına gider.',
    estimate: 'Kaç tarayıcıya gideceğini hesapla',
    estimateResult: '{{total}} abonelikten {{eligible}} tanesine gidecek.',
    anonymousExcluded: 'Üye girişi olmadan abone olan {{count}} tarayıcı segment kitlesine girmez.',
    estimateNote: 'Tahmindir: süresi dolan abonelikler gönderimde düşer.',
    preview: 'Önizleme',
    previewTitle: 'Başlık',
    previewBody: 'Bildirim metni',
    previewNote: 'Görünüm tarayıcıya ve işletim sistemine göre değişir; uzun metin kısaltılabilir.',
    findingsNote:
      'Metinde {{count}} olası sağlık beyanı var: kaydettikten sonra uzman onayı gerekir. Hastalık önleme veya tedavi iddiası kullanılmaz.',
    send: 'Gönder…',
    reviewRequired: 'Metin uzman onayı bekliyor; onaylanmadan gönderilemez.',
    sendTitle: 'Bildirim kampanyasını gönder',
    sendLead:
      'Bildirim gerçek kişilerin tarayıcısına gider ve geri alınamaz. Gönderim iki adımlı doğrulama ister.',
    sendConfirm: '{{count}} tarayıcıya gönder',
    scheduleConfirm: 'Zamanla',
    sendSetupWarning: 'Vitrin bildirimleri kurulmadı (Kurulum Gerekli); gönderim reddedilecek.',
    scheduledToast: 'Kampanya zamanlandı.',
    queuedToast: 'Kampanya gönderim sırasına alındı.',
    statusTitle: 'Gönderim durumu',
    statusLabel: 'Durum',
    progressLabel: 'Gönderim ilerlemesi',
    progress:
      '{{done}} / {{total}} işlendi: {{sent}} gönderildi, {{expired}} abonelik sona ermiş, {{failed}} gönderilemedi.',
    pauseReasons: {
      template_review_required: 'Duraklatıldı: metin uzman onayı bekliyor.',
      web_push_not_configured: 'Duraklatıldı: vitrin bildirimleri kapatıldı veya anahtar silindi.',
      push_auth_failed:
        'Duraklatıldı: bildirim hizmeti anahtarı reddetti. İletişim adresini kontrol edin; sorun sürerse anahtarı yenilemek gerekebilir.',
    },
    pauseReasonOther: 'Duraklatıldı ({{code}}).',
    resume: 'Sürdür',
    cancelConfirm: 'Gönderim durdurulsun mu? Gönderilmemiş tarayıcılara bildirim gitmez.',
    cancel: 'Durdur',
    reportTitle: 'Rapor',
    reportLead:
      'Bildirimin tarayıcıda gösterilip gösterilmediği ölçülmez; yalnızca hizmetin kabul ettiği gönderimler sayılır.',
    purged: 'Alıcı kayıtları saklama süresi (180 gün) dolduğu için silindi; toplamlar korunur.',
    stats: {
      recipients: 'Alıcı',
      sent: 'Gönderilen',
      expired: 'Sona eren abonelik',
      failed: 'Gönderilemeyen',
      skipped: 'Atlanan',
    },
    errorsTitle: 'Nedenler',
    sendErrors: {
      push_404: 'Abonelik bulunamadı (kaldırıldı): {{count}}',
      push_410: 'Abonelik sona ermiş (kaldırıldı): {{count}}',
      push_403: 'Abonelik başka anahtarla yapılmış (kaldırıldı): {{count}}',
      push_too_large: 'Bildirim çok büyük: {{count}}',
      push_unavailable: 'Bildirim hizmetine birkaç denemede ulaşılamadı: {{count}}',
      interrupted: 'Gönderim yarıda kaldı (yeniden gönderilmez): {{count}}',
    },
    serviceError: 'Bildirim hizmeti yanıtı {{code}}: {{count}}',
    ordersNote: 'Bildirim bağlantısıyla gelip çerez iznini veren ziyaretçilerin siparişleri (son temas).',
    dangerZone: 'Silme',
    deleteConfirm: '"{{name}}" kampanyası silinsin mi?',
    updated: 'Son değişiklik: {{date}}',
  },
  notifications: {
    title: 'Mobil bildirimler (Android)',
    lead: 'Android yönetim uygulamasında yeni sipariş, iade talebi gibi olaylar için bildirim. Yalnızca yetkiniz olan olaylar gelir; bildirimde kişisel veri yoktur.',
    firebaseMissing:
      'İşletmede Firebase bağlı değil; bağlanana kadar bildirim gönderilmez (Entegrasyonlar → Firebase).',
    devices: 'Cihazlarım',
    noDevices:
      'Bu hesaba kayıtlı cihaz yok. Android yönetim uygulamasında bildirimleri açınca cihaz burada görünür.',
    unnamed: 'Adsız cihaz',
    deviceLine: 'Uygulama sürümü {{version}} · son görülme {{seen}}',
    remove: 'Kaldır',
    removeConfirm: 'Bu cihaz kaldırılsın mı? Uygulama yeniden açılınca tekrar kaydolabilir.',
    removed: 'Cihaz kaldırıldı.',
    events: 'Bildirim gelecek olaylar',
    eventNames: {
      order_created: 'Yeni sipariş',
      payment_review_required: 'Ödeme incelemesi gerekiyor',
      return_requested: 'Yeni iade talebi',
      dealer_applied: 'Yeni bayilik başvurusu',
      form_submitted: 'Yeni iletişim mesajı',
      dealer_balance_paid: 'Bayi ödemesi alındı',
    },
    noPermission: '(yetkiniz yok)',
    quietHours: 'Sessiz saat (bu aralıkta bildirim gelmez)',
    save: 'Tercihleri kaydet',
    saved: 'Bildirim tercihleri kaydedildi.',
    test: 'Deneme bildirimi gönder',
    testSent: '{{count}} cihaza deneme bildirimi gönderildi.',
  },
  promotions: {
    create: 'Yeni kampanya',
    lead: 'Kupon gerektirmeyen indirimler: ürün/kategori/marka indirimi, sepet tutarı veya adet kademesi, X al Y öde, ücretsiz kargo. İndirim sepette uygulanır; ürünlerde üstü çizili fiyat gösterilmez. Fiyatı kampanyadan önceki 10 günde artırılan ürün indirim almaz.',
    emptyTitle: 'Henüz otomatik kampanya yok',
    emptyLead: 'Yeni kampanya ile taslak açın; yayına alana kadar müşteriye görünmez.',
    listLabel: 'Otomatik kampanyalar',
    colName: 'Kampanya',
    colKind: 'Tür',
    colStatus: 'Durum',
    colUsage: 'Kullanım',
    colDates: 'Tarih',
    kinds: {
      item_discount: 'Ürün indirimi (yüzde)',
      cart_tiers: 'Sepet kademesi',
      buy_x_pay_y: 'X al Y öde',
      free_shipping: 'Ücretsiz kargo',
    },
    kindLeads: {
      item_discount:
        'Seçilen ürünlere (veya tüm ürünlere) sepette yüzde indirim. Bir ürüne en çok bir ürün indirimi uygulanır.',
      cart_tiers:
        'Sepet tutarı veya ürün adedi eşiği geçince indirim; en yüksek uygun kademe uygulanır. Ürün indirimlerinden sonra kalan tutara bakar.',
      buy_x_pay_y:
        'Her X üründe en düşük fiyatlı (X − Y) ürün bedava. Seçilen ürünler birbirine karışabilir.',
      free_shipping:
        'Eşiği geçen siparişte kargo ücreti alınmaz (kapıda ödeme bedeli alınır). İndirimli tutara bakar.',
    },
    phases: {
      draft: 'Taslak',
      scheduled: 'Başlamayı bekliyor',
      running: 'Yayında',
      paused: 'Duraklatıldı',
      ended: 'Sona erdi',
    },
    usageShort: '{{orders}} sipariş · {{discount}}',
    noDates: 'Süresiz',
    saved: 'Kampanya kaydedildi.',
    activated: 'Kampanya yayına alındı.',
    paused: 'Kampanya duraklatıldı.',
    deleted: 'Taslak silindi.',
    save: 'Kaydet',
    createConfirm: 'Taslağı oluştur',
    activate: 'Yayına al',
    pause: 'Duraklat',
    back: 'Otomatik indirimlere dön',
    unsaved: 'Kaydedilmemiş değişiklik',
    liveLocked: 'Yayındaki kampanya değiştirilemez; değiştirmek için önce duraklatın.',
    reviewRequired:
      'Kampanya adında olası sağlık beyanı var: Veteriner Uzman İnceleyici onayı olmadan yayına alınmaz.',
    editor: 'Kampanya ayarları',
    name: 'Kampanya adı',
    nameLead: 'Yalnızca panelde görünür.',
    label: 'Müşteriye görünen ad',
    labelLead: 'Sepette, ödeme adımında ve ürün sayfasında görünür ({{n}}/{{max}}).',
    kind: 'Kampanya türü',
    percent: 'İndirim yüzdesi',
    buy: 'Al (adet)',
    pay: 'Öde (adet)',
    minSubtotal: 'En az sepet tutarı',
    minSubtotalLead: 'Boş bırakılırsa her siparişte kargo bedava.',
    basis: 'Eşik türü',
    bases: { subtotal: 'Sepet tutarı', quantity: 'Ürün adedi' },
    tierType: 'İndirim türü',
    tiers: 'Kademeler',
    tierMinAmount: 'En az tutar',
    tierMinQty: 'En az adet',
    removeTier: '{{n}}. kademeyi kaldır',
    addTier: 'Kademe ekle',
    currency: 'Para birimi',
    targets: 'Hedef ürünler',
    targetsLead:
      'Hiçbiri seçilmezse tüm ürünler. Seçilenlerden herhangi birine uyan ürün kampanyaya girer; alt kategoriler dahildir.',
    categories: 'Kategoriler',
    brands: 'Markalar',
    collections: 'Koleksiyonlar',
    noCollections: 'Koleksiyon yok.',
    products: 'Ürünler',
    audienceTitle: 'Kitle',
    audience: 'Kimler için',
    audiences: { all: 'Herkes', retail: 'Yalnızca perakende müşteriler', dealers: 'Yalnızca bayiler' },
    groups: 'Müşteri grupları (isteğe bağlı)',
    segments: 'Segmentler (isteğe bağlı; yalnızca giriş yapmış üyeler)',
    noSegments: 'Segment yok.',
    rulesTitle: 'Öncelik, birleşme ve tarih',
    priority: 'Öncelik',
    stacking: 'Birleşme',
    stackings: {
      combinable: 'Diğer kampanyalarla birleşebilir',
      exclusive: 'Tek başına (uygulanırsa başka kampanya uygulanmaz)',
    },
    allowCoupon: 'Kuponla birlikte kullanılabilir',
    startsAt: 'Başlangıç',
    endsAt: 'Bitiş',
    preview: 'Müşteri ne görür',
    previewLabel: 'Müşteriye görünen ad',
    previewNote:
      'Ürün sayfasında kampanya adı, koşulu ve bitiş tarihi görünür; üstü çizili fiyat gösterilmez.',
    excludedTitle: 'İndirim almayan ürünler (fiyat artışı)',
    excludedLead:
      'Fiyatı kampanya başlangıcından önceki {{days}} gün içinde veya kampanya sırasında artırılan ürünler bu kampanyadan indirim almaz ve ürün sayfasında kampanya görünmez (indirimli satış kuralı). Taslakta "şimdi yayına alınsa" hesaplanır.',
    excludedNone: 'Fiyatı artırılan ürün yok; tüm hedef ürünler kampanyaya girer.',
    excludedCount: '{{count}} ürün seçeneği kampanya dışında kalıyor.',
    colProduct: 'Ürün',
    colPriceList: 'Fiyat listesi',
    colCurrent: 'Şimdiki fiyat',
    colLowest: 'Dönemdeki en düşük fiyat',
    usageTitle: 'Kullanım',
    usageNone: 'Henüz bu kampanyanın uygulandığı sipariş yok.',
    usageLine: '{{orders}} sipariş · toplam indirim {{discount}} · sipariş tutarı {{revenue}}',
    dangerZone: 'Taslağı sil',
    deleteConfirm: '"{{name}}" taslağı silinsin mi?',
    updated: 'Son değişiklik: {{date}}',
  },
  giftCards: {
    lead: 'Hediye kartı, ödeme adımında kodu girilerek harcanan ön ödemedir. Kod yalnızca oluşturulurken bir kez gösterilir; sistemde yalnızca son dört karakteri durur. Kısmen harcanan kartın kalan bakiyesi sonraki alışverişte kullanılır.',
    create: 'Hediye kartı oluştur',
    search: 'Son dört karakter',
    searchPlaceholder: 'Ör. 7KQ2',
    searchInvalid: 'En fazla dört harf veya rakam yazın.',
    stateFilter: 'Durum',
    states: {
      active: 'Kullanılabilir',
      disabled: 'Kapatıldı',
      expired: 'Süresi doldu',
      empty: 'Bakiyesi bitti',
    },
    emptyTitle: 'Henüz hediye kartı yok',
    emptyLead:
      '"Hediye kartı oluştur" ile tutar ve isteğe bağlı son kullanma tarihi seçerek kart oluşturun; kodu müşteriye siz iletirsiniz.',
    noMatch: 'Bu ölçütlere uyan kart yok',
    listLabel: 'Hediye kartları',
    colCard: 'Kart',
    colState: 'Durum',
    colBalance: 'Bakiye',
    colExpires: 'Son kullanma',
    colCreated: 'Oluşturuldu',
    cardTitle: 'Kart ···· {{last4}}',
    ofInitial: 'İlk tutar {{amount}}',
    noExpiry: 'Süresiz',
    createTitle: 'Hediye kartı oluştur',
    createLead:
      'Kod oluşturulduktan sonra yalnızca bir kez gösterilir. Kodu müşteriye siz iletirsiniz; sistem e-posta göndermez.',
    createForCustomer:
      'Kart {{name}} adına kaydedilir. Kod yalnızca bir kez gösterilir; müşteriye siz iletirsiniz.',
    createButton: 'Oluştur',
    amount: 'Tutar',
    amountInvalid: 'Tutarı 250 veya 250,50 biçiminde yazın.',
    currency: 'Para birimi',
    expiresAt: 'Son kullanma tarihi',
    expiresHint: 'Seçilen günün sonuna kadar geçerlidir. Boş bırakılırsa süresizdir.',
    note: 'İç not',
    noteHint: 'Yalnızca panelde görünür (ör. "Doğum günü hediyesi").',
    createdTitle: 'Hediye kartı oluşturuldu',
    createdLead: '{{amount}} bakiyeli kartın kodu aşağıda.',
    code: 'Kod',
    copy: 'Kodu kopyala',
    copied: 'Kod kopyalandı',
    copyFailed: 'Kopyalanamadı; kodu seçip elle kopyalayın.',
    codeOnce:
      'Bu kod bir daha gösterilmez. Pencereyi kapatmadan önce kopyalayın ve müşteriye güvenli biçimde iletin. Kod kaybolursa kartı kapatıp yenisini oluşturun.',
    openCard: 'Kartı aç',
    savedCode: 'Kodu kaydettim',
    backToList: 'Hediye kartları',
    summary: 'Kart',
    balance: 'Bakiye',
    initial: 'İlk tutar',
    customer: 'Müşteri',
    created: 'Oluşturuldu',
    adjust: 'Bakiyeyi düzelt',
    disable: 'Kartı kapat',
    enable: 'Kartı yeniden aç',
    disableConfirm:
      'Kart kapatılır ve kalan bakiye harcanamaz. Önceki siparişlerde kullanılan tutar etkilenmez. Devam edilsin mi?',
    enableConfirm: 'Kart yeniden kullanılabilir olur. Devam edilsin mi?',
    settings: 'Son kullanma ve not',
    history: 'Hareketler',
    noHistory: 'Hareket yok.',
    colDate: 'Tarih',
    colKind: 'İşlem',
    colAmount: 'Tutar',
    colAfter: 'Sonraki bakiye',
    kinds: {
      issue: 'Oluşturuldu',
      redeem: 'Siparişte kullanıldı',
      release: 'Sipariş iptal edildi, geri yüklendi',
      refund: 'İade, geri yüklendi',
      adjust: 'Elle düzeltme',
    },
    adjustTitle: 'Kart ···· {{last4}} bakiyesini düzelt',
    adjustLead:
      'Güncel bakiye {{balance}}. Düzeltme, gerekçesiyle birlikte hareketlere ve denetim kaydına yazılır.',
    direction: 'İşlem',
    directionAdd: 'Bakiye ekle',
    directionSubtract: 'Bakiyeden düş',
    adjustAmount: 'Tutar ({{currency}})',
    adjustNote: 'Gerekçe',
    adjustNoteHint: 'En az 3 karakter. Ör. "Hatalı yükleme düzeltmesi".',
    adjustAdd: 'Ekle',
    adjustSubtract: 'Düş',
    adjusted: 'Bakiye güncellendi',
  },
  storeCredit: {
    title: 'Mağaza kredisi',
    lead: 'Müşterinin hesabındaki kredi, ödeme adımında "Mağaza kredimi kullan" ile harcanır. Kredi iadeden (müşterinin onayıyla) veya elle eklenir.',
    adjust: 'Kredi ekle / düş',
    issueGiftCard: 'Hediye kartı ver',
    none: 'Kredi yok.',
    history: 'Kredi hareketleri',
    giftCards: 'Bu müşteriye verilen hediye kartları',
    kinds: {
      grant: 'Eklendi',
      refund: 'İade',
      redeem: 'Siparişte kullanıldı',
      release: 'Sipariş iptal edildi, geri yüklendi',
      adjust: 'Düşüldü',
    },
    adjustTitle: 'Mağaza kredisi ekle / düş',
    adjustLead:
      'Gerekçe hareketlere ve denetim kaydına yazılır; müşteri Hesabım sayfasında yalnızca tutarı ve işlem türünü görür.',
  },
  loyalty: {
    lead: 'Üyeler teslim edilen siparişlerden puan kazanır ve ödeme adımında puanla öder; son 12 aydaki alışverişlerine göre VIP seviyesi alır (seviye indirimi ve ücretsiz kargo). Program kapalıyken hiçbir müşteriye uygulanmaz; puanlar silinmez.',
    summary: 'Program özeti',
    on: 'Açık',
    off: 'Kapalı',
    members: 'Puanı olan üye',
    outstanding: 'Kullanılmamış puan (değeri)',
    earned30: 'Son 30 gün kazanılan',
    redeemed30: 'Son 30 gün harcanan',
    expired30: 'Son 30 gün süresi dolan',
    tierCounts: 'Seviyelere göre üye: {{list}}',
    settings: 'Program ayarları',
    settingsLead:
      'Değişiklikler kaydedilince sepet ve ödeme adımında hemen geçerli olur. Verilmiş siparişler değişmez.',
    enabled: 'Sadakat programı açık',
    currency: 'Para birimi',
    earn: 'Her 1 birime kazanılan puan',
    value: '1 birim indirim için gereken puan',
    preview:
      'Müşteri her {{one}} alışverişe {{earn}} puan kazanır; {{value}} puan = {{one}}. Geri dönüş oranı: {{percent}}.',
    previewNoEarn: 'Puan kazanma kapalı: yalnızca seviyeler uygulanır.',
    minRedeem: 'Kullanmak için en az puan',
    holdDays: 'Teslimden sonra bekleme (gün)',
    expiryMonths: 'Puan geçerliliği (ay)',
    expiryHint: '0 = puanların süresi dolmaz.',
    tiers: 'VIP seviyeleri',
    tiersLead:
      'Seviye, müşterinin son 12 aydaki net alışverişine göre her siparişte yeniden hesaplanır (iadeler düşülür). En çok 5 seviye.',
    tierName: 'Seviye adı',
    tierSpend: 'Son 12 ay en az ({{currency}})',
    tierDiscount: 'İndirim (%)',
    tierShipping: 'Ücretsiz kargo',
    tierAdd: 'Seviye ekle',
    tierRemove: '{{name}} seviyesini kaldır',
    fixErrors: 'Kaydedilmedi: işaretli alanları düzeltin.',
    save: 'Kaydet',
    saved: 'Sadakat programı kaydedildi',
    enableConfirm:
      'Program açılınca seviye indirimleri üyelerin sepetinde hemen uygulanır ve teslim edilen siparişler puan kazanmaya başlar. Müşterilere bildirim gönderilmez. Devam edilsin mi?',
    customerTitle: 'Sadakat',
    adjust: 'Puan ekle / düş',
    points: '{{points}} puan',
    expiringSoon: '{{points}} puanın süresi 30 gün içinde doluyor.',
    customerTier: 'Seviye: {{tier}}',
    customerNoTier: 'Seviye yok',
    spend12: 'son 12 ay {{amount}}',
    nextTier: '{{tier}} için {{amount}} kaldı',
    history: 'Puan hareketleri',
    colDate: 'Tarih',
    colKind: 'İşlem',
    colPoints: 'Puan',
    colExpires: 'Son kullanma',
    kinds: {
      earn: 'Kazanıldı',
      redeem: 'Siparişte kullanıldı',
      release: 'Geri yüklendi',
      reverse: 'İade nedeniyle geri alındı',
      expire: 'Süresi doldu',
      adjust: 'Elle düzeltme',
    },
    adjustTitle: 'Puan ekle / düş',
    adjustLead:
      'Güncel bakiye {{points}} puan. Gerekçe hareketlere ve denetim kaydına yazılır; müşteri görmez.',
    direction: 'İşlem',
    directionAdd: 'Puan ekle',
    directionSubtract: 'Puandan düş',
    pointsField: 'Puan',
    pointsInvalid: 'Pozitif bir tam sayı yazın.',
    adjustAdd: 'Ekle',
    adjustSubtract: 'Düş',
    adjusted: 'Puan güncellendi',
  },
  referrals: {
    lead: 'Üye, Hesabım sayfasından davet kodunu alıp arkadaşlarıyla paylaşır. Arkadaş ilk siparişinde indirim kazanır; sipariş teslim edilip bekleme süresi geçince davet edene tek kullanımlık ödül kuponu verilir. Mağaza kimseye mesaj göndermez. Program kapalıyken davet kodları çalışmaz.',
    summary: 'Program özeti',
    on: 'Açık',
    off: 'Kapalı',
    codes: 'Davet kodu alan üye',
    pending: 'Bekleyen davet',
    rewarded: 'Ödül verilen davet',
    cancelled: 'Ödülsüz kapanan',
    rewardCoupons: 'Ödül kuponu (verilen / kullanılan)',
    rewardCouponsValue: '{{issued}} / {{used}}',
    settings: 'Program ayarları',
    settingsLead:
      'Kaydedince tüm davet kodları yeni indirimle güncellenir. Daha önce verilmiş ödül kuponları değişmez.',
    enabled: 'Tavsiye programı açık',
    currency: 'Para birimi',
    friend: 'Arkadaşın indirimi (ilk sipariş)',
    referrer: 'Davet edenin ödülü (kupon)',
    rewardType: 'İndirim türü',
    typePercent: 'Yüzde',
    typeFixed: 'Sabit tutar ({{currency}})',
    valuePercent: 'İndirim (%)',
    valueFixed: 'İndirim tutarı ({{currency}})',
    minSubtotal: 'En az sepet tutarı ({{currency}})',
    minSubtotalHint: 'Boş bırakılırsa sınır yok.',
    holdDays: 'Teslimden sonra bekleme (gün)',
    rewardValidDays: 'Ödül kuponu geçerliliği (gün)',
    maxRewards: 'Üye başına en çok ödül',
    fixErrors: 'Kaydedilmedi: işaretli alanları düzeltin.',
    save: 'Kaydet',
    saved: 'Tavsiye programı kaydedildi',
    enableConfirm:
      'Program açılınca üyeler Hesabım sayfasında davet kodu alabilir ve davet kodları sepette indirim olarak çalışır. Müşterilere bildirim gönderilmez. Devam edilsin mi?',
    recent: 'Son davetler',
    recentLead:
      'Davet koduyla verilen siparişler. Ödül, teslimden sonra bekleme süresi geçince saatlik işte verilir.',
    emptyTitle: 'Henüz davetle verilmiş sipariş yok',
    emptyLead: 'Bir arkadaş davet koduyla ilk siparişini verdiğinde burada görünür.',
    colDate: 'Tarih',
    colReferrer: 'Davet eden',
    colOrder: 'Sipariş',
    colStatus: 'Durum',
    colReward: 'Ödül kuponu',
    statuses: {
      pending: 'Teslim bekleniyor',
      rewarded: 'Ödül verildi',
      cancelled: 'İptal / iade',
      limit: 'Ödül sınırı doldu',
    },
  },
  affiliates: {
    lead: 'İş ortağı ve influencer siparişleri kupon koduyla ya da bağlantıdaki utm_source değeriyle eşleşir. Bağlantı eşleşmesi yalnızca ziyaretçi ölçüm çerezine izin verdiyse çalışır. Komisyon KDV ve kargo hariç ürün tutarı üzerinden hesaplanır, teslimden 14 gün sonra onaylanır. Ödemeyi siz yaparsınız: CSV indirip ödeyin, sonra "ödendi" işaretleyin.',
    create: 'İş ortağı ekle',
    emptyTitle: 'Henüz iş ortağı yok',
    emptyLead: 'İş ortağı ekleyince ona özel kupon veya bağlantı kaynağı tanımlarsınız.',
    listLabel: 'İş ortakları',
    colName: 'İş ortağı',
    colMatch: 'Eşleşme',
    colRate: 'Oran',
    colPending: 'Bekleyen',
    colApproved: 'Onaylanan',
    colPaid: 'Ödenen',
    colActions: 'İşlemler',
    kinds: { affiliate: 'Affiliate', influencer: 'Influencer' },
    paused: 'Duraklatıldı',
    coupon: 'Kupon: {{code}}',
    edit: 'Düzenle',
    editNamed: '{{name}} iş ortağını düzenle',
    createTitle: 'İş ortağı ekle',
    editTitle: 'İş ortağını düzenle',
    dialogLead:
      'Oran ve durum değişiklikleri yalnızca bundan sonraki siparişlere uygulanır; yazılmış komisyonlar değişmez.',
    name: 'Ad',
    kind: 'Tür',
    email: 'E-posta',
    emailMasked: 'E-posta gizli. Değiştirmek için yenisini yazın.',
    source: 'Bağlantı kaynağı (utm_source)',
    sourceHint: 'Bağlantının sonuna ekleyin: ?utm_source={{source}}',
    rate: 'Komisyon oranı (%)',
    discount: 'Kupon',
    noDiscount: 'Kupon yok (yalnızca bağlantı)',
    status: 'Durum',
    statuses: { active: 'Etkin', paused: 'Duraklatıldı' },
    note: 'İç not',
    save: 'Kaydet',
    created: 'İş ortağı eklendi',
    updated: 'İş ortağı güncellendi',
    commissions: 'Komisyonlar',
    commissionsLead:
      'Bekleyen komisyon teslimden 14 gün sonra onaylanır; iptal ve tam iadede iptal olur, kısmi iadede taban düşer.',
    filterAffiliate: 'İş ortağı',
    filterStatus: 'Durum',
    export: 'CSV indir',
    markPaid: 'Ödendi işaretle ({{count}})',
    selectAll: 'Onaylanmış komisyonların tümünü seç',
    selectOne: '{{order}} komisyonunu seç',
    noCommissions: 'Komisyon yok',
    noCommissionsLead: 'Eşleşen siparişler burada görünür.',
    colOrder: 'Sipariş',
    colAffiliate: 'İş ortağı',
    colBase: 'Taban',
    colCommission: 'Komisyon',
    colStatus: 'Durum',
    sources: { coupon: 'Kuponla', link: 'Bağlantıyla' },
    commissionStatuses: {
      pending: 'Beklemede',
      approved: 'Onaylandı',
      paid: 'Ödendi',
      cancelled: 'İptal edildi',
    },
    markPaidTitle: 'Komisyonları ödendi işaretle',
    markPaidLead:
      '{{count}} komisyon, toplam {{total}}. Ödemeyi sistem dışında yaptıysanız işaretleyin; işlem geri alınamaz ve denetim kaydına yazılır.',
    paidNote: 'Ödeme açıklaması',
    paidNoteHint: 'Örn. dekont numarası ve ödeme tarihi.',
    markPaidConfirm: 'Ödendi işaretle',
    markedPaid: '{{count}} komisyon ödendi işaretlendi',
  },
  support: {
    lead: 'Müşteriler Hesabım sayfasından talep açar; iletişim formu mesajları da talebe dönüştürülebilir. Müşteriye yazdığınız yanıt e-postayla da gider; iç notları yalnızca ekip görür. Çözülen talepte müşteri hizmeti 1–5 arasında puanlayabilir.',
    countsLabel: 'Talep sayıları',
    countOpen: 'Yanıt bekleyen: {{count}}',
    countWaiting: 'Müşteri yanıtı bekleyen: {{count}}',
    countUnassigned: 'Atanmamış: {{count}}',
    listTitle: 'Talepler',
    filterStatus: 'Durum',
    filterActive: 'Açık ve bekleyen',
    filterAssigned: 'Atanan',
    assignedMe: 'Bana atananlar',
    unassigned: 'Atanmamış',
    filterPriority: 'Öncelik',
    search: 'Ara',
    searchPlaceholder: 'Talep no, e-posta veya konu',
    emptyTitle: 'Talep yok',
    emptyLead: 'Müşteriler Hesabım → Destek taleplerim bölümünden talep açtığında burada görünür.',
    colTicket: 'Talep',
    colCustomer: 'Müşteri',
    colStatus: 'Durum',
    colAssignee: 'Atanan',
    colLast: 'Son hareket',
    pageOf: 'Sayfa {{page}} / {{pages}}',
    statuses: {
      open: 'Yanıt bekliyor',
      waiting: 'Müşteri yanıtı bekleniyor',
      resolved: 'Çözüldü',
      closed: 'Kapatıldı',
    },
    priorities: { low: 'Düşük', normal: 'Normal', high: 'Yüksek', urgent: 'Acil' },
    categories: {
      order: 'Sipariş',
      shipping: 'Kargo ve teslimat',
      return: 'İade ve değişim',
      payment: 'Ödeme ve fatura',
      product: 'Ürün bilgisi',
      account: 'Hesap',
      other: 'Diğer',
    },
    channels: { account: 'Hesabım', contact_form: 'İletişim formu', panel: 'Panel', chat: 'Canlı sohbet' },
    kinds: { customer: 'Müşteri', staff: 'Yanıt', note: 'İç not' },
    durationDays: '{{d}} gün {{h}} sa',
    durationHours: '{{h}} sa {{m}} dk',
    durationMinutes: '{{m}} dk',
    report: 'Destek ve memnuniyet raporu',
    reportLead:
      'Seçilen dönemde açılan ve çözülen talepler, ilk yanıt süresi (ortanca), memnuniyet puanları ve konular. Sipariş görme yetkiniz varsa iade nedenleri de görünür.',
    period: 'Dönem',
    lastDays: 'Son {{days}} gün',
    statCreated: 'Açılan talep',
    statResolved: 'Çözülen talep',
    statOpen: 'Şu an açık',
    statFirstResponse: 'İlk yanıt süresi (ortanca)',
    statSatisfaction: 'Memnuniyet',
    satisfactionValue: '{{avg}} / 5 ({{count}} puan)',
    distribution: 'Puan dağılımı',
    score: '{{score}} puan',
    byCategory: 'Konulara göre talepler',
    noData: 'Bu dönemde kayıt yok.',
    returnReasons: 'İade nedenleri',
    returnTotal: '{{count}} iade talebi',
    colReason: 'Neden',
    colRequests: 'Talep',
    colApproved: 'Onaylanan',
    topReturned: 'En çok iade edilen ürünler',
    units: '{{count}} adet',
    macros: 'Hazır yanıtlar',
    macrosLead:
      'Sık verilen yanıtları kaydedin; yanıt yazarken seçip düzenleyebilirsiniz. {{name}} müşterinin adıyla değişir.',
    macrosEmpty: 'Hazır yanıt yok',
    macrosEmptyLead: 'Örneğin kargo gecikmesi veya iade süreci için bir yanıt ekleyin.',
    macroAdd: 'Hazır yanıt ekle',
    macroEdit: 'Hazır yanıtı düzenle',
    macroEditNamed: '{{name}} hazır yanıtını düzenle',
    macroDeleteNamed: '{{name}} hazır yanıtını sil',
    macroDeleteConfirm: '"{{name}}" hazır yanıtı silinsin mi?',
    macroDeleted: 'Hazır yanıt silindi',
    macroSaved: 'Hazır yanıt kaydedildi',
    macroDialogLead: 'Yanıt metnindeki {{name}} ifadesi, eklerken müşterinin adıyla değiştirilir.',
    macroTitle: 'Ad',
    macroBody: 'Yanıt metni',
    macroBodyHint: 'Kişisel veri (sipariş, adres) yazmayın; bunları her yanıtta ayrıca ekleyin.',
    ticketTitle: 'Talep #{{number}}: {{subject}}',
    backToList: 'Taleplere dön',
    details: 'Talep bilgileri',
    customer: 'Müşteri',
    guest: 'misafir',
    order: 'Sipariş',
    channel: 'Geldiği yer',
    opened: 'Açılış',
    firstResponse: 'İlk yanıt süresi',
    noResponseYet: 'Henüz yanıt verilmedi',
    satisfaction: 'Memnuniyet',
    ratingValue: '{{rating}} / 5',
    status: 'Durum',
    priority: 'Öncelik',
    category: 'Konu',
    assignee: 'Atanan çalışan',
    notifyResolved: 'Müşteriye "talebiniz çözüldü" e-postası gönder (puanlama bağlantısıyla)',
    saveDetails: 'Değişiklikleri kaydet',
    savedEmailed: 'Kaydedildi; müşteriye e-posta gönderildi',
    savedNotEmailed:
      'Kaydedildi; e-posta altyapısı kurulu olmadığı için müşteriye e-posta gitmedi (Kurulum Gerekli)',
    conversation: 'Yazışma',
    emailed: 'E-postayla gönderildi',
    notEmailed: 'E-posta gönderilmedi',
    closedHint:
      'Talep kapatıldı: müşteriye yanıt yazılamaz, yalnızca iç not eklenebilir. Yeniden yanıtlamak için durumu değiştirin.',
    insertMacro: 'Hazır yanıt ekle',
    chooseMacro: 'Seçin…',
    replyLabel: 'Yanıt veya iç not',
    noteLabel: 'İç not',
    replyHint:
      'Yanıt müşterinin talep sayfasında görünür ve e-postayla da gönderilir. İç not yalnızca ekipte kalır.',
    sendReply: 'Yanıtı gönder',
    sendAndResolve: 'Gönder ve çözüldü yap',
    addNote: 'İç not ekle',
    noteSaved: 'İç not eklendi',
    replySent: 'Yanıt gönderildi; müşteriye e-postalandı',
    replySavedNotEmailed:
      'Yanıt kaydedildi; müşteri talep sayfasında görür. E-posta altyapısı kurulu olmadığı için e-posta gitmedi (Kurulum Gerekli).',
    convertTitle: 'Destek talebine dönüştür',
    convertLead:
      'Mesaj, talebin ilk müşteri mesajı olur ve "işlendi" olarak işaretlenir. Müşteriye ilk yanıtınızla birlikte talep bağlantısı e-postayla gider.',
    subject: 'Talep konusu',
    convert: 'Talebe dönüştür',
    converted: 'Talep #{{number}} oluşturuldu',
  },
  chat: {
    lead: 'Vitrindeki "Canlı destek" penceresinden gelen sohbetler. Ziyaretçi sohbeti yalnızca en az bir çalışan "Sohbete açığım" iken başlatabilir; değilse pencere mesaj formuna (destek talebi) düşer. Ekran 5 saniyede bir yenilenir.',
    disabledNotice: 'Canlı sohbet kapalı: vitrinde pencere görünmez. Aşağıdaki ayarlardan açabilirsiniz.',
    workspace: 'Sohbetler',
    available: 'Sohbete açığım',
    onlineAgents: 'Şu an sohbete açık çalışan: {{count}}',
    waiting: 'Bekleyen',
    active: 'Süren',
    closedRecent: 'Son 24 saatte kapanan',
    noWaiting: 'Bekleyen sohbet yok.',
    noActive: 'Süren sohbet yok.',
    noClosed: 'Kapanan sohbet yok.',
    anonymous: 'Adsız ziyaretçi',
    visitor: 'Ziyaretçi',
    with: '{{name}} ile',
    pickTitle: 'Bir sohbet seçin',
    pickLead: 'Soldaki listeden bir sohbet seçin; bekleyen sohbeti üstlenip yanıtlayabilirsiniz.',
    statuses: { waiting: 'Bekliyor', active: 'Sürüyor', closed: 'Kapandı' },
    noEmail: 'E-posta yazılmadı',
    customerCard: 'Müşteri kartı',
    messages: 'Sohbet mesajları',
    events: {
      joined: 'Çalışan sohbete katıldı',
      closed_visitor: 'Ziyaretçi sohbeti bitirdi',
      closed_staff: 'Çalışan sohbeti kapattı',
      closed_idle: 'Hareketsizlik nedeniyle kapandı',
      ticket: 'Destek talebine dönüştürüldü',
    },
    openTicket: 'Destek talebini aç',
    claim: 'Üstlen',
    reply: 'Yanıtınız',
    replyHint: 'Enter gönderir, Shift+Enter yeni satır. Ziyaretçi adınızı görmez; "Destek ekibi" görür.',
    send: 'Gönder',
    close: 'Sohbeti kapat',
    closeConfirm: 'Sohbet kapatılsın mı? Ziyaretçi yeni sohbet başlatabilir.',
    closedToast: 'Sohbet kapatıldı',
    convert: 'Talebe dönüştür',
    convertNeedsEmail: 'Ziyaretçi e-posta yazmadığı için talebe dönüştürülemez.',
    convertTitle: 'Sohbeti destek talebine dönüştür',
    convertLead:
      'Ziyaretçi mesajları müşteri, ekip mesajları yanıt olarak talebe taşınır; sohbet kapanır. Talebe yazacağınız yanıt müşteriye e-postayla gider.',
    settings: 'Sohbet ayarları',
    settingsLead: 'Sohbet varsayılan kapalıdır. Açmak için KVKK aydınlatma metni yayımda olmalıdır.',
    enabled: 'Vitrinde canlı destek penceresi',
    needsNotice: 'KVKK aydınlatma metni yayımlanmadan sohbet açılamaz (Yasal metinler).',
    retentionDays: 'Kapanan sohbetlerin saklama süresi (gün)',
    idleMinutes: 'Hareketsiz sohbetin kapanma süresi (dakika)',
    saveSettings: 'Ayarları kaydet',
    settingsSaved: 'Sohbet ayarları kaydedildi',
  },
  ads: {
    sourcesTitle: 'Reklam hesapları ve veri',
    sourcesLead:
      'Harcama verisi Meta ve TikTok bağlantılarından her sabah okunur ya da platformdan indirdiğiniz raporu (CSV/XLSX) yüklersiniz. Gelir her zaman mağazanın gerçek siparişlerinden hesaplanır.',
    connections: 'Reklam bağlantıları',
    connected: 'Bağlı',
    connectionError: 'Bağlantı hatası',
    setupRequired: 'Kurulum gerekli',
    manageConnections: 'Bağlantıları yönet',
    googleNote:
      'Google Ads harcamasının her sabah API ile gelmesi için Google bağlantıları sayfasında Google hesabını "Google Ads" izniyle bağlayıp müşteri hesabını mağazaya seçin (geliştirici jetonu gerekmez). O zamana kadar Google Ads raporunu dosya olarak yükleyebilirsiniz.',
    googleNoteLink: 'Google bağlantıları',
    syncNow: 'Şimdi eşitle',
    synced: 'Eşitlendi: {{rows}} satır okundu.',
    syncFailed: 'Eşitleme tamamlanamadı: {{error}}',
    addAccount: 'Hesap ekle',
    addAccountLead:
      'Dosyayla veri yükleyeceğiniz reklam hesabı. Meta ve TikTok hesapları bağlantı kurulunca kendiliğinden eklenir.',
    editAccount: 'Hesabı düzenle',
    editAccountFor: '{{name}} hesabını düzenle',
    accountSaved: 'Hesap kaydedildi.',
    noAccounts: 'Henüz reklam hesabı yok',
    noAccountsLead:
      'Meta veya TikTok bağlantısı kurun ya da Google Ads ve diğer platformların raporunu yüklemek için hesap ekleyin.',
    accountsTable: 'Reklam hesapları',
    account: 'Hesap',
    accountName: 'Hesap adı',
    platform: 'Platform',
    externalId: 'Platformdaki hesap kimliği',
    currency: 'Para birimi',
    utmSources: 'Eşleşen kaynaklar (utm_source)',
    utmDefault:
      'Boş bırakırsanız platformun alışılmış değerleri kullanılır (ör. Meta için facebook, instagram).',
    noUtm: 'Kaynak tanımlı değil',
    accountStatus: 'Durum',
    active: 'Etkin',
    archived: 'Arşivlendi',
    source: 'Veri kaynağı',
    sources: { api: 'API eşitlemesi', file: 'Dosya' },
    lastData: 'Son eşitleme',
    automatic: 'Otomatik',
    platforms: { google_ads: 'Google Ads', meta: 'Meta', tiktok: 'TikTok', other: 'Diğer' },
    uploadReport: 'Rapor yükle',
    uploadTitle: '{{name}} — rapor yükle',
    uploadLead:
      'Platformun günlük kırılımlı raporunu yükleyin (tarih, kampanya, harcama; varsa reklam grubu, reklam, gösterim, tıklama). Tutarlar {{currency}} olmalıdır.',
    chooseFile: 'Dosya seç',
    applyImport: 'Verileri kaydet',
    imported: 'Kaydedildi: {{inserted}} yeni, {{updated}} güncellenen satır.',
    previewFile: 'Dosya',
    previewRows: 'Satırlar',
    previewRowsValue: '{{rows}} satırdan {{valid}} geçerli, {{skipped}} atlandı',
    previewPeriod: 'Dönem',
    previewSpend: 'Toplam harcama',
    previewCampaigns: 'Kampanya sayısı',
    previewErrors: 'Atlanan satırlar (ilk 20)',
    rowError: '{{row}}. satır: {{error}}',
    rowErrors: {
      ads_import_date: 'tarih okunamadı veya ileri bir tarih',
      ads_import_campaign: 'kampanya adı yok veya toplam satırı',
      ads_import_currency: 'para birimi hesabınkiyle aynı değil',
      ads_import_amount: 'tutar veya sayı okunamadı',
    },
    reportTitle: 'Kampanya performansı',
    reportLead:
      'Platform verisi ile mağaza siparişleri birlikte. Gelir; son ziyaretin kaynağı hesabın kaynaklarından biri ve kampanya adı (utm_campaign) eşleşen, ödenmiş siparişlerden gelir.',
    period: 'Dönem',
    lastDays: 'Son {{n}} gün',
    allPlatforms: 'Tüm platformlar',
    noData: 'Bu dönemde reklam verisi yok',
    noDataLead: 'Bağlantıların eşitlenmesini bekleyin veya bir hesap için rapor yükleyin.',
    totalsLabel: 'Toplamlar ({{currency}})',
    campaignsTable: 'Kampanyalar',
    campaign: 'Kampanya',
    unmatchedCampaign: 'Kampanyası eşleşmeyen siparişler',
    spend: 'Harcama',
    impressions: 'Gösterim',
    clicks: 'Tıklama',
    ctr: 'TO (tıklama oranı)',
    cpc: 'TBM (tıklama başı)',
    cpm: 'BGBM (bin gösterim)',
    platformConversions: 'Platform dönüşümü',
    orders: 'Sipariş',
    revenue: 'Gelir',
    cpa: 'Sipariş başı maliyet',
    newCustomers: 'Yeni müşteri',
    cac: 'Yeni müşteri başı maliyet (CAC)',
    roas: 'ROAS',
    profit: 'Reklam sonrası kâr',
    revenueNote:
      'Gelir KDV ve kargo hariç ürün tutarıdır; iadeler ve iptaller düşülür. Platform dönüşümü yalnızca karşılaştırma içindir.',
    profitNote:
      'Kâr = gelir − ürün maliyeti − reklam harcaması. Siparişteki bir ürünün maliyeti girilmemişse kâr gösterilmez (—).',
    profitHidden: 'Reklam sonrası kârı görmek için maliyet görüntüleme yetkisi gerekir.',
    currencyMismatch: 'Para birimi reklam hesabından farklı olduğu için {{n}} sipariş hesaba katılmadı.',
    compare: 'Karşılaştır',
    compareThis: '{{name}} kampanyasını karşılaştırmaya ekle',
    compareHint: 'Karşılaştırmak için en çok {{n}} kampanya seçin.',
    compareTitle: 'Kampanya karşılaştırma',
    metric: 'Ölçüt',
    anomaliesTitle: 'Uyarılar',
    noAnomalies: 'Son veride olağan dışı bir durum yok.',
    anomalyKinds: {
      spend_spike: 'Harcama sıçraması',
      ctr_drop: 'Tıklama oranı düştü',
      no_clicks: 'Tıklamasız harcama',
      sync_failed: 'Eşitleme hatası',
      sync_stale: 'Veri eski',
    },
    anomalyText: {
      spend_spike:
        '{{account}} · {{campaign}}: {{date}} harcaması {{value}}, önceki 7 günün ortalaması {{baseline}}.',
      ctr_drop: '{{account}} · {{campaign}}: {{date}} tıklama oranı önceki 7 günün yarısının altında.',
      no_clicks: '{{account}} · {{campaign}}: {{date}} günü {{value}} harcandı, tıklama yok.',
      sync_failed: '{{account}}: son eşitleme başarısız. Bağlantı anahtarını kontrol edin.',
      sync_stale: '{{account}}: 2 günden uzun süredir yeni veri gelmedi.',
    },
    productsTitle: 'Ürün performansı (reklamdan gelen siparişler)',
    product: 'Ürün',
    quantity: 'Adet',
    productRevenue: 'Net satış',
    productAdsTitle: 'Alışveriş reklamı ürünleri (Google Ads)',
    productAdsNote:
      'Harcama ve tıklama Google’ın ürün raporundan; net satış aynı hesaptan gelen ödenmiş siparişlerdeki bu ürünün tutarı (stok koduyla eşleşir).',
    requestChange: 'Değişiklik iste',
    changeTitle: 'Bütçe veya yayın değişikliği iste',
    changeLead:
      '{{account}} · {{campaign}}. İstek onaylanınca değişikliği reklam platformunda siz uygularsınız.',
    changeKind: 'Değişiklik',
    kinds: { budget: 'Günlük bütçeyi değiştir', status: 'Yayın durumunu değiştir' },
    dailyBudget: 'Yeni günlük bütçe ({{currency}})',
    budgetInvalid: 'Geçerli bir tutar yazın (ör. 750 veya 750,50).',
    targetStatus: 'Yeni durum',
    targets: { paused: 'Yayını durdur', active: 'Yayına al' },
    changeNote: 'Gerekçe',
    changeManualNote:
      'Sistem reklam platformunda kendiliğinden değişiklik yapmaz; onaydan sonra platformda uygulayıp "Uygulandı" olarak işaretleyin.',
    sendRequest: 'Onaya gönder',
    changeRequested: 'İstek onaya gönderildi.',
    changeUpdated: 'İstek güncellendi.',
    historyTitle: 'Değişiklik geçmişi',
    historyLead: 'Bütçe ve yayın istekleri, onaylar ve veri yüklemeleri.',
    changesTable: 'Değişiklik istekleri',
    noChanges: 'Henüz değişiklik isteği yok.',
    when: 'Tarih',
    request: 'İstek',
    status: 'Durum',
    budgetTo: 'Günlük bütçe: {{amount}}',
    requestedBy: 'İsteyen: {{name}}',
    decidedBy: '{{name}}, {{at}}',
    appliedAt: 'Uygulandı: {{at}}',
    changeStatuses: {
      pending: 'Onay bekliyor',
      approved: 'Onaylandı — uygulanacak',
      rejected: 'Reddedildi',
      applied: 'Uygulandı',
      cancelled: 'İptal edildi',
    },
    decide: 'Karar ver',
    decideTitle: 'Değişiklik isteği',
    decideLead: '{{campaign}}: {{change}}',
    decisionNote: 'Karar notu',
    approve: 'Onayla',
    reject: 'Reddet',
    markApplied: 'Uygulandı',
    markAppliedConfirm: 'Değişikliği reklam platformunda uyguladınız mı? Uygulandı olarak işaretlenecek.',
    cancelRequest: 'İptal et',
    cancelConfirm: 'Bekleyen istek iptal edilsin mi?',
    runsTitle: 'Veri yüklemeleri ve eşitlemeler',
    noRuns: 'Henüz veri yüklenmedi.',
    runRows: 'Satır',
    runRowsValue: '{{inserted}} yeni · {{updated}} güncel · {{skipped}} atlandı',
    gcTitle: 'Google Ads dönüşüm yükleme',
    gcLead:
      'Reklamdan gelen ödenmiş siparişleri Google Ads’e dönüşüm olarak bildirir; Google Ads teklif stratejileri gerçek satışla öğrenir. Varsayılan kapalı.',
    gcPrivacy:
      'Açıldığında pazarlama çerezi izni veren ziyaretçilerin siparişleri için Google tıklama kimliği (gclid), sipariş numarası, tutar ve zaman Google’a (yurt dışı) gönderilir. Açmadan önce aydınlatma metninin bunu kapsadığını avukatınızla teyit edin. Ad, e-posta veya telefon gönderilmez.',
    gcEnabled: 'Ödenmiş siparişleri Google Ads’e dönüşüm olarak yükle',
    gcEnabledHint: 'Her sabah eşitlemeden sonra; son 60 gün, sipariş başına bir kez.',
    gcAction: 'Dönüşüm işlemi',
    gcActionHint:
      'Google Ads → Hedefler → Dönüşümler’de "Tıklama içe aktarma" türünde işlem; kaynak adı customers/…/conversionActions/….',
    gcSaved: 'Dönüşüm yükleme ayarı kaydedildi.',
    gcNoUploads: 'Henüz dönüşüm yüklenmedi.',
    gcUploaded: '{{count}} sipariş yüklendi ({{value}})',
    gcFailed: '{{count}} sipariş Google tarafından reddedildi',
    runStatuses: { ok: 'Tamam', partial: 'Kısmen', failed: 'Başarısız' },
  },
  googleReports: {
    ga4Title: 'Analytics (GA4) raporu',
    ga4Lead:
      'Bağlı mülk: {{property}}. Dün dahil; Google Analytics verisi çerez izni veren ziyaretçilerden gelir.',
    ga4LeadEmpty: 'Mağazaya bağlı GA4 mülkünün kanal ve gün raporu.',
    period: 'Dönem',
    lastDays: 'Son {{n}} gün',
    totals: 'Dönem toplamları',
    sessions: 'Oturum',
    users: 'Kullanıcı',
    keyEvents: 'Temel etkinlik',
    revenue: 'Satın alma geliri',
    byChannel: 'Kanala göre',
    byDay: 'Güne göre',
    channel: 'Kanal',
    day: 'Gün',
    noData: 'Bu dönemde GA4 verisi yok.',
    ga4Note:
      'GA4 gelirleri yalnızca ölçüm izni veren ziyaretçileri kapsar ve iade/iptalleri içermez; kesin satış için Satış ve Kampanyalar ve kaynaklar raporlarına bakın. Kullanıcı sayıları satırlar arasında toplanmaz (aynı kişi birden çok kanaldan gelebilir).',
    gbpTitle: 'Google Business Profile',
    gbpLead: 'Konum bilgisi ve son 50 Google yorumu (salt okuma). Yorumlar Google’da yanıtlanır.',
    location: 'Konum',
    address: 'Adres',
    phone: 'Telefon',
    website: 'Web sitesi',
    rating: 'Ortalama puan',
    ratingValue: '{{avg}} / 5 ({{count}} yorum)',
    replyOnGoogle: 'Google Haritalar’da aç ve yorumları yanıtla',
    reviews: 'Google yorumları',
    noReviews: 'Henüz yorum yok.',
    anonymous: 'Google kullanıcısı',
    stars: '{{n}} yıldız',
    replied: 'Yanıtınız: {{reply}}',
    noReply: 'Henüz yanıtlanmadı.',
    problem_google_not_linked: 'Bu mağazaya bağlı Google kaynağı yok',
    problem_google_scope_missing: 'Google hesabı bu hizmet için izin vermedi',
    problem_google_not_connected: 'Google hesabı bağlı değil',
    problemLead:
      'Google bağlantıları sayfasında hesabı ilgili izinle bağlayıp mağaza için mülk veya konum seçin.',
    openConnections: 'Google bağlantılarına git',
  },
  trackingEvents: {
    title: 'Olay yöneticisi',
    lead: 'Vitrinin gönderdiği e-ticaret olaylarından hangisinin hangi ölçüm hizmetine gideceği ve kendi tanımladığınız özel olaylar.',
    standardTitle: 'Standart olaylar',
    event: 'Olay',
    sendTo: '{{event}}: {{provider}} hizmetine gönder',
    notApplicable: 'Bu hizmette karşılığı yok',
    events: {
      view_item_list: 'Ürün listesi görüntüleme',
      select_item: 'Listeden ürün seçme',
      view_item: 'Ürün görüntüleme',
      add_to_cart: 'Sepete ekleme',
      remove_from_cart: 'Sepetten çıkarma',
      view_cart: 'Sepeti görüntüleme',
      begin_checkout: 'Ödemeye başlama',
      add_shipping_info: 'Teslimat bilgisi',
      add_payment_info: 'Ödeme bilgisi',
      purchase: 'Satın alma',
      search: 'Arama',
      sign_up: 'Üye olma',
      login: 'Giriş',
      generate_lead: 'Form gönderme (bayilik, iletişim)',
      quiz_start: 'İhtiyaç bulucuya başlama',
      quiz_step: 'İhtiyaç bulucu adımı',
      quiz_complete: 'İhtiyaç bulucu sonucu',
    },
    customTitle: 'Özel olaylar',
    customLead:
      'Belirli bir sayfanın görüntülenmesini veya telefon, e-posta, WhatsApp ve başka siteye giden bağlantılara tıklamayı ölçün. Kişisel veri gönderilmez; dış bağlantıda yalnızca alan adı gider.',
    noCustom: 'Özel olay yok.',
    name: 'Olay adı',
    nameHint: 'Küçük harf, rakam ve alt çizgi; ör. kampanya_gorundu',
    trigger: 'Ne zaman',
    triggers: {
      page_view: 'Sayfa görüntülenince',
      click_phone: 'Telefon bağlantısına tıklanınca',
      click_email: 'E-posta bağlantısına tıklanınca',
      click_whatsapp: 'WhatsApp bağlantısına tıklanınca',
      click_outbound: 'Başka siteye giden bağlantıya tıklanınca',
    },
    path: 'Sayfa yolu',
    pathHint: 'Tam yol (/kampanya/ekim) veya başlangıç için sonuna * (/kampanya/*)',
    destinations: 'Gönderilecek hizmetler',
    addTitle: 'Özel olay ekle',
    add: 'Listeye ekle',
    remove: '{{name}} olayını kaldır',
    consentNote:
      'Olaylar yalnızca çerez politikası yayımdayken ve ziyaretçi ilgili çerez türüne izin verdiyse gider (GA4: analitik; Meta ve TikTok: pazarlama). Google Ads satın alma dönüşümü etiket ayarından yönetilir.',
    save: 'Olay ayarlarını kaydet',
    saved: 'Olay ayarları kaydedildi. Vitrinde birkaç dakika içinde geçerli olur.',
  },
  credit: {
    available: 'Kalan limit: {{amount}}',
    overdue: 'Vadesi geçmiş borç: {{amount}}',
    overrideLead:
      'Cari hesap yönetimi yetkiniz var: gerekçe yazıp yeniden kaydederseniz sipariş limit aşılarak açılır (iki adımlı doğrulama; denetim kaydına yazılır).',
    overrideReason: 'Limit aşımı gerekçesi',
    summary: 'Kredi limiti {{limit}} · kalan {{available}}',
    blocked: {
      overdue: 'Vadesi geçmiş borç olduğu için açık hesap durduruldu.',
      currency: 'Limit başka para biriminde: bu para biriminde açık hesap kapalı.',
    },
    limit: 'Kredi limiti',
    limitHint: 'Boş bırakılırsa limit yok.',
    currency: 'Limit para birimi',
    blockWhenOverdue: 'Vadesi geçmiş borçta açık hesabı durdur',
    limitColumn: 'Limit / kalan',
  },
  compliance: {
    title: 'Ülke uygunluğu',
    lead: 'Ürünün ülkelerde satışa açık/kapalı durumu, kayıt/izin numarası ve teyit durumu. Kayıt eklenmeyen ülkede ürün satışa açıktır.',
    add: 'Ülke ekle',
    editTitle: 'Ülke kaydını düzenle',
    dialogLead:
      'Kapalı ürün o ülkenin pazarında vitrinde listelenmez, aramada ve feed’de görünmez, sepete eklenemez. Gerekçe ve not ziyaretçiye gösterilmez.',
    empty: 'Ülke kaydı yok',
    emptyLead:
      'Ürün tüm ülkelerde satışa açık. Bir ülkede satılamıyorsa veya kayıt/izin numarası girmek için ülke ekleyin.',
    country: 'Ülke',
    saleStatus: 'Satış durumu',
    status: { allowed: 'Satışa açık', blocked: 'Satışa kapalı' },
    allowedLead: 'Satışa açık',
    reason: 'Gerekçe',
    reasons: {
      registration_missing: 'Kayıt/izin yok veya bekleniyor',
      legal_restriction: 'Yasal kısıtlama',
      shipping_restriction: 'Kargo/gümrük kısıtı',
      business_decision: 'İşletme kararı',
      other: 'Diğer',
    },
    registrationNo: 'Kayıt / izin numarası',
    registrationHint:
      'Ör. Tarım ve Orman Bakanlığı kayıt numarası veya AB yem katkı onayı. Yalnızca teyit edilen numara vitrinde görünür.',
    registrationShort: 'Kayıt no {{no}}',
    verificationLabel: 'Teyit durumu',
    verification: { unverified: 'Teyit edilmedi', verified: 'Teyit edildi', not_required: 'Gerekmiyor' },
    verifiedAt: 'Teyit: {{date}}',
    note: 'İç not',
    confirmDelete: '{{country}} kaydı silinsin mi? Ürün bu ülkede yeniden satışa açık olur.',
  },
  fx: {
    statusTitle: 'Kur kaynağı',
    sourceLead:
      "TCMB iş günlerinde 15:30 civarında kur bülteni yayımlar; kurlar 15:40'tan sonra kendiliğinden alınır. Kur uydurulmaz: alınamazsa son geçerli kur ve tarihi kullanılır.",
    source: 'Kaynak',
    sourceName: 'TCMB gösterge niteliğindeki döviz kurları',
    bulletinLabel: 'Son bülten',
    bulletin: '{{date}} tarihli bülten',
    bulletinNo: 'bülten no {{no}}',
    noBulletin: 'Henüz kur alınmadı',
    lastSuccess: 'Son başarılı alım',
    nextAttempt: 'Sonraki deneme',
    nextAttemptNone: 'Planlanmadı (döviz kullanılınca başlar)',
    lastError: 'Son hata',
    refresh: 'Kurları şimdi güncelle',
    refreshResult: {
      updated: 'Yeni bülten alındı ({{date}}); {{count}} liste yeniden hesaplandı.',
      unchanged: 'Kurlar güncel ({{date}} bülteni).',
      throttled: 'Az önce denendi; bir dakika sonra yeniden deneyin.',
      not_needed: 'Hiçbir pazar veya fiyat listesi TL dışı para birimi kullanmıyor; kur alınmadı.',
      not_due: 'Henüz vakti gelmedi.',
      failed: "TCMB'ye ulaşılamadı: {{error}}",
    },
    stale: {
      no_data: 'Henüz kur yok; kurdan türetilmiş listeler hesaplanamaz.',
      old_bulletin: 'Kur eski: son bülten {{date}} tarihli. Fiyatlar ve siparişler bu kurla devam ediyor.',
      fetch_failing:
        'Kurlar alınamıyor ({{count}} deneme başarısız). Son geçerli kur ({{date}}) kullanılıyor.',
    },
    ratesTitle: 'Kurlar',
    ratesLead: 'Dövizin TL karşılığı; birim 1 değilse (ör. JPY 100) o kadar birimin karşılığıdır.',
    currency: 'Para birimi',
    unit: 'Birim',
    rateTypes: {
      forex_buying: 'Döviz alış',
      forex_selling: 'Döviz satış',
      banknote_buying: 'Efektif alış',
      banknote_selling: 'Efektif satış',
    },
    notPublished: 'yayımlanmadı',
    inUse: 'Kullanılıyor',
    noRates: 'Kur tablosu boş',
    noRatesLead:
      'Bir pazar veya fiyat listesi TL dışı para birimine ayarlandığında kurlar alınır; hemen almak için "Kurları şimdi güncelle".',
    derivedTitle: 'Kurdan türetilmiş fiyat listeleri',
    derivedLead: 'Fiyatlar temel listeden seçilen kurla hesaplanır; elle girilmez.',
    toPricing: 'Fiyat listelerine git',
    noDerived: 'Kurdan türetilmiş liste yok',
    noDerivedLead: 'Fiyatlar sayfasında listenin "Kurdan türet" düğmesiyle başlayın.',
    derivedFrom: '{{base}} ({{currency}}) listesinden',
    rule: '{{rateType}} · ek oran {{markup}} · fiyat sonu {{ending}}',
    auto: 'Kendiliğinden güncellenir',
    manualOnly: 'Elle hesaplanır',
    applied: '{{date}} bülteni: {{pair}} · {{count}} fiyat',
    notApplied: 'Henüz hesaplanmadı (kur yok)',
    behind: 'Son bültenle hesaplanmadı',
    recompute: 'Şimdi hesapla',
    recomputed: 'Liste son kurla hesaplandı; {{count}} fiyat değişti.',
    pair: '{{unit}} {{currency}} = {{rate}} TL',
    deriveButton: 'Kurdan türet',
    deriveTitle: '{{name}} — kurdan türet',
    deriveLead:
      'Bu listenin ({{currency}}) fiyatları temel listeden TCMB kuruyla hesaplanır. Listedeki mevcut fiyatların yerine hesaplanan fiyatlar yazılır (fiyat geçmişine kaydedilir); listeye elle fiyat girilemez.',
    lastApplied: 'Son hesap: {{date}} bülteni, {{pair}} ({{rateType}}).',
    baseList: 'Temel liste',
    baseListHint: 'Başka para birimindeki, elle fiyatlı liste. Kademeli fiyatlar da çevrilir.',
    rateType: 'Kur türü',
    markup: 'Ek oran (%)',
    markupHint: 'Kur dönüşümünden sonra uygulanır; azaltmak için eksi yazın (ör. -5).',
    markupInvalid: 'Oranı 5 veya -2,5 gibi girin.',
    autoLabel: 'Yeni bültende ve temel listede fiyat değişince kendiliğinden güncelle',
    saved: 'Kur ayarı kaydedildi; {{count}} fiyat güncellendi.',
    savedNoRate: 'Kur ayarı kaydedildi ancak liste hesaplanamadı: {{reason}}',
    clear: 'Elle fiyatlıya döndür',
    confirmClear:
      'Liste elle fiyatlı olur; mevcut fiyatlar kalır ve artık kurla güncellenmez. Devam edilsin mi?',
    cleared: 'Liste artık elle fiyatlı.',
    badge: 'Kurdan · {{base}}',
    noBaseOptions:
      'Başka para biriminde elle fiyatlı liste yok. Önce temel listeyi (ör. TL perakende) oluşturun.',
    orderRate: 'Kur',
    orderRateLine: '{{pair}} · TCMB döviz alış · {{date}} bülteni ({{no}})',
    orderRateNone: 'Sipariş anında kur yoktu (uydurulmadı).',
    orderTryEquivalent: 'TL karşılığı (sipariş anındaki kurla, bilgi amaçlı): {{amount}}',
    orderRateStale: 'Sipariş anında kur eskiydi.',
    orderListRate: '{{name}} fiyatları: {{pair}} ({{rateType}}, {{date}} bülteni)',
  },
  internationalReport: {
    csv: 'CSV indir',
    from: 'Başlangıç',
    to: 'Bitiş',
    store: 'Mağaza',
    allStores: 'Tüm mağazalar',
    note: 'Ülke, teslimat adresinin ülkesidir. Tutarlar siparişin para birimindedir; farklı para birimleri birbirine eklenmez. Brüt KDV dahildir ve iptal edilen ürünler düşülür; net = brüt − iade. İhracat: KDV istisnalı (ihracat) siparişler. TL karşılığı siparişe yazılan TCMB kuruyla hesaplanır.',
    empty: 'Bu dönemde sipariş yok',
    emptyLead: 'Taslak ve iptal edilen siparişler sayılmaz. Dönemi veya mağazayı değiştirin.',
    totalOrders: 'Sipariş',
    tryNet: 'Net (TL karşılığı)',
    exportOrders: 'İhracat siparişi',
    exportTryNet: 'İhracat net (TL karşılığı)',
    withoutRate: '{{count}} döviz siparişinde kur kaydı yok; bu siparişler TL karşılığına katılmadı.',
    caption: 'Ülke ve para birimine göre satışlar',
    country: 'Ülke',
    currency: 'Para birimi',
    orders: 'Sipariş',
    gross: 'Brüt',
    tax: 'KDV',
    shipping: 'Kargo',
    refunded: 'İade',
    net: 'Net',
    unknown: 'Adres yok',
    rowWithoutRate: '{{count}} siparişte kur yok',
    currencyTotal: 'Toplam',
  },
  dealerReports: {
    csv: 'CSV indir',
    report: 'Rapor',
    reports: {
      sales: 'Satış',
      products: 'Ürünler',
      categories: 'Kategoriler',
      aging: 'Vade dağılımı',
      collections: 'Tahsilat',
    },
    from: 'Başlangıç',
    to: 'Bitiş',
    groupBy: 'Kırılım',
    groups: { company: 'Bayi', rep: 'Temsilci', region: 'Bölge' },
    none: { company: 'Firmasız', rep: 'Temsilci atanmamış', region: 'Bölgesiz' },
    rep: 'Temsilci',
    region: 'Bölge',
    all: 'Tümü',
    noRep: 'Temsilci atanmamış',
    noRegion: 'Bölgesiz',
    notes: {
      sales:
        'Dönemde verilen bayi siparişleri (taslak ve iptal hariç). Brüt: sipariş toplamı − iptal edilen ürünler (KDV dahil). Net: brüt − iade. Ürün satışı KDV ve kargo hariçtir. Temsilci kırılımı siparişteki temsilciye, bölge bayinin bugünkü bölgesine göredir.',
      products:
        'Dönemde verilen bayi siparişlerinde ürün bazında adet ve KDV hariç satış (iptal edilen adetler düşülür).',
      categories:
        'Ürünün bağlı olduğu her kategori sayılır: ürün birden çok kategorideyse her birinde görünür; alt satır ürün satışı toplamıdır.',
      aging:
        'Bugün itibarıyla açık kalemler, vadesinin üzerinden geçen güne göre (bu sistemin cari defteri; tahsilatlar en eski vadeli borca uygulanır). BizimHesap bakiyesi bilgi sütunudur. Temsilci ve bölge bayinin bugünkü atamasıdır.',
      collections:
        'Dönemde cari hesaba yazılan tahsilatlar (ters kaydı yapılanlar hariç); "Sipariş tahsilatı" siparişte "Ödeme alındı" ile girilenlerdir.',
    },
    orders: 'Sipariş',
    dealers: 'Bayi',
    gross: 'Brüt (KDV dahil)',
    refunded: 'İade',
    net: 'Net (KDV dahil)',
    netExTax: 'Ürün satışı (KDV hariç)',
    average: 'Ortalama sipariş',
    lastOrder: 'Son sipariş',
    total: 'Toplam',
    product: 'Ürün',
    quantity: 'Adet',
    category: 'Kategori',
    noCategory: 'Kategorisiz',
    productTotal: 'Ürün satışı toplamı',
    balance: 'Bakiye',
    buckets: {
      notDue: 'Vadesi gelmemiş',
      d1_30: '1–30 gün',
      d31_60: '31–60 gün',
      d61_90: '61–90 gün',
      d90plus: '90+ gün',
    },
    bizimhesap: 'BizimHesap bakiyesi',
    oldest: 'En eski gecikme',
    days: '{{days}} gün',
    count: 'Tahsilat sayısı',
    collected: 'Toplam tahsilat',
    methods: {
      bank_transfer: 'Havale/EFT',
      cash: 'Nakit',
      card: 'Kart',
      cheque: 'Çek',
      note: 'Senet',
      other: 'Diğer',
      order: 'Sipariş tahsilatı',
    },
    emptySales: 'Bu dönemde bayi siparişi yok.',
    emptyAging: 'Açık bakiyesi olan bayi yok.',
    emptyCollections: 'Bu dönemde tahsilat yok.',
    emptyLead: 'Tarihleri veya süzgeçleri değiştirin.',
  },
  dealerCampaigns: {
    companies: 'Bayi firmaları',
    search: 'Unvan, bayi kodu veya vergi no ile arayın',
    companiesNote:
      'Firma seçildi: kampanya yalnızca bu bayilerin kullanıcılarına uygulanır (kitle bayiler). Grup ve segment seçimi de ayrıca uygulanır.',
    forCompanies: '{{count}} bayiye özel',
    couponFor: 'Yalnızca: {{names}}',
  },
  balancePayments: {
    recent: {
      title: 'Son bayi ödemeleri',
      lead: 'Bayilerin Hesabım → Cari hesabım’dan kartla yaptığı ödemeler (son 30 gün). Ödeme bayinin cari hesabına kendiliğinden işlenir; para ödeme kuruluşunun hesabınıza geçer.',
      all: 'Cari hesaplar',
      empty: 'Son {{days}} günde kartla bayi ödemesi yok.',
      email: 'Bayi ödemesinde e-posta',
      emailOn: 'Bayi ödemesinde uyarı alıcılarına e-posta gider.',
      emailOff: 'Bayi ödemesinde e-posta kapalı.',
    },
    title: 'Kartla bakiye ödemeleri',
    lead: 'Bayinin Hesabım → Cari hesabım’dan kartla yaptığı ödemeler. Alınan ödeme deftere kart tahsilatı olarak kendiliğinden yazılır.',
    reference: 'Ödeme anahtarı',
    status: 'Durum',
    card: 'Kart',
    sandbox: 'Test',
    installments: '{{count}} taksit',
    modes: { balance: 'Bakiyenin tamamı', items: 'Seçilen kalemler', custom: 'Tutar' },
    providers: { iyzico: 'iyzico', paytr: 'PayTR' },
    statuses: {
      pending: 'Bekleniyor',
      captured: 'Alındı',
      failed: 'Alınamadı',
      expired: 'Süresi doldu',
      requires_action: 'İnceleniyor',
    },
    reviewHint:
      '{{reason}} Deftere yazılmadı: ödeme kuruluşunun panelinden kontrol edin; para alındıysa Tahsilat gir ile kart tahsilatı girin.',
    reasons: {
      amount_mismatch: 'Ödeme kuruluşunun bildirdiği tutar farklı.',
      amount_unverified: 'Tutar doğrulanamadı.',
      currency_mismatch: 'Para birimi farklı.',
      provider_review: 'Ödeme kuruluşu inceliyor.',
      provider_review_stale: 'Ödeme kuruluşunun incelemesi uzun sürdü.',
      provider_unreachable: 'Ödeme kuruluşuna ulaşılamadı.',
      test_mode_payment: 'Canlı ortamda test işlemi.',
      other: 'Sonuç kesinleşmedi.',
    },
  },
  bankImport: {
    open: 'Banka hareketi yükle',
    back: 'Cari hesaplara dön',
    columns:
      'Bankanızın hesap hareketleri dökümünü CSV veya Excel (XLSX) olarak yükleyin. Gerekli sütunlar: Tarih ve Tutar (ya da ayrı Alacak/Borç). Açıklama, Gönderen ve Dekont No varsa eşleştirmede kullanılır. Yalnızca gelen hareketler alınır.',
    file: 'Banka dökümü',
    summary:
      '{{incoming}} gelen hareket: {{matched}} bayiyle eşleşti, {{ambiguous}} birden çok aday, {{unmatched}} eşleşmedi, {{blocked}} yazılamaz. {{outgoing}} giden hareket atlandı.',
    validUntil: 'Önizleme {{time}} saatine kadar geçerli.',
    tableCaption: 'Banka hareketleri ve önerilen bayiler',
    pick: 'Seç',
    pickRow: 'Satır {{line}} deftere yazılsın',
    date: 'Tarih',
    description: 'Açıklama',
    amount: 'Tutar',
    dealer: 'Bayi',
    dealerFor: 'Satır {{line}} için bayi',
    matchColumn: 'Eşleşme',
    reference: 'Dekont {{ref}}',
    line: 'Dosya satırı {{line}}',
    chooseDealer: 'Bayi seçin',
    candidates: 'Adaylar',
    allDealers: 'Tüm bayiler',
    match: {
      order: 'Sipariş {{number}}',
      code: 'Bayi kodu',
      bizimhesap: 'BizimHesap kodu',
      tax: 'Vergi no',
      name: 'Unvan benzerliği — kontrol edin',
      ambiguous: 'Birden çok aday',
      none: 'Eşleşmedi',
    },
    issues: {
      amount_invalid: 'Tutar okunamadı',
      date_invalid: 'Tarih okunamadı',
      date_in_future: 'İleri tarihli',
      duplicate: 'Daha önce deftere yazıldı',
    },
    apply: 'Seçilenleri deftere yaz ({{count}} hareket · {{total}})',
    missingDealer: 'Seçilen her satır için bayi seçin.',
    applied: '{{count}} tahsilat deftere yazıldı.',
    appliedWithBh:
      '{{count}} tahsilat deftere yazıldı; {{queued}} tanesi BizimHesap tahsilat kuyruğuna girdi.',
    alreadyApplied: 'Bu döküm deftere yazıldı. Yeni hareketler için dökümü yeniden yükleyin.',
  },
  ledger: {
    import: 'Açılış bakiyesi aktar',
    importLead:
      'Eski muhasebenizdeki bayi bakiyelerini dosyayla aktarın. Önce önizleme gösterilir; deftere ancak onaylayınca yazılır.',
    importColumns:
      'Sütunlar: Bayi kodu veya Vergi no (eşleştirme), Tutar (bayinin borcu artı, alacağı eksi), isteğe bağlı Para birimi (boşsa TRY), Tarih, Vade ve Açıklama. CSV (noktalı virgül) veya Excel.',
    importFile: 'Dosya',
    importSummary: '{{valid}} satır aktarılacak, {{invalid}} satır hatalı (atlanır). Toplam: {{totals}}',
    importAlready:
      'Bu dosyadaki {{count}} bayinin defterinde zaten açılış bakiyesi var. Aynı bakiyeyi iki kez aktarmadığınızdan emin olun.',
    importApply: '{{count}} satırı deftere yaz',
    importApplied: '{{count}} açılış bakiyesi kaydı deftere yazıldı.',
    importPreview: 'Açılış bakiyesi önizlemesi',
    importLine: 'Satır',
    importStatus: 'Durum',
    importOk: 'Aktarılacak',
    importErrors: {
      dealer_key_required: 'Bayi kodu veya vergi no yok.',
      dealer_not_found: 'Bayi bulunamadı.',
      currency_invalid: 'Para birimi geçersiz (ör. TRY, EUR).',
      amount_invalid: 'Tutar okunamadı.',
      amount_zero: 'Tutar sıfır.',
      date_invalid: 'Tarih okunamadı.',
      date_in_future: 'Tarih ileri bir gün.',
      due_date_invalid: 'Vade okunamadı.',
    },
    totals: 'Toplamlar',
    totalBalance: 'Toplam bakiye ({{currency}})',
    totalOverdue: 'Vadesi geçen: {{amount}}',
    search: 'Bayi ara',
    onlyOverdue: 'Yalnızca vadesi geçenler',
    empty: 'Cari hareketi olan bayi yok',
    emptyLead:
      'Açık hesapla (vadeli) verilen siparişler bayinin cari hesabına kendiliğinden yazılır. Eski bakiyeler için "Açılış bakiyesi aktar"ı kullanın.',
    listCaption: 'Bayi cari hesapları',
    dealer: 'Bayi',
    balance: 'Bakiye',
    overdue: 'Vadesi geçen',
    notDue: 'Vadesi gelmemiş',
    oldestOverdue: 'En eski vade',
    daysOverdue: '{{date}} ({{days}} gün geçti)',
    lastEntry: 'Son hareket',
    companyTitle: '{{name}} — cari hesap',
    toDealer: 'Bayi kartı',
    term: 'Vade: siparişten sonra {{days}} gün. Bakiye artıysa bayi borçlu, eksiyse alacaklıdır.',
    noEntries: 'Henüz cari hareket yok',
    noEntriesLead: 'Açık hesap siparişi, tahsilat veya açılış bakiyesi girildiğinde burada görünür.',
    statement: 'Ekstre',
    csv: 'Ekstre indir (CSV)',
    print: 'Yazdır',
    currency: 'Para birimi',
    from: 'Başlangıç',
    to: 'Bitiş',
    date: 'Tarih',
    kind: 'Tür',
    description: 'Açıklama',
    dueDate: 'Vade',
    debit: 'Borç',
    credit: 'Alacak',
    actions: 'İşlemler',
    broughtForward: 'Devir (dönem başı bakiye)',
    periodTotal: 'Dönem toplamı / kapanış bakiyesi',
    reversedBadge: 'Ters çevrildi',
    kinds: {
      order: 'Sipariş',
      order_change: 'Sipariş değişikliği',
      order_payment: 'Sipariş tahsilatı',
      payment: 'Tahsilat',
      opening: 'Açılış bakiyesi',
      adjustment: 'Düzeltme',
      reversal: 'Ters kayıt',
    },
    reasons: {
      placed: 'Sipariş verildi',
      cancelled: 'İptal',
      partial_cancel: 'Kısmi iptal',
      edited: 'Sipariş düzenlendi',
      refunded: 'İade',
      paid: 'Ödeme alındı',
      refund_paid: 'İade ödemesi',
      changed: 'Tutar değişti',
      card_balance: 'Hesabım’dan kartla ödeme',
    },
    methods: {
      bank_transfer: 'Havale/EFT',
      cash: 'Nakit',
      cheque: 'Çek',
      note: 'Senet',
      card: 'Kart',
      other: 'Diğer',
    },
    payment: 'Tahsilat gir',
    paymentLead:
      'Bayiden alınan ödeme alacak olarak yazılır ve en eski vadeli borca uygulanır. Bayi BizimHesap’a bağlıysa havale, nakit ve kart tahsilatı BizimHesap tahsilat kuyruğuna da girer (BizimHesap’a yazma açıksa hemen gönderilir).',
    paymentSaved: 'Tahsilat kaydedildi.',
    adjustment: 'Düzeltme gir',
    adjustmentLead: 'Bayinin borcunu artıran veya azaltan elle kayıt. Açıklama zorunludur.',
    adjustmentSaved: 'Düzeltme kaydedildi.',
    direction: 'Yön',
    directions: { debit: 'Borç (bayinin borcu artar)', credit: 'Alacak (bayinin borcu azalır)' },
    amount: 'Tutar',
    amountIn: 'Tutar ({{currency}})',
    amountInvalid: 'Tutar okunamadı (ör. 1.250,50).',
    entryDate: 'Kayıt tarihi',
    method: 'Ödeme şekli',
    reference: 'Belge no',
    reverse: 'Ters kayıt',
    reverseTitle: 'Ters kayıt',
    reverseLead:
      '{{kind}} kaydı ({{amount}}) aynı tutarın tersiyle kapatılır. Kayıt silinmez; ikisi de ekstrede görünür.',
    reverseReason: 'Neden',
    reversed: 'Ters kayıt yapıldı.',
    openItems: 'Açık kalemler',
    openItemsLead:
      'Kapanmamış borçlar, en eski vade önce. Tahsilatlar en eski vadeli borçtan başlayarak düşülür.',
    openItem: 'Sipariş / kayıt',
    original: 'Tutar',
    open: 'Kalan',
    reminders: {
      title: 'Vade hatırlatması',
      lead: 'Vadesi yaklaşan ve vadesi geçen borçlar için bayilere her sabah e-posta. Varsayılan kapalıdır.',
      noMail:
        'E-posta altyapısı kurulu değil (Kurulum Gerekli): hatırlatma açık olsa da e-posta gönderilmez. Entegrasyonlar sayfasından bir e-posta sağlayıcısı (SMTP, Amazon SES, SendGrid veya Postmark) bağlayın.',
      enabled: 'Bayilere vade hatırlatması gönder',
      daysBefore: 'Vadeden kaç gün önce',
      daysInvalid: '0 ile 30 arasında bir gün sayısı yazın.',
      confirm:
        'Açık kalemi olan bayilerime (firma e-postası ve firma Yetkilileri) her sabah gerçek e-posta gönderileceğini onaylıyorum.',
      saved: 'Vade hatırlatması ayarı kaydedildi.',
    },
  },
  sales: {
    sectionTitle: 'Satış temsilcisi ve bölge',
    sectionLead:
      'Temsilci ve bölge sorumlusu, bayi kapsamları "yalnızca atanan bayiler" ise bu bayiyi, kullanıcılarını, siparişlerini ve tekliflerini görür.',
    rep: 'Satış temsilcisi',
    region: 'Satış bölgesi',
    noRep: 'Temsilci yok',
    noRegion: 'Bölge yok',
    saveAssignment: 'Atamayı kaydet',
    repLabel: 'Temsilci: {{name}}',
    regionLabel: 'Bölge: {{name}}',
    newRegion: 'Bölge ekle',
    editRegion: '{{name}} bölgesini düzenle',
    saveRegion: 'Bölgeyi kaydet',
    regionSaved: 'Bölge kaydedildi.',
    regionDeleted: 'Bölge silindi.',
    emptyRegions: 'Henüz satış bölgesi yok',
    emptyRegionsLead:
      'İl/ilçe gruplarından bölge oluşturun, sorumlu atayın; bayileri il/ilçesine göre bölgeye toplayın.',
    regionsTable: 'Satış bölgeleri',
    regionName: 'Bölge adı',
    places: 'İller ve ilçeler',
    manager: 'Bölge sorumlusu',
    noManager: 'Sorumlu yok',
    dealerCount: 'Bayi',
    morePlaces: 've {{count}} yer daha',
    confirmDelete:
      '{{name}} bölgesi silinsin mi? {{count}} bayinin bölgesi boşalır; bayiler ve siparişler etkilenmez.',
    city: 'İl',
    district: 'İlçe',
    wholeCity: 'İlin tamamı',
    addPlace: 'Ekle',
    chosenPlaces: 'Bölgedeki iller ve ilçeler',
    removePlace: '{{place}} bölgeden çıkar',
    noPlaces: 'Henüz il/ilçe eklenmedi.',
    autoAssign: 'İl/ilçeye göre ata',
    autoAssignLead:
      'Bayilerin kayıtlı il/ilçesi bölgelerle eşleştirilir: önce ilçe, yoksa ilin tamamı. Önce önizleme gösterilir; hiçbir şey yazılmaz.',
    reassignAll: 'Bölgesi olan bayileri de yeniden eşleştir',
    previewAssign: 'Önizle',
    previewSummary:
      '{{assigned}} bayi bölgeye atanacak; {{unmatched}} bayinin il/ilçesi hiçbir bölgeye uymuyor.',
    applyAssign: '{{count}} bayiyi ata',
    autoAssigned: '{{count}} bayi bölgeye atandı.',
  },
  bizimhesap: {
    reversedFixAtBh: 'Defterde ters kaydı yapıldı; tahsilatı BizimHesap’ta elle düzeltin.',
    ledgerEntry: 'BizimHesap tahsilatı {{number}}: {{status}}',
    statement: {
      title: 'BizimHesap ekstresi',
      lead: 'Cari hesabın ana kaydı BizimHesap’tır: bakiye ekstrenin son yürüyen bakiyesidir. Kredi limiti bu bakiye ile BizimHesap’a henüz aktarılmamış açık hesap siparişlerinin toplamıyla denetlenir. Ekstre 30 dakikada bir (hareketsiz bayide 6 saatte bir) çekilir.',
      notLinked: 'Bayi BizimHesap carisine bağlı değil. Bağlamak için:',
      balance: 'BizimHesap bakiyesi',
      pending: 'Aktarılmamış siparişler',
      effective: 'Kredi limitinde kullanılan',
      fetchedAt: 'Son güncelleme {{date}}',
      neverFetched: 'Henüz çekilmedi',
      lastError: 'Son deneme başarısız: {{error}}',
      refreshOne: 'Bu bayiyi güncelle',
      refreshed: 'Ekstre BizimHesap’tan güncellendi.',
      pendingOrders: 'BizimHesap’a henüz aktarılmamış açık hesap siparişleri: {{orders}}',
      rows: 'BizimHesap ekstre satırları',
      date: 'Tarih',
      type: 'Tür',
      note: 'Açıklama',
      debit: 'Borç',
      credit: 'Alacak',
      running: 'Bakiye',
      sources: {
        field: 'Bakiye ekstrenin üst alanından okundu (satır bakiyesi yok)',
        sums: 'Bakiye borç − alacak toplamından hesaplandı',
        rows: 'Bakiye satırlardan hesaplandı',
      },
      creditSource: 'Kredi limiti BizimHesap bakiyesi + aktarılmamış siparişlerle denetleniyor.',
    },
    diff: {
      title: 'BizimHesap bakiyeleri ve fark raporu',
      lead: 'BizimHesap’a bağlı her bayi için BizimHesap bakiyesi, henüz aktarılmamış açık hesap siparişleri ve bu sistemdeki cari defter bakiyesi. Fark = BizimHesap + aktarılmamış − defter (büyük fark önce).',
      refreshAll: 'Şimdi güncelle',
      queued: '{{count}} bayinin ekstresi sıraya alındı; birkaç dakika içinde güncellenir.',
      bizimhesap: 'BizimHesap',
      pending: 'Aktarılmamış',
      ledger: 'Defter',
      diff: 'Fark',
      updated: 'Son güncelleme',
    },
    dealerTitle: 'BizimHesap carisi',
    dealerLead:
      'Bu bayinin faturası ve tahsilatı BizimHesap’ta bu cari koduna yazılır; cari hesabın ana kaydı BizimHesap’tır. Kod BizimHesap cari listesinde doğrulanır.',
    notLinked: 'Bağlı değil — faturası gönderilmez',
    linkedAt: 'Bağlanma',
    link: 'Bağla',
    unlink: 'Bağlantıyı kaldır',
    notConnected:
      'BizimHesap bağlantısı yok veya test edilmedi (Kurulum Gerekli). Firma kimliğini girip "Bağlantıyı test et" deyin:',
    cashTitle: 'Kasa eşlemesi',
    cashLead:
      'Ödenmiş siparişin faturası, ödeme yönteminin kasasıyla gönderilir; BizimHesap tahsilatı bu kasaya yazar. Açık hesap (vadeli) siparişte kasa gönderilmez, tutar cari borç olarak kalır.',
    cashiersRefreshed: 'Kasa listesi güncellendi.',
    cashiersAt: 'BizimHesap’tan {{count}} kasa · {{date}}',
    cashiersNever: 'Kasa listesi henüz çekilmedi.',
    refreshCashiers: 'Kasa listesini getir',
    cashKeys: {
      card: 'Kartla ödeme',
      bank_transfer: 'Havale/EFT',
      cash_on_delivery: 'Kapıda ödeme',
      manual: 'Elle ödeme (panel)',
      cash: 'Nakit tahsilat (cari)',
    },
    noCash: 'Kasa seçilmedi',
    cashRule:
      'Kasası seçilmemiş yöntemle ödenmiş siparişin faturası gönderilmez (kasasız fatura BizimHesap’ta tahsilatsız görünür).',
    saveCash: 'Kasa eşlemesini kaydet',
    linksTitle: 'Bayi ↔ BizimHesap carisi',
    linksLead:
      'Bayi siparişinin faturası ve tahsilatı bayinin BizimHesap cari koduna yazılır. Eşleştirme cari listesinden: önce bayi kodu = cari kodu, yoksa vergi numarası. Bağlı olmayan bayinin faturası gönderilmez.',
    dealers: 'Bayi',
    linked: 'BizimHesap’a bağlı',
    customersCheck: 'Gece cari listesi kontrolü',
    customersCheckResult: 'Bağlı kodu listede bulunmayan bayi: {{missing}}',
    importCustomers: 'Carileri içe aktar',
    linkedDone: '{{count}} bayi BizimHesap carisine bağlandı.',
    previewSummary:
      'Eşleşen {{matched}} · belirsiz {{ambiguous}} · BizimHesap’ta olmayan {{unmatched}} · zaten bağlı {{linked}}. BizimHesap’ta hiçbir bayiye eşleşmeyen {{other}} cari (perakende olabilir) değişmez.',
    applyLinks: '{{count}} eşleşmeyi kaydet',
    groupMatched: 'Eşleşenler (kaydetmek için işaretli)',
    byCode: 'bayi kodu',
    byTax: 'vergi no',
    groupAmbiguous: 'Belirsiz: birden çok aday',
    leaveUnlinked: 'Bağlama',
    groupUnmatched: 'BizimHesap’ta bulunamayanlar',
    unmatchedLead:
      'Bu bayiler için BizimHesap’ta cari açılmalı. Cari ekleme (AddCustomer) BizimHesap’a yazar ve varsayılan kapalıdır; o zamana kadar cariyi BizimHesap’ta açıp listeyi yeniden içe aktarın.',
    linkMissing: 'bağlı kod ({{code}}) listede yok',
    alreadyLinked: '{{count}} bayi zaten bağlı.',
    writesTitle: 'BizimHesap’a yazma',
    writesLead:
      'Bu adımlar gerçek BizimHesap hesabınıza kayıt yazar ve varsayılan kapalıdır. Kapalıyken kayıtlar burada bekler; açınca elle gönderilir.',
    writeKeys: {
      collections: 'Tahsilat gönder (AddCollection)',
      customers: 'Cari ekle (AddCustomer)',
      cancel: 'Fatura iptali (CancelInvoice)',
    },
    writesConfirm: 'Açtığım adımların gerçek BizimHesap hesabıma kayıt yazacağını onaylıyorum.',
    saveWrites: 'Yazma ayarını kaydet',
    writesOwnerOnly: 'Bu ayarı işletme sahibi veya yönetici değiştirir.',
    correctionsTitle: 'Kasasız gönderilmiş ödenmiş siparişler',
    correctionsLead:
      'Daha önce kasa kimliği olmadan gönderilmiş, ödemesi alınmış siparişler: BizimHesap’ta tahsilatları görünmez. İşaretleyip tahsilat kaydı açın; gönderim sahibin onayıyla açılan yazma ayarına bağlıdır.',
    queued: '{{count}} tahsilat kaydı açıldı.',
    noCorrections: 'Düzeltilecek fatura yok.',
    method: 'Ödeme yöntemi',
    customerCode: 'Cari kodu',
    sentAt: 'Fatura gönderimi',
    amount: 'Tutar',
    collection: 'Tahsilat',
    pickCorrection: '{{number}} siparişini seç',
    cashMissing: 'Kasa seçilmemiş',
    statuses: {
      pending: 'Bekliyor',
      sending: 'Gönderiliyor',
      sent: 'Gönderildi',
      failed: 'Başarısız',
      uncertain: 'Belirsiz',
      cancelled: 'İptal',
    },
    queueCorrections: 'Seçilenler için tahsilat kaydı aç ({{count}})',
    writesOffNote: 'BizimHesap’a tahsilat yazma kapalı: kayıtlar gönderilmeden bekler.',
    collectionsTitle: 'Tahsilat kuyruğu',
    collectionsLead:
      'BizimHesap’a gidecek ve gitmiş tahsilatlar. Tahsilat numarası (ZT-TAH-…) BizimHesap’ta not alanına yazılır; yanıt gelmezse durum "belirsiz" olur ve ekstrede bu numara aranarak kontrol edilir — kör tekrar yapılmaz.',
    sent: 'Tahsilat BizimHesap’a gönderildi.',
    sendResult: {
      uncertain: 'BizimHesap yanıt vermedi: tahsilat oluşmuş olabilir. Ekstreden kontrol edin.',
      failed: 'BizimHesap tahsilatı reddetti; hata satırda.',
    },
    checkFound: 'Ekstrede tahsilat numarası bulundu: gönderildi olarak işaretlendi.',
    checkNotFound: 'Ekstrede bulunamadı: yeniden gönderebilirsiniz.',
    noCollections: 'Tahsilat kaydı yok.',
    collectionNumber: 'Tahsilat no',
    account: 'Cari',
    paymentType: 'Tür',
    status: 'Durum',
    sources: {
      order_correction: 'Fatura düzeltmesi',
      ledger_payment: 'Panel tahsilatı',
      balance_payment: 'Kartla bakiye ödemesi',
    },
    paymentTypes: { 1: 'Nakit', 2: 'Kredi kartı', 3: 'Havale/EFT' },
    send: 'Gönder',
    cancelCollection: 'Kaydı iptal et',
    checkStatement: 'Ekstreden kontrol et',
    collectionActionsNote:
      'Gönder, Ekstreden kontrol et ve Kaydı iptal et işlemleri denetim kaydına yazılır.',
    cancelled: 'Tahsilat kaydı iptal edildi.',
    cancelTitle: '{{number}} kaydını iptal et',
    cancelLead: 'Kayıt BizimHesap’a gönderilmez. Tahsilatı BizimHesap’a elle girdiyseniz bunu not edin.',
    cancelNote: 'Gerekçe',
    sampleReset: 'Örnek silindi; sonraki gerçek yanıt yeniden saklanacak.',
    samplesTitle: 'BizimHesap yanıt örnekleri',
    samplesLead:
      'Cari listesi, ekstre ve kasa listesi yanıtlarının alan yapısı BizimHesap belgesinde yok. İlk gerçek yanıt kişisel veriler maskelenerek burada saklanır; alan eşlemesi buna göre doğrulanır.',
    endpoints: {
      customers: 'Cari listesi (customers)',
      abstract: 'Ekstre (abstract)',
      cashiers: 'Kasa listesi (cashiers)',
    },
    sampleAt: 'alındı {{date}}',
    sampleNone: 'henüz yok',
    copySample: 'Kopyala',
    copied: 'Kopyalandı.',
    resetSample: 'Örneği sil',
  },
  commissions: {
    rules: 'Komisyon kuralları',
    rulesLead:
      'Oran, siparişin KDV ve kargo hariç net tutarına uygulanır. Bir satıra en özel kural uyar: temsilciye özel kural genel kuraldan, ürün kuralı kategoriden, kategori kuralı tüm ürünlerden önce gelir.',
    newRule: 'Kural ekle',
    editRule: '{{name}} kuralını düzenle',
    saveRule: 'Kuralı kaydet',
    ruleSaved: 'Komisyon kuralı kaydedildi.',
    ruleDeleted: 'Komisyon kuralı silindi.',
    confirmDeleteRule:
      '{{name}} kuralı silinsin mi? Hesaplanmış siparişlerin oranı değişmez; yeni siparişlere uygulanmaz.',
    noRules: 'Henüz komisyon kuralı yok',
    noRulesLead:
      'Tüm temsilciler için genel bir oranla başlayın; gerekirse temsilciye veya ürüne özel kural ekleyin.',
    ruleName: 'Kural adı',
    rep: 'Temsilci',
    allReps: 'Tüm temsilciler',
    scope: 'Kapsam',
    allProducts: 'Tüm ürünler',
    categoryCount: '{{count}} kategori',
    productCount: '{{count}} ürün',
    rate: 'Oran',
    rateHint: 'Yüzde olarak; ör. 5 veya 2,5. En çok %50.',
    rateInvalid: '0 ile 50 arasında bir yüzde yazın (ör. 2,5).',
    validity: 'Geçerlilik',
    always: 'Süresiz',
    validFrom: 'Başlangıç günü',
    validTo: 'Bitiş günü',
    categories: 'Kategoriler',
    products: 'Ürünler',
    activeLabel: 'Kural etkin',
    inactive: 'Kapalı',
    statements: 'Aylık dökümler',
    statementsLead:
      'Dönemi hesaplayınca her temsilci için taslak döküm oluşur. Komisyon tahsil edilen tutar kadar yazılır; sonraki aylarda iade, iptal ve geç tahsilat düzeltme satırı olarak gelir.',
    period: 'Dönem (ay)',
    calculate: 'Dönemi hesapla',
    calculated: '{{count}} temsilci için döküm hazırlandı; onaylı {{locked}} döküm korundu.',
    downloadCsv: 'CSV indir',
    noStatements: 'Bu dönem için döküm yok. Dönemi hesaplayın.',
    orders: 'Sipariş',
    base: 'Taban (KDV hariç)',
    commission: 'Komisyon',
    status: 'Durum',
    statuses: { draft: 'Taslak', approved: 'Onaylandı', paid: 'Ödendi' },
    details: 'Ayrıntı',
    approve: 'Onayla',
    approved: 'Döküm onaylandı.',
    markPaid: 'Ödendi işaretle',
    markPaidTitle: '{{name}} — ödendi işaretle',
    markPaidLead:
      'Ödeme sistem dışında (havale, bordro) yapılır; burada yalnızca kaydı tutulur. Ödendi işaretlenen döküm değiştirilemez.',
    paidNote: 'Ödeme notu',
    paidDone: 'Döküm ödendi olarak işaretlendi.',
    detailTitle: '{{name}} — {{period}}',
    calculatedAt: 'Hesaplanma: {{date}}',
    entries: 'Döküm satırları',
    kind: 'Tür',
    kinds: { accrual: 'Tahakkuk', adjustment: 'Düzeltme' },
    collected: 'Tahsil oranı',
    ownOnly: 'Yalnızca kendi dökümlerinizi görüyorsunuz.',
  },
  quotes: {
    new: 'Yeni teklif',
    newLead:
      'Teklif hazırlanacak bayiyi seçin. Teklif üst çubuktaki çalışılan mağazada açılır; fiyatlar bayinin grubuna göre gelir.',
    create: 'Teklif oluştur',
    changeDealer: 'Bayiyi değiştir',
    status: 'Durum',
    search: 'Teklif no veya bayi',
    empty: 'Teklif yok',
    emptyLead: 'Bayiler sepetten teklif isteyebilir; siz de "Yeni teklif" ile hazırlayabilirsiniz.',
    listCaption: 'Teklifler',
    number: 'Teklif no',
    dealer: 'Bayi',
    total: 'Toplam',
    validUntil: 'Geçerlilik (son gün)',
    validUntilShort: 'son gün {{date}}',
    createdAt: 'Oluşturma',
    expired: 'Süresi doldu',
    statuses: {
      requested: 'İstek',
      draft: 'Taslak',
      sent: 'Gönderildi',
      ordered: 'Siparişe dönüştü',
      rejected: 'Reddedildi',
      cancelled: 'İptal',
    },
    title: 'Teklif {{number}}',
    backToList: 'Teklif listesi',
    print: 'Yazdır',
    send: 'Gönder',
    resend: 'Yeni sürümü gönder',
    cancel: 'Teklifi iptal et',
    saved: 'Teklif kaydedildi.',
    sentEmailed: 'Teklif gönderildi; bayiye e-posta gitti.',
    sentNoEmail:
      'Teklif gönderildi; bayi Hesabım’da görür. E-posta altyapısı kurulu olmadığı için e-posta gitmedi (Kurulum Gerekli).',
    summary: 'Özet',
    requester: 'İsteyen',
    requestNote: 'Bayinin notu',
    version: 'Gönderilen sürüm',
    versionValue: '{{version}}. sürüm',
    rejectReason: 'Ret gerekçesi',
    cancelReason: 'İptal gerekçesi',
    order: 'Sipariş',
    openOrder: 'Siparişi aç',
    editResetsLead:
      'Gönderilmiş teklifi değiştirip kaydederseniz teklif taslağa döner; bayi yeni sürümü siz gönderene kadar kabul edemez.',
    lines: 'Ürünler',
    linesLead:
      'Birim fiyat bayinin fiyat listesindeki gibi (KDV dahil/hariç) girilir; boş bırakılırsa bayinin liste fiyatı kullanılır.',
    product: 'Ürün',
    qty: 'Adet',
    listPrice: 'Liste fiyatı',
    unitPrice: 'Teklif fiyatı',
    lineTotal: 'Tutar (KDV dahil)',
    taxIncluded: 'KDV: {{tax}}',
    saving: 'Liste fiyatına göre indirim: {{amount}}',
    saveToRecalc: 'Satır ve fiyat değişikliklerinin tutarı kaydedince hesaplanır.',
    terms: 'Koşullar',
    note: 'Bayiye not',
    noteHint: 'Teklifte görünür',
    internalNote: 'İç not',
    internalNoteHint: 'Yalnızca panelde',
    versions: 'Gönderilen sürümler',
    cancelTitle: 'Teklifi iptal et',
    cancelLead: 'İptal edilen teklif bayi tarafından kabul edilemez. Gerekçe panelde kalır.',
    cancelled: 'Teklif iptal edildi.',
  },
  locations: {
    title: 'Lokasyonlar',
    lead: 'Bayinin şube, teslimat ve fatura adresleri. Bayi kullanıcıları ödeme adımında seçer; firma Yetkilisi vitrinden de ekleyebilir.',
    add: 'Lokasyon ekle',
    edit: 'Lokasyonu düzenle',
    empty: 'Lokasyon yok',
    emptyLead: 'Şubesi veya ayrı teslimat/fatura adresi olan bayiler için lokasyon ekleyin.',
    label: 'Lokasyon adı',
    contact: 'Teslim alacak kişi',
    postalCode: 'Posta kodu',
    defaultShipping: 'Varsayılan teslimat',
    defaultBilling: 'Varsayılan fatura',
    makeDefaultShipping: 'Varsayılan teslimat adresi yap',
    makeDefaultBilling: 'Varsayılan fatura adresi yap',
    saved: 'Lokasyon kaydedildi.',
    deleted: 'Lokasyon silindi.',
    confirmDelete: '"{{name}}" lokasyonu silinsin mi? Geçmiş siparişlerdeki adres değişmez.',
    fill: 'Firma lokasyonundan doldur',
    choose: 'Lokasyon seçin',
  },
  retention: {
    rulesTitle: 'Otomatik imha kuralları',
    rulesLead:
      'Açık kurallar her gece 03:40’ta çalışır ve saklama süresi dolan kayıtları kalıcı olarak siler. Hepsi varsayılan olarak kapalıdır. Süreler önerilen değerlerdir; avukatınızla teyit edin.',
    colData: 'Veri',
    colDays: 'Saklama süresi (gün)',
    colDue: 'Bugün silinecek',
    colEnabled: 'Otomatik imha',
    daysLabel: '{{name}}: saklama süresi (gün)',
    daysRange: '{{min}}–{{max}} gün; önerilen {{def}}',
    dueValue: '{{n}} kayıt',
    enabledLabel: '{{name}}: otomatik imha',
    on: 'Açık',
    off: 'Kapalı',
    saved: 'Saklama kuralları kaydedildi.',
    lastRun: 'Son imha: {{day}}',
    noRunYet: 'Henüz imha yapılmadı.',
    confirmTitle: 'Otomatik imhayı aç',
    confirmLead:
      'Açılan kurallar her gece çalışır. Saklama süresi dolan kayıtlar geri alınamaz şekilde silinir ve imha kaydına yazılır.',
    confirmRow: '{{days}} gün: ilk çalışmada {{n}} kayıt silinecek',
    confirmRowUnknown: '{{days}} gün: silinecek kayıt sayısı hesaplanamadı',
    confirmAck: 'Süresi dolan kayıtların her gece geri alınamaz şekilde silineceğini anlıyorum.',
    confirmButton: 'Aç ve kaydet',
    fixedTitle: 'Sabit saklama süreleri',
    fixedLead:
      'Bu kayıtlar ilgili özelliğin kendi süresi dolunca silinir ve imha kaydına yazılır. Canlı sohbetin süresi Canlı sohbet ayarlarından değişir.',
    colRetention: 'Saklama süresi',
    days: '{{n}} gün',
    logTitle: 'İmha kaydı',
    logLead:
      'Silinen veya anonimleştirilen kişisel veri: gün, veri türü, yöntem ve kayıt sayısı. Kayıt kişisel veri içermez ve silinmez.',
    period: 'Dönem',
    lastDays: 'Son {{n}} gün',
    colDay: 'Gün',
    colRule: 'Veri türü',
    colMethod: 'Yöntem',
    colCount: 'Kayıt',
    methods: { delete: 'Silme', anonymize: 'Anonimleştirme' },
    byRequest: 'Başvuru üzerine',
    logEmpty: 'Bu dönemde imha yapılmadı',
    logEmptyLead:
      'Süresi dolan kayıt silindiğinde veya bir başvuru üzerine veri anonimleştirildiğinde burada görünür.',
    rules: {
      carts: 'Sepetler',
      pending_subscribers: 'Onaylanmamış bülten kayıtları',
      unsubscribed_subscribers: 'Aboneliği biten bülten kayıtları',
      integration_logs: 'Entegrasyon günlükleri',
      support_tickets: 'Çözülmüş destek talepleri',
      form_submissions: 'İletişim formu mesajları',
      chat_conversations: 'Kapanmış canlı sohbetler',
      email_campaign_recipients: 'E-posta kampanyası alıcı kayıtları',
      automation_runs: 'Biten otomasyon kayıtları',
      stock_alerts: 'Kapanan "gelince haber ver" talepleri',
      price_drop_notices: 'Fiyat düşüşü bildirimleri',
      message_recipients: 'SMS/WhatsApp kampanya alıcı kayıtları',
      push_deliveries: 'Tarayıcı bildirimi gönderim kayıtları',
      push_subscriptions: 'Sona eren tarayıcı bildirimi abonelikleri',
      staff_notifications: 'Çalışan bildirimleri',
      staff_devices: 'Kullanılmayan çalışan cihazları',
      server_events: 'Sunucu taraflı ölçüm olayları',
      privacy_request: 'KVKK başvurusu (kişinin verileri)',
    },
    ruleLeads: {
      carts: 'Siparişe dönüşmüş veya bırakılmış sepetler; son değişiklikten itibaren.',
      pending_subscribers: 'Onay bağlantısı açılmamış (izin oluşmamış) kayıtlar; kayıttan itibaren.',
      unsubscribed_subscribers:
        'Bültenden çıkanların kayıtları; çıkıştan itibaren. İzin kayıtları izin bittikten sonra 3 yıl saklanır; adres engel listesinde kalır.',
      integration_logs: 'Dış hizmet bağlantılarının günlükleri (maskeli özet).',
    },
  },
  questions: {
    filter: 'Durum',
    statuses: { pending: 'Yanıt bekleyen', published: 'Yayında', rejected: 'Reddedilen' },
    empty: {
      pending: 'Yanıt bekleyen soru yok',
      published: 'Yayında soru yok',
      rejected: 'Reddedilen soru yok',
    },
    answered: 'Yanıt yazıldı',
    unanswered: 'Yanıt yok',
    detailTitle: 'Ürün sorusu',
    back: 'Tüm sorular',
    question: 'Soru',
    meta: '{{author}} · {{date}}',
    answer: 'Yanıt',
    answerLead: 'Yanıt ürün sayfasında mağaza adıyla görünür.',
    answerLabel: 'Yanıtınız',
    answeredBy: 'Son yanıtlayan: {{name}}, {{date}}',
    save: 'Yanıtı kaydet',
    saved: 'Yanıt kaydedildi',
    saveFirst: 'Yayımlamadan önce yanıtı kaydedin.',
    publish: 'Yayımla',
    publishedToast: 'Soru yayımlandı',
    notified: 'Müşteriye yanıt e-postası gönderildi: {{date}}',
    rejectTitle: 'Reddet',
    rejectLead: 'Soru vitrinde gösterilmez; müşteriye bildirim gitmez.',
    rejectNote: 'Gerekçe (yalnızca panelde)',
    reject: 'Reddet',
    unpublish: 'Yayından kaldır',
    rejectConfirm: 'Soru vitrinde gösterilmeyecek. Devam edilsin mi?',
    rejectedToast: 'Soru reddedildi',
    rejectedNote: 'Reddetme gerekçesi: {{note}}',
  },
  productTools: {
    copy: 'Kopyala',
    copyConfirm:
      'Ürünün taslak bir kopyası oluşturulur: içerik, varyantlar (yeni SKU, barkodsuz), kategoriler, özellikler, görseller ve fiyatlar kopyalanır; mağaza yayını ve stok kopyalanmaz. Devam edilsin mi?',
    copied: 'Kopya taslak olarak oluşturuldu. Yeni SKU: {{skus}}',
    saveTemplate: 'Şablon olarak kaydet',
    saveTemplateLead:
      'Marka, kategoriler, türler, seçenekler, özellikler, etiketler ve açıklama metinleri şablona kaydedilir. Ad, SKU, fiyat ve görseller kaydedilmez.',
    templateName: 'Şablon adı',
    templateSaved: 'Şablon kaydedildi',
    startFrom: 'Şablondan başla',
    startFromLead:
      'Kayıtlı bir şablonu seçip uygularsanız form şablondaki değerlerle dolar; sonra düzenleyebilirsiniz.',
    template: 'Şablon',
    chooseTemplate: 'Şablon seçin',
    applyTemplate: 'Şablonu uygula',
    templateApplied: '"{{name}}" şablonu uygulandı',
    noTemplates: 'Kayıtlı şablon yok. Bir ürünün ekranındaki "Şablon olarak kaydet" ile oluşturabilirsiniz.',
    deleteTemplate: 'Şablonu sil',
    deleteTemplateConfirm: '"{{name}}" şablonu silinsin mi? Bu şablondan oluşturulmuş ürünler etkilenmez.',
    templateDeleted: 'Şablon silindi',
    suggestSkus: 'SKU öner',
    skusSuggested: 'Boş SKU alanları dolduruldu (kalıp: {{pattern}}). Kaydetmeyi unutmayın.',
    skuPattern: 'SKU kalıbı',
    skuPatternLead: 'SKU önerisi bu kalıba göre üretilir. Öneri her zaman işletmede benzersizdir.',
    skuPatternLabel: 'Kalıp',
    skuPatternHint:
      'Jetonlar: {marka} (ör. ZG), {kategori}, {urun} (ürün adının ilk üç kelimesi), {secenek} (ör. 60-ML), {sira} (ürün sırası, 0001). Ayırıcı olarak - _ . / kullanılabilir.',
    skuPatternSaved: 'SKU kalıbı kaydedildi',
    schedule: 'Yayını planla',
    scheduleLead:
      'Seçtiğiniz zamanda ürün bu mağazada yayına alınır. O anda yayın şartları (etkin, onaylı, fiyatlı) yeniden denetlenir; sağlanmıyorsa yayınlanmaz ve nedeni burada görünür.',
    publishAt: 'Yayın zamanı',
    publishAtHint: 'Tarayıcınızın saatine göre; en erken 1 dakika sonra, en geç 1 yıl içinde.',
    scheduleSave: 'Planla',
    scheduled: 'Yayın planlandı',
    scheduledFor: 'Planlandı: {{date}}',
    unschedule: 'Planı iptal et',
    unscheduled: 'Plan iptal edildi',
    scheduleFailed: 'Planlı yayın yapılamadı:',
  },
  productBulk: {
    selectAllPage: 'Bu sayfadaki tüm ürünleri seç',
    selectRow: '{{title}} ürününü seç',
    selected: '{{count}} ürün seçildi',
    allMatching: 'Süzgece uyan tüm ürünler seçildi',
    selectAllMatching: 'Süzgece uyan tüm ürünleri seç',
    clear: 'Seçimi temizle',
    open: 'Toplu işlem',
    history: 'Toplu işlem geçmişi',
    lead: 'İşlemi seçip önizleyin. Önizlemede hiçbir ürün değişmez; değişiklik "Uygula" ile yapılır ve toplu işlem geçmişinden geri alınabilir.',
    kind: 'İşlem',
    kinds: {
      status: 'Durumu değiştir',
      categories_add: 'Kategori ekle',
      categories_remove: 'Kategoriden çıkar',
      tags_add: 'Etiket ekle',
      tags_remove: 'Etiket kaldır',
      collection_add: 'Koleksiyona ekle',
      collection_remove: 'Koleksiyondan çıkar',
      stock_set: 'Stoku sayıma göre ayarla',
      stock_adjust: 'Stok ekle veya çıkar',
      seo: 'SEO başlığı ve açıklaması',
      merchant: 'Google alışveriş',
      cells: 'Tablo düzenleme',
      store_publish: 'Mağazada yayınla',
      store_unpublish: 'Mağazada yayından kaldır',
    },
    newStatus: 'Yeni durum',
    categories: 'Kategoriler',
    tags: 'Etiketler',
    tagsHint: 'Virgülle ayırın (ör. yavru kedi, tahılsız).',
    collection: 'Koleksiyon',
    chooseCollection: 'Koleksiyon seçin',
    noManualCollections:
      'Elle seçilen koleksiyon yok. Kurallı koleksiyonlara ürünler kurala göre kendiliğinden girer.',
    warehouse: 'Depo',
    chooseWarehouse: 'Depo seçin',
    quantitySet: 'Yeni stok (adet)',
    quantityAdjust: 'Eklenecek veya çıkarılacak adet',
    stockHint:
      'Her etkin varyantın bu depodaki stoku değişir. Çıkarmak için eksi yazın (ör. -5). Stok, siparişlere ayrılmış adetin altına düşecekse o varyant atlanır; parti/SKT takipli varyantlar stok ekranından girilir.',
    seoTitle: 'SEO başlığı kalıbı',
    seoDescription: 'SEO açıklaması kalıbı',
    seoHint:
      'Jetonlar: {urun}, {marka}, {kategori} (ör. {urun} | {marka}). Boş bıraktığınız alan değişmez. Başlık 70, açıklama 170 karakterde kesilir.',
    onlyEmpty: 'Yalnızca boş olanları doldur',
    merchantChoice: 'Google alışveriş ürün listesinde',
    store: 'Mağaza',
    storeHint:
      'Etkin olmayan, veteriner onayı bekleyen veya bu mağazada fiyatı olmayan ürünler yayınlanmaz; önizlemede gerekçesiyle atlanır.',
    merchantOptions: { include: 'Dahil et', exclude: 'Hariç tut' },
    preview: 'Önizle',
    back: 'Geri',
    apply: 'Uygula',
    summary: '{{products}} ürün incelendi: {{total}} değişiklik yapılacak, {{skipped}} atlanacak.',
    nothing: 'Değişecek bir şey yok. Atlananların nedenlerine bakın.',
    expires: 'Önizleme {{time}} saatine kadar geçerli.',
    item: 'Ürün',
    before: 'Şimdi',
    after: 'Sonra',
    sampleNote: 'İlk 200 değişiklik gösteriliyor.',
    skippedTitle: 'Atlanacaklar ({{count}})',
    queued: 'Arka planda uygulanıyor: {{processed}} / {{total}}',
    queuedLead: 'Bu pencereyi kapatabilirsiniz; ilerleme toplu işlem geçmişinde görünür.',
    done: 'Toplu işlem uygulandı: {{applied}} değişiklik, {{skipped}} satır atlandı.',
    notes: {
      unchanged: 'Zaten bu değerde',
      product_requires_active_variant: 'Etkin varyantı yok',
      too_many_categories: 'Kategori sınırı (20) aşılır',
      too_many_tags: 'Etiket sınırı (30) aşılır',
      lot_tracked: 'Parti/SKT takipli; stok ekranından girin',
      insufficient_stock: 'Stok sıfırın veya ayrılmış adetin altına düşer',
      changed_since_preview: 'Önizlemeden sonra değişti; dokunulmadı',
      error: 'Bu satırda işlem yapılamadı ({{code}})',
    },
    values: {
      inCollection: 'Koleksiyonda',
      notInCollection: 'Koleksiyonda değil',
      included: 'Dahil',
      excluded: 'Hariç',
      published: 'Yayında',
      notPublished: 'Yayında değil',
    },
    date: 'Tarih',
    status: 'Durum',
    rows: 'Satır',
    statuses: {
      preview: 'Uygulanmadı',
      queued: 'Sırada',
      running: 'Uygulanıyor',
      applied: 'Uygulandı',
      failed: 'Başarısız',
      reverted: 'Geri alındı',
      expired: 'Süresi doldu',
    },
    states: {
      pending: 'Bekliyor',
      applied: 'Uygulandı',
      skipped: 'Atlandı',
      reverted: 'Geri alındı',
      revert_skipped: 'Geri alınmadı (sonradan değişmiş)',
    },
    progress: '{{processed}} / {{total}}',
    skippedCount: '{{count}} atlandı',
    empty: 'Henüz toplu işlem yok',
    emptyLead: 'Ürünler ekranında ürünleri seçip "Toplu işlem" ile başlayın.',
    details: 'Ayrıntı',
    revert: 'Geri al',
    revertConfirm:
      'Bu işlemle değişen değerler eski hâline döner. Sonradan elle değiştirilmiş satırlara dokunulmaz; stok ters hareketle düzeltilir. Devam edilsin mi?',
    reverted: 'Geri alındı: {{reverted}} satır. Sonradan değiştiği için atlanan: {{skipped}}.',
    itemsNote: 'İlk 200 satır gösteriliyor.',
    note: 'Not',
  },
  productGrid: {
    open: 'Tabloda düzenle',
    tableLabel: 'Ürün tablosu',
    priceList: 'Fiyat listesi',
    noPriceList: 'Fiyat gösterme',
    warehouse: 'Depo',
    noWarehouse: 'Stok gösterme',
    lockedWhileDirty:
      'Fiyat listesini veya depoyu değiştirmek için önce değişiklikleri kaydedin ya da vazgeçin.',
    keyboard:
      'Ok tuşlarıyla hücreler arasında gezinin. Düzenlemek için Enter’a basın, çift tıklayın veya yazmaya başlayın; Enter kaydedip aşağı iner, Tab sağa geçer, Esc vazgeçer.',
    changesRegion: 'Kaydedilmemiş değişiklikler',
    cols: {
      product: 'Ürün',
      sku: 'SKU',
      barcode: 'Barkod',
      status: 'Durum',
      price: 'Fiyat',
      priceIn: 'Fiyat ({{currency}})',
      onHand: 'Stok',
    },
    statuses: { active: 'Etkin', archived: 'Arşiv' },
    changes: '{{count}} değişiklik kaydedilmedi',
    noChanges: 'Kaydedilmemiş değişiklik yok',
    discard: 'Vazgeç',
    discardConfirm: 'Kaydedilmemiş {{count}} değişiklik silinsin mi?',
    review: 'Değişiklikleri kaydet',
    previously: 'Önceki: {{value}}',
    edited: 'değiştirildi, kaydedilmedi',
    invalidPrice: 'Tutarı 129,90 biçiminde girin.',
    invalidStock: 'Sıfır veya pozitif tam sayı girin.',
    lotTracked: 'Parti/SKT takipli; stok ekranından girin',
    prevPage: 'Önceki sayfa',
    nextPage: 'Sonraki sayfa',
    empty: 'Bu aramayla ürün yok',
    previewTitle: 'Değişiklikleri kaydet',
    previewLead:
      'Kaydetmeden önce kontrol edin. Siz düzenlerken başkası tarafından değiştirilmiş hücreler kaydedilmez.',
    summary: '{{total}} satırda değişiklik kaydedilecek.',
    nothing: 'Kaydedilecek geçerli değişiklik yok.',
    field: 'Alan',
    conflictsTitle: 'Siz düzenlerken değişti ({{count}})',
    conflictsLead:
      'Bu hücreler kaydedilmez ve tablodan silinir. Tablo yenilenince güncel değerin üzerine yeniden düzenleyin.',
    conflict: 'sizin gördüğünüz {{yours}}, şimdi {{current}}',
    problemsTitle: 'Kaydedilemeyecek hücreler ({{count}})',
    save: 'Kaydet',
    saved: '{{count}} satır kaydedildi.',
    queued: 'Değişiklikler arka planda kaydediliyor; ilerleme toplu işlem geçmişinde görünür.',
  },
  priceTiers: {
    title: 'Adet bazlı fiyatlar',
    lead: 'Belirli adetten itibaren geçerli fiyat (ör. 6 adet ve üzeri). Sepette adede uyan en yüksek eşik uygulanır.',
    row: '{{list}} · {{sku}} · {{qty}} adet ve üzeri: {{price}}',
    empty: 'Adet bazlı fiyat yok.',
    list: 'Liste',
    variant: 'Varyant',
    minQuantity: 'En az adet',
    price: 'Birim fiyat ({{currency}})',
    add: 'Ekle',
    remove: 'Kaldır',
    removeConfirm: '{{qty}} adet ve üzeri fiyatı kaldırılsın mı?',
  },
  reviews: {
    enabled: 'Değerlendirmeler vitrinde açık',
    filter: 'Durum',
    statuses: { pending: 'Onay bekleyen', published: 'Yayında', rejected: 'Reddedilen' },
    empty: {
      pending: 'Onay bekleyen değerlendirme yok',
      published: 'Yayında değerlendirme yok',
      rejected: 'Reddedilen değerlendirme yok',
    },
    ratingFilter: 'Puan',
    allRatings: 'Tüm puanlar',
    ratingN: '{{n}} yıldız',
    listLabel: 'Değerlendirmeler',
    itemLabel: '{{rating}}/5 — {{title}}',
    verified: 'Doğrulanmış alışveriş',
    replied: 'Yanıtlandı',
    detailTitle: 'Ürün değerlendirmesi',
    back: 'Tüm değerlendirmeler',
    verifiedOrder: 'Doğrulanmış alışveriş: sipariş {{number}}',
    review: 'Değerlendirme',
    ratingOutOf: '5 üzerinden {{n}}',
    meta: '{{author}} · {{date}}',
    reply: 'Mağaza yanıtı',
    replyLead: 'Yanıt ürün sayfasında değerlendirmenin altında mağaza adıyla görünür.',
    replyLabel: 'Yanıtınız',
    repliedBy: 'Son yanıtlayan: {{name}}, {{date}}',
    saveReply: 'Yanıtı kaydet',
    replySaved: 'Yanıt kaydedildi',
    saveFirst: 'Yayımlamadan önce yanıtı kaydedin.',
    publish: 'Onayla ve yayımla',
    publishedToast: 'Değerlendirme yayımlandı',
    rejectTitle: 'Reddet',
    rejectLead: 'Değerlendirme vitrinde gösterilmez ve ortalamaya katılmaz; müşteriye bildirim gitmez.',
    rejectNote: 'Gerekçe (yalnızca panelde)',
    reject: 'Reddet',
    unpublish: 'Yayından kaldır',
    rejectConfirm: 'Değerlendirme vitrinde gösterilmeyecek. Devam edilsin mi?',
    rejectedToast: 'Değerlendirme reddedildi',
    rejectedNote: 'Reddetme gerekçesi: {{note}}',
  },
  translations: {
    locale: 'İçerik dili',
    current: 'Dil: {{lang}}',
    others: 'Diğer diller:',
    add: 'Çeviri ekle',
    lead: 'İçerik seçilen dilde taslak olarak kopyalanır. Metinleri çevirip kaydedin; yayımlanmadan vitrinde görünmez. Sağlık içeriği çeviride yeniden uzman onayı ister.',
    target: 'Hedef dil',
    create: 'Çeviriyi oluştur',
    created: 'Çeviri taslağı oluşturuldu',
    categoryName: 'Kategori adı ({{lang}})',
  },
  // F7-19: düzenli sipariş (abonelik)
  subscriptions: {
    lead: 'Müşteri ürün sayfasından "her N haftada bir" düzenli gönderim başlatır. Her dönemde güncel fiyattan, abonelik indirimiyle sipariş açılır, stok ayrılır ve kartla ödeme bağlantısı gönderilir. Kart saklanmaz, otomatik çekim yapılmaz; süresinde ödenmeyen sipariş iptal edilir ve stok geri döner.',
    store: 'Mağaza',
    settingsTitle: 'Ayarlar',
    settingsLead: 'Düzenli gönderim mağaza başına açılır; varsayılan kapalıdır.',
    readiness: 'Hazırlık',
    ok: 'Hazır',
    missing: 'Eksik',
    readyCard: 'Kartla ödeme sağlayıcısı bağlı (ödeme bağlantısı için)',
    readyLegal: 'Ön bilgilendirme formu ve mesafeli satış sözleşmesi yayımlanmış',
    readyEmail: 'E-posta gönderimi açık (kapalıysa müşteri ödeme bağlantısını yalnızca Hesabım’da görür)',
    readyProducts: 'Düzenli gönderime uygun ürün: {{count}}',
    enabled: 'Düzenli gönderimi aç',
    enabledLead:
      'Açıkken uygun ürünlerin sayfasında "Düzenli gönder" kutusu görünür. Kapatınca yeni dönem siparişi açılmaz; abonelikler bekler.',
    intervals: 'Müşterinin seçebileceği aralıklar',
    everyWeek: 'Her hafta',
    everyWeeks: 'Her {{n}} haftada bir',
    discount: 'Abonelik indirimi (%)',
    discountHint: '0 ile 30 arası. Abonelik başladığı andaki oran o abonelikte değişmez.',
    discountShort: '%{{pct}} indirim',
    linkHours: 'Ödeme bağlantısı süresi',
    hoursOption: '{{n}} saat',
    save: 'Ayarları kaydet',
    saved: 'Düzenli sipariş ayarları kaydedildi.',
    enableConfirm:
      'Düzenli gönderim açılsın mı? Uygun ürünlerin sayfasında "Düzenli gönder" kutusu görünür ve müşteriler abonelik başlatabilir.',
    listTitle: 'Abonelikler',
    listLead: 'Müşteri, ürün, aralık, sonraki sipariş günü ve ödeme bekleyen sipariş.',
    statusFilter: 'Durum',
    all: 'Tümü',
    statuses: {
      active: 'Etkin',
      paused: 'Duraklatıldı',
      cancelled: 'İptal edildi',
    },
    reasons: {
      customer: 'Müşteri isteğiyle',
      unpaid: 'Üst üste iki sipariş ödenmedi',
      unavailable: 'Ürün veya müşteri artık uygun değil',
      panel: 'Panelden iptal edildi',
      payment_unavailable: 'Ödeme bağlantısı oluşturulamadı (kartla ödeme bağlı mı?)',
    },
    emptyTitle: 'Henüz düzenli sipariş yok',
    emptyLead:
      'Ayarları açıp ürünleri "Düzenli gönderime uygun" olarak işaretleyince müşteriler ürün sayfasından başlatabilir.',
    colCustomer: 'Müşteri',
    colProduct: 'Ürün',
    colQuantity: 'Adet',
    colInterval: 'Aralık',
    colNext: 'Sonraki sipariş',
    colStatus: 'Durum',
    colPending: 'Ödeme bekleyen',
    colActions: 'İşlemler',
    runs: 'Dönemler',
    runsFor: '{{product}} için dönem kayıtları',
    runsTitle: 'Dönem kayıtları',
    noRuns: 'Henüz dönem kaydı yok.',
    runStatuses: {
      order_created: 'Sipariş açıldı (ödeme bekliyor)',
      paid: 'Ödendi',
      skipped: 'Atlandı',
      out_of_stock: 'Stok yoktu',
      unpaid: 'Ödenmedi (sipariş iptal edildi)',
      failed: 'Sipariş açılamadı',
    },
    cancel: 'İptal et',
    cancelFor: '{{product}} aboneliğini iptal et',
    cancelTitle: 'Aboneliği iptal et',
    cancelLead:
      'Yeni dönem siparişi açılmaz. Ödeme bekleyen sipariş ödenmezse süresi dolunca kendiliğinden iptal edilir. Müşteriye e-posta gönderilmez; Hesabım’da "İptal edildi" görür.',
    cancelReason: 'Gerekçe (denetim kaydına yazılır)',
    cancelSubmit: 'Aboneliği iptal et',
    cancelled: 'Abonelik iptal edildi.',
  },
  gads: {
    textReviewStatus: {
      not_required: 'Uzman onayı gerekmiyor',
      pending:
        'Metinde {{count}} sağlık beyanı bulgusu var: Veteriner Uzman İnceleyici onayı bekleniyor; onay verilmeden bu işlem onaylanamaz.',
      approved: 'Metin uzman tarafından onaylandı ({{count}} bulgu incelendi).',
      rejected: 'Metin uzman tarafından reddedildi; metni düzenleyip yeniden isteyin.',
    },
    keywordChanges: {
      added: 'Eklenecek ({{count}})',
      removed: 'Çıkarılacak ({{count}})',
    },
    accessLevel: 'Google Ads API erişim düzeyi',
    accessLevelHint:
      'Google Cloud projenize Google’ın verdiği düzey. Explorer’da anahtar kelime önerisi kapalıdır; Basic onayı geldiğinde değiştirin.',
    accessLevels: {
      explorer: 'Explorer (varsayılan)',
      basic: 'Basic',
      standard: 'Standard',
    },
    searchOnlyReady: 'Yalnızca arama kampanyası kurulabilir: Performance Max ve Alışveriş için şunlar eksik',
    search: {
      source: 'Taslağı veriden oluştur',
      sourceKinds: {
        product: 'Ürün',
        category: 'Kategori',
      },
      sourceCategory: 'Kategori',
      sourceSearch: 'Ürün ara',
      sourceProduct: 'Ürün',
      suggest: 'Taslak oluştur',
      preview: 'Reklam önizlemesi',
      previewCaption: 'Örnek görünüm: Google başlık ve açıklamaların sırasını ve birleşimini kendisi seçer.',
      sponsored: 'Sponsorlu',
      previewEmpty: 'Başlık girin',
      findings: '{{count}} sağlık beyanı bulgusu',
      findingsLead:
        'Bu metin Veteriner Uzman İnceleyici onayı olmadan Google’a gönderilemez. Hastalığı önleme veya tedavi iddiası kullanmayın.',
      shortOf: 'Veride yeterli metin yok: {{headlines}} başlık ve {{descriptions}} açıklama daha yazın.',
      finalUrl: 'Son URL',
      finalUrlHint:
        'Mağazanızdaki sayfa (https://…). Taslak oluşturulunca ürün veya kategori sayfası yazılır.',
      path1: 'Görünen yol 1',
      path2: 'Görünen yol 2',
      headlines: 'Başlıklar (3–15, en çok 30 karakter)',
      headlinesHint: 'Farklı anlamda başlıklar yazın; sabitleme yalnızca gerektiğinde.',
      headlineN: 'Başlık {{n}}',
      pinN: 'Başlık {{n}} sabitleme',
      pinNone: 'Sabitleme yok',
      pins: {
        h1: '1. başlık konumu',
        h2: '2. başlık konumu',
        h3: '3. başlık konumu',
        d1: '1. açıklama konumu',
        d2: '2. açıklama konumu',
      },
      removeHeadline: 'Başlık {{n}} sil',
      addHeadline: 'Başlık ekle',
      descriptions: 'Açıklamalar (2–4, en çok 90 karakter)',
      descriptionN: 'Açıklama {{n}}',
      pinDescN: 'Açıklama {{n}} sabitleme',
      removeDescription: 'Açıklama {{n}} sil',
      addDescription: 'Açıklama ekle',
      keywordN: '{{label}} {{n}}',
      matchTypeN: '{{label}} {{n}} eşleme türü',
      matchTypes: {
        broad: 'Geniş eşleme',
        phrase: 'Sıralı eşleme',
        exact: 'Tam eşleme',
      },
      removeKeyword: '“{{text}}” sil',
      addKeywords: '{{label}} ekle',
      addKeywordsHint: 'Her satıra bir tane (veya ; ile ayırın). Sıralı eşlemeyle eklenir.',
      add: 'Ekle',
      keywordCount: '{{count}} / {{max}}',
      ideas: 'Anahtar kelime öner',
      basicRequired: 'Basic erişim gerekli',
      basicRequiredLead:
        'Google, Explorer erişiminde planlama hizmetlerini (anahtar kelime önerisi) kapatır. Basic onayı alındığında Bütçe tavanı ve ayarlar’dan erişim düzeyini değiştirin.',
      noIdeas: 'Google bu tohumlar için öneri döndürmedi.',
      monthlySearches: 'aylık ≈ {{n}} arama',
      competition: {
        LOW: 'düşük rekabet',
        MEDIUM: 'orta rekabet',
        HIGH: 'yüksek rekabet',
        UNSPECIFIED: 'rekabet bilinmiyor',
        UNKNOWN: 'rekabet bilinmiyor',
      },
      addIdea: '“{{text}}” ekle',
      approvalStatuses: {
        APPROVED: 'Onaylandı',
        APPROVED_LIMITED: 'Sınırlı onaylı',
        AREA_OF_INTEREST_ONLY: 'Yalnızca ilgi alanında',
        DISAPPROVED: 'Reddedildi',
        UNKNOWN: 'Bilinmiyor',
      },
      googleReviewStatuses: {
        REVIEW_IN_PROGRESS: 'İnceleniyor',
        REVIEWED: 'İncelendi',
        UNDER_APPEAL: 'İtirazda',
        ELIGIBLE_MAY_SERVE: 'Yayınlanabilir (inceleme sürüyor)',
      },
      adStrengths: {
        EXCELLENT: 'Mükemmel',
        GOOD: 'İyi',
        AVERAGE: 'Orta',
        POOR: 'Zayıf',
        PENDING: 'Hesaplanıyor',
        NO_ADS: 'Reklam yok',
      },
      notSent: 'Google’a gönderilmedi',
      reviewSaved: 'İnceleme kararı kaydedildi.',
      reviewTitle: 'Uzman incelemesi',
      reviewStatuses: {
        not_required: 'Gerekmiyor',
        pending: 'Bekliyor',
        approved: 'Onaylandı',
        rejected: 'Reddedildi',
      },
      reviewedBy: 'Karar: {{name}}',
      reviewNote: 'İnceleme notu',
      reviewNoteHint: 'Reddederken gerekçe zorunlu.',
      reviewApprove: 'Metni onayla',
      reviewReject: 'Metni reddet',
      reviewWaiting: 'Veteriner Uzman İnceleyici’nin kararı bekleniyor.',
      adTitle: 'Reklam metni',
      adLead: 'Duyarlı arama reklamı: Google başlık ve açıklamaları birleştirerek gösterir.',
      requestedDiffers: 'İstenen yeni metin henüz Google’da değil (onay veya uygulama bekliyor).',
      googleState: 'Google’daki durum',
      approvalStatus: 'Politika onayı',
      googleReview: 'Google incelemesi',
      adStrength: 'Reklam gücü',
      keywords: 'Anahtar kelimeler',
      keywordsLead: 'Reklamın görünebileceği aramalar. Eklemek onay ister; yalnızca çıkarmak onaysızdır.',
      negatives: 'Negatif anahtar kelimeler',
      negativesLead: 'Reklamın görünmeyeceği aramalar. Eklemek onaysız; çıkarmak onay ister.',
      noKeywords: 'Anahtar kelime yok.',
      noNegatives: 'Negatif anahtar kelime yok.',
      edit: {
        ad: 'Reklam metnini düzenle',
        keywords: 'Anahtar kelimeleri düzenle',
        negatives: 'Negatifleri düzenle',
      },
      draftSaved: 'Taslak kaydedildi.',
      draftEditLead: 'Kampanya taslakta: değişiklik Google’a gitmeden kaydedilir.',
      adChangeLead:
        'Yeni metin onaya gider; onaylanınca Google’daki reklam güncellenir. Sağlık beyanı bulgusu varsa önce uzman onayı gerekir.',
      changeSummary: '{{added}} eklenecek, {{removed}} çıkarılacak.',
      summaryAd: 'Reklam',
      summaryAdValue:
        '{{headlines}} başlık, {{descriptions}} açıklama, {{keywords}} anahtar kelime, {{negatives}} negatif',
      summaryReviewNote:
        'Metinde sağlık beyanı bulgusu varsa kampanya Veteriner Uzman İnceleyici onayı olmadan oluşturulamaz.',
    },
    backToAds: 'Reklam merkezi',
    backToList: 'Kampanyalar',
    settings: 'Bütçe tavanı ve ayarlar',
    newCampaign: 'Yeni kampanya',
    stopAll: 'Tüm Google kampanyalarını durdur',
    stopConfirm:
      'Yayındaki tüm Google Ads kampanyaları duraklatılacak ve onay bekleyen harcama istekleri iptal edilecek. Devam edilsin mi?',
    stopDone: '{{pausing}} kampanya duraklatılıyor; {{cancelled}} istek iptal edildi.',
    monthTitle: 'Bu ay',
    monthSpent: 'Bu ay harcanan',
    monthlyCap: 'Aylık reklam bütçesi tavanı',
    capMissing: 'Tanımlı değil',
    capExceeded: 'Tavanı ({{cap}}) aşıyor',
    projected: 'Tahmini aylık üst sınır',
    projectedAll: 'Tüm yayındakilerle aylık üst sınır',
    projectedNote:
      'Tahmini aylık üst sınır, yayındaki kampanyaların günlük bütçeleri toplamının 30,4 katıdır. Google bir günde günlük bütçenin 2 katına kadar harcayabilir; ay toplamı günlük × 30,4’ü geçmez.',
    apiUsage: 'Bugünkü Google Ads API işlemi',
    apiUsageValue: '{{used}} / {{limit}}',
    campaignsTitle: 'Kampanyalar',
    empty: 'Henüz Google Ads kampanyası yok',
    emptyLead:
      'Yeni kampanya ile ürünlerinizden Performance Max veya Alışveriş kampanyası hazırlayın. Kampanya Google’da duraklatılmış oluşturulur; yayına alma ayrıca onay ister.',
    campaign: 'Kampanya',
    status: 'Durum',
    dailyBudget: 'Günlük bütçe',
    dailyMax: 'Bir günde en fazla',
    monthlyMax: 'Aylık en fazla',
    productsCount: 'Ürün',
    notes: 'Notlar',
    driftBadge: 'Google Ads’te değiştirildi',
    pendingBadge: '{{count}} onay bekliyor',
    kinds: {
      search: 'Arama',
      pmax: 'Performance Max',
      shopping: 'Alışveriş',
    },
    kindHints: {
      search:
        'Google arama sonuçlarında metin reklamı (duyarlı arama reklamı): başlık, açıklama ve anahtar kelimelerle. Merchant Center gerekmez. Teklif: dönüşüm değeri, dönüşüm veya tıklama.',
      pmax: 'Google’ın tüm kanallarında (Arama, Alışveriş, YouTube, Görüntülü Reklam Ağı, Gmail) ürün akışından otomatik reklam. Teklif: dönüşüm değeri veya dönüşüm.',
      shopping: 'Yalnızca Google Alışveriş sonuçlarında ürün reklamı. Teklif: dönüşüm değeri veya tıklama.',
    },
    statuses: {
      draft: 'Taslak',
      paused: 'Duraklatıldı',
      enabled: 'Yayında',
      removed: 'Kaldırıldı',
    },
    biddings: {
      max_conv_value: 'Dönüşüm değerini en üst düzeye çıkar',
      max_conversions: 'Dönüşümleri en üst düzeye çıkar',
      max_clicks: 'Tıklamaları en üst düzeye çıkar',
    },
    alerts: {
      month_80: 'Bu ay {{spent}} harcandı: aylık tavanın ({{cap}}) %80’ine ulaşıldı.',
      month_cap_reached: 'Bu ay {{spent}} harcandı: aylık tavana ({{cap}}) ulaşıldı.',
      daily_overspend: 'Son günde harcama ({{spent}}) günlük bütçenin ({{budget}}) 1,5 katını geçti.',
      no_conversions_2d: 'Son iki günde {{spent}} harcandı ama Google dönüşüm bildirmedi.',
    },
    approvalsTitle: 'Onay bekleyenler',
    approvalsLead:
      'Para harcatabilecek değişiklikler onaylanmadan Google’a gitmez. Onay iki adımlı doğrulama ister; kendi isteğinizi yalnızca işletme sahibi onaylayabilir.',
    noApprovals: 'Onay bekleyen işlem yok.',
    requestedBy: 'İsteyen: {{name}}',
    system: 'Sistem',
    approve: 'Onayla',
    reject: 'Reddet',
    approveTitle: 'Değişikliği onayla',
    rejectTitle: 'Değişikliği reddet',
    approveSubmit: 'Onayla ve Google’a gönder',
    rejectSubmit: 'Reddet',
    approved: 'Onaylandı; işlem kuyruğa alındı.',
    rejected: 'Reddedildi.',
    approveStepUp: 'Onay iki adımlı doğrulama ister; gerekiyorsa doğrulama kodu sorulur.',
    decisionNote: 'Not',
    moneyLine: 'Günlük bütçe: {{daily}}.',
    moneyRule:
      'Google bir günde 2 katına kadar harcayabilir ({{dailyMax}}); aylık en fazla ≈ günlük × 30,4 ({{monthlyMax}}).',
    moneyProjected: 'Bu onayla yayındaki tüm kampanyaların tahmini aylık üst sınırı: {{value}}.',
    loosensWarning:
      'Bu değişiklik teklif hedefini gevşetiyor veya stratejiyi değiştiriyor: harcama artabilir.',
    removeWarning: 'Kaldırma geri döndürülemez: kampanya Google Ads’te kaldırılır ve yeniden açılamaz.',
    settingsTitle: 'Bütçe tavanı ve ayarlar',
    settingsLead:
      'Aylık tavan, harcatan işlemlerin onayında denetlenir. Değiştirmek onay yetkisi ve iki adımlı doğrulama ister.',
    monthlyCapLabel: 'Aylık reklam bütçesi tavanı ({{currency}})',
    monthlyCapHint: 'Boş bırakılırsa yayına alma ve bütçe artırma onaylanamaz.',
    autoStop: 'Tavana ulaşınca otomatik durdur',
    autoStopHint:
      'Varsayılan kapalı. Açıksa ay içi Google Ads harcaması tavana ulaşınca yayındaki kampanyalar onaysız duraklatılır.',
    dailyLimitHint:
      'Günlük Google Ads API işlem sınırı: {{limit}}. Sınır dolunca işlemler ertesi sabah uygulanır.',
    settingsReadOnly: 'Ayarları yalnızca onay yetkisi olanlar değiştirebilir.',
    settingsSaved: 'Ayarlar kaydedildi.',
    wizardTitle: 'Yeni Google Ads kampanyası',
    wizardStep: 'Adım {{n}} / {{total}}: {{name}}',
    stepsLabel: 'Sihirbaz adımları',
    steps: {
      ad: 'Reklam ve anahtar kelimeler',
      store: 'Mağaza',
      campaign: 'Tür ve ad',
      products: 'Ürünler',
      budget: 'Bütçe ve teklif',
      targeting: 'Bölge, dil, tarih',
      summary: 'Özet',
    },
    back: 'Geri',
    next: 'İleri',
    store: 'Mağaza',
    checking: 'Google bağlantıları denetleniyor…',
    ready: 'Hazır',
    readyLead:
      'Google Ads hesabı {{customer}}, Merchant Center {{merchant}}; satın alma dönüşümü: {{conversion}}.',
    locked: 'Kampanya hazırlamak için önce şunlar tamamlanmalı:',
    kind: 'Kampanya türü',
    name: 'Kampanya adı',
    productSearch: 'Ürün ara',
    productsHint:
      'Seçtiğiniz ürünler kampanyanın ürün filtresine girer. Google feed’ine giremeyen ürünler (ör. veteriner onayı yok, sağlık beyanı) eklenmez; nedenleri gösterilir.',
    selectedCount: '{{count}} ürün seçildi',
    dailyBudgetLabel: 'Günlük bütçe ({{currency}})',
    budgetInvalid: 'Geçerli bir tutar girin.',
    bidding: 'Teklif stratejisi',
    targetRoas: 'Hedef ROAS (%)',
    targetRoasHint: 'İsteğe bağlı. Örnek: 400 = her 1 ₺ harcamaya 4 ₺ dönüşüm değeri hedeflenir.',
    targetCpa: 'Hedef dönüşüm başı maliyet ({{currency}})',
    targetCpaHint: 'İsteğe bağlı. Boşsa Google bütçe içinde en çok dönüşümü arar.',
    roasValue: '%{{value}} ROAS',
    noTarget: 'hedefsiz',
    countries: 'Ülkeler',
    languagesLabel: 'Diller',
    languages: {
      tr: 'Türkçe',
      en: 'İngilizce',
      de: 'Almanca',
      ar: 'Arapça',
    },
    countryNames: {
      TR: 'Türkiye',
      DE: 'Almanya',
      GB: 'Birleşik Krallık',
      AE: 'BAE',
      US: 'ABD',
      NL: 'Hollanda',
      FR: 'Fransa',
      AT: 'Avusturya',
      BE: 'Belçika',
      CH: 'İsviçre',
      AZ: 'Azerbaycan',
      SA: 'Suudi Arabistan',
      QA: 'Katar',
      KW: 'Kuveyt',
      BG: 'Bulgaristan',
      GR: 'Yunanistan',
      IT: 'İtalya',
      ES: 'İspanya',
      SE: 'İsveç',
      DK: 'Danimarka',
    },
    startDate: 'Başlangıç tarihi',
    endDate: 'Bitiş tarihi',
    startHint: 'Boşsa onaylanıp yayına alındığında başlar.',
    endHint: 'Boşsa süresiz.',
    dates: 'Tarihler',
    startNow: 'Yayına alınınca',
    noEnd: 'süresiz',
    assetsNote:
      'Öğeler: Google reklam metinlerini ve görsellerini ürün feed’inden ve sitenizden üretir (bu sürümde başlık ve görsel eklenmez; Google’ın notuna göre erişim sınırlı olabilir).',
    pausedNote:
      'Kampanya Google Ads’te DURAKLATILMIŞ oluşturulur ve teklife yalnızca “Satın alma” dönüşümü esas alınır. Yayına alma ayrıca onay ister.',
    requestNote: 'Not (onaylayana)',
    saveDraft: 'Taslak kaydet',
    submitForApproval: 'Onaya gönder',
    wizardSaved: 'Taslak kaydedildi',
    wizardSavedLead: 'Taslak Google’a gönderilmedi. Kampanya sayfasından düzenleyip onaya gönderebilirsiniz.',
    wizardSubmitted: 'Onaya gönderildi',
    wizardSubmittedLead: 'Onaylanınca kampanya Google Ads’te duraklatılmış oluşturulur.',
    openCampaign: 'Kampanyayı aç',
    rejectedTitle: 'Eklenemeyen ürünler',
    reasons: {
      product_not_active: 'Ürün yayında değil.',
      product_not_found: 'Ürün bulunamadı.',
      in_other_campaign: 'Ürün başka bir kampanyada (bir ürün yalnızca bir kampanyada olabilir).',
      feed_not_listed:
        'Ürün bu mağazanın Google feed’inde değil (mağazada yayında mı, perakendeye açık mı?).',
      feed_excluded_by_user: 'Ürün Google feed’inden çıkarılmış.',
      feed_health_not_approved: 'Sağlık içeriği veteriner onayı bekliyor.',
      feed_health_claim: 'Metinde hastalık/tedavi iddiası var (Google sağlık politikası ve mevzuat).',
      feed_image_missing: 'Görsel yok.',
      feed_image_too_small: 'Görsel Google’ın en küçük boyutunun altında.',
      feed_image_too_large: 'Görsel çok büyük.',
      feed_price_missing: 'Fiyat yok.',
      feed_price_not_tax_inclusive: 'Fiyat KDV dahil değil.',
      feed_no_variants: 'Etkin seçenek yok.',
      feed_country_blocked: 'Ürün bu ülkede satışa kapalı.',
      feed_translation_missing: 'Pazarın dilinde çeviri yok.',
      feed_tax_rate_missing: 'KDV oranı tanımlı değil.',
      out_of_stock: 'Stokta yok: Google stoksuz ürünü göstermez.',
    },
    productStates: {
      queued: 'Kuyrukta',
      sent: 'Google’a iletildi — işleniyor',
      eligible: 'Uygun',
      limited: 'Sınırlı',
      not_eligible: 'Uygun değil',
    },
    googleId: 'Google kimliği {{id}}',
    labelValue: 'Ürün etiketi {{label}}',
    primaryStatus: 'Google’daki durum: {{status}}',
    primaryStatuses: {
      ELIGIBLE: 'Uygun',
      PAUSED: 'Duraklatıldı',
      REMOVED: 'Kaldırıldı',
      ENDED: 'Sona erdi',
      PENDING: 'Başlamayı bekliyor',
      MISCONFIGURED: 'Yapılandırma hatalı',
      LIMITED: 'Sınırlı',
      LEARNING: 'Öğreniyor',
      NOT_ELIGIBLE: 'Uygun değil',
    },
    readAt: 'okundu {{at}}',
    driftTitle: 'Google Ads’te değiştirildi',
    driftLead:
      'Google Ads’teki değerler sistemdekinden farklı. Sistem Google’daki değerin üzerine kendiliğinden yazmaz: Google’dakini kabul edin veya yeni bir istek açın.',
    driftFields: {
      ad_text: 'Reklam metni (ilk başlık)',
      keywords: 'Anahtar kelime sayısı',
      negatives: 'Negatif anahtar kelime sayısı',
      status: 'Durum',
      name: 'Ad',
      budget: 'Günlük bütçe (mikro)',
      bidding: 'Teklif stratejisi',
      target_roas: 'Hedef ROAS (%)',
      target_cpa: 'Hedef EBM (mikro)',
      end_date: 'Bitiş tarihi',
    },
    driftValues: 'sistemde {{expected}}, Google’da {{google}}',
    acceptGoogle: 'Google’daki değerleri kabul et',
    driftAccepted: 'Sistemdeki kayıt Google Ads’e uyarlandı.',
    goal: 'Dönüşüm hedefi',
    goalApplied: 'Yalnızca satın alma',
    goalPending: 'Uygulanıyor',
    accounts: 'Google Ads / Merchant',
    actions: 'Kampanya işlemleri',
    ops: {
      adTextText: 'İlk başlık: {{headline}}',
      keywordsText: '{{add}} eklenecek, {{remove}} çıkarılacak',
      actions: {
        ad_text: 'Reklam metni',
        keywords: 'Anahtar kelimeler',
        negatives: 'Negatif anahtar kelimeler',
        create: 'Onaya gönder (oluştur)',
        enable: 'Yayına al',
        pause: 'Duraklat',
        budget: 'Bütçeyi değiştir',
        bidding: 'Teklif stratejisi',
        targeting: 'Bölge, dil ve tarih',
        rename: 'Adı değiştir',
        remove: 'Kaldır',
        apply_recommendation: 'Google önerisi',
        conversion_goal: 'Dönüşüm hedefi',
      },
      kinds: {
        ad_text: 'Reklam metni',
        keywords: 'Anahtar kelimeler',
        negatives: 'Negatif anahtar kelimeler',
        create: 'Oluşturma',
        enable: 'Yayına alma',
        pause: 'Duraklatma',
        budget: 'Bütçe',
        bidding: 'Teklif',
        targeting: 'Hedefleme',
        rename: 'Ad',
        remove: 'Kaldırma',
        apply_recommendation: 'Google önerisi',
        conversion_goal: 'Satın alma hedefi',
      },
      budgetText: 'Günlük bütçe {{from}} → {{to}}',
      biddingText: '{{bidding}} ({{target}})',
      targetingText: '{{countries}} · {{languages}} · {{start}} — {{end}}',
      renameText: 'Yeni ad: {{name}}',
      recommendationText: 'Öneri: {{type}}',
    },
    opStatuses: {
      pending_approval: 'Onay bekliyor',
      queued: 'Kuyrukta',
      applying: 'Uygulanıyor',
      applied: 'Uygulandı',
      failed: 'Başarısız',
      rejected: 'Reddedildi',
      cancelled: 'İptal edildi',
    },
    origins: {
      user: 'Kullanıcı',
      system: 'Sistem',
      emergency: 'Acil durdurma',
      auto_stop: 'Otomatik durdurma (tavan)',
    },
    deleteDraft: 'Taslağı sil',
    deleteDraftConfirm: 'Taslak silinecek. Google’a gönderilmediği için Google Ads’te bir şey değişmez.',
    draftDeleted: 'Taslak silindi.',
    openNote: 'Bekleyen bir işlem var; duraklatma dışında yeni işlem istenemez.',
    productsTitle: 'Ürünler',
    productsLead:
      'Ürünler Merchant Center’a kampanya etiketiyle (custom_label_0) ve marj bandıyla (custom_label_1) gider; Google işleyince ürünün kampanyadaki durumu görünür.',
    addProducts: 'Ürün ekle',
    addProductsLead: 'Yalnızca Google feed’ine giren ve başka kampanyada olmayan ürünler eklenir.',
    addSelected: '{{count}} ürünü ekle',
    noProducts: 'Kampanyada ürün yok.',
    removeProduct: 'Çıkar',
    productRemoved: 'Ürün kampanyadan çıkarıldı.',
    productsAdded: '{{count}} ürün eklendi.',
    productsRemoved: '{{count}} ürün çıkarıldı.',
    operationsTitle: 'İşlemler',
    noOperations: 'Henüz işlem yok.',
    operation: 'İşlem',
    who: 'İsteyen → karar veren',
    when: 'Zaman',
    cancel: 'İptal et',
    cancelled: 'İşlem iptal edildi.',
    nextAttempt: 'Yeniden deneme: {{at}}',
    recommendationsTitle: 'Google önerileri',
    recommendationsLead: 'Google’dan istek anında okunur. Bir öneriyi uygulamak her zaman onay ister.',
    loadRecommendations: 'Önerileri getir',
    noRecommendations: 'Bu kampanya için Google önerisi yok.',
    recommendationTypes: {
      CAMPAIGN_BUDGET: 'Bütçe önerisi',
      TARGET_ROAS_OPT_IN: 'Hedef ROAS önerisi',
      MAXIMIZE_CONVERSION_VALUE_OPT_IN: 'Dönüşüm değeri teklif önerisi',
    },
    recommendedBudget: 'Önerilen günlük bütçe {{daily}} (aylık en fazla {{monthly}})',
    requestRecommendation: 'Uygulama iste',
    recommendationRequested: 'Öneri onaya gönderildi.',
    historyTitle: 'Google Ads değişiklik geçmişi',
    historyLead: 'Son 14 gün; Google’dan istek anında okunur, saklanmaz.',
    loadHistory: 'Geçmişi getir',
    noHistory: 'Bu dönemde değişiklik yok.',
    historyBy: 'Kaynak: {{client}} · {{user}}',
    historyNote: 'Okunma zamanı: {{at}}',
    noApprovalLead:
      'Bu değişiklik onay gerektirmez; onay kutusunu işaretleyince kuyruğa girer ve Google’a uygulanır.',
    approvalLead: 'Bu değişiklik harcamayı artırabilir: onaylanmadan Google’a gitmez.',
    applyNow: 'Google Ads’e uygula',
    sendForApproval: 'Onaya gönder',
    queued: 'İşlem kuyruğa alındı.',
    sentForApproval: 'Onaya gönderildi.',
    enableLead: 'Kampanya yayına alınınca harcama başlar: günlük {{daily}}, aylık en fazla {{monthly}}.',
    confirmApply: 'Bu değişikliği Google Ads’e uygulamayı onaylıyorum.',
    productBox: 'Google reklamları',
    productBoxTitle: 'Google reklamları',
    inCampaign: 'Kampanya:',
    notInCampaign: 'Bu ürün hiçbir Google Ads kampanyasında değil.',
    checkedAt: 'Google’dan okundu: {{at}}',
    labelsNote:
      'Bu ürün için Merchant’a custom_label_0 = {{label}} ve custom_label_1 = marj bandı gider (ürünün kendi 1. ve 2. etiketlerinin yerine).',
    removeFromCampaign: 'Kampanyadan çıkar',
    notEligible: 'Bu ürün şu an kampanyaya eklenemez:',
    chooseCampaign: 'Kampanya',
    chooseCampaignPlaceholder: 'Kampanya seçin',
    addToCampaign: 'Kampanyaya ekle',
    productAdded: 'Ürün kampanyaya eklendi.',
    productNotAdded: 'Ürün eklenemedi; nedenler aşağıda.',
    noCampaignsYet: 'Henüz kampanya yok. Pazarlama → Google Ads kampanyaları’ndan oluşturun.',
    bulkCampaign: 'Google Ads kampanyası',
    bulkAdd: 'Seçili {{count}} ürünü ekle',
    bulkRemove: 'Seçilileri kampanyadan çıkar',
    filterLabel: 'Google reklamları',
    filterAny: 'Bir kampanyada',
    filterNone: 'Kampanyada değil',
    filterNotEligible: 'Google’a göre uygun değil',
  },
} as const;
